/* tslint:disable */
/* eslint-disable */
/**
 * Nexelem
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  AbsenteesResponse,
  Address,
  AjaxAction,
  AjaxActionResponse,
  AmountInPlace,
  AmountWithUnit,
  ApiProductionOrderImportView,
  AppConfiguration,
  AutoAssignWorkersOnAreasRequest,
  AutoAssignWorkersRequest,
  AutoAssignWorkersResultView,
  AvailabilityDetailsResponse,
  AvailabilityInputView,
  BankAccount,
  BarcodeAction,
  BarcodeResultData,
  BarcodeScanContext,
  BarcodesView,
  BasicMachinePlanningView,
  BatchDowntimeReportDurationSaveView,
  BatchDowntimeReportEndStopwatchView,
  BatchDowntimeReportStartEndSaveView,
  BomReportEntryView,
  BomReportSaveView,
  BpscExportRequest,
  CalculationPropertyTypesView,
  CalendarAssigneeMultipleRequestView,
  CalendarAssigneeRequestView,
  CalendarAssigneesMultipleView,
  CalendarAssigneesSaveView,
  CalendarEventAssigneeView,
  CalendarEventRole,
  CalendarEventTypeView,
  CalendarEventView,
  CancelProductionLots,
  CancelProductionLotsInColumn,
  ClientSpecification,
  ClonedOrderView,
  CommentView,
  Competence,
  CompoundResultActiveVehicleListController,
  CompoundResultBlobItemsListController,
  CompoundResultCompetenceCategoryListViewController,
  CompoundResultCompetenceListViewController,
  CompoundResultCompetenceMatrixListController,
  CompoundResultContactsListController,
  CompoundResultContractorsListController,
  CompoundResultCountsheetEntriesListController,
  CompoundResultDemandListController,
  CompoundResultDemandsManagerListController,
  CompoundResultDocumentStatusListController,
  CompoundResultDowntimeReasonsListController,
  CompoundResultDriverListController,
  CompoundResultEquipmentDemandListController,
  CompoundResultEquipmentListController,
  CompoundResultItemTypePropertySetListController,
  CompoundResultItemTypePropertyTypesListController,
  CompoundResultItemTypeTagListController,
  CompoundResultItemTypeTotalStockListController,
  CompoundResultItemTypeVariantListController,
  CompoundResultItemTypeVariantWithPropertySetListController,
  CompoundResultLegacyProductionLotListController,
  CompoundResultLegacyProductionOrdersListController,
  CompoundResultLoadCardListController,
  CompoundResultMachineAreasListController,
  CompoundResultMachinesListController,
  CompoundResultMarketingKeepersListController,
  CompoundResultMarketingRulesListController,
  CompoundResultMaterialMovementListController,
  CompoundResultMeasurementDevicesListController,
  CompoundResultMeasurementStandardsListController,
  CompoundResultMethodsOfPaymentListController,
  CompoundResultOffersListController,
  CompoundResultOrderDemandsToProductionListController,
  CompoundResultOrderItemCostsGroupListController,
  CompoundResultOrdersListController,
  CompoundResultOtherDemandListController,
  CompoundResultPriceListsListController,
  CompoundResultProductCatalogListController,
  CompoundResultProductionLotListController,
  CompoundResultProductionLotPeriodsGroupListController,
  CompoundResultProductionLotRawMaterialsUsageListController,
  CompoundResultProductionLotTagListController,
  CompoundResultProductionOrderCreatorListController,
  CompoundResultProductionOrderLotListController,
  CompoundResultProductionOrderRawMaterialsUsageListController,
  CompoundResultProductionOrderWorktimeListController,
  CompoundResultProductionOrdersListController,
  CompoundResultPushStatusListController,
  CompoundResultReleaseListController,
  CompoundResultReleasePlanListController,
  CompoundResultRolesListViewController,
  CompoundResultSalesEntryDocumentListViewController,
  CompoundResultSalesEntryTagListController,
  CompoundResultSpecificationsByMachineFeaturesListController,
  CompoundResultSpecificationsByProducedItemTagsListController,
  CompoundResultSpecificationsByProducedVariantListController,
  CompoundResultSpecificationsByProducedVariantListControllerV2,
  CompoundResultStandardParametersListController,
  CompoundResultStocksToSupplementListViewController,
  CompoundResultStocktakingListController,
  CompoundResultSupplyCardListController,
  CompoundResultSupplyOrderCreatorListController,
  CompoundResultSupplyOrderListController,
  CompoundResultSynchronizationStatusListController,
  CompoundResultTicketsListController,
  CompoundResultUsersListController,
  CompoundResultWarehouseStateListController,
  CompoundResultWarehouseStateToProductionListController,
  CompoundResultWarehouseTagListController,
  CompoundResultWasteCausesListController,
  CompoundResultWithSummaryProductionUnitListViewRow,
  CompoundResultWorkerCompetenceListViewController,
  CompoundResultWorkerDocumentListViewController,
  CompoundResultWorkerListViewController,
  Contact,
  ContactDataUpdateView,
  ContextualItemTypeVariant,
  Contractor,
  ContractorCommentUpdateView,
  ContractorShortView,
  ContractorTag,
  ContractorView,
  CostEstimateResult,
  CountsheetEntrySaveView,
  CountsheetInitView,
  DemandDestination,
  DocumentStatusView,
  DocumentTypes,
  DowntimeBatchGroupReportView,
  DowntimeReportDurationSaveView,
  DowntimeReportEndStopwatchView,
  DowntimeReportStartEndSaveView,
  DowntimeReportStartStopwatchView,
  DowntimeReportView,
  DowntimesOverTimeRequest,
  DowntimesOverTimeRequestV2,
  DowntimesOverTimeResponse,
  DowntimesOverTimeResponseV2,
  EntityVersionTW,
  EquipmentDemandSavingView,
  EquipmentDemandView,
  ErpType,
  ErrorResultAcceptSupplyOrder,
  ErrorResultBackProductionOrderOrderProductionorderidDelete,
  ErrorResultCancelLot,
  ErrorResultCancelOrderItem,
  ErrorResultCancelSupplyOrder,
  ErrorResultClearMeasurement,
  ErrorResultConfirmSingleSupplyOrder,
  ErrorResultConfirmSupplyOrders,
  ErrorResultCreateMeasurement,
  ErrorResultDeleteManualBatchDowntime,
  ErrorResultDeleteManualDowntime,
  ErrorResultDeleteMeasurement,
  ErrorResultEndStopwatchBatchDowntime,
  ErrorResultEndStopwatchDowntime,
  ErrorResultEstimateProductionTimes,
  ErrorResultGetBackSupplyPlannedSupplyorderid,
  ErrorResultGetExpectedTotalAvailability,
  ErrorResultGetExternalSynchronizationRunSaga,
  ErrorResultGetSupplyWarehouseState,
  ErrorResultImportProductionOrder,
  ErrorResultLotFinishTask,
  ErrorResultMarkSupplyOrderInProgress,
  ErrorResultOrdersEndpointsConfirm,
  ErrorResultPostBackContractorsFetchDetails,
  ErrorResultPostBackProductionLotAutoAssignWorkers,
  ErrorResultPostBackProductionLotAutoAssignWorkersOnAreas,
  ErrorResultPostBackProductionOrderCreateQuick,
  ErrorResultPostBackProductionOrderOrderCreate,
  ErrorResultPostBackProductionOrderSimulationGet,
  ErrorResultPostBackProductionOrderSimulationQuery,
  ErrorResultPostBackQsPlannedSupplyCardCreate,
  ErrorResultPostBackQsSpontaneousSupplyCardCreate,
  ErrorResultPostBackReportsWorkstationReportsAmountProductionlotid,
  ErrorResultPostBackReportsWorkstationReportsLoadUpdate,
  ErrorResultPostBackReportsWorkstationsByBatchBatchidAbort,
  ErrorResultPostBackReportsWorkstationsByBatchBatchidStart,
  ErrorResultPostBackReportsWorkstationsByLotBatchidFinish,
  ErrorResultPostBackReportsWorkstationsByLotProductionlotidAbort,
  ErrorResultPostBackReportsWorkstationsByLotProductionlotidFinish,
  ErrorResultPostBackReportsWorkstationsByLotProductionlotidStart,
  ErrorResultPostBackSupplyPlannedSupplyorderidCancel,
  ErrorResultPostBackWorkersWorkerCompetencesSave,
  ErrorResultProductionOrderLotMerge,
  ErrorResultProductionOrderLotSplit,
  ErrorResultQuerySupplyOrderItems,
  ErrorResultQuickSaveSupplyOrderItems,
  ErrorResultRecalculateProductionOrderSimulation,
  ErrorResultSaveBomReport,
  ErrorResultSaveDurationBatchDowntime,
  ErrorResultSaveDurationBatchDowntimeV2,
  ErrorResultSaveDurationDowntime,
  ErrorResultSaveDurationDowntimeV2,
  ErrorResultSavePlannedRelease,
  ErrorResultSaveSpontaneousRelease,
  ErrorResultSaveStartEndBatchDowntime,
  ErrorResultSaveStartEndBatchDowntimeV2,
  ErrorResultSaveSupplyOrderItems,
  ErrorResultSendExternalDocuments,
  ErrorResultStartSimulationMerge,
  ErrorResultStartStopwatchBatchDowntime,
  ErrorResultStartStopwatchDowntime,
  ErrorResultUpdateMeasurement,
  ErrorResultUpdateRfid,
  ExternalContractorDetailsView,
  ExternalContractorSavingView,
  ExternalOrder,
  FinishTaskView,
  FitAcrossRibbon,
  FitAlongRibbon,
  GeneratedPassword,
  GeneratingPasswordLength,
  GenericRecipe,
  GenericRecipeView,
  GroupLeaderDashboardFilters,
  GroupLeaderEventsResponse,
  HistoricalParallelMachinePairsView,
  IdWithNumberMaterialMovementId,
  IdWithNumberStocktakingId,
  IdWithNumberSupplyOrderId,
  ImportResult,
  ItemTypeBasicInfoSaveView,
  ItemTypePricingSaveView,
  ItemTypePropertySaveView,
  ItemTypePropertySet,
  ItemTypePropertyType,
  ItemTypePropertyTypeWithValuesView,
  ItemTypeSavingView,
  ItemTypeSearchCriteriaView,
  ItemTypeServiceSavingView,
  ItemTypeServiceView,
  ItemTypeTag,
  ItemTypeVariant,
  ItemTypeView,
  ItemTypeWithTemplateSavingView,
  JsError,
  KanbanFilterDefinition,
  KanbanWebsocketOutput,
  LabelDimensionsView,
  LabelEditabilityView,
  Lang,
  LegacyOfferView,
  LendingLedgerEntrySaveView,
  LoadReportSaveView,
  LoadReportView,
  Machine,
  MachineDetailsView,
  MachineFeature,
  MachineFeaturesView,
  MachinePermissionsView,
  MachinePlanningView,
  MachineSaveView,
  MachineState,
  MachineStateChangeData,
  MachineStateDisplayConfig,
  MachineStateTimesView,
  MarketingKeeperUpdateView,
  MarketingRule,
  MarketingRuleType,
  MaterialMovementApplyView,
  MaterialMovementItemsView,
  MaterialMovementSaveView,
  MaterialMovementValidationView,
  MeasurementCreateView,
  MeasurementDeleteView,
  MeasurementReport,
  MeasurementReportFilter,
  MeasurementUpdateView,
  MessagesAction,
  MethodOfPaymentView,
  NewManuallyTypedPassword,
  NexelemMergeImportState,
  NoksOverTimeRequest,
  NoksOverTimeRequestV2,
  NoksOverTimeResponse,
  NoksOverTimeResponseV2,
  NotificationSystemSettings,
  OeeResponse,
  OfferItemView,
  OfferSaveView,
  OfferView,
  OrderAssignmentEventSaveView,
  OrderAssignmentEventView,
  OrderAssignmentsSaveView,
  OrderAssignmentsView,
  OrderDraft,
  OrderFromOffer,
  OrderSavingView,
  OrderSavingViewV2,
  OrderView,
  OtherDemand,
  OtherDemandSavingView,
  PerformanceDetailsResponse,
  Place,
  PlannedReleaseInitialView,
  PlannedReleaseSavingView,
  PlannedSupplyCardCreateView,
  PlannedSupplyInitialView,
  PlateItemTypeSaveView,
  PossibleProductView,
  PostBackContractorsContactsListFilterRequest,
  PostBackContractorsListFilterRequest,
  PostBackContractorsMarketingKeepersListFilterRequest,
  PostBackDocumentsDocumentStatusListFilterRequest,
  PostBackErpSynchronizationStatusesFilterRequest,
  PostBackItemsItemTypeTagsListFilterRequest,
  PostBackItemsPriceListsFilterRequest,
  PostBackItemsPropertySetsListFilterRequest,
  PostBackItemsPropertyTypesFilterRequest,
  PostBackItemsVariantsFilterRequest,
  PostBackItemsVariantsPropertySetFilterRequest,
  PostBackMachineAreasListFilterRequest,
  PostBackMachinesListFilterRequest,
  PostBackMarketingrulesListFilterRequest,
  PostBackMaterialMovementsListFilterRequest,
  PostBackMeasurementsMeasurementDevicesFilterRequest,
  PostBackOffersListFilterRequest,
  PostBackOrdersEquipmentDemandsListFilterRequest,
  PostBackOrdersListFilterRequest,
  PostBackOrdersOtherDemandsListFilterRequest,
  PostBackPresentationsOrderItemsItemsGroupListFilterRequest,
  PostBackPresentationsProductionLotPeriodsGroupListFilterRequest,
  PostBackProductcatalogListFilterRequest,
  PostBackProductionOrdersCreatorListFilterRequest,
  PostBackProductionOrdersLegacyListFilterRequest,
  PostBackProductionOrdersLegacyLotsFilterRequest,
  PostBackProductionOrdersListFilterRequest,
  PostBackProductionOrdersLotRawMaterialsUsageListFilterRequest,
  PostBackProductionOrdersLotsListFilterRequest,
  PostBackProductionOrdersOrderDemandsListFilterRequest,
  PostBackProductionOrdersProductionOrderLotsListFilterRequest,
  PostBackProductionOrdersRawMaterialsUsageListFilterRequest,
  PostBackProductionOrdersWarehouseStateListFilterRequest,
  PostBackProductionOrdersWarehouseToProductionListFilterRequest,
  PostBackProductionOrdersWorktimeListFilterRequest,
  PostBackProductionSpecificationTagsListFilterRequest,
  PostBackPushListFilterRequest,
  PostBackQsCardListFilterRequest,
  PostBackReleasesListFilterRequest,
  PostBackReleasesPlanListFilterRequest,
  PostBackReportsDowntimeReasonsFilterRequest,
  PostBackReportsLoadCardsListFilterRequest,
  PostBackSalesDocumentsListFilterRequest,
  PostBackSalesTagsListFilterRequest,
  PostBackShippingDriversListFilterRequest,
  PostBackSpecificationsByMachineFeaturesListFilterRequest,
  PostBackSpecificationsByProducedItemTagsListFilterRequest,
  PostBackSpecificationsByProducedVariantListFilterRequest,
  PostBackSpecificationsStandardParametersFilterRequest,
  PostBackSpecificationsV2ByProducedVariantListFilterRequest,
  PostBackStocksDemandsListFilterRequest,
  PostBackStocksListFilterRequest,
  PostBackStocksSupplementListFilterRequest,
  PostBackStocktakingCountsheetListFilterRequest,
  PostBackStocktakingListFilterRequest,
  PostBackSupplyListFilterRequest,
  PostBackSupplyOrdersCreatorListFilterRequest,
  PostBackSupplyWarehouseTagListFilterRequest,
  PostBackTicketsListFilterRequest,
  PostBackUnitsBlobsListFilterRequest,
  PostBackUnitsEquipmentListFilterRequest,
  PostBackUnitsItemsListFilterRequest,
  PostBackUnitsListFilterRequest,
  PostBackVehiclesListFilterRequest,
  PostBackWorkersCompetenceCategoriesListFilterRequest,
  PostBackWorkersCompetencesListFilterRequest,
  PostBackWorkersCompetencesMatrixListFilterRequest,
  PostBackWorkersDocumentsListFilterRequest,
  PostBackWorkersListFilterRequest,
  PostBackWorkersWorkerCompetencesListFilterRequest,
  PostUmRolesListFilterRequest,
  PostUmUsersListFilterRequest,
  PriceCalculationInputView,
  PriceList,
  PrinterView,
  PrintingRequest,
  ProductData,
  ProductSpecificationGraph,
  ProductionConfirmationDocumentStatusView,
  ProductionLotDetailsView,
  ProductionOrderDetailsLotView,
  ProductionOrderEditView,
  ProductionOrderLotsMergeOutputView,
  ProductionOrderLotsMergeQueryView,
  ProductionOrderLotsSplitOutputView,
  ProductionOrderLotsSplitQueryView,
  ProductionOrderSavingView,
  ProductionOrderView,
  ProductionTimeEstimationItem,
  ProductionTimeEstimationResult,
  Profile,
  QualityDetailsResponse,
  RecalculateProductionOrderPayload,
  RecipeTypeView,
  RecipeUserDefinedParameterWithValuesView,
  Redirect,
  ReleaseItemsView,
  ReleasePlanItemsView,
  Rfid,
  RoleView,
  SalesEntryDocumentMetadataView,
  SalesEntryDocumentType,
  SalesEntryDocumentUpdateView,
  SalesEntryItemSavingView,
  SalesEntryItemView,
  SalesEntryItemsView,
  SalesEntryTag,
  SearchResponseCompetenceAuthority,
  SearchResponseIdWithName,
  SearchResponseString,
  SelfProfileUpdateView,
  SensorDowntimeGroupUpdateView,
  SensorDowntimeUpdateView,
  SimilarOrderInfoView,
  SimulationLotView,
  SimulationMergeView,
  SimulationQueryPayload,
  SimulationQueryView,
  SimulationView,
  SpecificationTemplate,
  SpecificationTemplateForVariantView,
  SpecificationTemplateShortView,
  SpecificationTemplateSimpleCreateView,
  SpecificationTemplateSimpleUpdateView,
  SpecificationTemplateSimpleView,
  SpecificationTemplateWithItemTypeSavingView,
  SpontaneousReleaseSavingView,
  SpontaneousSupplyCardCreateView,
  StockAmountView,
  StockInteractionView,
  StocktakingSaveView,
  SupplyCardDetailsView,
  SupplyOrderAcceptanceResolution,
  SupplyOrderBasicData,
  SupplyOrderConfirmationSavingView,
  SupplyOrderConfirmationView,
  SupplyOrderDetailsView,
  SupplyOrderDetailsView2,
  SupplyOrderInitView,
  SupplyOrderItemsSavingView,
  SupplyWarehouseStateWithPlannedDeliveriesViewRow,
  TemplateType,
  TemplateView,
  TimeRecordEventGetView,
  TimeRecordEventView,
  TopDowntimesResponse,
  TopDowntimesResponseV2,
  TopNoksResponse,
  TopNoksResponseV2,
  TotalAvailabilityQuery,
  TotalAvailabilityView,
  TraceabilityGraphPart,
  TraceabilityProductionUnitDetails,
  User,
  UserContextView,
  UserCreationView,
  UserShortView,
  UserView,
  UserView1,
  VariantAvailabilityView,
  VatRateView,
  WorkerAddView,
  WorkerAutoAssignmentDefaultsView,
  WorkerCompetenceSaveView,
  WorkerDocumentMetadataView,
  WorkerDocumentType,
  WorkerDocumentUpdateView,
  WorkerEventCalendarView,
  WorkerEventFilterView,
  WorkerEventSaveView,
  WorkerUpdateView,
  WorkerView,
  Workstation,
  WorkstationAmountReportSaveView,
  WorkstationAmountReportView,
  WorkstationBatchView,
  WorkstationDashboardView,
  WorkstationDocument,
  WorkstationObjectView,
  WorkstationSensorAmountView,
  WorkstationTodoView,
} from '../models';

export interface AcceptStocktakingRequest {
    stocktakingId: number;
}

export interface AcceptSupplyOrderRequest {
    supplyOrderId: number;
}

export interface ApplyMaterialMovementRequest {
    materialMovementApplyView: MaterialMovementApplyView;
}

export interface BackProductionOrderOrderProductionorderidDeleteRequest {
    productionOrderId: number;
}

export interface CancelLotRequest {
    productionLotId: number;
    machineIdOpt?: number;
}

export interface CancelOrderItemRequest {
    orderItemId: number;
}

export interface CancelStocktakingRequest {
    stocktakingId: number;
}

export interface CancelSupplyOrderRequest {
    supplyOrderId: number;
}

export interface ClearMeasurementRequest {
    measurementDeleteView: MeasurementDeleteView;
}

export interface ConfirmCountsheetRequest {
    countsheetId: number;
}

export interface ConfirmSingleSupplyOrderRequest {
    supplyOrderId: number;
}

export interface ConfirmSupplyOrdersRequest {
    supplyOrderConfirmationSavingView: SupplyOrderConfirmationSavingView;
}

export interface CreateMeasurementRequest {
    measurementCreateView: MeasurementCreateView;
}

export interface DeleteBackCalendarEventCalendareventidRequest {
    calendarEventId: number;
}

export interface DeleteBackContractorsContactsP1Request {
    p1: number;
}

export interface DeleteBackMachinesCalendarEventP1Request {
    p1: number;
}

export interface DeleteBackOffersDeleteP1Request {
    p1: number;
}

export interface DeleteBackOrdersAssignmentEventsP1DeleteRequest {
    p1: number;
}

export interface DeleteBackOrdersEquipmentDemandsP1DeleteRequest {
    p1: number;
}

export interface DeleteBackOrdersOtherDemandsP1DeleteRequest {
    p1: number;
}

export interface DeleteBackSalesDocumentP1DeleteRequest {
    p1: number;
}

export interface DeleteBackSpecificationsTemplateDeactivateP1Request {
    p1: number;
}

export interface DeleteBackWorkersAbsenceEventsP1DeleteRequest {
    p1: number;
}

export interface DeleteBackWorkersCompetencesP1DeleteRequest {
    p1: number;
}

export interface DeleteBackWorkersDocumentP1DeleteRequest {
    p1: number;
}

export interface DeleteBackWorkersWorkerCompetencesP1DeleteRequest {
    p1: number;
}

export interface DeleteBackWorkersWorkerP1DeactivateRequest {
    p1: number;
    deactivateUser?: boolean;
}

export interface DeleteManualBatchDowntimeRequest {
    downtimeBatchGroupId: number;
}

export interface DeleteManualDowntimeRequest {
    downtimeReportId: number;
}

export interface DeleteMeasurementRequest {
    measurementDeleteView: MeasurementDeleteView;
}

export interface DeleteUmConfigurationKeyDeleteRequest {
    path: string;
}

export interface DeleteUmRolesIdUsersUidRequest {
    id: number;
    uid: number;
}

export interface DeleteUmRolesP1Request {
    p1: number;
}

export interface DeleteUmSuUsersIdRequest {
    id: number;
}

export interface DownloadStocktakingReportRequest {
    stocktakingId: number;
}

export interface DuplicateStocktakingRequest {
    stocktakingId: number;
}

export interface DuplicateSupplyOrderRequest {
    supplyOrderId: number;
}

export interface EditSupplyOrderBasicDataRequest {
    supplyOrderId: number;
    supplyOrderBasicData: SupplyOrderBasicData;
}

export interface EndStopwatchBatchDowntimeRequest {
    batchId: number;
    batchDowntimeReportEndStopwatchView: BatchDowntimeReportEndStopwatchView;
}

export interface EndStopwatchDowntimeRequest {
    productionLotId: number;
    downtimeReportEndStopwatchView: DowntimeReportEndStopwatchView;
}

export interface EstimateProductionTimesRequest {
    productionTimeEstimationItem?: Array<ProductionTimeEstimationItem>;
}

export interface GetBackApiImportProductCodeProductcodeRequest {
    productCode: string;
    erp: ErpType;
}

export interface GetBackApiImportSimulationStatusSimulationidRequest {
    simulationId: number;
}

export interface GetBackBarcodesGenerateProductionUnitStockitemidRequest {
    stockItemId: number;
}

export interface GetBackBarcodesGenerateSupplyItemSupplycarditemidRequest {
    supplyCardItemId: number;
}

export interface GetBackBarcodesGenerateSupplySupplycardidRequest {
    supplyCardId: number;
}

export interface GetBackBarcodesResolveVariantRequest {
    ean: string;
    width: string;
}

export interface GetBackContractorsMarketingKeepersRequest {
    userIds?: Array<number>;
}

export interface GetBackContractorsP1Request {
    p1: number;
}

export interface GetBackContractorsP1AllContactsRequest {
    p1: number;
}

export interface GetBackContractorsP1BankAccountsRequest {
    p1: number;
}

export interface GetBackContractorsP1EligibleMarketingKeepersRequest {
    p1: number;
}

export interface GetBackContractorsP1PrimaryAddressRequest {
    p1: number;
}

export interface GetBackContractorsSearchNameOrExternalIdRequest {
    text: string;
    inactive: boolean;
    maxResults: number;
}

export interface GetBackContractorsTagsSearchRequest {
    text: string;
    maxResults: number;
    contractorTagIds?: Array<number>;
}

export interface GetBackContractorsTagsWithIdsSearchRequest {
    maxResults: number;
    text?: string;
    contractorTagIds?: Array<number>;
}

export interface GetBackDocumentsBatchBatchidConfirmationsRequest {
    batchId: number;
}

export interface GetBackDocumentsDocumentStatusP1Request {
    p1: number;
}

export interface GetBackDocumentsOfferOfferidP1PdfRequest {
    offerId: number;
    p1: number;
    showSummary: boolean;
    showDiscount: boolean;
    showTechnology: boolean;
    templateId?: number;
}

export interface GetBackDocumentsOfferOfferidPdfRequest {
    offerId: number;
    showSummary: boolean;
    showDiscount: boolean;
    showTechnology: boolean;
    templateId?: number;
}

export interface GetBackDocumentsOrderOrderidP1PdfRequest {
    orderId: number;
    p1: number;
    showSummary: boolean;
    showDiscount: boolean;
    showTechnology: boolean;
    templateId?: number;
}

export interface GetBackDocumentsOrderOrderidPdfRequest {
    orderId: number;
    showSummary: boolean;
    showDiscount: boolean;
    showTechnology: boolean;
    templateId?: number;
}

export interface GetBackDocumentsPrinterProductionlotidLabelViewRequest {
    productionLotId: number;
}

export interface GetBackDocumentsPrinterSearchPrintersRequest {
    text: string;
    maxResults: number;
}

export interface GetBackDocumentsPrinterSearchTemplatesRequest {
    text: string;
    maxResults: number;
}

export interface GetBackDocumentsPrinterSearchTemplatesOfTypeP1Request {
    p1: TemplateType;
    text: string;
    maxResults: number;
}

export interface GetBackDocumentsProductionLotProductionlotidConfirmationsRequest {
    productionLotId: number;
}

export interface GetBackEstimationMachinesP1Request {
    p1: number;
}

export interface GetBackEstimationMachinesWithEstimationsP1Request {
    p1: number;
}

export interface GetBackItemsDeactivateP1Request {
    p1: number;
}

export interface GetBackItemsItemHistoryP1Request {
    p1: number;
}

export interface GetBackItemsItemP1Request {
    p1: number;
}

export interface GetBackItemsP1ParameterValuesRequest {
    p1: number;
    text: string;
    maxResults: number;
}

export interface GetBackItemsP1VariantsRequest {
    p1: number;
}

export interface GetBackItemsPriceListsSaveRequest {
    priceList: PriceList;
}

export interface GetBackItemsPropertyTypesSearchRequest {
    text: string;
    maxResults: number;
}

export interface GetBackItemsPropertyTypesSearchSliceRequest {
    text: string;
    maxResults: number;
    skip: number;
}

export interface GetBackItemsReactivateP1Request {
    p1: number;
}

export interface GetBackItemsSearchItemTypeNamesRequest {
    text: string;
    maxResults: number;
}

export interface GetBackItemsSearchTagsRequest {
    text: string;
    maxResults: number;
}

export interface GetBackItemsSearchTagsActiveRequest {
    text: string;
    maxResults: number;
}

export interface GetBackItemsServicesIdRequest {
    id: number;
}

export interface GetBackItemsVariantP1Request {
    p1: number;
}

export interface GetBackItemsVariantsSearchRequest {
    text: string;
    maxResults: number;
    tag?: Array<string>;
}

export interface GetBackItemsVariantsVariantsAvailableForWasteRequest {
    text: string;
    maxResults: number;
}

export interface GetBackItemsVariantsVariantsWithExternalIdsRequest {
    text: string;
    maxResults: number;
}

export interface GetBackMachinesCalendarMachineidRequest {
    machineId: number;
}

export interface GetBackMachinesMachineMachineidRequest {
    machineId: number;
}

export interface GetBackMachinesMachineMachineidPermissionsRequest {
    machineId: number;
}

export interface GetBackMachinesMachineMachineidStateRequest {
    machineId: number;
}

export interface GetBackMachinesMachineMachineidStateSubscribeHeadRequest {
    machineId: number;
}

export interface GetBackMachinesMachineMachineidStateTransitionAggregationRequest {
    machineId: number;
    from: string;
    resolution: number;
    to?: string;
}

export interface GetBackMachinesMachineStateTransitionMachineidRequest {
    machineId: number;
    from?: string;
    to?: string;
}

export interface GetBackMachinesMachinesRoleRoleidRequest {
    roleId: number;
}

export interface GetBackMachinesSearchFeaturesRequest {
    key: string;
    text: string;
    maxResults: number;
}

export interface GetBackMarketingrulesContractorP1Request {
    p1: number;
}

export interface GetBackMeasurementReportsAllGroupNamesProductionlotidRequest {
    productionLotId: number;
}

export interface GetBackMeasurementReportsByProductionLotProductionlotidRequest {
    productionLotId: number;
}

export interface GetBackOffersAcceptP1Request {
    p1: number;
}

export interface GetBackOffersCancelP1Request {
    p1: number;
}

export interface GetBackOffersCloneP1Request {
    p1: number;
}

export interface GetBackOffersItemAllFromOfferP1Request {
    p1: number;
}

export interface GetBackOffersItemViewOfferitemidRequest {
    offerItemId: number;
}

export interface GetBackOffersMarkAsSentP1Request {
    p1: number;
}

export interface GetBackOffersP1AvailableCurrenciesRequest {
    p1: number;
}

export interface GetBackOffersViewP1Request {
    p1: number;
}

export interface GetBackOffersViewWithEntryLoggingP1Request {
    p1: number;
}

export interface GetBackOrdersAssignmentEventsP1Request {
    p1: number;
}

export interface GetBackOrdersAttributesSearchLabelRequest {
    text: string;
    maxResults: number;
}

export interface GetBackOrdersByItemIdRequest {
    id: number;
}

export interface GetBackOrdersByOfferOfferidRequest {
    offerId: number;
}

export interface GetBackOrdersClientsIdRequest {
    id: number;
}

export interface GetBackOrdersEquipmentDemandsP1Request {
    p1: number;
}

export interface GetBackOrdersGetIdRequest {
    id: number;
}

export interface GetBackOrdersIdAssignmentsRequest {
    id: number;
}

export interface GetBackOrdersIdOrderResponseRequest {
    id: number;
}

export interface GetBackOrdersItemGetOrderitemidRequest {
    orderItemId: number;
}

export interface GetBackOrdersOrderIdCloneRequest {
    id: number;
}

export interface GetBackOrdersOtherDemandsEntryP1Request {
    p1: number;
}

export interface GetBackOrdersOtherDemandsP1Request {
    p1: number;
}

export interface GetBackOrdersOtherDemandsUserP1Request {
    p1: number;
}

export interface GetBackOrdersViewIdRequest {
    id: number;
}

export interface GetBackPlacesSearchRequest {
    text: string;
    maxResults: number;
}

export interface GetBackPresentationsLotsProductionlotidRequest {
    productionLotId: number;
}

export interface GetBackProductionLotAcceptProductionlotidRequest {
    productionLotId: number;
}

export interface GetBackProductionLotAutoAssignWorkersHistoricalParallelPairsRequest {
    machineAreaId: number;
    lookbackMonths: number;
    minOverlapsForPairPerMonth?: number;
}

export interface GetBackProductionLotProductionlotidDocumentsRequest {
    productionLotId: number;
}

export interface GetBackProductionLotProductionlotidDocumentsFileidRequest {
    productionLotId: number;
    fileId: number;
}

export interface GetBackProductionLotUnacceptProductionlotidRequest {
    productionLotId: number;
}

export interface GetBackProductionOrderCheckOrderItemProductionLotsUnspecifiedSalesentryitemidRequest {
    salesEntryItemId: number;
}

export interface GetBackProductionOrderDetailsProductionorderidRequest {
    productionOrderId: number;
}

export interface GetBackProductionOrderDetailsProductionorderidLotsRequest {
    productionOrderId: number;
}

export interface GetBackProductionOrderItemFindP1Request {
    p1: number;
}

export interface GetBackQsCardSupplycardidDetailsRequest {
    supplyCardId: number;
}

export interface GetBackReleasesItemsReleaseidRequest {
    releaseId: number;
}

export interface GetBackReleasesPlanItemsReleaseplanidRequest {
    releasePlanId: number;
}

export interface GetBackReleasesPlannedInitReleaseplanidRequest {
    releasePlanId: number;
}

export interface GetBackReportsWorkstationReportsAmountBatchBatchidRequest {
    batchId: number;
}

export interface GetBackReportsWorkstationReportsAmountProductionlotidRequest {
    productionLotId: number;
}

export interface GetBackReportsWorkstationReportsAmountSensorProductionlotidHeadRequest {
    productionLotId: number;
}

export interface GetBackReportsWorkstationReportsBomProductionLotProductionlotidRequest {
    productionLotId: number;
}

export interface GetBackReportsWorkstationReportsCommentBatchGetBatchidRequest {
    batchId: number;
}

export interface GetBackReportsWorkstationReportsCommentGetProductionlotidRequest {
    productionLotId: number;
}

export interface GetBackReportsWorkstationReportsDowntimeBatchBatchidRequest {
    batchId: number;
}

export interface GetBackReportsWorkstationReportsDowntimeBatchBatchidActiveRequest {
    batchId: number;
}

export interface GetBackReportsWorkstationReportsDowntimeLotProductionlotidRequest {
    productionLotId: number;
}

export interface GetBackReportsWorkstationReportsLoadProductionLotProductionlotidRequest {
    productionLotId: number;
}

export interface GetBackReportsWorkstationReportsPossibleProductsProductionlotidRequest {
    productionLotId: number;
}

export interface GetBackReportsWorkstationReportsTimesProductionlotidHeadRequest {
    productionLotId: number;
}

export interface GetBackReportsWorkstationsByBatchBatchidRequest {
    batchId: number;
}

export interface GetBackReportsWorkstationsByLotProductionlotidRequest {
    productionLotId: number;
}

export interface GetBackReportsWorkstationsByMachineMachineidRequest {
    machineId: number;
    onlyMyTasks?: boolean;
}

export interface GetBackSalesDocumentP1Request {
    p1: number;
}

export interface GetBackSalesDocumentP1ContentRequest {
    p1: number;
}

export interface GetBackSalesDocumentSummaryExpensesSalesentryidRequest {
    salesEntryId: number;
}

export interface GetBackSalesEligibleResponsibleUsersRequest {
    userIds?: Array<number>;
}

export interface GetBackSalesSalesentryidItemsRequest {
    salesEntryId: number;
}

export interface GetBackSalesTagsSearchRequest {
    text: string;
    maxResults: number;
}

export interface GetBackSpecificationsCardsParametersLabelsRequest {
    text: string;
    maxResults: number;
}

export interface GetBackSpecificationsConfirmationTextRequest {
    text: string;
    maxResults: number;
}

export interface GetBackSpecificationsOfTypeP1Request {
    p1: number;
}

export interface GetBackSpecificationsOfVariantP1Request {
    p1: number;
}

export interface GetBackSpecificationsRecipeHistoryP1Request {
    p1: number;
}

export interface GetBackSpecificationsRecipePrintingDosageRollersRequest {
    text: string;
    maxResults: number;
}

export interface GetBackSpecificationsRecipePrintingHalftoneShapesRequest {
    text: string;
    maxResults: number;
}

export interface GetBackSpecificationsRecipePrintingLacqueringRequest {
    text: string;
    maxResults: number;
}

export interface GetBackSpecificationsRecipePrintingLaminationRequest {
    text: string;
    maxResults: number;
}

export interface GetBackSpecificationsRecipePrintingPaintRequest {
    text: string;
    maxResults: number;
}

export interface GetBackSpecificationsRecipePrintingPaperRequest {
    text: string;
    maxResults: number;
}

export interface GetBackSpecificationsRecipePrintingPlateMaterialsRequest {
    text: string;
    maxResults: number;
}

export interface GetBackSpecificationsRecipePrintingReliefPlatesRequest {
    text: string;
    maxResults: number;
}

export interface GetBackSpecificationsRecipePrintingRulingRequest {
    text: string;
    maxResults: number;
}

export interface GetBackSpecificationsRecipePrintingStampingRequest {
    text: string;
    maxResults: number;
}

export interface GetBackSpecificationsRecipeSummaryPartsRequest {
    text: string;
    maxResults: number;
}

export interface GetBackSpecificationsSimpleItemtypeidRequest {
    itemTypeId: number;
}

export interface GetBackSpecificationsSpecificationsActiveRequest {
    text: string;
    maxResults: number;
}

export interface GetBackSpecificationsSpecificationsAllRequest {
    text: string;
    maxResults: number;
}

export interface GetBackSpecificationsStandardParametersRequest {
    text: string;
    maxResults: number;
}

export interface GetBackSpecificationsStandardsRequest {
    text: string;
    maxResults: number;
}

export interface GetBackSpecificationsTemplateP1Request {
    p1: number;
}

export interface GetBackSpecificationsUnitsRequest {
    text: string;
}

export interface GetBackStocksDemandStockinteractionidRequest {
    stockInteractionId: number;
}

export interface GetBackStocksDemandStockinteractionidFulfillmentsRequest {
    stockInteractionId: number;
}

export interface GetBackStocksStockAmountsItemtypevariantidNotInPlaceidTimeframeRequest {
    itemTypeVariantId: number;
    placeId: number;
    from: string;
    to: string;
}

export interface GetBackStocksStockAmountsItemtypevariantidPlaceidTimeframeRequest {
    itemTypeVariantId: number;
    placeId: number;
    from: string;
    to: string;
}

export interface GetBackStocksStockAmountsP1TimeframeRequest {
    p1: number;
    from: string;
    to: string;
}

export interface GetBackStocksVariantAvailabilityRequest {
    variantId: number;
    futureDate: string;
}

export interface GetBackStocksVariantAvailabilityStockinteractionidRequest {
    stockInteractionId: number;
}

export interface GetBackSupplyOrderDetailsSupplyorderidRequest {
    supplyOrderId: number;
}

export interface GetBackSupplyPlannedSupplyorderidRequest {
    supplyOrderId: number;
}

export interface GetBackTraceabilityProductionUnitDetailsProductionunitidRequest {
    productionUnitId: number;
}

export interface GetBackWorkersAbsenceEventsP1Request {
    p1: number;
}

export interface GetBackWorkersCompetencesRequest {
    name: string;
}

export interface GetBackWorkersCompetencesAuthoritySearchRequest {
    text: string;
    maxResults: number;
}

export interface GetBackWorkersCompetencesP1Request {
    p1: number;
}

export interface GetBackWorkersDocumentP1Request {
    p1: number;
}

export interface GetBackWorkersDocumentP1ContentRequest {
    p1: number;
}

export interface GetBackWorkersWorkerP1Request {
    p1: number;
}

export interface GetExpectedTotalAvailabilityRequest {
    totalAvailabilityQuery: TotalAvailabilityQuery;
}

export interface GetInitStocktakingCountsheetViewRequest {
    requestBody?: Array<number>;
}

export interface GetMaterialMovementItemsRequest {
    materialMovementId: number;
}

export interface GetPlaceLabelsRequest {
    placeId: number;
    variantId: number;
}

export interface GetSupplyOrderConfirmationViewRequest {
    supplyOrderItemsSavingView: SupplyOrderItemsSavingView;
}

export interface GetSupplyOrderItemsRequest {
    supplyOrderId: number;
}

export interface GetSupplyWarehouseStateRequest {
    planningWindowDays: number;
}

export interface GetUmConfigurationKeyRequest {
    path: string;
}

export interface GetUmPermissionsIdRolesRequest {
    id: string;
}

export interface GetUmRolesIdPermissionsRequest {
    id: number;
}

export interface GetUmRolesIdUsersRequest {
    id: number;
}

export interface GetUmRolesP1Request {
    p1: number;
}

export interface GetUmRolesSelectRequest {
    requestBody?: Array<number>;
}

export interface GetUmUsersByIdsRequest {
    ids?: Array<number>;
}

export interface GetUmUsersIdRolesRequest {
    id: number;
}

export interface GetUmUsersUseridRequest {
    userId: number;
}

export interface GetUmUsersUseridViewRequest {
    userId: number;
}

export interface ImportProductionOrderRequest {
    apiProductionOrderImportView: ApiProductionOrderImportView;
}

export interface LotFinishTaskRequest {
    productionLotId: number;
    finishTaskView: FinishTaskView;
}

export interface MarkSupplyOrderInProgressRequest {
    supplyOrderId: number;
}

export interface OrdersEndpointsConfirmRequest {
    salesEntryId: number;
}

export interface PatchBackItemsTagsDeactivateP1Request {
    p1: number;
}

export interface PostBackApiAutoplanRequest {
    kanbanFilterDefinition: KanbanFilterDefinition;
}

export interface PostBackApiSynchronizeLotLotidRequest {
    lotId: number;
}

export interface PostBackBarcodesResolveRequest {
    barcodesView: BarcodesView;
}

export interface PostBackBarcodesResolveLegacyRequest {
    barcodeScanContext: BarcodeScanContext;
}

export interface PostBackCalculationsCogCountFitRequest {
    body: number;
}

export interface PostBackCalculationsCostEstimateRequest {
    priceCalculationInputView: PriceCalculationInputView;
}

export interface PostBackCalculationsPaperWidthFitRequest {
    body: number;
}

export interface PostBackCalculationsPunchingDiesSearchRequest {
    text: string;
    maxResults: number;
    labelDimensionsView: LabelDimensionsView;
}

export interface PostBackCalendarAssigneesRequest {
    id: number;
    calendarAssigneesSaveView: CalendarAssigneesSaveView;
}

export interface PostBackCalendarAssigneesCalendareventidRequest {
    calendarEventId: number;
    calendarAssigneeRequestView: CalendarAssigneeRequestView;
}

export interface PostBackCalendarMonthAssigneesRequest {
    calendarAssigneeMultipleRequestView: CalendarAssigneeMultipleRequestView;
}

export interface PostBackContractorsContactsListFilterOperationRequest {
    postBackContractorsContactsListFilterRequest: PostBackContractorsContactsListFilterRequest;
}

export interface PostBackContractorsContractoridCommentSaveRequest {
    contractorId: number;
    contractorCommentUpdateView: ContractorCommentUpdateView;
}

export interface PostBackContractorsContractoridMarketingKeeperSaveRequest {
    contractorId: number;
    marketingKeeperUpdateView: MarketingKeeperUpdateView;
}

export interface PostBackContractorsFetchDetailsRequest {
    taxId: string;
}

export interface PostBackContractorsListFilterOperationRequest {
    postBackContractorsListFilterRequest: PostBackContractorsListFilterRequest;
}

export interface PostBackContractorsMarketingKeepersListFilterOperationRequest {
    postBackContractorsMarketingKeepersListFilterRequest: PostBackContractorsMarketingKeepersListFilterRequest;
}

export interface PostBackContractorsP1ContactsSaveRequest {
    p1: number;
    contact: Contact;
}

export interface PostBackContractorsSearchMultipleRequest {
    requestBody?: Array<number>;
}

export interface PostBackDocumentsDocumentStatusListFilterOperationRequest {
    postBackDocumentsDocumentStatusListFilterRequest: PostBackDocumentsDocumentStatusListFilterRequest;
}

export interface PostBackDocumentsPrinterPrintLabelsRequest {
    printingRequest: PrintingRequest;
}

export interface PostBackErpSynchronizationStatusesFilterOperationRequest {
    postBackErpSynchronizationStatusesFilterRequest: PostBackErpSynchronizationStatusesFilterRequest;
}

export interface PostBackItemsItemSaveBasicInfoRequest {
    itemTypeBasicInfoSaveView: ItemTypeBasicInfoSaveView;
}

export interface PostBackItemsItemSavePricingItemtypeidRequest {
    itemTypeId: number;
    itemTypePricingSaveView: ItemTypePricingSaveView;
}

export interface PostBackItemsItemTypeTagsListFilterOperationRequest {
    postBackItemsItemTypeTagsListFilterRequest: PostBackItemsItemTypeTagsListFilterRequest;
}

export interface PostBackItemsMultipleRequest {
    requestBody?: Array<number>;
}

export interface PostBackItemsPriceListsFilterOperationRequest {
    postBackItemsPriceListsFilterRequest: PostBackItemsPriceListsFilterRequest;
}

export interface PostBackItemsPropertySetsListFilterOperationRequest {
    postBackItemsPropertySetsListFilterRequest: PostBackItemsPropertySetsListFilterRequest;
}

export interface PostBackItemsPropertyTypesFilterOperationRequest {
    postBackItemsPropertyTypesFilterRequest: PostBackItemsPropertyTypesFilterRequest;
}

export interface PostBackItemsPropertyTypesSaveRequest {
    itemTypePropertyType: ItemTypePropertyType;
}

export interface PostBackItemsSaveRequest {
    itemTypeSavingView: ItemTypeSavingView;
}

export interface PostBackItemsSavePropertiesItemtypeidRequest {
    itemTypeId: number;
    itemTypePropertySaveView?: Array<ItemTypePropertySaveView>;
}

export interface PostBackItemsSearchItemTypesRequest {
    itemTypeSearchCriteriaView: ItemTypeSearchCriteriaView;
}

export interface PostBackItemsServicesRequest {
    itemTypeServiceSavingView: ItemTypeServiceSavingView;
}

export interface PostBackItemsTagsSaveRequest {
    itemTypeTag: ItemTypeTag;
}

export interface PostBackItemsVariantsRequest {
    contextualItemTypeVariant: ContextualItemTypeVariant;
}

export interface PostBackItemsVariantsFilterOperationRequest {
    postBackItemsVariantsFilterRequest: PostBackItemsVariantsFilterRequest;
}

export interface PostBackItemsVariantsMultipleRequest {
    requestBody?: Array<number>;
}

export interface PostBackItemsVariantsPropertySetFilterOperationRequest {
    postBackItemsVariantsPropertySetFilterRequest: PostBackItemsVariantsPropertySetFilterRequest;
}

export interface PostBackMachineAreasListFilterOperationRequest {
    postBackMachineAreasListFilterRequest: PostBackMachineAreasListFilterRequest;
}

export interface PostBackMachinesCalendarEventP1Request {
    p1: number;
    calendarEventView: CalendarEventView;
}

export interface PostBackMachinesListFilterOperationRequest {
    postBackMachinesListFilterRequest: PostBackMachinesListFilterRequest;
}

export interface PostBackMachinesMachineRequest {
    machineSaveView: MachineSaveView;
}

export interface PostBackMachinesMachinePermissionsRequest {
    machinePermissionsView: MachinePermissionsView;
}

export interface PostBackMachinesMachinesRoleRoleidRequest {
    roleId: number;
    requestBody?: Array<number>;
}

export interface PostBackMarketingrulesListFilterOperationRequest {
    postBackMarketingrulesListFilterRequest: PostBackMarketingrulesListFilterRequest;
}

export interface PostBackMaterialMovementsListFilterOperationRequest {
    postBackMaterialMovementsListFilterRequest: PostBackMaterialMovementsListFilterRequest;
}

export interface PostBackMeasurementReportsByProductionLotWithFilterRequest {
    measurementReportFilter: MeasurementReportFilter;
}

export interface PostBackMeasurementsMeasurementDevicesFilterOperationRequest {
    postBackMeasurementsMeasurementDevicesFilterRequest: PostBackMeasurementsMeasurementDevicesFilterRequest;
}

export interface PostBackOffersItemCloneRequest {
    salesEntryItemView: SalesEntryItemView;
}

export interface PostBackOffersListFilterOperationRequest {
    postBackOffersListFilterRequest: PostBackOffersListFilterRequest;
}

export interface PostBackOffersSalesentryidItemsSaveRequest {
    salesEntryId: number;
    salesEntryItemSavingView?: Array<SalesEntryItemSavingView>;
}

export interface PostBackOffersSaveRequest {
    offerSaveView: OfferSaveView;
}

export interface PostBackOffersSaveWithViewRequest {
    offerSaveView: OfferSaveView;
}

export interface PostBackOffersUpdateAndAcceptRequest {
    offerSaveView: OfferSaveView;
}

export interface PostBackOrdersAssignmentEventsSaveRequest {
    orderAssignmentEventSaveView: OrderAssignmentEventSaveView;
}

export interface PostBackOrdersDraftRequest {
    orderDraft: OrderDraft;
}

export interface PostBackOrdersDraftAddReturningOrderRequest {
    orderDraft: OrderDraft;
}

export interface PostBackOrdersEquipmentDemandsListFilterOperationRequest {
    postBackOrdersEquipmentDemandsListFilterRequest: PostBackOrdersEquipmentDemandsListFilterRequest;
}

export interface PostBackOrdersEquipmentDemandsSaveRequest {
    equipmentDemandSavingView: EquipmentDemandSavingView;
}

export interface PostBackOrdersExternalRequest {
    externalOrder: ExternalOrder;
}

export interface PostBackOrdersFromOfferRequest {
    offerId: number;
}

export interface PostBackOrdersFromOfferCreateRequest {
    offerId: number;
}

export interface PostBackOrdersFromOfferSaveRequest {
    orderFromOffer: OrderFromOffer;
}

export interface PostBackOrdersIdAssignmentsRequest {
    id: number;
    orderAssignmentsSaveView: OrderAssignmentsSaveView;
}

export interface PostBackOrdersItemCloneRequest {
    salesEntryItemView: SalesEntryItemView;
}

export interface PostBackOrdersItemIdConfirmShippedRequest {
    id: number;
}

export interface PostBackOrdersListFilterOperationRequest {
    postBackOrdersListFilterRequest: PostBackOrdersListFilterRequest;
}

export interface PostBackOrdersOrderIdCancelRequest {
    id: number;
}

export interface PostBackOrdersOrderIdSetBudgetRequest {
    id: number;
    body?: number;
}

export interface PostBackOrdersOrderSalesentryidItemsSaveRequest {
    salesEntryId: number;
    draft?: boolean;
    salesEntryItemSavingView?: Array<SalesEntryItemSavingView>;
}

export interface PostBackOrdersOtherDemandsListFilterOperationRequest {
    postBackOrdersOtherDemandsListFilterRequest: PostBackOrdersOtherDemandsListFilterRequest;
}

export interface PostBackOrdersOtherDemandsSaveRequest {
    otherDemandSavingView: OtherDemandSavingView;
}

export interface PostBackOrdersSaveRequest {
    orderSavingView: OrderSavingView;
}

export interface PostBackOrdersSimilarRequest {
    externalOrder: ExternalOrder;
}

export interface PostBackOrdersSplitRequest {
    externalOrder: ExternalOrder;
}

export interface PostBackOrdersTimeRecordsRequest {
    timeRecordEventGetView: TimeRecordEventGetView;
}

export interface PostBackOrdersV2SaveRequest {
    orderSavingViewV2: OrderSavingViewV2;
}

export interface PostBackPresentationsContractorExternalSaveRequest {
    externalContractorSavingView: ExternalContractorSavingView;
}

export interface PostBackPresentationsFastStatusTransitionOrderCompleteSalesentryidRequest {
    salesEntryId: number;
}

export interface PostBackPresentationsFastStatusTransitionOrderStartSalesentryidRequest {
    salesEntryId: number;
}

export interface PostBackPresentationsOrderItemsItemsGroupListFilterOperationRequest {
    postBackPresentationsOrderItemsItemsGroupListFilterRequest: PostBackPresentationsOrderItemsItemsGroupListFilterRequest;
}

export interface PostBackPresentationsProductionLotPeriodsGroupListFilterOperationRequest {
    postBackPresentationsProductionLotPeriodsGroupListFilterRequest: PostBackPresentationsProductionLotPeriodsGroupListFilterRequest;
}

export interface PostBackProductcatalogListFilterOperationRequest {
    postBackProductcatalogListFilterRequest: PostBackProductcatalogListFilterRequest;
}

export interface PostBackProductionBoardActionsProductionLotProductionlotidAcceptRequest {
    productionLotId: number;
}

export interface PostBackProductionBoardActionsProductionLotProductionlotidUnacceptRequest {
    productionLotId: number;
}

export interface PostBackProductionLotAutoAssignWorkersRequest {
    autoAssignWorkersRequest: AutoAssignWorkersRequest;
}

export interface PostBackProductionLotAutoAssignWorkersOnAreasRequest {
    autoAssignWorkersOnAreasRequest: AutoAssignWorkersOnAreasRequest;
}

export interface PostBackProductionLotCancelRequest {
    cancelProductionLots: CancelProductionLots;
}

export interface PostBackProductionLotCancelColumnRequest {
    cancelProductionLotsInColumn: CancelProductionLotsInColumn;
}

export interface PostBackProductionLotProductionlotidCancelLegacyRequest {
    productionLotId: number;
    machineIdOpt?: number;
}

export interface PostBackProductionOrderCalculateTimeItemtypevariantidRequest {
    itemTypeVariantId: number;
    body: number;
}

export interface PostBackProductionOrderCreateQuickRequest {
    draft: boolean;
    simulationQueryPayload: SimulationQueryPayload;
}

export interface PostBackProductionOrderOrderCreateRequest {
    draft: boolean;
    productionOrderSavingView: ProductionOrderSavingView;
}

export interface PostBackProductionOrderOrderProductionorderidCancelRequest {
    productionOrderId: number;
}

export interface PostBackProductionOrderOrderProductionorderidEditRequest {
    productionOrderId: number;
    productionOrderEditView: ProductionOrderEditView;
}

export interface PostBackProductionOrderSimulationGetRequest {
    simulationQueryPayload: SimulationQueryPayload;
}

export interface PostBackProductionOrderSimulationGetProductionorderidRequest {
    productionOrderId: number;
}

export interface PostBackProductionOrderSimulationQueryRequest {
    simulationQueryPayload: SimulationQueryPayload;
}

export interface PostBackProductionOrdersCreatorListFilterOperationRequest {
    postBackProductionOrdersCreatorListFilterRequest: PostBackProductionOrdersCreatorListFilterRequest;
}

export interface PostBackProductionOrdersLegacyListFilterOperationRequest {
    postBackProductionOrdersLegacyListFilterRequest: PostBackProductionOrdersLegacyListFilterRequest;
}

export interface PostBackProductionOrdersLegacyLotsFilterOperationRequest {
    postBackProductionOrdersLegacyLotsFilterRequest: PostBackProductionOrdersLegacyLotsFilterRequest;
}

export interface PostBackProductionOrdersListFilterOperationRequest {
    postBackProductionOrdersListFilterRequest: PostBackProductionOrdersListFilterRequest;
}

export interface PostBackProductionOrdersLotRawMaterialsUsageListFilterOperationRequest {
    postBackProductionOrdersLotRawMaterialsUsageListFilterRequest: PostBackProductionOrdersLotRawMaterialsUsageListFilterRequest;
}

export interface PostBackProductionOrdersLotsListFilterOperationRequest {
    postBackProductionOrdersLotsListFilterRequest: PostBackProductionOrdersLotsListFilterRequest;
}

export interface PostBackProductionOrdersOrderDemandsListFilterOperationRequest {
    postBackProductionOrdersOrderDemandsListFilterRequest: PostBackProductionOrdersOrderDemandsListFilterRequest;
}

export interface PostBackProductionOrdersProductionOrderLotsListFilterOperationRequest {
    postBackProductionOrdersProductionOrderLotsListFilterRequest: PostBackProductionOrdersProductionOrderLotsListFilterRequest;
}

export interface PostBackProductionOrdersRawMaterialsUsageListFilterOperationRequest {
    postBackProductionOrdersRawMaterialsUsageListFilterRequest: PostBackProductionOrdersRawMaterialsUsageListFilterRequest;
}

export interface PostBackProductionOrdersWarehouseStateListFilterOperationRequest {
    postBackProductionOrdersWarehouseStateListFilterRequest: PostBackProductionOrdersWarehouseStateListFilterRequest;
}

export interface PostBackProductionOrdersWarehouseToProductionListFilterOperationRequest {
    postBackProductionOrdersWarehouseToProductionListFilterRequest: PostBackProductionOrdersWarehouseToProductionListFilterRequest;
}

export interface PostBackProductionOrdersWorktimeListFilterOperationRequest {
    postBackProductionOrdersWorktimeListFilterRequest: PostBackProductionOrdersWorktimeListFilterRequest;
}

export interface PostBackProductionSpecificationTagsListFilterOperationRequest {
    postBackProductionSpecificationTagsListFilterRequest: PostBackProductionSpecificationTagsListFilterRequest;
}

export interface PostBackPushCancelDocumenttypeTargetidRequest {
    documentType: DocumentTypes;
    targetId: number;
}

export interface PostBackPushForceDocumenttypeTargetidRequest {
    documentType: DocumentTypes;
    targetId: number;
}

export interface PostBackPushListFilterOperationRequest {
    postBackPushListFilterRequest: PostBackPushListFilterRequest;
}

export interface PostBackQsCardListFilterOperationRequest {
    postBackQsCardListFilterRequest: PostBackQsCardListFilterRequest;
}

export interface PostBackQsPlannedSupplyCardCreateRequest {
    plannedSupplyCardCreateView: PlannedSupplyCardCreateView;
}

export interface PostBackQsSpontaneousSupplyCardCreateRequest {
    spontaneousSupplyCardCreateView: SpontaneousSupplyCardCreateView;
}

export interface PostBackReleasesListFilterOperationRequest {
    postBackReleasesListFilterRequest: PostBackReleasesListFilterRequest;
}

export interface PostBackReleasesPlanListFilterOperationRequest {
    postBackReleasesPlanListFilterRequest: PostBackReleasesPlanListFilterRequest;
}

export interface PostBackReportsDowntimeReasonsFilterOperationRequest {
    postBackReportsDowntimeReasonsFilterRequest: PostBackReportsDowntimeReasonsFilterRequest;
}

export interface PostBackReportsGroupLeaderDashboardAbsenteesRequest {
    groupLeaderDashboardFilters: GroupLeaderDashboardFilters;
}

export interface PostBackReportsGroupLeaderDashboardAvailabilityRequest {
    groupLeaderDashboardFilters: GroupLeaderDashboardFilters;
}

export interface PostBackReportsGroupLeaderDashboardDowntimesOverTimeRequest {
    downtimesOverTimeRequest: DowntimesOverTimeRequest;
}

export interface PostBackReportsGroupLeaderDashboardLatestEventsRequest {
    groupLeaderDashboardFilters: GroupLeaderDashboardFilters;
}

export interface PostBackReportsGroupLeaderDashboardNoksOverTimeRequest {
    noksOverTimeRequest: NoksOverTimeRequest;
}

export interface PostBackReportsGroupLeaderDashboardOeeRequest {
    groupLeaderDashboardFilters: GroupLeaderDashboardFilters;
}

export interface PostBackReportsGroupLeaderDashboardPerformanceRequest {
    groupLeaderDashboardFilters: GroupLeaderDashboardFilters;
}

export interface PostBackReportsGroupLeaderDashboardQualityRequest {
    groupLeaderDashboardFilters: GroupLeaderDashboardFilters;
}

export interface PostBackReportsGroupLeaderDashboardTopDowntimesRequest {
    groupLeaderDashboardFilters: GroupLeaderDashboardFilters;
}

export interface PostBackReportsGroupLeaderDashboardTopNoksRequest {
    groupLeaderDashboardFilters: GroupLeaderDashboardFilters;
}

export interface PostBackReportsGroupLeaderDashboardV2DowntimesOverTimeRequest {
    downtimesOverTimeRequestV2: DowntimesOverTimeRequestV2;
}

export interface PostBackReportsGroupLeaderDashboardV2NoksOverTimeRequest {
    noksOverTimeRequestV2: NoksOverTimeRequestV2;
}

export interface PostBackReportsGroupLeaderDashboardV2TopDowntimesRequest {
    groupLeaderDashboardFilters: GroupLeaderDashboardFilters;
}

export interface PostBackReportsGroupLeaderDashboardV2TopNoksRequest {
    groupLeaderDashboardFilters: GroupLeaderDashboardFilters;
}

export interface PostBackReportsLoadCardsListFilterOperationRequest {
    postBackReportsLoadCardsListFilterRequest: PostBackReportsLoadCardsListFilterRequest;
}

export interface PostBackReportsWasteCausesFilterRequest {
    postBackMeasurementsMeasurementDevicesFilterRequest: PostBackMeasurementsMeasurementDevicesFilterRequest;
}

export interface PostBackReportsWorkstationReportsAmountProductionlotidRequest {
    productionLotId: number;
    workstationAmountReportSaveView: WorkstationAmountReportSaveView;
}

export interface PostBackReportsWorkstationReportsCommentSaveForBatchBatchidRequest {
    batchId: number;
    commentView: CommentView;
}

export interface PostBackReportsWorkstationReportsCommentSaveProductionlotidRequest {
    productionLotId: number;
    commentView: CommentView;
}

export interface PostBackReportsWorkstationReportsDowntimeBatchUpdateFromSensorRequest {
    sensorDowntimeGroupUpdateView: SensorDowntimeGroupUpdateView;
}

export interface PostBackReportsWorkstationReportsDowntimeSaveProductionlotidStartEndRequest {
    productionLotId: number;
    downtimeReportStartEndSaveView: DowntimeReportStartEndSaveView;
}

export interface PostBackReportsWorkstationReportsDowntimeUpdateFromSensorRequest {
    sensorDowntimeUpdateView: SensorDowntimeUpdateView;
}

export interface PostBackReportsWorkstationReportsLoadUpdateRequest {
    loadReportSaveView: LoadReportSaveView;
}

export interface PostBackReportsWorkstationsByBatchBatchidAbortRequest {
    batchId: number;
}

export interface PostBackReportsWorkstationsByBatchBatchidStartRequest {
    batchId: number;
    startDateTime?: string;
}

export interface PostBackReportsWorkstationsByLotBatchidFinishRequest {
    batchId: number;
    startDateTime?: string;
    endDateTime?: string;
    createNewLotForUnfinished?: boolean;
}

export interface PostBackReportsWorkstationsByLotProductionlotidAbortRequest {
    productionLotId: number;
}

export interface PostBackReportsWorkstationsByLotProductionlotidFinishRequest {
    productionLotId: number;
    startDateTime?: string;
    endDateTime?: string;
    createNewLotForUnfinished?: boolean;
}

export interface PostBackReportsWorkstationsByLotProductionlotidStartRequest {
    productionLotId: number;
    startDateTime?: string;
}

export interface PostBackReportsWorkstationsMachineMachineidSetBreakdownRequest {
    machineId: number;
    body: string;
}

export interface PostBackReportsWorkstationsMachineMachineidSetIdleRequest {
    machineId: number;
    machineStateChangeData: MachineStateChangeData;
}

export interface PostBackSalesDocumentAddRequest {
    name: string;
    fileName: string;
    content: Blob;
    salesEntryId: number;
    documentType: SalesEntryDocumentType;
    amount?: number;
}

export interface PostBackSalesDocumentUpdateRequest {
    salesEntryDocumentUpdateView: SalesEntryDocumentUpdateView;
}

export interface PostBackSalesDocumentsListFilterOperationRequest {
    postBackSalesDocumentsListFilterRequest: PostBackSalesDocumentsListFilterRequest;
}

export interface PostBackSalesPaymentMethodListFilterRequest {
    postBackMeasurementsMeasurementDevicesFilterRequest: PostBackMeasurementsMeasurementDevicesFilterRequest;
}

export interface PostBackSalesPaymentMethodSaveRequest {
    methodOfPaymentView: MethodOfPaymentView;
}

export interface PostBackSalesTagsListFilterOperationRequest {
    postBackSalesTagsListFilterRequest: PostBackSalesTagsListFilterRequest;
}

export interface PostBackSalesTagsSaveRequest {
    salesEntryTag: SalesEntryTag;
}

export interface PostBackShippingDriversListFilterOperationRequest {
    postBackShippingDriversListFilterRequest: PostBackShippingDriversListFilterRequest;
}

export interface PostBackSpecificationProductConvertItemtypevariantidRecipetypeRequest {
    itemTypeVariantId: number;
    recipeType: number;
    productSpecificationGraph: ProductSpecificationGraph;
}

export interface PostBackSpecificationsByMachineFeaturesListFilterOperationRequest {
    postBackSpecificationsByMachineFeaturesListFilterRequest: PostBackSpecificationsByMachineFeaturesListFilterRequest;
}

export interface PostBackSpecificationsByProducedItemTagsListFilterOperationRequest {
    postBackSpecificationsByProducedItemTagsListFilterRequest: PostBackSpecificationsByProducedItemTagsListFilterRequest;
}

export interface PostBackSpecificationsByProducedVariantListFilterOperationRequest {
    postBackSpecificationsByProducedVariantListFilterRequest: PostBackSpecificationsByProducedVariantListFilterRequest;
}

export interface PostBackSpecificationsItemTypeItemtypeidSaveRequest {
    itemTypeId: number;
    specificationTemplateWithItemTypeSavingView: SpecificationTemplateWithItemTypeSavingView;
}

export interface PostBackSpecificationsRecipeConvertToViewRequest {
    genericRecipe: GenericRecipe;
}

export interface PostBackSpecificationsRecipePrintingRequest {
    genericRecipe: GenericRecipe;
}

export interface PostBackSpecificationsRecipePrintingCreatePlateItemRequest {
    plateItemTypeSaveView: PlateItemTypeSaveView;
}

export interface PostBackSpecificationsRecipeRecipeToProductionSpecRequest {
    genericRecipe: GenericRecipe;
}

export interface PostBackSpecificationsRecipeReliefPlateRequest {
    genericRecipe: GenericRecipe;
}

export interface PostBackSpecificationsSaveRequest {
    specificationTemplate: SpecificationTemplate;
    asCopy?: boolean;
    asDefault?: boolean;
    deleteConflicting?: boolean;
}

export interface PostBackSpecificationsSimpleItemTypeItemtypeidCreateRequest {
    itemTypeId: number;
    specificationTemplateSimpleCreateView: SpecificationTemplateSimpleCreateView;
}

export interface PostBackSpecificationsSimpleUpdateRequest {
    specificationTemplateSimpleUpdateView: SpecificationTemplateSimpleUpdateView;
}

export interface PostBackSpecificationsStandardParametersFilterOperationRequest {
    postBackSpecificationsStandardParametersFilterRequest: PostBackSpecificationsStandardParametersFilterRequest;
}

export interface PostBackSpecificationsStandardsFilterRequest {
    postBackMeasurementsMeasurementDevicesFilterRequest: PostBackMeasurementsMeasurementDevicesFilterRequest;
}

export interface PostBackSpecificationsTemplateReactivateP1Request {
    p1: number;
}

export interface PostBackSpecificationsV2ByProducedVariantListFilterOperationRequest {
    postBackSpecificationsV2ByProducedVariantListFilterRequest: PostBackSpecificationsV2ByProducedVariantListFilterRequest;
}

export interface PostBackSpecificationsValidateRequest {
    clientSpecification: ClientSpecification;
}

export interface PostBackSpecificationsWithItemSaveRequest {
    itemTypeWithTemplateSavingView: ItemTypeWithTemplateSavingView;
}

export interface PostBackStocksDemandStockinteractionidChangeDestinationWithoutvalidationRequest {
    stockInteractionId: number;
    withoutValidation: boolean;
    demandDestination?: Array<DemandDestination>;
}

export interface PostBackStocksDemandsListFilterOperationRequest {
    postBackStocksDemandsListFilterRequest: PostBackStocksDemandsListFilterRequest;
}

export interface PostBackStocksListFilterOperationRequest {
    postBackStocksListFilterRequest: PostBackStocksListFilterRequest;
}

export interface PostBackStocksPlaceVariantAvailabilityStockinteractionidRequest {
    stockInteractionId: number;
    availabilityInputView: AvailabilityInputView;
}

export interface PostBackStocksProductionOrdersAddP1Request {
    p1: number;
    postBackStocksDemandsListFilterRequest: PostBackStocksDemandsListFilterRequest;
}

export interface PostBackStocksProductionOrdersCreateRequest {
    postBackStocksDemandsListFilterRequest: PostBackStocksDemandsListFilterRequest;
}

export interface PostBackStocksSupplementListFilterOperationRequest {
    postBackStocksSupplementListFilterRequest: PostBackStocksSupplementListFilterRequest;
}

export interface PostBackStocktakingCountsheetListFilterOperationRequest {
    postBackStocktakingCountsheetListFilterRequest: PostBackStocktakingCountsheetListFilterRequest;
}

export interface PostBackStocktakingListFilterOperationRequest {
    postBackStocktakingListFilterRequest: PostBackStocktakingListFilterRequest;
}

export interface PostBackSupplyListFilterOperationRequest {
    postBackSupplyListFilterRequest: PostBackSupplyListFilterRequest;
}

export interface PostBackSupplyOrdersCreatorListFilterOperationRequest {
    postBackSupplyOrdersCreatorListFilterRequest: PostBackSupplyOrdersCreatorListFilterRequest;
}

export interface PostBackSupplyPlannedSupplyorderidCancelRequest {
    supplyOrderId: number;
}

export interface PostBackSupplyWarehouseTagListFilterOperationRequest {
    postBackSupplyWarehouseTagListFilterRequest: PostBackSupplyWarehouseTagListFilterRequest;
}

export interface PostBackTicketsListFilterOperationRequest {
    postBackTicketsListFilterRequest: PostBackTicketsListFilterRequest;
}

export interface PostBackTraceabilityGraphExpandProductionLotProductionlotidLeftRequest {
    productionLotId: number;
}

export interface PostBackTraceabilityGraphExpandProductionLotProductionlotidRightRequest {
    productionLotId: number;
}

export interface PostBackTraceabilityGraphInitialProductionUnitProductionunitidRequest {
    productionUnitId: number;
}

export interface PostBackUnitsBlobsListFilterOperationRequest {
    postBackUnitsBlobsListFilterRequest: PostBackUnitsBlobsListFilterRequest;
}

export interface PostBackUnitsEquipmentListFilterOperationRequest {
    postBackUnitsEquipmentListFilterRequest: PostBackUnitsEquipmentListFilterRequest;
}

export interface PostBackUnitsItemsListFilterOperationRequest {
    postBackUnitsItemsListFilterRequest: PostBackUnitsItemsListFilterRequest;
}

export interface PostBackUnitsLendingLedgerReportRequest {
    lendingLedgerEntrySaveView: LendingLedgerEntrySaveView;
}

export interface PostBackUnitsListFilterOperationRequest {
    postBackUnitsListFilterRequest: PostBackUnitsListFilterRequest;
}

export interface PostBackVehiclesListFilterOperationRequest {
    postBackVehiclesListFilterRequest: PostBackVehiclesListFilterRequest;
}

export interface PostBackWorkersAbsenceEventsSaveRequest {
    workerEventSaveView: WorkerEventSaveView;
}

export interface PostBackWorkersCompetenceCategoriesListFilterOperationRequest {
    postBackWorkersCompetenceCategoriesListFilterRequest: PostBackWorkersCompetenceCategoriesListFilterRequest;
}

export interface PostBackWorkersCompetencesListFilterOperationRequest {
    postBackWorkersCompetencesListFilterRequest: PostBackWorkersCompetencesListFilterRequest;
}

export interface PostBackWorkersCompetencesMatrixListFilterOperationRequest {
    postBackWorkersCompetencesMatrixListFilterRequest: PostBackWorkersCompetencesMatrixListFilterRequest;
}

export interface PostBackWorkersCompetencesSaveRequest {
    competence: Competence;
}

export interface PostBackWorkersDocumentAddRequest {
    name: string;
    fileName: string;
    content: Blob;
    workerId: number;
    documentType: WorkerDocumentType;
    dueDate?: string;
    workerCompetenceId?: number;
}

export interface PostBackWorkersDocumentUpdateRequest {
    workerDocumentUpdateView: WorkerDocumentUpdateView;
}

export interface PostBackWorkersDocumentsListFilterOperationRequest {
    postBackWorkersDocumentsListFilterRequest: PostBackWorkersDocumentsListFilterRequest;
}

export interface PostBackWorkersEventsCalendarWorkeridRequest {
    workerId: number;
    workerEventFilterView: WorkerEventFilterView;
}

export interface PostBackWorkersListFilterOperationRequest {
    postBackWorkersListFilterRequest: PostBackWorkersListFilterRequest;
}

export interface PostBackWorkersWorkerAddRequest {
    workerAddView: WorkerAddView;
}

export interface PostBackWorkersWorkerCompetencesListFilterOperationRequest {
    postBackWorkersWorkerCompetencesListFilterRequest: PostBackWorkersWorkerCompetencesListFilterRequest;
}

export interface PostBackWorkersWorkerCompetencesSaveRequest {
    workerCompetenceSaveView: WorkerCompetenceSaveView;
}

export interface PostBackWorkersWorkerP1ReactivateRequest {
    p1: number;
    reactivateUser?: boolean;
}

export interface PostBackWorkersWorkerUpdateRequest {
    workerUpdateView: WorkerUpdateView;
}

export interface PostUmConfigurationKeySaveRequest {
    path: string;
    body: any | null;
}

export interface PostUmConfigurationSaveRequest {
    body: object;
}

export interface PostUmLoginRequest {
    login: string;
    password: string;
    redirect: string;
    pLAYLANG?: string;
    acceptLanguage?: string;
}

export interface PostUmLoginNoRedirectRequest {
    login: string;
    password: string;
    redirect: string;
    pLAYLANG?: string;
    acceptLanguage?: string;
}

export interface PostUmRfidLoginRequest {
    rfid: Rfid;
    pLAYLANG?: string;
    acceptLanguage?: string;
}

export interface PostUmRfidLoginLegacyRequest {
    rfid: Rfid;
    pLAYLANG?: string;
    acceptLanguage?: string;
}

export interface PostUmRolesRequest {
    roleView: RoleView;
}

export interface PostUmRolesIdPermissionsAddRequest {
    id: number;
    requestBody?: Array<string>;
}

export interface PostUmRolesIdPermissionsDeleteRequest {
    id: number;
    requestBody?: Array<string>;
}

export interface PostUmRolesListFilterOperationRequest {
    postUmRolesListFilterRequest: PostUmRolesListFilterRequest;
}

export interface PostUmSuUsersIdBlockRequest {
    id: number;
    blocked: boolean;
}

export interface PostUmUsersRequest {
    userCreationView: UserCreationView;
}

export interface PostUmUsersListFilterOperationRequest {
    postUmUsersListFilterRequest: PostUmUsersListFilterRequest;
}

export interface PostUmUsersPasswordGenerateRequest {
    generatingPasswordLength: GeneratingPasswordLength;
}

export interface ProductionOrderLotMergeRequest {
    productionOrderLotsMergeQueryView: ProductionOrderLotsMergeQueryView;
}

export interface ProductionOrderLotSplitRequest {
    productionOrderLotsSplitQueryView: ProductionOrderLotsSplitQueryView;
}

export interface PublishBpscExportRequest {
    bpscExportRequest: BpscExportRequest;
}

export interface PutBackMachinesMachineMachineidSetStateStateRequest {
    machineId: number;
    state: number;
}

export interface PutUmLanguagesLangRequest {
    lang: string;
}

export interface PutUmProfileRequest {
    profile: Profile;
}

export interface PutUmProfileContactDataUseridRequest {
    userId: number;
    contactDataUpdateView: ContactDataUpdateView;
}

export interface PutUmProfileSelfRequest {
    selfProfileUpdateView: SelfProfileUpdateView;
}

export interface PutUmProfileUseridUpdatePasswordRequest {
    userId: number;
    newManuallyTypedPassword: NewManuallyTypedPassword;
}

export interface PutUmRolesIdUsersUidRequest {
    id: number;
    uid: number;
}

export interface QuerySupplyOrderAcceptanceResolutionRequest {
    supplyOrderItemsSavingView: SupplyOrderItemsSavingView;
}

export interface QuerySupplyOrderItemsRequest {
    simulationQueryPayload: SimulationQueryPayload;
}

export interface QuickSaveSupplyOrderItemsRequest {
    simulationQueryPayload: SimulationQueryPayload;
}

export interface RecalculateProductionOrderSimulationRequest {
    recalculateProductionOrderPayload: RecalculateProductionOrderPayload;
}

export interface RescheduleStocktakingRequest {
    stocktakingId: number;
}

export interface SaveBomReportRequest {
    productionLotId: number;
    bomReportSaveView: BomReportSaveView;
}

export interface SaveCountsheetEntryRequest {
    countsheetEntrySaveView: CountsheetEntrySaveView;
}

export interface SaveDurationBatchDowntimeRequest {
    batchId: number;
    downtimeReportDurationSaveView: DowntimeReportDurationSaveView;
}

export interface SaveDurationBatchDowntimeV2Request {
    batchId: number;
    batchDowntimeReportDurationSaveView: BatchDowntimeReportDurationSaveView;
}

export interface SaveDurationDowntimeRequest {
    productionLotId: number;
    downtimeReportDurationSaveView: DowntimeReportDurationSaveView;
}

export interface SaveDurationDowntimeV2Request {
    productionLotId: number;
    downtimeReportDurationSaveView: DowntimeReportDurationSaveView;
}

export interface SaveMaterialMovementRequest {
    materialMovementSaveView: MaterialMovementSaveView;
}

export interface SavePlannedReleaseRequest {
    plannedReleaseSavingView: PlannedReleaseSavingView;
}

export interface SaveSpontaneousReleaseRequest {
    spontaneousReleaseSavingView: SpontaneousReleaseSavingView;
}

export interface SaveStartEndBatchDowntimeRequest {
    batchId: number;
    downtimeReportStartEndSaveView: DowntimeReportStartEndSaveView;
}

export interface SaveStartEndBatchDowntimeV2Request {
    batchId: number;
    batchDowntimeReportStartEndSaveView: BatchDowntimeReportStartEndSaveView;
}

export interface SaveStocktakingRequest {
    stocktakingSaveView: StocktakingSaveView;
}

export interface SaveSupplyOrderItemsRequest {
    supplyOrderItemsSavingView: SupplyOrderItemsSavingView;
}

export interface SendExternalDocumentsRequest {
    requestBody?: Array<number>;
}

export interface SetSupplyOrderCommentRequest {
    supplyOrderId: number;
    body: string;
}

export interface SetSupplyOrderResponsiblePersonRequest {
    supplyOrderId: number;
    userId: number;
}

export interface StartSimulationMergeRequest {
    simulationMergeView: SimulationMergeView;
}

export interface StartStocktakingRequest {
    stocktakingId: number;
}

export interface StartStopwatchBatchDowntimeRequest {
    batchId: number;
    downtimeReportStartStopwatchView: DowntimeReportStartStopwatchView;
}

export interface StartStopwatchDowntimeRequest {
    productionLotId: number;
    downtimeReportStartStopwatchView: DowntimeReportStartStopwatchView;
}

export interface SupplyOrderDetailsRequest {
    supplyOrderId: number;
}

export interface UpdateCountsheetResponsiblePersonRequest {
    countsheetId: number;
    userId: number;
}

export interface UpdateMeasurementRequest {
    measurementUpdateView: MeasurementUpdateView;
}

export interface UpdateRfidRequest {
    userId: number;
    rfid?: Rfid;
}

export interface UpdateStocktakingCommentRequest {
    stocktakingId: number;
    body?: string;
}

export interface ValidateMaterialMovementRequest {
    materialMovementValidationView: MaterialMovementValidationView;
}

/**
 * 
 */
export class DefaultApi extends runtime.BaseAPI {

    /**
     * Accept stocktaking
     */
    async acceptStocktakingRaw(requestParameters: AcceptStocktakingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IdWithNumberStocktakingId>> {
        if (requestParameters.stocktakingId === null || requestParameters.stocktakingId === undefined) {
            throw new runtime.RequiredError('stocktakingId','Required parameter requestParameters.stocktakingId was null or undefined when calling acceptStocktaking.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/stocktaking/accept/{StocktakingId}`.replace(`{${"StocktakingId"}}`, encodeURIComponent(String(requestParameters.stocktakingId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Accept stocktaking
     */
    async acceptStocktaking(requestParameters: AcceptStocktakingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IdWithNumberStocktakingId> {
        const response = await this.acceptStocktakingRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Accept supply order
     */
    async acceptSupplyOrderRaw(requestParameters: AcceptSupplyOrderRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IdWithNumberSupplyOrderId>> {
        if (requestParameters.supplyOrderId === null || requestParameters.supplyOrderId === undefined) {
            throw new runtime.RequiredError('supplyOrderId','Required parameter requestParameters.supplyOrderId was null or undefined when calling acceptSupplyOrder.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/supply-order/accept/{SupplyOrderId}`.replace(`{${"SupplyOrderId"}}`, encodeURIComponent(String(requestParameters.supplyOrderId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Accept supply order
     */
    async acceptSupplyOrder(requestParameters: AcceptSupplyOrderRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IdWithNumberSupplyOrderId> {
        const response = await this.acceptSupplyOrderRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Apply material movement
     */
    async applyMaterialMovementRaw(requestParameters: ApplyMaterialMovementRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IdWithNumberMaterialMovementId>> {
        if (requestParameters.materialMovementApplyView === null || requestParameters.materialMovementApplyView === undefined) {
            throw new runtime.RequiredError('materialMovementApplyView','Required parameter requestParameters.materialMovementApplyView was null or undefined when calling applyMaterialMovement.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/material-movements/apply`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.materialMovementApplyView,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Apply material movement
     */
    async applyMaterialMovement(requestParameters: ApplyMaterialMovementRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IdWithNumberMaterialMovementId> {
        const response = await this.applyMaterialMovementRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Delete production order and its lots
     */
    async backProductionOrderOrderProductionorderidDeleteRaw(requestParameters: BackProductionOrderOrderProductionorderidDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.productionOrderId === null || requestParameters.productionOrderId === undefined) {
            throw new runtime.RequiredError('productionOrderId','Required parameter requestParameters.productionOrderId was null or undefined when calling backProductionOrderOrderProductionorderidDelete.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/production-order/order/{ProductionOrderId}/delete`.replace(`{${"ProductionOrderId"}}`, encodeURIComponent(String(requestParameters.productionOrderId))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete production order and its lots
     */
    async backProductionOrderOrderProductionorderidDelete(requestParameters: BackProductionOrderOrderProductionorderidDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.backProductionOrderOrderProductionorderidDeleteRaw(requestParameters, initOverrides);
    }

    /**
     * Cancel production lot
     */
    async cancelLotRaw(requestParameters: CancelLotRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.productionLotId === null || requestParameters.productionLotId === undefined) {
            throw new runtime.RequiredError('productionLotId','Required parameter requestParameters.productionLotId was null or undefined when calling cancelLot.');
        }

        const queryParameters: any = {};

        if (requestParameters.machineIdOpt !== undefined) {
            queryParameters['machineIdOpt'] = requestParameters.machineIdOpt;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/production-lot/{ProductionLotId}/cancel-lot`.replace(`{${"ProductionLotId"}}`, encodeURIComponent(String(requestParameters.productionLotId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Cancel production lot
     */
    async cancelLot(requestParameters: CancelLotRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.cancelLotRaw(requestParameters, initOverrides);
    }

    /**
     * Cancel order item
     */
    async cancelOrderItemRaw(requestParameters: CancelOrderItemRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.orderItemId === null || requestParameters.orderItemId === undefined) {
            throw new runtime.RequiredError('orderItemId','Required parameter requestParameters.orderItemId was null or undefined when calling cancelOrderItem.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/orders/item/{OrderItemId}/cancel`.replace(`{${"OrderItemId"}}`, encodeURIComponent(String(requestParameters.orderItemId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Cancel order item
     */
    async cancelOrderItem(requestParameters: CancelOrderItemRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.cancelOrderItemRaw(requestParameters, initOverrides);
    }

    /**
     * Cancel stocktaking
     */
    async cancelStocktakingRaw(requestParameters: CancelStocktakingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IdWithNumberStocktakingId>> {
        if (requestParameters.stocktakingId === null || requestParameters.stocktakingId === undefined) {
            throw new runtime.RequiredError('stocktakingId','Required parameter requestParameters.stocktakingId was null or undefined when calling cancelStocktaking.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/stocktaking/cancel/{StocktakingId}`.replace(`{${"StocktakingId"}}`, encodeURIComponent(String(requestParameters.stocktakingId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Cancel stocktaking
     */
    async cancelStocktaking(requestParameters: CancelStocktakingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IdWithNumberStocktakingId> {
        const response = await this.cancelStocktakingRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Cancel supply order
     */
    async cancelSupplyOrderRaw(requestParameters: CancelSupplyOrderRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IdWithNumberSupplyOrderId>> {
        if (requestParameters.supplyOrderId === null || requestParameters.supplyOrderId === undefined) {
            throw new runtime.RequiredError('supplyOrderId','Required parameter requestParameters.supplyOrderId was null or undefined when calling cancelSupplyOrder.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/supply-order/cancel/{SupplyOrderId}`.replace(`{${"SupplyOrderId"}}`, encodeURIComponent(String(requestParameters.supplyOrderId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Cancel supply order
     */
    async cancelSupplyOrder(requestParameters: CancelSupplyOrderRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IdWithNumberSupplyOrderId> {
        const response = await this.cancelSupplyOrderRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Clear measurement
     */
    async clearMeasurementRaw(requestParameters: ClearMeasurementRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.measurementDeleteView === null || requestParameters.measurementDeleteView === undefined) {
            throw new runtime.RequiredError('measurementDeleteView','Required parameter requestParameters.measurementDeleteView was null or undefined when calling clearMeasurement.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/measurement-reports/measurement/clear`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.measurementDeleteView,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Clear measurement
     */
    async clearMeasurement(requestParameters: ClearMeasurementRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.clearMeasurementRaw(requestParameters, initOverrides);
    }

    /**
     * Confirm countsheet
     */
    async confirmCountsheetRaw(requestParameters: ConfirmCountsheetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<number>> {
        if (requestParameters.countsheetId === null || requestParameters.countsheetId === undefined) {
            throw new runtime.RequiredError('countsheetId','Required parameter requestParameters.countsheetId was null or undefined when calling confirmCountsheet.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/stocktaking/countsheet/confirm/{CountsheetId}`.replace(`{${"CountsheetId"}}`, encodeURIComponent(String(requestParameters.countsheetId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.TextApiResponse(response) as any;
    }

    /**
     * Confirm countsheet
     */
    async confirmCountsheet(requestParameters: ConfirmCountsheetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<number> {
        const response = await this.confirmCountsheetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Mark supply order as pending
     */
    async confirmSingleSupplyOrderRaw(requestParameters: ConfirmSingleSupplyOrderRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IdWithNumberSupplyOrderId>> {
        if (requestParameters.supplyOrderId === null || requestParameters.supplyOrderId === undefined) {
            throw new runtime.RequiredError('supplyOrderId','Required parameter requestParameters.supplyOrderId was null or undefined when calling confirmSingleSupplyOrder.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/supply-order/mark-pending/{SupplyOrderId}`.replace(`{${"SupplyOrderId"}}`, encodeURIComponent(String(requestParameters.supplyOrderId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Mark supply order as pending
     */
    async confirmSingleSupplyOrder(requestParameters: ConfirmSingleSupplyOrderRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IdWithNumberSupplyOrderId> {
        const response = await this.confirmSingleSupplyOrderRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Confirm supply orders or send for acceptance
     */
    async confirmSupplyOrdersRaw(requestParameters: ConfirmSupplyOrdersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<IdWithNumberSupplyOrderId>>> {
        if (requestParameters.supplyOrderConfirmationSavingView === null || requestParameters.supplyOrderConfirmationSavingView === undefined) {
            throw new runtime.RequiredError('supplyOrderConfirmationSavingView','Required parameter requestParameters.supplyOrderConfirmationSavingView was null or undefined when calling confirmSupplyOrders.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/supply-order/confirm`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.supplyOrderConfirmationSavingView,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Confirm supply orders or send for acceptance
     */
    async confirmSupplyOrders(requestParameters: ConfirmSupplyOrdersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<IdWithNumberSupplyOrderId>> {
        const response = await this.confirmSupplyOrdersRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Create measurement
     */
    async createMeasurementRaw(requestParameters: CreateMeasurementRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<number>> {
        if (requestParameters.measurementCreateView === null || requestParameters.measurementCreateView === undefined) {
            throw new runtime.RequiredError('measurementCreateView','Required parameter requestParameters.measurementCreateView was null or undefined when calling createMeasurement.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/measurement-reports/measurement/create`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.measurementCreateView,
        }, initOverrides);

        return new runtime.TextApiResponse(response) as any;
    }

    /**
     * Create measurement
     */
    async createMeasurement(requestParameters: CreateMeasurementRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<number> {
        const response = await this.createMeasurementRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Delete CalendarEvent by MachineId
     */
    async deleteBackCalendarEventCalendareventidRaw(requestParameters: DeleteBackCalendarEventCalendareventidRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AjaxActionResponse>> {
        if (requestParameters.calendarEventId === null || requestParameters.calendarEventId === undefined) {
            throw new runtime.RequiredError('calendarEventId','Required parameter requestParameters.calendarEventId was null or undefined when calling deleteBackCalendarEventCalendareventid.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/calendar/event/{calendarEventId}`.replace(`{${"calendarEventId"}}`, encodeURIComponent(String(requestParameters.calendarEventId))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Delete CalendarEvent by MachineId
     */
    async deleteBackCalendarEventCalendareventid(requestParameters: DeleteBackCalendarEventCalendareventidRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AjaxActionResponse> {
        const response = await this.deleteBackCalendarEventCalendareventidRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Delete Contact by ContactId
     */
    async deleteBackContractorsContactsP1Raw(requestParameters: DeleteBackContractorsContactsP1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AjaxActionResponse>> {
        if (requestParameters.p1 === null || requestParameters.p1 === undefined) {
            throw new runtime.RequiredError('p1','Required parameter requestParameters.p1 was null or undefined when calling deleteBackContractorsContactsP1.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/contractors/contacts/{p1}`.replace(`{${"p1"}}`, encodeURIComponent(String(requestParameters.p1))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Delete Contact by ContactId
     */
    async deleteBackContractorsContactsP1(requestParameters: DeleteBackContractorsContactsP1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AjaxActionResponse> {
        const response = await this.deleteBackContractorsContactsP1Raw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Delete CalendarEvent by MachineId
     */
    async deleteBackMachinesCalendarEventP1Raw(requestParameters: DeleteBackMachinesCalendarEventP1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AjaxActionResponse>> {
        if (requestParameters.p1 === null || requestParameters.p1 === undefined) {
            throw new runtime.RequiredError('p1','Required parameter requestParameters.p1 was null or undefined when calling deleteBackMachinesCalendarEventP1.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/machines/calendar/event/{p1}`.replace(`{${"p1"}}`, encodeURIComponent(String(requestParameters.p1))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Delete CalendarEvent by MachineId
     */
    async deleteBackMachinesCalendarEventP1(requestParameters: DeleteBackMachinesCalendarEventP1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AjaxActionResponse> {
        const response = await this.deleteBackMachinesCalendarEventP1Raw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Delete Offer
     */
    async deleteBackOffersDeleteP1Raw(requestParameters: DeleteBackOffersDeleteP1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<string>> {
        if (requestParameters.p1 === null || requestParameters.p1 === undefined) {
            throw new runtime.RequiredError('p1','Required parameter requestParameters.p1 was null or undefined when calling deleteBackOffersDeleteP1.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/offers/delete/{p1}`.replace(`{${"p1"}}`, encodeURIComponent(String(requestParameters.p1))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.TextApiResponse(response) as any;
    }

    /**
     * Delete Offer
     */
    async deleteBackOffersDeleteP1(requestParameters: DeleteBackOffersDeleteP1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<string> {
        const response = await this.deleteBackOffersDeleteP1Raw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Delete order assignment event
     */
    async deleteBackOrdersAssignmentEventsP1DeleteRaw(requestParameters: DeleteBackOrdersAssignmentEventsP1DeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.p1 === null || requestParameters.p1 === undefined) {
            throw new runtime.RequiredError('p1','Required parameter requestParameters.p1 was null or undefined when calling deleteBackOrdersAssignmentEventsP1Delete.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/orders/assignment-events/{p1}/delete`.replace(`{${"p1"}}`, encodeURIComponent(String(requestParameters.p1))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete order assignment event
     */
    async deleteBackOrdersAssignmentEventsP1Delete(requestParameters: DeleteBackOrdersAssignmentEventsP1DeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteBackOrdersAssignmentEventsP1DeleteRaw(requestParameters, initOverrides);
    }

    /**
     * Deletes equipment demand with the specified id
     */
    async deleteBackOrdersEquipmentDemandsP1DeleteRaw(requestParameters: DeleteBackOrdersEquipmentDemandsP1DeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.p1 === null || requestParameters.p1 === undefined) {
            throw new runtime.RequiredError('p1','Required parameter requestParameters.p1 was null or undefined when calling deleteBackOrdersEquipmentDemandsP1Delete.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/orders/equipment-demands/{p1}/delete`.replace(`{${"p1"}}`, encodeURIComponent(String(requestParameters.p1))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Deletes equipment demand with the specified id
     */
    async deleteBackOrdersEquipmentDemandsP1Delete(requestParameters: DeleteBackOrdersEquipmentDemandsP1DeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteBackOrdersEquipmentDemandsP1DeleteRaw(requestParameters, initOverrides);
    }

    /**
     * Deletes other demands with the specified id
     */
    async deleteBackOrdersOtherDemandsP1DeleteRaw(requestParameters: DeleteBackOrdersOtherDemandsP1DeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.p1 === null || requestParameters.p1 === undefined) {
            throw new runtime.RequiredError('p1','Required parameter requestParameters.p1 was null or undefined when calling deleteBackOrdersOtherDemandsP1Delete.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/orders/other-demands/{p1}/delete`.replace(`{${"p1"}}`, encodeURIComponent(String(requestParameters.p1))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Deletes other demands with the specified id
     */
    async deleteBackOrdersOtherDemandsP1Delete(requestParameters: DeleteBackOrdersOtherDemandsP1DeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteBackOrdersOtherDemandsP1DeleteRaw(requestParameters, initOverrides);
    }

    /**
     * Delete sales entry document
     */
    async deleteBackSalesDocumentP1DeleteRaw(requestParameters: DeleteBackSalesDocumentP1DeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.p1 === null || requestParameters.p1 === undefined) {
            throw new runtime.RequiredError('p1','Required parameter requestParameters.p1 was null or undefined when calling deleteBackSalesDocumentP1Delete.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/sales/document/{p1}/delete`.replace(`{${"p1"}}`, encodeURIComponent(String(requestParameters.p1))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete sales entry document
     */
    async deleteBackSalesDocumentP1Delete(requestParameters: DeleteBackSalesDocumentP1DeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteBackSalesDocumentP1DeleteRaw(requestParameters, initOverrides);
    }

    /**
     * Marks template with id as deleted
     */
    async deleteBackSpecificationsTemplateDeactivateP1Raw(requestParameters: DeleteBackSpecificationsTemplateDeactivateP1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.p1 === null || requestParameters.p1 === undefined) {
            throw new runtime.RequiredError('p1','Required parameter requestParameters.p1 was null or undefined when calling deleteBackSpecificationsTemplateDeactivateP1.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/specifications/template/deactivate/{p1}`.replace(`{${"p1"}}`, encodeURIComponent(String(requestParameters.p1))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Marks template with id as deleted
     */
    async deleteBackSpecificationsTemplateDeactivateP1(requestParameters: DeleteBackSpecificationsTemplateDeactivateP1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteBackSpecificationsTemplateDeactivateP1Raw(requestParameters, initOverrides);
    }

    /**
     * Delete worker absence event
     */
    async deleteBackWorkersAbsenceEventsP1DeleteRaw(requestParameters: DeleteBackWorkersAbsenceEventsP1DeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.p1 === null || requestParameters.p1 === undefined) {
            throw new runtime.RequiredError('p1','Required parameter requestParameters.p1 was null or undefined when calling deleteBackWorkersAbsenceEventsP1Delete.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/workers/absence-events/{p1}/delete`.replace(`{${"p1"}}`, encodeURIComponent(String(requestParameters.p1))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete worker absence event
     */
    async deleteBackWorkersAbsenceEventsP1Delete(requestParameters: DeleteBackWorkersAbsenceEventsP1DeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteBackWorkersAbsenceEventsP1DeleteRaw(requestParameters, initOverrides);
    }

    /**
     * Deletes competence with the specified id
     */
    async deleteBackWorkersCompetencesP1DeleteRaw(requestParameters: DeleteBackWorkersCompetencesP1DeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.p1 === null || requestParameters.p1 === undefined) {
            throw new runtime.RequiredError('p1','Required parameter requestParameters.p1 was null or undefined when calling deleteBackWorkersCompetencesP1Delete.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/workers/competences/{p1}/delete`.replace(`{${"p1"}}`, encodeURIComponent(String(requestParameters.p1))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Deletes competence with the specified id
     */
    async deleteBackWorkersCompetencesP1Delete(requestParameters: DeleteBackWorkersCompetencesP1DeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteBackWorkersCompetencesP1DeleteRaw(requestParameters, initOverrides);
    }

    /**
     * Delete worker document
     */
    async deleteBackWorkersDocumentP1DeleteRaw(requestParameters: DeleteBackWorkersDocumentP1DeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.p1 === null || requestParameters.p1 === undefined) {
            throw new runtime.RequiredError('p1','Required parameter requestParameters.p1 was null or undefined when calling deleteBackWorkersDocumentP1Delete.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/workers/document/{p1}/delete`.replace(`{${"p1"}}`, encodeURIComponent(String(requestParameters.p1))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete worker document
     */
    async deleteBackWorkersDocumentP1Delete(requestParameters: DeleteBackWorkersDocumentP1DeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteBackWorkersDocumentP1DeleteRaw(requestParameters, initOverrides);
    }

    /**
     * Delete worker competence with its past history
     */
    async deleteBackWorkersWorkerCompetencesP1DeleteRaw(requestParameters: DeleteBackWorkersWorkerCompetencesP1DeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.p1 === null || requestParameters.p1 === undefined) {
            throw new runtime.RequiredError('p1','Required parameter requestParameters.p1 was null or undefined when calling deleteBackWorkersWorkerCompetencesP1Delete.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/workers/worker-competences/{p1}/delete`.replace(`{${"p1"}}`, encodeURIComponent(String(requestParameters.p1))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete worker competence with its past history
     */
    async deleteBackWorkersWorkerCompetencesP1Delete(requestParameters: DeleteBackWorkersWorkerCompetencesP1DeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteBackWorkersWorkerCompetencesP1DeleteRaw(requestParameters, initOverrides);
    }

    /**
     * Mark worker as deactivated, optionally with deactivating linked user
     */
    async deleteBackWorkersWorkerP1DeactivateRaw(requestParameters: DeleteBackWorkersWorkerP1DeactivateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.p1 === null || requestParameters.p1 === undefined) {
            throw new runtime.RequiredError('p1','Required parameter requestParameters.p1 was null or undefined when calling deleteBackWorkersWorkerP1Deactivate.');
        }

        const queryParameters: any = {};

        if (requestParameters.deactivateUser !== undefined) {
            queryParameters['deactivateUser'] = requestParameters.deactivateUser;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/workers/worker/{p1}/deactivate`.replace(`{${"p1"}}`, encodeURIComponent(String(requestParameters.p1))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Mark worker as deactivated, optionally with deactivating linked user
     */
    async deleteBackWorkersWorkerP1Deactivate(requestParameters: DeleteBackWorkersWorkerP1DeactivateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteBackWorkersWorkerP1DeactivateRaw(requestParameters, initOverrides);
    }

    /**
     * Delete manual downtime report for a batch
     */
    async deleteManualBatchDowntimeRaw(requestParameters: DeleteManualBatchDowntimeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.downtimeBatchGroupId === null || requestParameters.downtimeBatchGroupId === undefined) {
            throw new runtime.RequiredError('downtimeBatchGroupId','Required parameter requestParameters.downtimeBatchGroupId was null or undefined when calling deleteManualBatchDowntime.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/reports/workstation-reports/downtime/batch/delete/{DowntimeBatchGroupId}`.replace(`{${"DowntimeBatchGroupId"}}`, encodeURIComponent(String(requestParameters.downtimeBatchGroupId))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete manual downtime report for a batch
     */
    async deleteManualBatchDowntime(requestParameters: DeleteManualBatchDowntimeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteManualBatchDowntimeRaw(requestParameters, initOverrides);
    }

    /**
     * Delete manual downtime report for a production lot
     */
    async deleteManualDowntimeRaw(requestParameters: DeleteManualDowntimeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.downtimeReportId === null || requestParameters.downtimeReportId === undefined) {
            throw new runtime.RequiredError('downtimeReportId','Required parameter requestParameters.downtimeReportId was null or undefined when calling deleteManualDowntime.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/reports/workstation-reports/downtime/delete/{DowntimeReportId}`.replace(`{${"DowntimeReportId"}}`, encodeURIComponent(String(requestParameters.downtimeReportId))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete manual downtime report for a production lot
     */
    async deleteManualDowntime(requestParameters: DeleteManualDowntimeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteManualDowntimeRaw(requestParameters, initOverrides);
    }

    /**
     * Delete measurement
     */
    async deleteMeasurementRaw(requestParameters: DeleteMeasurementRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.measurementDeleteView === null || requestParameters.measurementDeleteView === undefined) {
            throw new runtime.RequiredError('measurementDeleteView','Required parameter requestParameters.measurementDeleteView was null or undefined when calling deleteMeasurement.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/measurement-reports/measurement/delete`,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.measurementDeleteView,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete measurement
     */
    async deleteMeasurement(requestParameters: DeleteMeasurementRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteMeasurementRaw(requestParameters, initOverrides);
    }

    /**
     * Delete logged user\'s config for given key
     */
    async deleteUmConfigurationKeyDeleteRaw(requestParameters: DeleteUmConfigurationKeyDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.path === null || requestParameters.path === undefined) {
            throw new runtime.RequiredError('path','Required parameter requestParameters.path was null or undefined when calling deleteUmConfigurationKeyDelete.');
        }

        const queryParameters: any = {};

        if (requestParameters.path !== undefined) {
            queryParameters['path'] = requestParameters.path;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/um/configuration/key/delete`,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete logged user\'s config for given key
     */
    async deleteUmConfigurationKeyDelete(requestParameters: DeleteUmConfigurationKeyDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteUmConfigurationKeyDeleteRaw(requestParameters, initOverrides);
    }

    /**
     * Remove user\'s role
     */
    async deleteUmRolesIdUsersUidRaw(requestParameters: DeleteUmRolesIdUsersUidRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling deleteUmRolesIdUsersUid.');
        }

        if (requestParameters.uid === null || requestParameters.uid === undefined) {
            throw new runtime.RequiredError('uid','Required parameter requestParameters.uid was null or undefined when calling deleteUmRolesIdUsersUid.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/um/roles/{id}/users/{uid}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))).replace(`{${"uid"}}`, encodeURIComponent(String(requestParameters.uid))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Remove user\'s role
     */
    async deleteUmRolesIdUsersUid(requestParameters: DeleteUmRolesIdUsersUidRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteUmRolesIdUsersUidRaw(requestParameters, initOverrides);
    }

    /**
     * Delete role
     */
    async deleteUmRolesP1Raw(requestParameters: DeleteUmRolesP1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<number>> {
        if (requestParameters.p1 === null || requestParameters.p1 === undefined) {
            throw new runtime.RequiredError('p1','Required parameter requestParameters.p1 was null or undefined when calling deleteUmRolesP1.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/um/roles/{p1}`.replace(`{${"p1"}}`, encodeURIComponent(String(requestParameters.p1))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.TextApiResponse(response) as any;
    }

    /**
     * Delete role
     */
    async deleteUmRolesP1(requestParameters: DeleteUmRolesP1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<number> {
        const response = await this.deleteUmRolesP1Raw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Delete user by his ID
     */
    async deleteUmSuUsersIdRaw(requestParameters: DeleteUmSuUsersIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling deleteUmSuUsersId.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/um/su/users/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete user by his ID
     */
    async deleteUmSuUsersId(requestParameters: DeleteUmSuUsersIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteUmSuUsersIdRaw(requestParameters, initOverrides);
    }

    /**
     * Download stocktaking report
     */
    async downloadStocktakingReportRaw(requestParameters: DownloadStocktakingReportRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Blob>> {
        if (requestParameters.stocktakingId === null || requestParameters.stocktakingId === undefined) {
            throw new runtime.RequiredError('stocktakingId','Required parameter requestParameters.stocktakingId was null or undefined when calling downloadStocktakingReport.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/stocktaking/report/{StocktakingId}`.replace(`{${"StocktakingId"}}`, encodeURIComponent(String(requestParameters.stocktakingId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.BlobApiResponse(response);
    }

    /**
     * Download stocktaking report
     */
    async downloadStocktakingReport(requestParameters: DownloadStocktakingReportRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Blob> {
        const response = await this.downloadStocktakingReportRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Duplicate stocktaking
     */
    async duplicateStocktakingRaw(requestParameters: DuplicateStocktakingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IdWithNumberStocktakingId>> {
        if (requestParameters.stocktakingId === null || requestParameters.stocktakingId === undefined) {
            throw new runtime.RequiredError('stocktakingId','Required parameter requestParameters.stocktakingId was null or undefined when calling duplicateStocktaking.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/stocktaking/duplicate/{StocktakingId}`.replace(`{${"StocktakingId"}}`, encodeURIComponent(String(requestParameters.stocktakingId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Duplicate stocktaking
     */
    async duplicateStocktaking(requestParameters: DuplicateStocktakingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IdWithNumberStocktakingId> {
        const response = await this.duplicateStocktakingRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Duplicate supply order
     */
    async duplicateSupplyOrderRaw(requestParameters: DuplicateSupplyOrderRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IdWithNumberSupplyOrderId>> {
        if (requestParameters.supplyOrderId === null || requestParameters.supplyOrderId === undefined) {
            throw new runtime.RequiredError('supplyOrderId','Required parameter requestParameters.supplyOrderId was null or undefined when calling duplicateSupplyOrder.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/supply-order/duplicate/{SupplyOrderId}`.replace(`{${"SupplyOrderId"}}`, encodeURIComponent(String(requestParameters.supplyOrderId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Duplicate supply order
     */
    async duplicateSupplyOrder(requestParameters: DuplicateSupplyOrderRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IdWithNumberSupplyOrderId> {
        const response = await this.duplicateSupplyOrderRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Edit supply order\'s delivery date and tags
     */
    async editSupplyOrderBasicDataRaw(requestParameters: EditSupplyOrderBasicDataRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IdWithNumberSupplyOrderId>> {
        if (requestParameters.supplyOrderId === null || requestParameters.supplyOrderId === undefined) {
            throw new runtime.RequiredError('supplyOrderId','Required parameter requestParameters.supplyOrderId was null or undefined when calling editSupplyOrderBasicData.');
        }

        if (requestParameters.supplyOrderBasicData === null || requestParameters.supplyOrderBasicData === undefined) {
            throw new runtime.RequiredError('supplyOrderBasicData','Required parameter requestParameters.supplyOrderBasicData was null or undefined when calling editSupplyOrderBasicData.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/supply-order/edit-basic-data/{SupplyOrderId}`.replace(`{${"SupplyOrderId"}}`, encodeURIComponent(String(requestParameters.supplyOrderId))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.supplyOrderBasicData,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Edit supply order\'s delivery date and tags
     */
    async editSupplyOrderBasicData(requestParameters: EditSupplyOrderBasicDataRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IdWithNumberSupplyOrderId> {
        const response = await this.editSupplyOrderBasicDataRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * End stopwatch downtime report for a batch
     */
    async endStopwatchBatchDowntimeRaw(requestParameters: EndStopwatchBatchDowntimeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<number>> {
        if (requestParameters.batchId === null || requestParameters.batchId === undefined) {
            throw new runtime.RequiredError('batchId','Required parameter requestParameters.batchId was null or undefined when calling endStopwatchBatchDowntime.');
        }

        if (requestParameters.batchDowntimeReportEndStopwatchView === null || requestParameters.batchDowntimeReportEndStopwatchView === undefined) {
            throw new runtime.RequiredError('batchDowntimeReportEndStopwatchView','Required parameter requestParameters.batchDowntimeReportEndStopwatchView was null or undefined when calling endStopwatchBatchDowntime.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/reports/workstation-reports/downtime/batch/save/{BatchId}/stopwatch/end`.replace(`{${"BatchId"}}`, encodeURIComponent(String(requestParameters.batchId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.batchDowntimeReportEndStopwatchView,
        }, initOverrides);

        return new runtime.TextApiResponse(response) as any;
    }

    /**
     * End stopwatch downtime report for a batch
     */
    async endStopwatchBatchDowntime(requestParameters: EndStopwatchBatchDowntimeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<number> {
        const response = await this.endStopwatchBatchDowntimeRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * End downtime report for a production lot
     */
    async endStopwatchDowntimeRaw(requestParameters: EndStopwatchDowntimeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<number>> {
        if (requestParameters.productionLotId === null || requestParameters.productionLotId === undefined) {
            throw new runtime.RequiredError('productionLotId','Required parameter requestParameters.productionLotId was null or undefined when calling endStopwatchDowntime.');
        }

        if (requestParameters.downtimeReportEndStopwatchView === null || requestParameters.downtimeReportEndStopwatchView === undefined) {
            throw new runtime.RequiredError('downtimeReportEndStopwatchView','Required parameter requestParameters.downtimeReportEndStopwatchView was null or undefined when calling endStopwatchDowntime.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/reports/workstation-reports/downtime/save/{ProductionLotId}/stopwatch/end`.replace(`{${"ProductionLotId"}}`, encodeURIComponent(String(requestParameters.productionLotId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.downtimeReportEndStopwatchView,
        }, initOverrides);

        return new runtime.TextApiResponse(response) as any;
    }

    /**
     * End downtime report for a production lot
     */
    async endStopwatchDowntime(requestParameters: EndStopwatchDowntimeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<number> {
        const response = await this.endStopwatchDowntimeRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Estimate production times for given production lot, machine, and amount combinations
     */
    async estimateProductionTimesRaw(requestParameters: EstimateProductionTimesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<ProductionTimeEstimationResult>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/estimation/production-times`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.productionTimeEstimationItem,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Estimate production times for given production lot, machine, and amount combinations
     */
    async estimateProductionTimes(requestParameters: EstimateProductionTimesRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<ProductionTimeEstimationResult>> {
        const response = await this.estimateProductionTimesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Find recipe version name by product code and ERP
     */
    async getBackApiImportProductCodeProductcodeRaw(requestParameters: GetBackApiImportProductCodeProductcodeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<string>>> {
        if (requestParameters.productCode === null || requestParameters.productCode === undefined) {
            throw new runtime.RequiredError('productCode','Required parameter requestParameters.productCode was null or undefined when calling getBackApiImportProductCodeProductcode.');
        }

        if (requestParameters.erp === null || requestParameters.erp === undefined) {
            throw new runtime.RequiredError('erp','Required parameter requestParameters.erp was null or undefined when calling getBackApiImportProductCodeProductcode.');
        }

        const queryParameters: any = {};

        if (requestParameters.erp !== undefined) {
            queryParameters['erp'] = requestParameters.erp;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/api/import/product-code/{productCode}`.replace(`{${"productCode"}}`, encodeURIComponent(String(requestParameters.productCode))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Find recipe version name by product code and ERP
     */
    async getBackApiImportProductCodeProductcode(requestParameters: GetBackApiImportProductCodeProductcodeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<string>> {
        const response = await this.getBackApiImportProductCodeProductcodeRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Check status of simulation merge
     */
    async getBackApiImportSimulationStatusSimulationidRaw(requestParameters: GetBackApiImportSimulationStatusSimulationidRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<NexelemMergeImportState>> {
        if (requestParameters.simulationId === null || requestParameters.simulationId === undefined) {
            throw new runtime.RequiredError('simulationId','Required parameter requestParameters.simulationId was null or undefined when calling getBackApiImportSimulationStatusSimulationid.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/api/import/simulation/status/{SimulationId}`.replace(`{${"SimulationId"}}`, encodeURIComponent(String(requestParameters.simulationId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Check status of simulation merge
     */
    async getBackApiImportSimulationStatusSimulationid(requestParameters: GetBackApiImportSimulationStatusSimulationidRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<NexelemMergeImportState> {
        const response = await this.getBackApiImportSimulationStatusSimulationidRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 
     */
    async getBackBarcodesGenerateProductionUnitStockitemidRaw(requestParameters: GetBackBarcodesGenerateProductionUnitStockitemidRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Blob>> {
        if (requestParameters.stockItemId === null || requestParameters.stockItemId === undefined) {
            throw new runtime.RequiredError('stockItemId','Required parameter requestParameters.stockItemId was null or undefined when calling getBackBarcodesGenerateProductionUnitStockitemid.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/barcodes/generate/production-unit/{StockItemId}`.replace(`{${"StockItemId"}}`, encodeURIComponent(String(requestParameters.stockItemId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.BlobApiResponse(response);
    }

    /**
     * 
     */
    async getBackBarcodesGenerateProductionUnitStockitemid(requestParameters: GetBackBarcodesGenerateProductionUnitStockitemidRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Blob> {
        const response = await this.getBackBarcodesGenerateProductionUnitStockitemidRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 
     */
    async getBackBarcodesGenerateSupplyItemSupplycarditemidRaw(requestParameters: GetBackBarcodesGenerateSupplyItemSupplycarditemidRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Blob>> {
        if (requestParameters.supplyCardItemId === null || requestParameters.supplyCardItemId === undefined) {
            throw new runtime.RequiredError('supplyCardItemId','Required parameter requestParameters.supplyCardItemId was null or undefined when calling getBackBarcodesGenerateSupplyItemSupplycarditemid.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/barcodes/generate/supply/item/{SupplyCardItemId}`.replace(`{${"SupplyCardItemId"}}`, encodeURIComponent(String(requestParameters.supplyCardItemId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.BlobApiResponse(response);
    }

    /**
     * 
     */
    async getBackBarcodesGenerateSupplyItemSupplycarditemid(requestParameters: GetBackBarcodesGenerateSupplyItemSupplycarditemidRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Blob> {
        const response = await this.getBackBarcodesGenerateSupplyItemSupplycarditemidRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 
     */
    async getBackBarcodesGenerateSupplySupplycardidRaw(requestParameters: GetBackBarcodesGenerateSupplySupplycardidRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Blob>> {
        if (requestParameters.supplyCardId === null || requestParameters.supplyCardId === undefined) {
            throw new runtime.RequiredError('supplyCardId','Required parameter requestParameters.supplyCardId was null or undefined when calling getBackBarcodesGenerateSupplySupplycardid.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/barcodes/generate/supply/{SupplyCardId}`.replace(`{${"SupplyCardId"}}`, encodeURIComponent(String(requestParameters.supplyCardId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.BlobApiResponse(response);
    }

    /**
     * 
     */
    async getBackBarcodesGenerateSupplySupplycardid(requestParameters: GetBackBarcodesGenerateSupplySupplycardidRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Blob> {
        const response = await this.getBackBarcodesGenerateSupplySupplycardidRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 
     */
    async getBackBarcodesResolveVariantRaw(requestParameters: GetBackBarcodesResolveVariantRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ItemTypeVariant>> {
        if (requestParameters.ean === null || requestParameters.ean === undefined) {
            throw new runtime.RequiredError('ean','Required parameter requestParameters.ean was null or undefined when calling getBackBarcodesResolveVariant.');
        }

        if (requestParameters.width === null || requestParameters.width === undefined) {
            throw new runtime.RequiredError('width','Required parameter requestParameters.width was null or undefined when calling getBackBarcodesResolveVariant.');
        }

        const queryParameters: any = {};

        if (requestParameters.ean !== undefined) {
            queryParameters['ean'] = requestParameters.ean;
        }

        if (requestParameters.width !== undefined) {
            queryParameters['width'] = requestParameters.width;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/barcodes/resolve/variant`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * 
     */
    async getBackBarcodesResolveVariant(requestParameters: GetBackBarcodesResolveVariantRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ItemTypeVariant> {
        const response = await this.getBackBarcodesResolveVariantRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get calculation property types
     */
    async getBackCalculationsItemTypePropertiesRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CalculationPropertyTypesView>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/calculations/item-type-properties`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Get calculation property types
     */
    async getBackCalculationsItemTypeProperties(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CalculationPropertyTypesView> {
        const response = await this.getBackCalculationsItemTypePropertiesRaw(initOverrides);
        return await response.value();
    }

    /**
     * 
     */
    async getBackCalculationsItemTypePropertiesPunchingDiesRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<number>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/calculations/item-type-properties/punching-dies`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * 
     */
    async getBackCalculationsItemTypePropertiesPunchingDies(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<number>> {
        const response = await this.getBackCalculationsItemTypePropertiesPunchingDiesRaw(initOverrides);
        return await response.value();
    }

    /**
     * Get machine features
     */
    async getBackCalculationsMachineFeaturesRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<MachineFeature>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/calculations/machine-features`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Get machine features
     */
    async getBackCalculationsMachineFeatures(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<MachineFeature>> {
        const response = await this.getBackCalculationsMachineFeaturesRaw(initOverrides);
        return await response.value();
    }

    /**
     * Get all marketing keepers
     */
    async getBackContractorsAllMarketingKeepersRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<UserView>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/contractors/all-marketing-keepers`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Get all marketing keepers
     */
    async getBackContractorsAllMarketingKeepers(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<UserView>> {
        const response = await this.getBackContractorsAllMarketingKeepersRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async getBackContractorsContactsListHeadersRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<any>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/contractors/contacts/list/headers`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.TextApiResponse(response) as any;
    }

    /**
     */
    async getBackContractorsContactsListHeaders(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<any> {
        const response = await this.getBackContractorsContactsListHeadersRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async getBackContractorsListHeadersRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<any>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/contractors/list/headers`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.TextApiResponse(response) as any;
    }

    /**
     */
    async getBackContractorsListHeaders(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<any> {
        const response = await this.getBackContractorsListHeadersRaw(initOverrides);
        return await response.value();
    }

    /**
     * Get all marketing keepers
     */
    async getBackContractorsMarketingKeepersRaw(requestParameters: GetBackContractorsMarketingKeepersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<UserView>>> {
        const queryParameters: any = {};

        if (requestParameters.userIds) {
            queryParameters['userIds'] = requestParameters.userIds;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/contractors/marketing-keepers`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Get all marketing keepers
     */
    async getBackContractorsMarketingKeepers(requestParameters: GetBackContractorsMarketingKeepersRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<UserView>> {
        const response = await this.getBackContractorsMarketingKeepersRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getBackContractorsMarketingKeepersListHeadersRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<any>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/contractors/marketing-keepers/list/headers`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.TextApiResponse(response) as any;
    }

    /**
     */
    async getBackContractorsMarketingKeepersListHeaders(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<any> {
        const response = await this.getBackContractorsMarketingKeepersListHeadersRaw(initOverrides);
        return await response.value();
    }

    /**
     * Get ContractorView by ContractorId
     */
    async getBackContractorsP1Raw(requestParameters: GetBackContractorsP1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ContractorView>> {
        if (requestParameters.p1 === null || requestParameters.p1 === undefined) {
            throw new runtime.RequiredError('p1','Required parameter requestParameters.p1 was null or undefined when calling getBackContractorsP1.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/contractors/{p1}`.replace(`{${"p1"}}`, encodeURIComponent(String(requestParameters.p1))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Get ContractorView by ContractorId
     */
    async getBackContractorsP1(requestParameters: GetBackContractorsP1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ContractorView> {
        const response = await this.getBackContractorsP1Raw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get all contacts by ContractorId
     */
    async getBackContractorsP1AllContactsRaw(requestParameters: GetBackContractorsP1AllContactsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<Contact>>> {
        if (requestParameters.p1 === null || requestParameters.p1 === undefined) {
            throw new runtime.RequiredError('p1','Required parameter requestParameters.p1 was null or undefined when calling getBackContractorsP1AllContacts.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/contractors/{p1}/all-contacts`.replace(`{${"p1"}}`, encodeURIComponent(String(requestParameters.p1))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Get all contacts by ContractorId
     */
    async getBackContractorsP1AllContacts(requestParameters: GetBackContractorsP1AllContactsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<Contact>> {
        const response = await this.getBackContractorsP1AllContactsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Returns list of bank accounts for the contractor
     */
    async getBackContractorsP1BankAccountsRaw(requestParameters: GetBackContractorsP1BankAccountsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<BankAccount>>> {
        if (requestParameters.p1 === null || requestParameters.p1 === undefined) {
            throw new runtime.RequiredError('p1','Required parameter requestParameters.p1 was null or undefined when calling getBackContractorsP1BankAccounts.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/contractors/{p1}/bank-accounts`.replace(`{${"p1"}}`, encodeURIComponent(String(requestParameters.p1))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Returns list of bank accounts for the contractor
     */
    async getBackContractorsP1BankAccounts(requestParameters: GetBackContractorsP1BankAccountsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<BankAccount>> {
        const response = await this.getBackContractorsP1BankAccountsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get users assignable as marketing keepers by ContractorId
     */
    async getBackContractorsP1EligibleMarketingKeepersRaw(requestParameters: GetBackContractorsP1EligibleMarketingKeepersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<UserView>>> {
        if (requestParameters.p1 === null || requestParameters.p1 === undefined) {
            throw new runtime.RequiredError('p1','Required parameter requestParameters.p1 was null or undefined when calling getBackContractorsP1EligibleMarketingKeepers.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/contractors/{p1}/eligible-marketing-keepers`.replace(`{${"p1"}}`, encodeURIComponent(String(requestParameters.p1))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Get users assignable as marketing keepers by ContractorId
     */
    async getBackContractorsP1EligibleMarketingKeepers(requestParameters: GetBackContractorsP1EligibleMarketingKeepersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<UserView>> {
        const response = await this.getBackContractorsP1EligibleMarketingKeepersRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get primary adress by ContractorId
     */
    async getBackContractorsP1PrimaryAddressRaw(requestParameters: GetBackContractorsP1PrimaryAddressRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Address>> {
        if (requestParameters.p1 === null || requestParameters.p1 === undefined) {
            throw new runtime.RequiredError('p1','Required parameter requestParameters.p1 was null or undefined when calling getBackContractorsP1PrimaryAddress.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/contractors/{p1}/primary-address`.replace(`{${"p1"}}`, encodeURIComponent(String(requestParameters.p1))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Get primary adress by ContractorId
     */
    async getBackContractorsP1PrimaryAddress(requestParameters: GetBackContractorsP1PrimaryAddressRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Address> {
        const response = await this.getBackContractorsP1PrimaryAddressRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Search for contractors by name or external id
     */
    async getBackContractorsSearchNameOrExternalIdRaw(requestParameters: GetBackContractorsSearchNameOrExternalIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<ContractorShortView>>> {
        if (requestParameters.text === null || requestParameters.text === undefined) {
            throw new runtime.RequiredError('text','Required parameter requestParameters.text was null or undefined when calling getBackContractorsSearchNameOrExternalId.');
        }

        if (requestParameters.inactive === null || requestParameters.inactive === undefined) {
            throw new runtime.RequiredError('inactive','Required parameter requestParameters.inactive was null or undefined when calling getBackContractorsSearchNameOrExternalId.');
        }

        if (requestParameters.maxResults === null || requestParameters.maxResults === undefined) {
            throw new runtime.RequiredError('maxResults','Required parameter requestParameters.maxResults was null or undefined when calling getBackContractorsSearchNameOrExternalId.');
        }

        const queryParameters: any = {};

        if (requestParameters.text !== undefined) {
            queryParameters['text'] = requestParameters.text;
        }

        if (requestParameters.inactive !== undefined) {
            queryParameters['inactive'] = requestParameters.inactive;
        }

        if (requestParameters.maxResults !== undefined) {
            queryParameters['maxResults'] = requestParameters.maxResults;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/contractors/search/name-or-external-id`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Search for contractors by name or external id
     */
    async getBackContractorsSearchNameOrExternalId(requestParameters: GetBackContractorsSearchNameOrExternalIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<ContractorShortView>> {
        const response = await this.getBackContractorsSearchNameOrExternalIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Search contractor tags
     */
    async getBackContractorsTagsSearchRaw(requestParameters: GetBackContractorsTagsSearchRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<string>>> {
        if (requestParameters.text === null || requestParameters.text === undefined) {
            throw new runtime.RequiredError('text','Required parameter requestParameters.text was null or undefined when calling getBackContractorsTagsSearch.');
        }

        if (requestParameters.maxResults === null || requestParameters.maxResults === undefined) {
            throw new runtime.RequiredError('maxResults','Required parameter requestParameters.maxResults was null or undefined when calling getBackContractorsTagsSearch.');
        }

        const queryParameters: any = {};

        if (requestParameters.text !== undefined) {
            queryParameters['text'] = requestParameters.text;
        }

        if (requestParameters.contractorTagIds) {
            queryParameters['contractorTagIds'] = requestParameters.contractorTagIds;
        }

        if (requestParameters.maxResults !== undefined) {
            queryParameters['maxResults'] = requestParameters.maxResults;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/contractors/tags/search`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Search contractor tags
     */
    async getBackContractorsTagsSearch(requestParameters: GetBackContractorsTagsSearchRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<string>> {
        const response = await this.getBackContractorsTagsSearchRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Search contractor tags
     */
    async getBackContractorsTagsWithIdsSearchRaw(requestParameters: GetBackContractorsTagsWithIdsSearchRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<ContractorTag>>> {
        if (requestParameters.maxResults === null || requestParameters.maxResults === undefined) {
            throw new runtime.RequiredError('maxResults','Required parameter requestParameters.maxResults was null or undefined when calling getBackContractorsTagsWithIdsSearch.');
        }

        const queryParameters: any = {};

        if (requestParameters.text !== undefined) {
            queryParameters['text'] = requestParameters.text;
        }

        if (requestParameters.contractorTagIds) {
            queryParameters['contractorTagIds'] = requestParameters.contractorTagIds;
        }

        if (requestParameters.maxResults !== undefined) {
            queryParameters['maxResults'] = requestParameters.maxResults;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/contractors/tags-with-ids/search`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Search contractor tags
     */
    async getBackContractorsTagsWithIdsSearch(requestParameters: GetBackContractorsTagsWithIdsSearchRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<ContractorTag>> {
        const response = await this.getBackContractorsTagsWithIdsSearchRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Providing general app configuration for front-end
     */
    async getBackDevConfigurationRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AppConfiguration>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/back/dev/configuration`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Providing general app configuration for front-end
     */
    async getBackDevConfiguration(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AppConfiguration> {
        const response = await this.getBackDevConfigurationRaw(initOverrides);
        return await response.value();
    }

    /**
     * Serving PiwikPro code snippet used for tracking user behavior
     */
    async getBackDevPiwikBodySnippetRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<string>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/dev/piwik-body-snippet`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.TextApiResponse(response) as any;
    }

    /**
     * Serving PiwikPro code snippet used for tracking user behavior
     */
    async getBackDevPiwikBodySnippet(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<string> {
        const response = await this.getBackDevPiwikBodySnippetRaw(initOverrides);
        return await response.value();
    }

    /**
     * Start full inbound synchronization
     */
    async getBackDevSynchronizeErpRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<MessagesAction>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/dev/synchronize-erp`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Start full inbound synchronization
     */
    async getBackDevSynchronizeErp(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<MessagesAction>> {
        const response = await this.getBackDevSynchronizeErpRaw(initOverrides);
        return await response.value();
    }

    /**
     * Synchronize ERP documents
     */
    async getBackDevSynchronizeErpDocumentsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AjaxActionResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/dev/synchronize-erp-documents`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Synchronize ERP documents
     */
    async getBackDevSynchronizeErpDocuments(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AjaxActionResponse> {
        const response = await this.getBackDevSynchronizeErpDocumentsRaw(initOverrides);
        return await response.value();
    }

    /**
     * Get confirmation documents for batch
     */
    async getBackDocumentsBatchBatchidConfirmationsRaw(requestParameters: GetBackDocumentsBatchBatchidConfirmationsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<ProductionConfirmationDocumentStatusView>>> {
        if (requestParameters.batchId === null || requestParameters.batchId === undefined) {
            throw new runtime.RequiredError('batchId','Required parameter requestParameters.batchId was null or undefined when calling getBackDocumentsBatchBatchidConfirmations.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/documents/batch/{BatchId}/confirmations`.replace(`{${"BatchId"}}`, encodeURIComponent(String(requestParameters.batchId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Get confirmation documents for batch
     */
    async getBackDocumentsBatchBatchidConfirmations(requestParameters: GetBackDocumentsBatchBatchidConfirmationsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<ProductionConfirmationDocumentStatusView>> {
        const response = await this.getBackDocumentsBatchBatchidConfirmationsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getBackDocumentsDocumentStatusListHeadersRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<any>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/documents/document-status/list/headers`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.TextApiResponse(response) as any;
    }

    /**
     */
    async getBackDocumentsDocumentStatusListHeaders(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<any> {
        const response = await this.getBackDocumentsDocumentStatusListHeadersRaw(initOverrides);
        return await response.value();
    }

    /**
     * Get document status
     */
    async getBackDocumentsDocumentStatusP1Raw(requestParameters: GetBackDocumentsDocumentStatusP1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DocumentStatusView>> {
        if (requestParameters.p1 === null || requestParameters.p1 === undefined) {
            throw new runtime.RequiredError('p1','Required parameter requestParameters.p1 was null or undefined when calling getBackDocumentsDocumentStatusP1.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/documents/document-status/{p1}`.replace(`{${"p1"}}`, encodeURIComponent(String(requestParameters.p1))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Get document status
     */
    async getBackDocumentsDocumentStatusP1(requestParameters: GetBackDocumentsDocumentStatusP1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DocumentStatusView> {
        const response = await this.getBackDocumentsDocumentStatusP1Raw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 
     */
    async getBackDocumentsErpInterfaceRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<string>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/documents/erp/interface`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.TextApiResponse(response) as any;
    }

    /**
     * 
     */
    async getBackDocumentsErpInterface(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<string> {
        const response = await this.getBackDocumentsErpInterfaceRaw(initOverrides);
        return await response.value();
    }

    /**
     * Get offer PDF document with contact
     */
    async getBackDocumentsOfferOfferidP1PdfRaw(requestParameters: GetBackDocumentsOfferOfferidP1PdfRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Blob>> {
        if (requestParameters.offerId === null || requestParameters.offerId === undefined) {
            throw new runtime.RequiredError('offerId','Required parameter requestParameters.offerId was null or undefined when calling getBackDocumentsOfferOfferidP1Pdf.');
        }

        if (requestParameters.p1 === null || requestParameters.p1 === undefined) {
            throw new runtime.RequiredError('p1','Required parameter requestParameters.p1 was null or undefined when calling getBackDocumentsOfferOfferidP1Pdf.');
        }

        if (requestParameters.showSummary === null || requestParameters.showSummary === undefined) {
            throw new runtime.RequiredError('showSummary','Required parameter requestParameters.showSummary was null or undefined when calling getBackDocumentsOfferOfferidP1Pdf.');
        }

        if (requestParameters.showDiscount === null || requestParameters.showDiscount === undefined) {
            throw new runtime.RequiredError('showDiscount','Required parameter requestParameters.showDiscount was null or undefined when calling getBackDocumentsOfferOfferidP1Pdf.');
        }

        if (requestParameters.showTechnology === null || requestParameters.showTechnology === undefined) {
            throw new runtime.RequiredError('showTechnology','Required parameter requestParameters.showTechnology was null or undefined when calling getBackDocumentsOfferOfferidP1Pdf.');
        }

        const queryParameters: any = {};

        if (requestParameters.showSummary !== undefined) {
            queryParameters['showSummary'] = requestParameters.showSummary;
        }

        if (requestParameters.showDiscount !== undefined) {
            queryParameters['showDiscount'] = requestParameters.showDiscount;
        }

        if (requestParameters.showTechnology !== undefined) {
            queryParameters['showTechnology'] = requestParameters.showTechnology;
        }

        if (requestParameters.templateId !== undefined) {
            queryParameters['templateId'] = requestParameters.templateId;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/documents/offer/{offerId}/{p1}/pdf`.replace(`{${"offerId"}}`, encodeURIComponent(String(requestParameters.offerId))).replace(`{${"p1"}}`, encodeURIComponent(String(requestParameters.p1))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.BlobApiResponse(response);
    }

    /**
     * Get offer PDF document with contact
     */
    async getBackDocumentsOfferOfferidP1Pdf(requestParameters: GetBackDocumentsOfferOfferidP1PdfRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Blob> {
        const response = await this.getBackDocumentsOfferOfferidP1PdfRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get offer PDF document
     */
    async getBackDocumentsOfferOfferidPdfRaw(requestParameters: GetBackDocumentsOfferOfferidPdfRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Blob>> {
        if (requestParameters.offerId === null || requestParameters.offerId === undefined) {
            throw new runtime.RequiredError('offerId','Required parameter requestParameters.offerId was null or undefined when calling getBackDocumentsOfferOfferidPdf.');
        }

        if (requestParameters.showSummary === null || requestParameters.showSummary === undefined) {
            throw new runtime.RequiredError('showSummary','Required parameter requestParameters.showSummary was null or undefined when calling getBackDocumentsOfferOfferidPdf.');
        }

        if (requestParameters.showDiscount === null || requestParameters.showDiscount === undefined) {
            throw new runtime.RequiredError('showDiscount','Required parameter requestParameters.showDiscount was null or undefined when calling getBackDocumentsOfferOfferidPdf.');
        }

        if (requestParameters.showTechnology === null || requestParameters.showTechnology === undefined) {
            throw new runtime.RequiredError('showTechnology','Required parameter requestParameters.showTechnology was null or undefined when calling getBackDocumentsOfferOfferidPdf.');
        }

        const queryParameters: any = {};

        if (requestParameters.showSummary !== undefined) {
            queryParameters['showSummary'] = requestParameters.showSummary;
        }

        if (requestParameters.showDiscount !== undefined) {
            queryParameters['showDiscount'] = requestParameters.showDiscount;
        }

        if (requestParameters.showTechnology !== undefined) {
            queryParameters['showTechnology'] = requestParameters.showTechnology;
        }

        if (requestParameters.templateId !== undefined) {
            queryParameters['templateId'] = requestParameters.templateId;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/documents/offer/{offerId}/pdf`.replace(`{${"offerId"}}`, encodeURIComponent(String(requestParameters.offerId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.BlobApiResponse(response);
    }

    /**
     * Get offer PDF document
     */
    async getBackDocumentsOfferOfferidPdf(requestParameters: GetBackDocumentsOfferOfferidPdfRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Blob> {
        const response = await this.getBackDocumentsOfferOfferidPdfRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get order PDF document with contact
     */
    async getBackDocumentsOrderOrderidP1PdfRaw(requestParameters: GetBackDocumentsOrderOrderidP1PdfRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Blob>> {
        if (requestParameters.orderId === null || requestParameters.orderId === undefined) {
            throw new runtime.RequiredError('orderId','Required parameter requestParameters.orderId was null or undefined when calling getBackDocumentsOrderOrderidP1Pdf.');
        }

        if (requestParameters.p1 === null || requestParameters.p1 === undefined) {
            throw new runtime.RequiredError('p1','Required parameter requestParameters.p1 was null or undefined when calling getBackDocumentsOrderOrderidP1Pdf.');
        }

        if (requestParameters.showSummary === null || requestParameters.showSummary === undefined) {
            throw new runtime.RequiredError('showSummary','Required parameter requestParameters.showSummary was null or undefined when calling getBackDocumentsOrderOrderidP1Pdf.');
        }

        if (requestParameters.showDiscount === null || requestParameters.showDiscount === undefined) {
            throw new runtime.RequiredError('showDiscount','Required parameter requestParameters.showDiscount was null or undefined when calling getBackDocumentsOrderOrderidP1Pdf.');
        }

        if (requestParameters.showTechnology === null || requestParameters.showTechnology === undefined) {
            throw new runtime.RequiredError('showTechnology','Required parameter requestParameters.showTechnology was null or undefined when calling getBackDocumentsOrderOrderidP1Pdf.');
        }

        const queryParameters: any = {};

        if (requestParameters.showSummary !== undefined) {
            queryParameters['showSummary'] = requestParameters.showSummary;
        }

        if (requestParameters.showDiscount !== undefined) {
            queryParameters['showDiscount'] = requestParameters.showDiscount;
        }

        if (requestParameters.showTechnology !== undefined) {
            queryParameters['showTechnology'] = requestParameters.showTechnology;
        }

        if (requestParameters.templateId !== undefined) {
            queryParameters['templateId'] = requestParameters.templateId;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/documents/order/{orderId}/{p1}/pdf`.replace(`{${"orderId"}}`, encodeURIComponent(String(requestParameters.orderId))).replace(`{${"p1"}}`, encodeURIComponent(String(requestParameters.p1))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.BlobApiResponse(response);
    }

    /**
     * Get order PDF document with contact
     */
    async getBackDocumentsOrderOrderidP1Pdf(requestParameters: GetBackDocumentsOrderOrderidP1PdfRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Blob> {
        const response = await this.getBackDocumentsOrderOrderidP1PdfRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get order PDF document
     */
    async getBackDocumentsOrderOrderidPdfRaw(requestParameters: GetBackDocumentsOrderOrderidPdfRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Blob>> {
        if (requestParameters.orderId === null || requestParameters.orderId === undefined) {
            throw new runtime.RequiredError('orderId','Required parameter requestParameters.orderId was null or undefined when calling getBackDocumentsOrderOrderidPdf.');
        }

        if (requestParameters.showSummary === null || requestParameters.showSummary === undefined) {
            throw new runtime.RequiredError('showSummary','Required parameter requestParameters.showSummary was null or undefined when calling getBackDocumentsOrderOrderidPdf.');
        }

        if (requestParameters.showDiscount === null || requestParameters.showDiscount === undefined) {
            throw new runtime.RequiredError('showDiscount','Required parameter requestParameters.showDiscount was null or undefined when calling getBackDocumentsOrderOrderidPdf.');
        }

        if (requestParameters.showTechnology === null || requestParameters.showTechnology === undefined) {
            throw new runtime.RequiredError('showTechnology','Required parameter requestParameters.showTechnology was null or undefined when calling getBackDocumentsOrderOrderidPdf.');
        }

        const queryParameters: any = {};

        if (requestParameters.showSummary !== undefined) {
            queryParameters['showSummary'] = requestParameters.showSummary;
        }

        if (requestParameters.showDiscount !== undefined) {
            queryParameters['showDiscount'] = requestParameters.showDiscount;
        }

        if (requestParameters.showTechnology !== undefined) {
            queryParameters['showTechnology'] = requestParameters.showTechnology;
        }

        if (requestParameters.templateId !== undefined) {
            queryParameters['templateId'] = requestParameters.templateId;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/documents/order/{orderId}/pdf`.replace(`{${"orderId"}}`, encodeURIComponent(String(requestParameters.orderId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.BlobApiResponse(response);
    }

    /**
     * Get order PDF document
     */
    async getBackDocumentsOrderOrderidPdf(requestParameters: GetBackDocumentsOrderOrderidPdfRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Blob> {
        const response = await this.getBackDocumentsOrderOrderidPdfRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get label view
     */
    async getBackDocumentsPrinterProductionlotidLabelViewRaw(requestParameters: GetBackDocumentsPrinterProductionlotidLabelViewRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<LabelEditabilityView>> {
        if (requestParameters.productionLotId === null || requestParameters.productionLotId === undefined) {
            throw new runtime.RequiredError('productionLotId','Required parameter requestParameters.productionLotId was null or undefined when calling getBackDocumentsPrinterProductionlotidLabelView.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/documents/printer/{ProductionLotId}/label-view`.replace(`{${"ProductionLotId"}}`, encodeURIComponent(String(requestParameters.productionLotId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Get label view
     */
    async getBackDocumentsPrinterProductionlotidLabelView(requestParameters: GetBackDocumentsPrinterProductionlotidLabelViewRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<LabelEditabilityView> {
        const response = await this.getBackDocumentsPrinterProductionlotidLabelViewRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Search printer
     */
    async getBackDocumentsPrinterSearchPrintersRaw(requestParameters: GetBackDocumentsPrinterSearchPrintersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<PrinterView>>> {
        if (requestParameters.text === null || requestParameters.text === undefined) {
            throw new runtime.RequiredError('text','Required parameter requestParameters.text was null or undefined when calling getBackDocumentsPrinterSearchPrinters.');
        }

        if (requestParameters.maxResults === null || requestParameters.maxResults === undefined) {
            throw new runtime.RequiredError('maxResults','Required parameter requestParameters.maxResults was null or undefined when calling getBackDocumentsPrinterSearchPrinters.');
        }

        const queryParameters: any = {};

        if (requestParameters.text !== undefined) {
            queryParameters['text'] = requestParameters.text;
        }

        if (requestParameters.maxResults !== undefined) {
            queryParameters['maxResults'] = requestParameters.maxResults;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/documents/printer/search/printers`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Search printer
     */
    async getBackDocumentsPrinterSearchPrinters(requestParameters: GetBackDocumentsPrinterSearchPrintersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<PrinterView>> {
        const response = await this.getBackDocumentsPrinterSearchPrintersRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Search ZPL templates
     */
    async getBackDocumentsPrinterSearchTemplatesRaw(requestParameters: GetBackDocumentsPrinterSearchTemplatesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<TemplateView>>> {
        if (requestParameters.text === null || requestParameters.text === undefined) {
            throw new runtime.RequiredError('text','Required parameter requestParameters.text was null or undefined when calling getBackDocumentsPrinterSearchTemplates.');
        }

        if (requestParameters.maxResults === null || requestParameters.maxResults === undefined) {
            throw new runtime.RequiredError('maxResults','Required parameter requestParameters.maxResults was null or undefined when calling getBackDocumentsPrinterSearchTemplates.');
        }

        const queryParameters: any = {};

        if (requestParameters.text !== undefined) {
            queryParameters['text'] = requestParameters.text;
        }

        if (requestParameters.maxResults !== undefined) {
            queryParameters['maxResults'] = requestParameters.maxResults;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/documents/printer/search/templates`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Search ZPL templates
     */
    async getBackDocumentsPrinterSearchTemplates(requestParameters: GetBackDocumentsPrinterSearchTemplatesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<TemplateView>> {
        const response = await this.getBackDocumentsPrinterSearchTemplatesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Search templates of type
     */
    async getBackDocumentsPrinterSearchTemplatesOfTypeP1Raw(requestParameters: GetBackDocumentsPrinterSearchTemplatesOfTypeP1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<TemplateView>>> {
        if (requestParameters.p1 === null || requestParameters.p1 === undefined) {
            throw new runtime.RequiredError('p1','Required parameter requestParameters.p1 was null or undefined when calling getBackDocumentsPrinterSearchTemplatesOfTypeP1.');
        }

        if (requestParameters.text === null || requestParameters.text === undefined) {
            throw new runtime.RequiredError('text','Required parameter requestParameters.text was null or undefined when calling getBackDocumentsPrinterSearchTemplatesOfTypeP1.');
        }

        if (requestParameters.maxResults === null || requestParameters.maxResults === undefined) {
            throw new runtime.RequiredError('maxResults','Required parameter requestParameters.maxResults was null or undefined when calling getBackDocumentsPrinterSearchTemplatesOfTypeP1.');
        }

        const queryParameters: any = {};

        if (requestParameters.text !== undefined) {
            queryParameters['text'] = requestParameters.text;
        }

        if (requestParameters.maxResults !== undefined) {
            queryParameters['maxResults'] = requestParameters.maxResults;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/documents/printer/search/templates/of-type/{p1}`.replace(`{${"p1"}}`, encodeURIComponent(String(requestParameters.p1))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Search templates of type
     */
    async getBackDocumentsPrinterSearchTemplatesOfTypeP1(requestParameters: GetBackDocumentsPrinterSearchTemplatesOfTypeP1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<TemplateView>> {
        const response = await this.getBackDocumentsPrinterSearchTemplatesOfTypeP1Raw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get confirmation documents for production lot
     */
    async getBackDocumentsProductionLotProductionlotidConfirmationsRaw(requestParameters: GetBackDocumentsProductionLotProductionlotidConfirmationsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<ProductionConfirmationDocumentStatusView>>> {
        if (requestParameters.productionLotId === null || requestParameters.productionLotId === undefined) {
            throw new runtime.RequiredError('productionLotId','Required parameter requestParameters.productionLotId was null or undefined when calling getBackDocumentsProductionLotProductionlotidConfirmations.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/documents/production-lot/{ProductionLotId}/confirmations`.replace(`{${"ProductionLotId"}}`, encodeURIComponent(String(requestParameters.productionLotId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Get confirmation documents for production lot
     */
    async getBackDocumentsProductionLotProductionlotidConfirmations(requestParameters: GetBackDocumentsProductionLotProductionlotidConfirmationsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<ProductionConfirmationDocumentStatusView>> {
        const response = await this.getBackDocumentsProductionLotProductionlotidConfirmationsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Fetches last sync date of production order executions
     */
    async getBackErpSynchronizationFetchLastExecutionsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<string>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/erp/synchronization/fetch/last/executions`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.TextApiResponse(response) as any;
    }

    /**
     * Fetches last sync date of production order executions
     */
    async getBackErpSynchronizationFetchLastExecutions(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<string> {
        const response = await this.getBackErpSynchronizationFetchLastExecutionsRaw(initOverrides);
        return await response.value();
    }

    /**
     * Run contractors synchronization
     */
    async getBackErpSynchronizationRunContractorsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AjaxActionResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/erp/synchronization/run/contractors`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Run contractors synchronization
     */
    async getBackErpSynchronizationRunContractors(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AjaxActionResponse> {
        const response = await this.getBackErpSynchronizationRunContractorsRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async getBackErpSynchronizationStatusesHeadersRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<any>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/erp/synchronization/statuses/headers`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.TextApiResponse(response) as any;
    }

    /**
     */
    async getBackErpSynchronizationStatusesHeaders(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<any> {
        const response = await this.getBackErpSynchronizationStatusesHeadersRaw(initOverrides);
        return await response.value();
    }

    /**
     * Get all machines available for user with given production lot
     */
    async getBackEstimationMachinesP1Raw(requestParameters: GetBackEstimationMachinesP1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<BasicMachinePlanningView>>> {
        if (requestParameters.p1 === null || requestParameters.p1 === undefined) {
            throw new runtime.RequiredError('p1','Required parameter requestParameters.p1 was null or undefined when calling getBackEstimationMachinesP1.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/estimation/machines/{p1}`.replace(`{${"p1"}}`, encodeURIComponent(String(requestParameters.p1))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Get all machines available for user with given production lot
     */
    async getBackEstimationMachinesP1(requestParameters: GetBackEstimationMachinesP1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<BasicMachinePlanningView>> {
        const response = await this.getBackEstimationMachinesP1Raw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get all machines with estimations available for user with given production lot
     */
    async getBackEstimationMachinesWithEstimationsP1Raw(requestParameters: GetBackEstimationMachinesWithEstimationsP1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<MachinePlanningView>>> {
        if (requestParameters.p1 === null || requestParameters.p1 === undefined) {
            throw new runtime.RequiredError('p1','Required parameter requestParameters.p1 was null or undefined when calling getBackEstimationMachinesWithEstimationsP1.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/estimation/machines-with-estimations/{p1}`.replace(`{${"p1"}}`, encodeURIComponent(String(requestParameters.p1))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Get all machines with estimations available for user with given production lot
     */
    async getBackEstimationMachinesWithEstimationsP1(requestParameters: GetBackEstimationMachinesWithEstimationsP1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<MachinePlanningView>> {
        const response = await this.getBackEstimationMachinesWithEstimationsP1Raw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 
     */
    async getBackEventsConfigurationNotificationSystemSettingsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<NotificationSystemSettings>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/events/configuration/notification-system-settings`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * 
     */
    async getBackEventsConfigurationNotificationSystemSettings(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<NotificationSystemSettings> {
        const response = await this.getBackEventsConfigurationNotificationSystemSettingsRaw(initOverrides);
        return await response.value();
    }

    /**
     * Deactivates item for the specified id
     */
    async getBackItemsDeactivateP1Raw(requestParameters: GetBackItemsDeactivateP1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<number>> {
        if (requestParameters.p1 === null || requestParameters.p1 === undefined) {
            throw new runtime.RequiredError('p1','Required parameter requestParameters.p1 was null or undefined when calling getBackItemsDeactivateP1.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/items/deactivate/{p1}`.replace(`{${"p1"}}`, encodeURIComponent(String(requestParameters.p1))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.TextApiResponse(response) as any;
    }

    /**
     * Deactivates item for the specified id
     */
    async getBackItemsDeactivateP1(requestParameters: GetBackItemsDeactivateP1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<number> {
        const response = await this.getBackItemsDeactivateP1Raw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Returns list of all currencies
     */
    async getBackItemsExchangeRatesAllRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<string>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/items/exchange/rates/all`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Returns list of all currencies
     */
    async getBackItemsExchangeRatesAll(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<string>> {
        const response = await this.getBackItemsExchangeRatesAllRaw(initOverrides);
        return await response.value();
    }

    /**
     * 
     */
    async getBackItemsItemHistoryP1Raw(requestParameters: GetBackItemsItemHistoryP1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<EntityVersionTW>>> {
        if (requestParameters.p1 === null || requestParameters.p1 === undefined) {
            throw new runtime.RequiredError('p1','Required parameter requestParameters.p1 was null or undefined when calling getBackItemsItemHistoryP1.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/items/item/history/{p1}`.replace(`{${"p1"}}`, encodeURIComponent(String(requestParameters.p1))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * 
     */
    async getBackItemsItemHistoryP1(requestParameters: GetBackItemsItemHistoryP1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<EntityVersionTW>> {
        const response = await this.getBackItemsItemHistoryP1Raw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Returns item for the specified id
     */
    async getBackItemsItemP1Raw(requestParameters: GetBackItemsItemP1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ItemTypeView>> {
        if (requestParameters.p1 === null || requestParameters.p1 === undefined) {
            throw new runtime.RequiredError('p1','Required parameter requestParameters.p1 was null or undefined when calling getBackItemsItemP1.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/items/item/{p1}`.replace(`{${"p1"}}`, encodeURIComponent(String(requestParameters.p1))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Returns item for the specified id
     */
    async getBackItemsItemP1(requestParameters: GetBackItemsItemP1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ItemTypeView> {
        const response = await this.getBackItemsItemP1Raw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getBackItemsItemTypeTagsListHeadersRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<any>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/items/item-type-tags/list/headers`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.TextApiResponse(response) as any;
    }

    /**
     */
    async getBackItemsItemTypeTagsListHeaders(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<any> {
        const response = await this.getBackItemsItemTypeTagsListHeadersRaw(initOverrides);
        return await response.value();
    }

    /**
     * Get parameter values of given ItemTypePropertyTypeId
     */
    async getBackItemsP1ParameterValuesRaw(requestParameters: GetBackItemsP1ParameterValuesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SearchResponseString>> {
        if (requestParameters.p1 === null || requestParameters.p1 === undefined) {
            throw new runtime.RequiredError('p1','Required parameter requestParameters.p1 was null or undefined when calling getBackItemsP1ParameterValues.');
        }

        if (requestParameters.text === null || requestParameters.text === undefined) {
            throw new runtime.RequiredError('text','Required parameter requestParameters.text was null or undefined when calling getBackItemsP1ParameterValues.');
        }

        if (requestParameters.maxResults === null || requestParameters.maxResults === undefined) {
            throw new runtime.RequiredError('maxResults','Required parameter requestParameters.maxResults was null or undefined when calling getBackItemsP1ParameterValues.');
        }

        const queryParameters: any = {};

        if (requestParameters.text !== undefined) {
            queryParameters['text'] = requestParameters.text;
        }

        if (requestParameters.maxResults !== undefined) {
            queryParameters['maxResults'] = requestParameters.maxResults;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/items/{p1}/parameter-values`.replace(`{${"p1"}}`, encodeURIComponent(String(requestParameters.p1))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Get parameter values of given ItemTypePropertyTypeId
     */
    async getBackItemsP1ParameterValues(requestParameters: GetBackItemsP1ParameterValuesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SearchResponseString> {
        const response = await this.getBackItemsP1ParameterValuesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 
     */
    async getBackItemsP1VariantsRaw(requestParameters: GetBackItemsP1VariantsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<ContextualItemTypeVariant>>> {
        if (requestParameters.p1 === null || requestParameters.p1 === undefined) {
            throw new runtime.RequiredError('p1','Required parameter requestParameters.p1 was null or undefined when calling getBackItemsP1Variants.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/items/{p1}/variants`.replace(`{${"p1"}}`, encodeURIComponent(String(requestParameters.p1))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * 
     */
    async getBackItemsP1Variants(requestParameters: GetBackItemsP1VariantsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<ContextualItemTypeVariant>> {
        const response = await this.getBackItemsP1VariantsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getBackItemsPriceListsHeadersRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<any>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/items/price-lists/headers`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.TextApiResponse(response) as any;
    }

    /**
     */
    async getBackItemsPriceListsHeaders(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<any> {
        const response = await this.getBackItemsPriceListsHeadersRaw(initOverrides);
        return await response.value();
    }

    /**
     * Save price list
     */
    async getBackItemsPriceListsSaveRaw(requestParameters: GetBackItemsPriceListsSaveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<number>> {
        if (requestParameters.priceList === null || requestParameters.priceList === undefined) {
            throw new runtime.RequiredError('priceList','Required parameter requestParameters.priceList was null or undefined when calling getBackItemsPriceListsSave.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/items/price-lists/save`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.priceList,
        }, initOverrides);

        return new runtime.TextApiResponse(response) as any;
    }

    /**
     * Save price list
     */
    async getBackItemsPriceListsSave(requestParameters: GetBackItemsPriceListsSaveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<number> {
        const response = await this.getBackItemsPriceListsSaveRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getBackItemsPropertySetsListHeadersRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<any>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/items/property-sets/list/headers`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.TextApiResponse(response) as any;
    }

    /**
     */
    async getBackItemsPropertySetsListHeaders(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<any> {
        const response = await this.getBackItemsPropertySetsListHeadersRaw(initOverrides);
        return await response.value();
    }

    /**
     * 
     */
    async getBackItemsPropertyTypesRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<ItemTypePropertyType>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/items/property/types`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * 
     */
    async getBackItemsPropertyTypes(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<ItemTypePropertyType>> {
        const response = await this.getBackItemsPropertyTypesRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async getBackItemsPropertyTypesHeadersRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<any>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/items/property/types/headers`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.TextApiResponse(response) as any;
    }

    /**
     */
    async getBackItemsPropertyTypesHeaders(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<any> {
        const response = await this.getBackItemsPropertyTypesHeadersRaw(initOverrides);
        return await response.value();
    }

    /**
     * 
     */
    async getBackItemsPropertyTypesSearchRaw(requestParameters: GetBackItemsPropertyTypesSearchRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<ItemTypePropertyType>>> {
        if (requestParameters.text === null || requestParameters.text === undefined) {
            throw new runtime.RequiredError('text','Required parameter requestParameters.text was null or undefined when calling getBackItemsPropertyTypesSearch.');
        }

        if (requestParameters.maxResults === null || requestParameters.maxResults === undefined) {
            throw new runtime.RequiredError('maxResults','Required parameter requestParameters.maxResults was null or undefined when calling getBackItemsPropertyTypesSearch.');
        }

        const queryParameters: any = {};

        if (requestParameters.text !== undefined) {
            queryParameters['text'] = requestParameters.text;
        }

        if (requestParameters.maxResults !== undefined) {
            queryParameters['maxResults'] = requestParameters.maxResults;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/items/property/types/search`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * 
     */
    async getBackItemsPropertyTypesSearch(requestParameters: GetBackItemsPropertyTypesSearchRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<ItemTypePropertyType>> {
        const response = await this.getBackItemsPropertyTypesSearchRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Search property types with slice
     */
    async getBackItemsPropertyTypesSearchSliceRaw(requestParameters: GetBackItemsPropertyTypesSearchSliceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<ItemTypePropertyType>>> {
        if (requestParameters.text === null || requestParameters.text === undefined) {
            throw new runtime.RequiredError('text','Required parameter requestParameters.text was null or undefined when calling getBackItemsPropertyTypesSearchSlice.');
        }

        if (requestParameters.maxResults === null || requestParameters.maxResults === undefined) {
            throw new runtime.RequiredError('maxResults','Required parameter requestParameters.maxResults was null or undefined when calling getBackItemsPropertyTypesSearchSlice.');
        }

        if (requestParameters.skip === null || requestParameters.skip === undefined) {
            throw new runtime.RequiredError('skip','Required parameter requestParameters.skip was null or undefined when calling getBackItemsPropertyTypesSearchSlice.');
        }

        const queryParameters: any = {};

        if (requestParameters.text !== undefined) {
            queryParameters['text'] = requestParameters.text;
        }

        if (requestParameters.maxResults !== undefined) {
            queryParameters['maxResults'] = requestParameters.maxResults;
        }

        if (requestParameters.skip !== undefined) {
            queryParameters['skip'] = requestParameters.skip;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/items/property/types/search/slice`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Search property types with slice
     */
    async getBackItemsPropertyTypesSearchSlice(requestParameters: GetBackItemsPropertyTypesSearchSliceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<ItemTypePropertyType>> {
        const response = await this.getBackItemsPropertyTypesSearchSliceRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Returns all item type property types with their possible values
     */
    async getBackItemsPropertyTypesWithPossibleValuesRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<ItemTypePropertyTypeWithValuesView>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/items/property/types/with-possible-values`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Returns all item type property types with their possible values
     */
    async getBackItemsPropertyTypesWithPossibleValues(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<ItemTypePropertyTypeWithValuesView>> {
        const response = await this.getBackItemsPropertyTypesWithPossibleValuesRaw(initOverrides);
        return await response.value();
    }

    /**
     * Reactivates item for the specified id
     */
    async getBackItemsReactivateP1Raw(requestParameters: GetBackItemsReactivateP1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<number>> {
        if (requestParameters.p1 === null || requestParameters.p1 === undefined) {
            throw new runtime.RequiredError('p1','Required parameter requestParameters.p1 was null or undefined when calling getBackItemsReactivateP1.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/items/reactivate/{p1}`.replace(`{${"p1"}}`, encodeURIComponent(String(requestParameters.p1))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.TextApiResponse(response) as any;
    }

    /**
     * Reactivates item for the specified id
     */
    async getBackItemsReactivateP1(requestParameters: GetBackItemsReactivateP1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<number> {
        const response = await this.getBackItemsReactivateP1Raw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Search item type names
     */
    async getBackItemsSearchItemTypeNamesRaw(requestParameters: GetBackItemsSearchItemTypeNamesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<string>>> {
        if (requestParameters.text === null || requestParameters.text === undefined) {
            throw new runtime.RequiredError('text','Required parameter requestParameters.text was null or undefined when calling getBackItemsSearchItemTypeNames.');
        }

        if (requestParameters.maxResults === null || requestParameters.maxResults === undefined) {
            throw new runtime.RequiredError('maxResults','Required parameter requestParameters.maxResults was null or undefined when calling getBackItemsSearchItemTypeNames.');
        }

        const queryParameters: any = {};

        if (requestParameters.text !== undefined) {
            queryParameters['text'] = requestParameters.text;
        }

        if (requestParameters.maxResults !== undefined) {
            queryParameters['maxResults'] = requestParameters.maxResults;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/items/search/item-type-names`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Search item type names
     */
    async getBackItemsSearchItemTypeNames(requestParameters: GetBackItemsSearchItemTypeNamesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<string>> {
        const response = await this.getBackItemsSearchItemTypeNamesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Search active and inactive item type tags
     */
    async getBackItemsSearchTagsRaw(requestParameters: GetBackItemsSearchTagsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<string>>> {
        if (requestParameters.text === null || requestParameters.text === undefined) {
            throw new runtime.RequiredError('text','Required parameter requestParameters.text was null or undefined when calling getBackItemsSearchTags.');
        }

        if (requestParameters.maxResults === null || requestParameters.maxResults === undefined) {
            throw new runtime.RequiredError('maxResults','Required parameter requestParameters.maxResults was null or undefined when calling getBackItemsSearchTags.');
        }

        const queryParameters: any = {};

        if (requestParameters.text !== undefined) {
            queryParameters['text'] = requestParameters.text;
        }

        if (requestParameters.maxResults !== undefined) {
            queryParameters['maxResults'] = requestParameters.maxResults;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/items/search/tags`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Search active and inactive item type tags
     */
    async getBackItemsSearchTags(requestParameters: GetBackItemsSearchTagsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<string>> {
        const response = await this.getBackItemsSearchTagsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 
     */
    async getBackItemsSearchTagsActiveRaw(requestParameters: GetBackItemsSearchTagsActiveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<string>>> {
        if (requestParameters.text === null || requestParameters.text === undefined) {
            throw new runtime.RequiredError('text','Required parameter requestParameters.text was null or undefined when calling getBackItemsSearchTagsActive.');
        }

        if (requestParameters.maxResults === null || requestParameters.maxResults === undefined) {
            throw new runtime.RequiredError('maxResults','Required parameter requestParameters.maxResults was null or undefined when calling getBackItemsSearchTagsActive.');
        }

        const queryParameters: any = {};

        if (requestParameters.text !== undefined) {
            queryParameters['text'] = requestParameters.text;
        }

        if (requestParameters.maxResults !== undefined) {
            queryParameters['maxResults'] = requestParameters.maxResults;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/items/search/tags/active`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * 
     */
    async getBackItemsSearchTagsActive(requestParameters: GetBackItemsSearchTagsActiveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<string>> {
        const response = await this.getBackItemsSearchTagsActiveRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get item with service kind by Id
     */
    async getBackItemsServicesIdRaw(requestParameters: GetBackItemsServicesIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ItemTypeServiceView>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling getBackItemsServicesId.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/items/services/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Get item with service kind by Id
     */
    async getBackItemsServicesId(requestParameters: GetBackItemsServicesIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ItemTypeServiceView> {
        const response = await this.getBackItemsServicesIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get all item type tags
     */
    async getBackItemsTagsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<ItemTypeTag>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/items/tags`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Get all item type tags
     */
    async getBackItemsTags(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<ItemTypeTag>> {
        const response = await this.getBackItemsTagsRaw(initOverrides);
        return await response.value();
    }

    /**
     * Get ItemTypeVariant of given ItemTypeVariantId
     */
    async getBackItemsVariantP1Raw(requestParameters: GetBackItemsVariantP1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ItemTypeVariant>> {
        if (requestParameters.p1 === null || requestParameters.p1 === undefined) {
            throw new runtime.RequiredError('p1','Required parameter requestParameters.p1 was null or undefined when calling getBackItemsVariantP1.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/items/variant/{p1}`.replace(`{${"p1"}}`, encodeURIComponent(String(requestParameters.p1))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Get ItemTypeVariant of given ItemTypeVariantId
     */
    async getBackItemsVariantP1(requestParameters: GetBackItemsVariantP1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ItemTypeVariant> {
        const response = await this.getBackItemsVariantP1Raw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getBackItemsVariantsHeadersRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<any>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/items/variants/headers`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.TextApiResponse(response) as any;
    }

    /**
     */
    async getBackItemsVariantsHeaders(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<any> {
        const response = await this.getBackItemsVariantsHeadersRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async getBackItemsVariantsPropertySetHeadersRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<any>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/items/variants/property-set/headers`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.TextApiResponse(response) as any;
    }

    /**
     */
    async getBackItemsVariantsPropertySetHeaders(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<any> {
        const response = await this.getBackItemsVariantsPropertySetHeadersRaw(initOverrides);
        return await response.value();
    }

    /**
     * Search item type variants
     */
    async getBackItemsVariantsSearchRaw(requestParameters: GetBackItemsVariantsSearchRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<ItemTypeVariant>>> {
        if (requestParameters.text === null || requestParameters.text === undefined) {
            throw new runtime.RequiredError('text','Required parameter requestParameters.text was null or undefined when calling getBackItemsVariantsSearch.');
        }

        if (requestParameters.maxResults === null || requestParameters.maxResults === undefined) {
            throw new runtime.RequiredError('maxResults','Required parameter requestParameters.maxResults was null or undefined when calling getBackItemsVariantsSearch.');
        }

        const queryParameters: any = {};

        if (requestParameters.text !== undefined) {
            queryParameters['text'] = requestParameters.text;
        }

        if (requestParameters.maxResults !== undefined) {
            queryParameters['maxResults'] = requestParameters.maxResults;
        }

        if (requestParameters.tag) {
            queryParameters['tag'] = requestParameters.tag;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/items/variants/search`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Search item type variants
     */
    async getBackItemsVariantsSearch(requestParameters: GetBackItemsVariantsSearchRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<ItemTypeVariant>> {
        const response = await this.getBackItemsVariantsSearchRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Search item type variants available for waste
     */
    async getBackItemsVariantsVariantsAvailableForWasteRaw(requestParameters: GetBackItemsVariantsVariantsAvailableForWasteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<ItemTypeVariant>>> {
        if (requestParameters.text === null || requestParameters.text === undefined) {
            throw new runtime.RequiredError('text','Required parameter requestParameters.text was null or undefined when calling getBackItemsVariantsVariantsAvailableForWaste.');
        }

        if (requestParameters.maxResults === null || requestParameters.maxResults === undefined) {
            throw new runtime.RequiredError('maxResults','Required parameter requestParameters.maxResults was null or undefined when calling getBackItemsVariantsVariantsAvailableForWaste.');
        }

        const queryParameters: any = {};

        if (requestParameters.text !== undefined) {
            queryParameters['text'] = requestParameters.text;
        }

        if (requestParameters.maxResults !== undefined) {
            queryParameters['maxResults'] = requestParameters.maxResults;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/items/variants/variants-available-for-waste`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Search item type variants available for waste
     */
    async getBackItemsVariantsVariantsAvailableForWaste(requestParameters: GetBackItemsVariantsVariantsAvailableForWasteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<ItemTypeVariant>> {
        const response = await this.getBackItemsVariantsVariantsAvailableForWasteRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Search item type variants with external ids
     */
    async getBackItemsVariantsVariantsWithExternalIdsRaw(requestParameters: GetBackItemsVariantsVariantsWithExternalIdsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<string>>> {
        if (requestParameters.text === null || requestParameters.text === undefined) {
            throw new runtime.RequiredError('text','Required parameter requestParameters.text was null or undefined when calling getBackItemsVariantsVariantsWithExternalIds.');
        }

        if (requestParameters.maxResults === null || requestParameters.maxResults === undefined) {
            throw new runtime.RequiredError('maxResults','Required parameter requestParameters.maxResults was null or undefined when calling getBackItemsVariantsVariantsWithExternalIds.');
        }

        const queryParameters: any = {};

        if (requestParameters.text !== undefined) {
            queryParameters['text'] = requestParameters.text;
        }

        if (requestParameters.maxResults !== undefined) {
            queryParameters['maxResults'] = requestParameters.maxResults;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/items/variants/variants-with-external-ids`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Search item type variants with external ids
     */
    async getBackItemsVariantsVariantsWithExternalIds(requestParameters: GetBackItemsVariantsVariantsWithExternalIdsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<string>> {
        const response = await this.getBackItemsVariantsVariantsWithExternalIdsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Returns list of all vat rates
     */
    async getBackItemsVatRatesRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<VatRateView>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/items/vat/rates`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Returns list of all vat rates
     */
    async getBackItemsVatRates(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<VatRateView>> {
        const response = await this.getBackItemsVatRatesRaw(initOverrides);
        return await response.value();
    }

    /**
     * Returns list of currently used vat rates
     */
    async getBackItemsVatRatesCurrentRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<VatRateView>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/items/vat/rates/current`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Returns list of currently used vat rates
     */
    async getBackItemsVatRatesCurrent(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<VatRateView>> {
        const response = await this.getBackItemsVatRatesCurrentRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async getBackMachineAreasListHeadersRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<any>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/machine-areas/list/headers`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.TextApiResponse(response) as any;
    }

    /**
     */
    async getBackMachineAreasListHeaders(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<any> {
        const response = await this.getBackMachineAreasListHeadersRaw(initOverrides);
        return await response.value();
    }

    /**
     * Get all machines
     */
    async getBackMachinesAllRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<Machine>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/machines/all`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Get all machines
     */
    async getBackMachinesAll(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<Machine>> {
        const response = await this.getBackMachinesAllRaw(initOverrides);
        return await response.value();
    }

    /**
     * Get all machines
     */
    async getBackMachinesAllDetailsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<MachineDetailsView>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/machines/all/details`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Get all machines
     */
    async getBackMachinesAllDetails(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<MachineDetailsView>> {
        const response = await this.getBackMachinesAllDetailsRaw(initOverrides);
        return await response.value();
    }

    /**
     * Get available Calendar event types
     */
    async getBackMachinesCalendarEventTypesRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<CalendarEventTypeView>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/machines/calendar/event/types`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Get available Calendar event types
     */
    async getBackMachinesCalendarEventTypes(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<CalendarEventTypeView>> {
        const response = await this.getBackMachinesCalendarEventTypesRaw(initOverrides);
        return await response.value();
    }

    /**
     * Get machine Calendar events
     */
    async getBackMachinesCalendarMachineidRaw(requestParameters: GetBackMachinesCalendarMachineidRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<CalendarEventView>>> {
        if (requestParameters.machineId === null || requestParameters.machineId === undefined) {
            throw new runtime.RequiredError('machineId','Required parameter requestParameters.machineId was null or undefined when calling getBackMachinesCalendarMachineid.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/machines/calendar/{machineId}`.replace(`{${"machineId"}}`, encodeURIComponent(String(requestParameters.machineId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Get machine Calendar events
     */
    async getBackMachinesCalendarMachineid(requestParameters: GetBackMachinesCalendarMachineidRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<CalendarEventView>> {
        const response = await this.getBackMachinesCalendarMachineidRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get available Calendar role types
     */
    async getBackMachinesCalendarRoleTypesRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<CalendarEventRole>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/machines/calendar/role/types`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Get available Calendar role types
     */
    async getBackMachinesCalendarRoleTypes(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<CalendarEventRole>> {
        const response = await this.getBackMachinesCalendarRoleTypesRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async getBackMachinesListHeadersRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<any>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/machines/list/headers`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.TextApiResponse(response) as any;
    }

    /**
     */
    async getBackMachinesListHeaders(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<any> {
        const response = await this.getBackMachinesListHeadersRaw(initOverrides);
        return await response.value();
    }

    /**
     * Get machine states
     */
    async getBackMachinesMachineAvailableStatesRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<MachineState>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/machines/machine/available-states`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Get machine states
     */
    async getBackMachinesMachineAvailableStates(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<MachineState>> {
        const response = await this.getBackMachinesMachineAvailableStatesRaw(initOverrides);
        return await response.value();
    }

    /**
     * Get machine by id
     */
    async getBackMachinesMachineMachineidRaw(requestParameters: GetBackMachinesMachineMachineidRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Machine>> {
        if (requestParameters.machineId === null || requestParameters.machineId === undefined) {
            throw new runtime.RequiredError('machineId','Required parameter requestParameters.machineId was null or undefined when calling getBackMachinesMachineMachineid.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/machines/machine/{MachineId}`.replace(`{${"MachineId"}}`, encodeURIComponent(String(requestParameters.machineId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Get machine by id
     */
    async getBackMachinesMachineMachineid(requestParameters: GetBackMachinesMachineMachineidRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Machine> {
        const response = await this.getBackMachinesMachineMachineidRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get machine permissions by id
     */
    async getBackMachinesMachineMachineidPermissionsRaw(requestParameters: GetBackMachinesMachineMachineidPermissionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<MachinePermissionsView>> {
        if (requestParameters.machineId === null || requestParameters.machineId === undefined) {
            throw new runtime.RequiredError('machineId','Required parameter requestParameters.machineId was null or undefined when calling getBackMachinesMachineMachineidPermissions.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/machines/machine/{MachineId}/permissions`.replace(`{${"MachineId"}}`, encodeURIComponent(String(requestParameters.machineId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Get machine permissions by id
     */
    async getBackMachinesMachineMachineidPermissions(requestParameters: GetBackMachinesMachineMachineidPermissionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<MachinePermissionsView> {
        const response = await this.getBackMachinesMachineMachineidPermissionsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get machine state by its id
     */
    async getBackMachinesMachineMachineidStateRaw(requestParameters: GetBackMachinesMachineMachineidStateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<MachineState>> {
        if (requestParameters.machineId === null || requestParameters.machineId === undefined) {
            throw new runtime.RequiredError('machineId','Required parameter requestParameters.machineId was null or undefined when calling getBackMachinesMachineMachineidState.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/machines/machine/{MachineId}/state`.replace(`{${"MachineId"}}`, encodeURIComponent(String(requestParameters.machineId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Get machine state by its id
     */
    async getBackMachinesMachineMachineidState(requestParameters: GetBackMachinesMachineMachineidStateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<MachineState> {
        const response = await this.getBackMachinesMachineMachineidStateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 
     */
    async getBackMachinesMachineMachineidStateSubscribeHeadRaw(requestParameters: GetBackMachinesMachineMachineidStateSubscribeHeadRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<string>> {
        if (requestParameters.machineId === null || requestParameters.machineId === undefined) {
            throw new runtime.RequiredError('machineId','Required parameter requestParameters.machineId was null or undefined when calling getBackMachinesMachineMachineidStateSubscribeHead.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/machines/machine/{MachineId}/state-subscribe/head`.replace(`{${"MachineId"}}`, encodeURIComponent(String(requestParameters.machineId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.TextApiResponse(response) as any;
    }

    /**
     * 
     */
    async getBackMachinesMachineMachineidStateSubscribeHead(requestParameters: GetBackMachinesMachineMachineidStateSubscribeHeadRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<string> {
        const response = await this.getBackMachinesMachineMachineidStateSubscribeHeadRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Set machine state
     */
    async getBackMachinesMachineMachineidStateTransitionAggregationRaw(requestParameters: GetBackMachinesMachineMachineidStateTransitionAggregationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<string>>> {
        if (requestParameters.machineId === null || requestParameters.machineId === undefined) {
            throw new runtime.RequiredError('machineId','Required parameter requestParameters.machineId was null or undefined when calling getBackMachinesMachineMachineidStateTransitionAggregation.');
        }

        if (requestParameters.from === null || requestParameters.from === undefined) {
            throw new runtime.RequiredError('from','Required parameter requestParameters.from was null or undefined when calling getBackMachinesMachineMachineidStateTransitionAggregation.');
        }

        if (requestParameters.resolution === null || requestParameters.resolution === undefined) {
            throw new runtime.RequiredError('resolution','Required parameter requestParameters.resolution was null or undefined when calling getBackMachinesMachineMachineidStateTransitionAggregation.');
        }

        const queryParameters: any = {};

        if (requestParameters.from !== undefined) {
            queryParameters['from'] = requestParameters.from;
        }

        if (requestParameters.to !== undefined) {
            queryParameters['to'] = requestParameters.to;
        }

        if (requestParameters.resolution !== undefined) {
            queryParameters['resolution'] = requestParameters.resolution;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/machines/machine/{MachineId}/state-transition-aggregation`.replace(`{${"MachineId"}}`, encodeURIComponent(String(requestParameters.machineId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Set machine state
     */
    async getBackMachinesMachineMachineidStateTransitionAggregation(requestParameters: GetBackMachinesMachineMachineidStateTransitionAggregationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<string>> {
        const response = await this.getBackMachinesMachineMachineidStateTransitionAggregationRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get machine state config
     */
    async getBackMachinesMachineStateConfigRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<MachineStateDisplayConfig>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/machines/machine/state/config`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Get machine state config
     */
    async getBackMachinesMachineStateConfig(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<MachineStateDisplayConfig> {
        const response = await this.getBackMachinesMachineStateConfigRaw(initOverrides);
        return await response.value();
    }

    /**
     * Get machine state transitions for given interval
     */
    async getBackMachinesMachineStateTransitionMachineidRaw(requestParameters: GetBackMachinesMachineStateTransitionMachineidRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<string>>> {
        if (requestParameters.machineId === null || requestParameters.machineId === undefined) {
            throw new runtime.RequiredError('machineId','Required parameter requestParameters.machineId was null or undefined when calling getBackMachinesMachineStateTransitionMachineid.');
        }

        const queryParameters: any = {};

        if (requestParameters.from !== undefined) {
            queryParameters['from'] = requestParameters.from;
        }

        if (requestParameters.to !== undefined) {
            queryParameters['to'] = requestParameters.to;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/machines/machine/state-transition/{MachineId}`.replace(`{${"MachineId"}}`, encodeURIComponent(String(requestParameters.machineId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Get machine state transitions for given interval
     */
    async getBackMachinesMachineStateTransitionMachineid(requestParameters: GetBackMachinesMachineStateTransitionMachineidRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<string>> {
        const response = await this.getBackMachinesMachineStateTransitionMachineidRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get machine types
     */
    async getBackMachinesMachineTypeRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<Machine>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/machines/machine/type`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Get machine types
     */
    async getBackMachinesMachineType(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<Machine>> {
        const response = await this.getBackMachinesMachineTypeRaw(initOverrides);
        return await response.value();
    }

    /**
     * Get machines permitted for user
     */
    async getBackMachinesMachineWorkersRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<Machine>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/machines/machine/workers`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Get machines permitted for user
     */
    async getBackMachinesMachineWorkers(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<Machine>> {
        const response = await this.getBackMachinesMachineWorkersRaw(initOverrides);
        return await response.value();
    }

    /**
     * Get machines for role
     */
    async getBackMachinesMachinesRoleRoleidRaw(requestParameters: GetBackMachinesMachinesRoleRoleidRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<number>>> {
        if (requestParameters.roleId === null || requestParameters.roleId === undefined) {
            throw new runtime.RequiredError('roleId','Required parameter requestParameters.roleId was null or undefined when calling getBackMachinesMachinesRoleRoleid.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/machines/machines/role/{RoleId}`.replace(`{${"RoleId"}}`, encodeURIComponent(String(requestParameters.roleId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Get machines for role
     */
    async getBackMachinesMachinesRoleRoleid(requestParameters: GetBackMachinesMachinesRoleRoleidRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<number>> {
        const response = await this.getBackMachinesMachinesRoleRoleidRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get view of all available machine parameters and features for them
     */
    async getBackMachinesParametersRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<MachineFeaturesView>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/machines/parameters`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Get view of all available machine parameters and features for them
     */
    async getBackMachinesParameters(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<MachineFeaturesView> {
        const response = await this.getBackMachinesParametersRaw(initOverrides);
        return await response.value();
    }

    /**
     * Search for machine features values
     */
    async getBackMachinesSearchFeaturesRaw(requestParameters: GetBackMachinesSearchFeaturesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<string>>> {
        if (requestParameters.key === null || requestParameters.key === undefined) {
            throw new runtime.RequiredError('key','Required parameter requestParameters.key was null or undefined when calling getBackMachinesSearchFeatures.');
        }

        if (requestParameters.text === null || requestParameters.text === undefined) {
            throw new runtime.RequiredError('text','Required parameter requestParameters.text was null or undefined when calling getBackMachinesSearchFeatures.');
        }

        if (requestParameters.maxResults === null || requestParameters.maxResults === undefined) {
            throw new runtime.RequiredError('maxResults','Required parameter requestParameters.maxResults was null or undefined when calling getBackMachinesSearchFeatures.');
        }

        const queryParameters: any = {};

        if (requestParameters.key !== undefined) {
            queryParameters['key'] = requestParameters.key;
        }

        if (requestParameters.text !== undefined) {
            queryParameters['text'] = requestParameters.text;
        }

        if (requestParameters.maxResults !== undefined) {
            queryParameters['maxResults'] = requestParameters.maxResults;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/machines/search/features`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Search for machine features values
     */
    async getBackMachinesSearchFeatures(requestParameters: GetBackMachinesSearchFeaturesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<string>> {
        const response = await this.getBackMachinesSearchFeaturesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 
     */
    async getBackMarketingrulesContractorP1Raw(requestParameters: GetBackMarketingrulesContractorP1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<MarketingRule>>> {
        if (requestParameters.p1 === null || requestParameters.p1 === undefined) {
            throw new runtime.RequiredError('p1','Required parameter requestParameters.p1 was null or undefined when calling getBackMarketingrulesContractorP1.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/marketingrules/contractor/{p1}`.replace(`{${"p1"}}`, encodeURIComponent(String(requestParameters.p1))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * 
     */
    async getBackMarketingrulesContractorP1(requestParameters: GetBackMarketingrulesContractorP1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<MarketingRule>> {
        const response = await this.getBackMarketingrulesContractorP1Raw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 
     */
    async getBackMarketingrulesContractorRulesAllRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<MarketingRuleType>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/marketingrules/contractor/rules/all`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * 
     */
    async getBackMarketingrulesContractorRulesAll(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<MarketingRuleType>> {
        const response = await this.getBackMarketingrulesContractorRulesAllRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async getBackMarketingrulesListHeadersRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<any>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/marketingrules/list/headers`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.TextApiResponse(response) as any;
    }

    /**
     */
    async getBackMarketingrulesListHeaders(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<any> {
        const response = await this.getBackMarketingrulesListHeadersRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async getBackMaterialMovementsListHeadersRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<any>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/material-movements/list/headers`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.TextApiResponse(response) as any;
    }

    /**
     */
    async getBackMaterialMovementsListHeaders(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<any> {
        const response = await this.getBackMaterialMovementsListHeadersRaw(initOverrides);
        return await response.value();
    }

    /**
     * Retrieves all group names for a specific production lot
     */
    async getBackMeasurementReportsAllGroupNamesProductionlotidRaw(requestParameters: GetBackMeasurementReportsAllGroupNamesProductionlotidRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<string>>> {
        if (requestParameters.productionLotId === null || requestParameters.productionLotId === undefined) {
            throw new runtime.RequiredError('productionLotId','Required parameter requestParameters.productionLotId was null or undefined when calling getBackMeasurementReportsAllGroupNamesProductionlotid.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/measurement-reports/all-group-names/{ProductionLotId}`.replace(`{${"ProductionLotId"}}`, encodeURIComponent(String(requestParameters.productionLotId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Retrieves all group names for a specific production lot
     */
    async getBackMeasurementReportsAllGroupNamesProductionlotid(requestParameters: GetBackMeasurementReportsAllGroupNamesProductionlotidRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<string>> {
        const response = await this.getBackMeasurementReportsAllGroupNamesProductionlotidRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieves measurement reports for a specific production lot
     */
    async getBackMeasurementReportsByProductionLotProductionlotidRaw(requestParameters: GetBackMeasurementReportsByProductionLotProductionlotidRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<MeasurementReport>>> {
        if (requestParameters.productionLotId === null || requestParameters.productionLotId === undefined) {
            throw new runtime.RequiredError('productionLotId','Required parameter requestParameters.productionLotId was null or undefined when calling getBackMeasurementReportsByProductionLotProductionlotid.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/measurement-reports/by-production-lot/{ProductionLotId}`.replace(`{${"ProductionLotId"}}`, encodeURIComponent(String(requestParameters.productionLotId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Retrieves measurement reports for a specific production lot
     */
    async getBackMeasurementReportsByProductionLotProductionlotid(requestParameters: GetBackMeasurementReportsByProductionLotProductionlotidRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<MeasurementReport>> {
        const response = await this.getBackMeasurementReportsByProductionLotProductionlotidRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getBackMeasurementsMeasurementDevicesHeadersRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<any>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/measurements/measurement-devices/headers`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.TextApiResponse(response) as any;
    }

    /**
     */
    async getBackMeasurementsMeasurementDevicesHeaders(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<any> {
        const response = await this.getBackMeasurementsMeasurementDevicesHeadersRaw(initOverrides);
        return await response.value();
    }

    /**
     * Accept Offer
     */
    async getBackOffersAcceptP1Raw(requestParameters: GetBackOffersAcceptP1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<string>> {
        if (requestParameters.p1 === null || requestParameters.p1 === undefined) {
            throw new runtime.RequiredError('p1','Required parameter requestParameters.p1 was null or undefined when calling getBackOffersAcceptP1.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/offers/accept/{p1}`.replace(`{${"p1"}}`, encodeURIComponent(String(requestParameters.p1))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.TextApiResponse(response) as any;
    }

    /**
     * Accept Offer
     */
    async getBackOffersAcceptP1(requestParameters: GetBackOffersAcceptP1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<string> {
        const response = await this.getBackOffersAcceptP1Raw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Cancel Offer
     */
    async getBackOffersCancelP1Raw(requestParameters: GetBackOffersCancelP1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<string>> {
        if (requestParameters.p1 === null || requestParameters.p1 === undefined) {
            throw new runtime.RequiredError('p1','Required parameter requestParameters.p1 was null or undefined when calling getBackOffersCancelP1.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/offers/cancel/{p1}`.replace(`{${"p1"}}`, encodeURIComponent(String(requestParameters.p1))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.TextApiResponse(response) as any;
    }

    /**
     * Cancel Offer
     */
    async getBackOffersCancelP1(requestParameters: GetBackOffersCancelP1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<string> {
        const response = await this.getBackOffersCancelP1Raw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Clone Offer
     */
    async getBackOffersCloneP1Raw(requestParameters: GetBackOffersCloneP1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<LegacyOfferView>> {
        if (requestParameters.p1 === null || requestParameters.p1 === undefined) {
            throw new runtime.RequiredError('p1','Required parameter requestParameters.p1 was null or undefined when calling getBackOffersCloneP1.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/offers/clone/{p1}`.replace(`{${"p1"}}`, encodeURIComponent(String(requestParameters.p1))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Clone Offer
     */
    async getBackOffersCloneP1(requestParameters: GetBackOffersCloneP1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<LegacyOfferView> {
        const response = await this.getBackOffersCloneP1Raw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get default unit type
     */
    async getBackOffersDefaultUnitTypeRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<string>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/offers/default-unit-type`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.TextApiResponse(response) as any;
    }

    /**
     * Get default unit type
     */
    async getBackOffersDefaultUnitType(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<string> {
        const response = await this.getBackOffersDefaultUnitTypeRaw(initOverrides);
        return await response.value();
    }

    /**
     * Get default validity period for Offer
     */
    async getBackOffersDefaultValidityPeriodRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<number>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/offers/default-validity-period`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.TextApiResponse(response) as any;
    }

    /**
     * Get default validity period for Offer
     */
    async getBackOffersDefaultValidityPeriod(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<number> {
        const response = await this.getBackOffersDefaultValidityPeriodRaw(initOverrides);
        return await response.value();
    }

    /**
     * Get all SalesEntryItems in Offer
     */
    async getBackOffersItemAllFromOfferP1Raw(requestParameters: GetBackOffersItemAllFromOfferP1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<OfferItemView>>> {
        if (requestParameters.p1 === null || requestParameters.p1 === undefined) {
            throw new runtime.RequiredError('p1','Required parameter requestParameters.p1 was null or undefined when calling getBackOffersItemAllFromOfferP1.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/offers/item/all-from-offer/{p1}`.replace(`{${"p1"}}`, encodeURIComponent(String(requestParameters.p1))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Get all SalesEntryItems in Offer
     */
    async getBackOffersItemAllFromOfferP1(requestParameters: GetBackOffersItemAllFromOfferP1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<OfferItemView>> {
        const response = await this.getBackOffersItemAllFromOfferP1Raw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get offer item by id
     */
    async getBackOffersItemViewOfferitemidRaw(requestParameters: GetBackOffersItemViewOfferitemidRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OfferItemView>> {
        if (requestParameters.offerItemId === null || requestParameters.offerItemId === undefined) {
            throw new runtime.RequiredError('offerItemId','Required parameter requestParameters.offerItemId was null or undefined when calling getBackOffersItemViewOfferitemid.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/offers/item/view/{OfferItemId}`.replace(`{${"OfferItemId"}}`, encodeURIComponent(String(requestParameters.offerItemId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Get offer item by id
     */
    async getBackOffersItemViewOfferitemid(requestParameters: GetBackOffersItemViewOfferitemidRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OfferItemView> {
        const response = await this.getBackOffersItemViewOfferitemidRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getBackOffersListHeadersRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<any>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/offers/list/headers`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.TextApiResponse(response) as any;
    }

    /**
     */
    async getBackOffersListHeaders(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<any> {
        const response = await this.getBackOffersListHeadersRaw(initOverrides);
        return await response.value();
    }

    /**
     * Mark Offer as sent
     */
    async getBackOffersMarkAsSentP1Raw(requestParameters: GetBackOffersMarkAsSentP1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<string>> {
        if (requestParameters.p1 === null || requestParameters.p1 === undefined) {
            throw new runtime.RequiredError('p1','Required parameter requestParameters.p1 was null or undefined when calling getBackOffersMarkAsSentP1.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/offers/mark-as-sent/{p1}`.replace(`{${"p1"}}`, encodeURIComponent(String(requestParameters.p1))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.TextApiResponse(response) as any;
    }

    /**
     * Mark Offer as sent
     */
    async getBackOffersMarkAsSentP1(requestParameters: GetBackOffersMarkAsSentP1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<string> {
        const response = await this.getBackOffersMarkAsSentP1Raw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get available currencies by SalesEntryId
     */
    async getBackOffersP1AvailableCurrenciesRaw(requestParameters: GetBackOffersP1AvailableCurrenciesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<string>>> {
        if (requestParameters.p1 === null || requestParameters.p1 === undefined) {
            throw new runtime.RequiredError('p1','Required parameter requestParameters.p1 was null or undefined when calling getBackOffersP1AvailableCurrencies.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/offers/{p1}/available-currencies`.replace(`{${"p1"}}`, encodeURIComponent(String(requestParameters.p1))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Get available currencies by SalesEntryId
     */
    async getBackOffersP1AvailableCurrencies(requestParameters: GetBackOffersP1AvailableCurrenciesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<string>> {
        const response = await this.getBackOffersP1AvailableCurrenciesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get SalesEntryView by SalesEntryId
     */
    async getBackOffersViewP1Raw(requestParameters: GetBackOffersViewP1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OfferView>> {
        if (requestParameters.p1 === null || requestParameters.p1 === undefined) {
            throw new runtime.RequiredError('p1','Required parameter requestParameters.p1 was null or undefined when calling getBackOffersViewP1.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/offers/view/{p1}`.replace(`{${"p1"}}`, encodeURIComponent(String(requestParameters.p1))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Get SalesEntryView by SalesEntryId
     */
    async getBackOffersViewP1(requestParameters: GetBackOffersViewP1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OfferView> {
        const response = await this.getBackOffersViewP1Raw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get SalesEntryView by SalesEntryId. Logs view entry
     */
    async getBackOffersViewWithEntryLoggingP1Raw(requestParameters: GetBackOffersViewWithEntryLoggingP1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OfferView>> {
        if (requestParameters.p1 === null || requestParameters.p1 === undefined) {
            throw new runtime.RequiredError('p1','Required parameter requestParameters.p1 was null or undefined when calling getBackOffersViewWithEntryLoggingP1.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/offers/view/with-entry-logging/{p1}`.replace(`{${"p1"}}`, encodeURIComponent(String(requestParameters.p1))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Get SalesEntryView by SalesEntryId. Logs view entry
     */
    async getBackOffersViewWithEntryLoggingP1(requestParameters: GetBackOffersViewWithEntryLoggingP1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OfferView> {
        const response = await this.getBackOffersViewWithEntryLoggingP1Raw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get order assignment event by id
     */
    async getBackOrdersAssignmentEventsP1Raw(requestParameters: GetBackOrdersAssignmentEventsP1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OrderAssignmentEventView>> {
        if (requestParameters.p1 === null || requestParameters.p1 === undefined) {
            throw new runtime.RequiredError('p1','Required parameter requestParameters.p1 was null or undefined when calling getBackOrdersAssignmentEventsP1.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/orders/assignment-events/{p1}`.replace(`{${"p1"}}`, encodeURIComponent(String(requestParameters.p1))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Get order assignment event by id
     */
    async getBackOrdersAssignmentEventsP1(requestParameters: GetBackOrdersAssignmentEventsP1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OrderAssignmentEventView> {
        const response = await this.getBackOrdersAssignmentEventsP1Raw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Search for labels
     */
    async getBackOrdersAttributesSearchLabelRaw(requestParameters: GetBackOrdersAttributesSearchLabelRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SearchResponseString>> {
        if (requestParameters.text === null || requestParameters.text === undefined) {
            throw new runtime.RequiredError('text','Required parameter requestParameters.text was null or undefined when calling getBackOrdersAttributesSearchLabel.');
        }

        if (requestParameters.maxResults === null || requestParameters.maxResults === undefined) {
            throw new runtime.RequiredError('maxResults','Required parameter requestParameters.maxResults was null or undefined when calling getBackOrdersAttributesSearchLabel.');
        }

        const queryParameters: any = {};

        if (requestParameters.text !== undefined) {
            queryParameters['text'] = requestParameters.text;
        }

        if (requestParameters.maxResults !== undefined) {
            queryParameters['maxResults'] = requestParameters.maxResults;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/orders/attributes/search/label`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Search for labels
     */
    async getBackOrdersAttributesSearchLabel(requestParameters: GetBackOrdersAttributesSearchLabelRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SearchResponseString> {
        const response = await this.getBackOrdersAttributesSearchLabelRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get order item by item id
     */
    async getBackOrdersByItemIdRaw(requestParameters: GetBackOrdersByItemIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OrderView>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling getBackOrdersByItemId.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/orders/by-item/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Get order item by item id
     */
    async getBackOrdersByItemId(requestParameters: GetBackOrdersByItemIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OrderView> {
        const response = await this.getBackOrdersByItemIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get orders by offer id
     */
    async getBackOrdersByOfferOfferidRaw(requestParameters: GetBackOrdersByOfferOfferidRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<OrderView>>> {
        if (requestParameters.offerId === null || requestParameters.offerId === undefined) {
            throw new runtime.RequiredError('offerId','Required parameter requestParameters.offerId was null or undefined when calling getBackOrdersByOfferOfferid.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/orders/by-offer/{offerId}`.replace(`{${"offerId"}}`, encodeURIComponent(String(requestParameters.offerId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Get orders by offer id
     */
    async getBackOrdersByOfferOfferid(requestParameters: GetBackOrdersByOfferOfferidRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<OrderView>> {
        const response = await this.getBackOrdersByOfferOfferidRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get client by id
     */
    async getBackOrdersClientsIdRaw(requestParameters: GetBackOrdersClientsIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Contractor>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling getBackOrdersClientsId.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/orders/clients/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Get client by id
     */
    async getBackOrdersClientsId(requestParameters: GetBackOrdersClientsIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Contractor> {
        const response = await this.getBackOrdersClientsIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getBackOrdersEquipmentDemandsListHeadersRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<any>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/orders/equipment-demands/list/headers`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.TextApiResponse(response) as any;
    }

    /**
     */
    async getBackOrdersEquipmentDemandsListHeaders(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<any> {
        const response = await this.getBackOrdersEquipmentDemandsListHeadersRaw(initOverrides);
        return await response.value();
    }

    /**
     * Retrieves equipment demands by the specified id
     */
    async getBackOrdersEquipmentDemandsP1Raw(requestParameters: GetBackOrdersEquipmentDemandsP1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<EquipmentDemandView>> {
        if (requestParameters.p1 === null || requestParameters.p1 === undefined) {
            throw new runtime.RequiredError('p1','Required parameter requestParameters.p1 was null or undefined when calling getBackOrdersEquipmentDemandsP1.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/orders/equipment-demands/{p1}`.replace(`{${"p1"}}`, encodeURIComponent(String(requestParameters.p1))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Retrieves equipment demands by the specified id
     */
    async getBackOrdersEquipmentDemandsP1(requestParameters: GetBackOrdersEquipmentDemandsP1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<EquipmentDemandView> {
        const response = await this.getBackOrdersEquipmentDemandsP1Raw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get order details
     */
    async getBackOrdersGetIdRaw(requestParameters: GetBackOrdersGetIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OrderView>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling getBackOrdersGetId.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/orders/get/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Get order details
     */
    async getBackOrdersGetId(requestParameters: GetBackOrdersGetIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OrderView> {
        const response = await this.getBackOrdersGetIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getBackOrdersIdAssignmentsRaw(requestParameters: GetBackOrdersIdAssignmentsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OrderAssignmentsView>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling getBackOrdersIdAssignments.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/orders/{id}/assignments`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async getBackOrdersIdAssignments(requestParameters: GetBackOrdersIdAssignmentsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OrderAssignmentsView> {
        const response = await this.getBackOrdersIdAssignmentsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Generate order response
     */
    async getBackOrdersIdOrderResponseRaw(requestParameters: GetBackOrdersIdOrderResponseRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Blob>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling getBackOrdersIdOrderResponse.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/orders/{id}/order-response`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.BlobApiResponse(response);
    }

    /**
     * Generate order response
     */
    async getBackOrdersIdOrderResponse(requestParameters: GetBackOrdersIdOrderResponseRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Blob> {
        const response = await this.getBackOrdersIdOrderResponseRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get order item details by id
     */
    async getBackOrdersItemGetOrderitemidRaw(requestParameters: GetBackOrdersItemGetOrderitemidRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<any>> {
        if (requestParameters.orderItemId === null || requestParameters.orderItemId === undefined) {
            throw new runtime.RequiredError('orderItemId','Required parameter requestParameters.orderItemId was null or undefined when calling getBackOrdersItemGetOrderitemid.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/orders/item/get/{OrderItemId}`.replace(`{${"OrderItemId"}}`, encodeURIComponent(String(requestParameters.orderItemId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.TextApiResponse(response) as any;
    }

    /**
     * Get order item details by id
     */
    async getBackOrdersItemGetOrderitemid(requestParameters: GetBackOrdersItemGetOrderitemidRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<any> {
        const response = await this.getBackOrdersItemGetOrderitemidRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getBackOrdersListHeadersRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<any>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/orders/list/headers`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.TextApiResponse(response) as any;
    }

    /**
     */
    async getBackOrdersListHeaders(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<any> {
        const response = await this.getBackOrdersListHeadersRaw(initOverrides);
        return await response.value();
    }

    /**
     * Clone order by id
     */
    async getBackOrdersOrderIdCloneRaw(requestParameters: GetBackOrdersOrderIdCloneRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ClonedOrderView>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling getBackOrdersOrderIdClone.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/orders/order/{id}/clone`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Clone order by id
     */
    async getBackOrdersOrderIdClone(requestParameters: GetBackOrdersOrderIdCloneRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ClonedOrderView> {
        const response = await this.getBackOrdersOrderIdCloneRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieves other demands related to the specified sales entry\'s id
     */
    async getBackOrdersOtherDemandsEntryP1Raw(requestParameters: GetBackOrdersOtherDemandsEntryP1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<OtherDemand>>> {
        if (requestParameters.p1 === null || requestParameters.p1 === undefined) {
            throw new runtime.RequiredError('p1','Required parameter requestParameters.p1 was null or undefined when calling getBackOrdersOtherDemandsEntryP1.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/orders/other-demands/entry/{p1}`.replace(`{${"p1"}}`, encodeURIComponent(String(requestParameters.p1))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Retrieves other demands related to the specified sales entry\'s id
     */
    async getBackOrdersOtherDemandsEntryP1(requestParameters: GetBackOrdersOtherDemandsEntryP1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<OtherDemand>> {
        const response = await this.getBackOrdersOtherDemandsEntryP1Raw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getBackOrdersOtherDemandsListHeadersRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<any>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/orders/other-demands/list/headers`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.TextApiResponse(response) as any;
    }

    /**
     */
    async getBackOrdersOtherDemandsListHeaders(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<any> {
        const response = await this.getBackOrdersOtherDemandsListHeadersRaw(initOverrides);
        return await response.value();
    }

    /**
     * Retrieves other demands by the specified id
     */
    async getBackOrdersOtherDemandsP1Raw(requestParameters: GetBackOrdersOtherDemandsP1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OtherDemand>> {
        if (requestParameters.p1 === null || requestParameters.p1 === undefined) {
            throw new runtime.RequiredError('p1','Required parameter requestParameters.p1 was null or undefined when calling getBackOrdersOtherDemandsP1.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/orders/other-demands/{p1}`.replace(`{${"p1"}}`, encodeURIComponent(String(requestParameters.p1))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Retrieves other demands by the specified id
     */
    async getBackOrdersOtherDemandsP1(requestParameters: GetBackOrdersOtherDemandsP1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OtherDemand> {
        const response = await this.getBackOrdersOtherDemandsP1Raw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieves other demands related to the specified user\'s id
     */
    async getBackOrdersOtherDemandsUserP1Raw(requestParameters: GetBackOrdersOtherDemandsUserP1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<OtherDemand>>> {
        if (requestParameters.p1 === null || requestParameters.p1 === undefined) {
            throw new runtime.RequiredError('p1','Required parameter requestParameters.p1 was null or undefined when calling getBackOrdersOtherDemandsUserP1.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/orders/other-demands/user/{p1}`.replace(`{${"p1"}}`, encodeURIComponent(String(requestParameters.p1))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Retrieves other demands related to the specified user\'s id
     */
    async getBackOrdersOtherDemandsUserP1(requestParameters: GetBackOrdersOtherDemandsUserP1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<OtherDemand>> {
        const response = await this.getBackOrdersOtherDemandsUserP1Raw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get order details for view
     */
    async getBackOrdersViewIdRaw(requestParameters: GetBackOrdersViewIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OrderView>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling getBackOrdersViewId.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/orders/view/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Get order details for view
     */
    async getBackOrdersViewId(requestParameters: GetBackOrdersViewIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OrderView> {
        const response = await this.getBackOrdersViewIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get all places
     */
    async getBackPlacesAllRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<Place>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/places/all`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Get all places
     */
    async getBackPlacesAll(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<Place>> {
        const response = await this.getBackPlacesAllRaw(initOverrides);
        return await response.value();
    }

    /**
     * Search places
     */
    async getBackPlacesSearchRaw(requestParameters: GetBackPlacesSearchRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<Place>>> {
        if (requestParameters.text === null || requestParameters.text === undefined) {
            throw new runtime.RequiredError('text','Required parameter requestParameters.text was null or undefined when calling getBackPlacesSearch.');
        }

        if (requestParameters.maxResults === null || requestParameters.maxResults === undefined) {
            throw new runtime.RequiredError('maxResults','Required parameter requestParameters.maxResults was null or undefined when calling getBackPlacesSearch.');
        }

        const queryParameters: any = {};

        if (requestParameters.text !== undefined) {
            queryParameters['text'] = requestParameters.text;
        }

        if (requestParameters.maxResults !== undefined) {
            queryParameters['maxResults'] = requestParameters.maxResults;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/places/search`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Search places
     */
    async getBackPlacesSearch(requestParameters: GetBackPlacesSearchRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<Place>> {
        const response = await this.getBackPlacesSearchRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get production lot details by production lot id
     */
    async getBackPresentationsLotsProductionlotidRaw(requestParameters: GetBackPresentationsLotsProductionlotidRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ProductionLotDetailsView>> {
        if (requestParameters.productionLotId === null || requestParameters.productionLotId === undefined) {
            throw new runtime.RequiredError('productionLotId','Required parameter requestParameters.productionLotId was null or undefined when calling getBackPresentationsLotsProductionlotid.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/presentations/lots/{ProductionLotId}`.replace(`{${"ProductionLotId"}}`, encodeURIComponent(String(requestParameters.productionLotId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Get production lot details by production lot id
     */
    async getBackPresentationsLotsProductionlotid(requestParameters: GetBackPresentationsLotsProductionlotidRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ProductionLotDetailsView> {
        const response = await this.getBackPresentationsLotsProductionlotidRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getBackPresentationsOrderItemsItemsGroupListHeadersRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<any>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/presentations/order-items/items-group/list/headers`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.TextApiResponse(response) as any;
    }

    /**
     */
    async getBackPresentationsOrderItemsItemsGroupListHeaders(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<any> {
        const response = await this.getBackPresentationsOrderItemsItemsGroupListHeadersRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async getBackPresentationsProductionLotPeriodsGroupListHeadersRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<any>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/presentations/production-lot/periods-group/list/headers`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.TextApiResponse(response) as any;
    }

    /**
     */
    async getBackPresentationsProductionLotPeriodsGroupListHeaders(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<any> {
        const response = await this.getBackPresentationsProductionLotPeriodsGroupListHeadersRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async getBackProductcatalogListHeadersRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<any>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/productcatalog/list/headers`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.TextApiResponse(response) as any;
    }

    /**
     */
    async getBackProductcatalogListHeaders(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<any> {
        const response = await this.getBackProductcatalogListHeadersRaw(initOverrides);
        return await response.value();
    }

    /**
     * Websocket for production board updates
     */
    async getBackProductionBoardDisplayBoardUpdatesSubscribeHeadRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<KanbanWebsocketOutput>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/production-board/display/board/updates/subscribe/head`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Websocket for production board updates
     */
    async getBackProductionBoardDisplayBoardUpdatesSubscribeHead(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<KanbanWebsocketOutput> {
        const response = await this.getBackProductionBoardDisplayBoardUpdatesSubscribeHeadRaw(initOverrides);
        return await response.value();
    }

    /**
     * Accept production lot reports
     */
    async getBackProductionLotAcceptProductionlotidRaw(requestParameters: GetBackProductionLotAcceptProductionlotidRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<number>> {
        if (requestParameters.productionLotId === null || requestParameters.productionLotId === undefined) {
            throw new runtime.RequiredError('productionLotId','Required parameter requestParameters.productionLotId was null or undefined when calling getBackProductionLotAcceptProductionlotid.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/production/lot/accept/{ProductionLotId}`.replace(`{${"ProductionLotId"}}`, encodeURIComponent(String(requestParameters.productionLotId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.TextApiResponse(response) as any;
    }

    /**
     * Accept production lot reports
     */
    async getBackProductionLotAcceptProductionlotid(requestParameters: GetBackProductionLotAcceptProductionlotidRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<number> {
        const response = await this.getBackProductionLotAcceptProductionlotidRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Default policy settings for worker auto-assignment from application configuration.
     */
    async getBackProductionLotAutoAssignWorkersDefaultsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<WorkerAutoAssignmentDefaultsView>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/production/lot/auto-assign-workers-defaults`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Default policy settings for worker auto-assignment from application configuration.
     */
    async getBackProductionLotAutoAssignWorkersDefaults(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<WorkerAutoAssignmentDefaultsView> {
        const response = await this.getBackProductionLotAutoAssignWorkersDefaultsRaw(initOverrides);
        return await response.value();
    }

    /**
     * Historical parallel machine pairs for auto-assignment preview. Overlap thresholds are configured per month and scaled by lookbackMonths.
     */
    async getBackProductionLotAutoAssignWorkersHistoricalParallelPairsRaw(requestParameters: GetBackProductionLotAutoAssignWorkersHistoricalParallelPairsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<HistoricalParallelMachinePairsView>> {
        if (requestParameters.machineAreaId === null || requestParameters.machineAreaId === undefined) {
            throw new runtime.RequiredError('machineAreaId','Required parameter requestParameters.machineAreaId was null or undefined when calling getBackProductionLotAutoAssignWorkersHistoricalParallelPairs.');
        }

        if (requestParameters.lookbackMonths === null || requestParameters.lookbackMonths === undefined) {
            throw new runtime.RequiredError('lookbackMonths','Required parameter requestParameters.lookbackMonths was null or undefined when calling getBackProductionLotAutoAssignWorkersHistoricalParallelPairs.');
        }

        const queryParameters: any = {};

        if (requestParameters.machineAreaId !== undefined) {
            queryParameters['machineAreaId'] = requestParameters.machineAreaId;
        }

        if (requestParameters.lookbackMonths !== undefined) {
            queryParameters['lookbackMonths'] = requestParameters.lookbackMonths;
        }

        if (requestParameters.minOverlapsForPairPerMonth !== undefined) {
            queryParameters['minOverlapsForPairPerMonth'] = requestParameters.minOverlapsForPairPerMonth;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/production/lot/auto-assign-workers-historical-parallel-pairs`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Historical parallel machine pairs for auto-assignment preview. Overlap thresholds are configured per month and scaled by lookbackMonths.
     */
    async getBackProductionLotAutoAssignWorkersHistoricalParallelPairs(requestParameters: GetBackProductionLotAutoAssignWorkersHistoricalParallelPairsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<HistoricalParallelMachinePairsView> {
        const response = await this.getBackProductionLotAutoAssignWorkersHistoricalParallelPairsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get links to production lot\'s documents
     */
    async getBackProductionLotProductionlotidDocumentsRaw(requestParameters: GetBackProductionLotProductionlotidDocumentsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<WorkstationDocument>>> {
        if (requestParameters.productionLotId === null || requestParameters.productionLotId === undefined) {
            throw new runtime.RequiredError('productionLotId','Required parameter requestParameters.productionLotId was null or undefined when calling getBackProductionLotProductionlotidDocuments.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/production-lot/{ProductionLotId}/documents`.replace(`{${"ProductionLotId"}}`, encodeURIComponent(String(requestParameters.productionLotId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Get links to production lot\'s documents
     */
    async getBackProductionLotProductionlotidDocuments(requestParameters: GetBackProductionLotProductionlotidDocumentsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<WorkstationDocument>> {
        const response = await this.getBackProductionLotProductionlotidDocumentsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get production lot\'s document
     */
    async getBackProductionLotProductionlotidDocumentsFileidRaw(requestParameters: GetBackProductionLotProductionlotidDocumentsFileidRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Blob>> {
        if (requestParameters.productionLotId === null || requestParameters.productionLotId === undefined) {
            throw new runtime.RequiredError('productionLotId','Required parameter requestParameters.productionLotId was null or undefined when calling getBackProductionLotProductionlotidDocumentsFileid.');
        }

        if (requestParameters.fileId === null || requestParameters.fileId === undefined) {
            throw new runtime.RequiredError('fileId','Required parameter requestParameters.fileId was null or undefined when calling getBackProductionLotProductionlotidDocumentsFileid.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/production-lot/{ProductionLotId}/documents/{FileId}`.replace(`{${"ProductionLotId"}}`, encodeURIComponent(String(requestParameters.productionLotId))).replace(`{${"FileId"}}`, encodeURIComponent(String(requestParameters.fileId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.BlobApiResponse(response);
    }

    /**
     * Get production lot\'s document
     */
    async getBackProductionLotProductionlotidDocumentsFileid(requestParameters: GetBackProductionLotProductionlotidDocumentsFileidRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Blob> {
        const response = await this.getBackProductionLotProductionlotidDocumentsFileidRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Unaccept production lot reports
     */
    async getBackProductionLotUnacceptProductionlotidRaw(requestParameters: GetBackProductionLotUnacceptProductionlotidRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<number>> {
        if (requestParameters.productionLotId === null || requestParameters.productionLotId === undefined) {
            throw new runtime.RequiredError('productionLotId','Required parameter requestParameters.productionLotId was null or undefined when calling getBackProductionLotUnacceptProductionlotid.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/production/lot/unaccept/{ProductionLotId}`.replace(`{${"ProductionLotId"}}`, encodeURIComponent(String(requestParameters.productionLotId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.TextApiResponse(response) as any;
    }

    /**
     * Unaccept production lot reports
     */
    async getBackProductionLotUnacceptProductionlotid(requestParameters: GetBackProductionLotUnacceptProductionlotidRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<number> {
        const response = await this.getBackProductionLotUnacceptProductionlotidRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Check if production lots created from order item are unspecified
     */
    async getBackProductionOrderCheckOrderItemProductionLotsUnspecifiedSalesentryitemidRaw(requestParameters: GetBackProductionOrderCheckOrderItemProductionLotsUnspecifiedSalesentryitemidRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<boolean>> {
        if (requestParameters.salesEntryItemId === null || requestParameters.salesEntryItemId === undefined) {
            throw new runtime.RequiredError('salesEntryItemId','Required parameter requestParameters.salesEntryItemId was null or undefined when calling getBackProductionOrderCheckOrderItemProductionLotsUnspecifiedSalesentryitemid.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/production-order/check/order/item/production-lots-unspecified/{SalesEntryItemId}`.replace(`{${"SalesEntryItemId"}}`, encodeURIComponent(String(requestParameters.salesEntryItemId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.TextApiResponse(response) as any;
    }

    /**
     * Check if production lots created from order item are unspecified
     */
    async getBackProductionOrderCheckOrderItemProductionLotsUnspecifiedSalesentryitemid(requestParameters: GetBackProductionOrderCheckOrderItemProductionLotsUnspecifiedSalesentryitemidRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<boolean> {
        const response = await this.getBackProductionOrderCheckOrderItemProductionLotsUnspecifiedSalesentryitemidRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get production order details
     */
    async getBackProductionOrderDetailsProductionorderidRaw(requestParameters: GetBackProductionOrderDetailsProductionorderidRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ProductionOrderView>> {
        if (requestParameters.productionOrderId === null || requestParameters.productionOrderId === undefined) {
            throw new runtime.RequiredError('productionOrderId','Required parameter requestParameters.productionOrderId was null or undefined when calling getBackProductionOrderDetailsProductionorderid.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/production-order/details/{ProductionOrderId}`.replace(`{${"ProductionOrderId"}}`, encodeURIComponent(String(requestParameters.productionOrderId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Get production order details
     */
    async getBackProductionOrderDetailsProductionorderid(requestParameters: GetBackProductionOrderDetailsProductionorderidRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ProductionOrderView> {
        const response = await this.getBackProductionOrderDetailsProductionorderidRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get production order details\' lots
     */
    async getBackProductionOrderDetailsProductionorderidLotsRaw(requestParameters: GetBackProductionOrderDetailsProductionorderidLotsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<ProductionOrderDetailsLotView>>> {
        if (requestParameters.productionOrderId === null || requestParameters.productionOrderId === undefined) {
            throw new runtime.RequiredError('productionOrderId','Required parameter requestParameters.productionOrderId was null or undefined when calling getBackProductionOrderDetailsProductionorderidLots.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/production-order/details/{ProductionOrderId}/lots`.replace(`{${"ProductionOrderId"}}`, encodeURIComponent(String(requestParameters.productionOrderId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Get production order details\' lots
     */
    async getBackProductionOrderDetailsProductionorderidLots(requestParameters: GetBackProductionOrderDetailsProductionorderidLotsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<ProductionOrderDetailsLotView>> {
        const response = await this.getBackProductionOrderDetailsProductionorderidLotsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Find production order product data for given production lot id
     */
    async getBackProductionOrderItemFindP1Raw(requestParameters: GetBackProductionOrderItemFindP1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ProductData>> {
        if (requestParameters.p1 === null || requestParameters.p1 === undefined) {
            throw new runtime.RequiredError('p1','Required parameter requestParameters.p1 was null or undefined when calling getBackProductionOrderItemFindP1.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/production-order/item/find/{p1}`.replace(`{${"p1"}}`, encodeURIComponent(String(requestParameters.p1))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Find production order product data for given production lot id
     */
    async getBackProductionOrderItemFindP1(requestParameters: GetBackProductionOrderItemFindP1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ProductData> {
        const response = await this.getBackProductionOrderItemFindP1Raw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getBackProductionOrdersCreatorListHeadersRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<any>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/production-orders/creator/list/headers`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.TextApiResponse(response) as any;
    }

    /**
     */
    async getBackProductionOrdersCreatorListHeaders(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<any> {
        const response = await this.getBackProductionOrdersCreatorListHeadersRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async getBackProductionOrdersLegacyListHeadersRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<any>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/production-orders/legacy/list/headers`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.TextApiResponse(response) as any;
    }

    /**
     */
    async getBackProductionOrdersLegacyListHeaders(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<any> {
        const response = await this.getBackProductionOrdersLegacyListHeadersRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async getBackProductionOrdersLegacyLotsHeadersRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<any>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/production-orders/legacy/lots/headers`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.TextApiResponse(response) as any;
    }

    /**
     */
    async getBackProductionOrdersLegacyLotsHeaders(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<any> {
        const response = await this.getBackProductionOrdersLegacyLotsHeadersRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async getBackProductionOrdersListHeadersRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<any>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/production-orders/list/headers`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.TextApiResponse(response) as any;
    }

    /**
     */
    async getBackProductionOrdersListHeaders(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<any> {
        const response = await this.getBackProductionOrdersListHeadersRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async getBackProductionOrdersLotRawMaterialsUsageListHeadersRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<any>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/production-orders/lot/raw-materials-usage/list/headers`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.TextApiResponse(response) as any;
    }

    /**
     */
    async getBackProductionOrdersLotRawMaterialsUsageListHeaders(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<any> {
        const response = await this.getBackProductionOrdersLotRawMaterialsUsageListHeadersRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async getBackProductionOrdersLotsListHeadersRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<any>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/production-orders/lots/list/headers`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.TextApiResponse(response) as any;
    }

    /**
     */
    async getBackProductionOrdersLotsListHeaders(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<any> {
        const response = await this.getBackProductionOrdersLotsListHeadersRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async getBackProductionOrdersOrderDemandsListHeadersRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<any>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/production-orders/order-demands/list/headers`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.TextApiResponse(response) as any;
    }

    /**
     */
    async getBackProductionOrdersOrderDemandsListHeaders(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<any> {
        const response = await this.getBackProductionOrdersOrderDemandsListHeadersRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async getBackProductionOrdersProductionOrderLotsListHeadersRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<any>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/production-orders/production-order-lots/list/headers`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.TextApiResponse(response) as any;
    }

    /**
     */
    async getBackProductionOrdersProductionOrderLotsListHeaders(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<any> {
        const response = await this.getBackProductionOrdersProductionOrderLotsListHeadersRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async getBackProductionOrdersRawMaterialsUsageListHeadersRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<any>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/production-orders/raw-materials-usage/list/headers`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.TextApiResponse(response) as any;
    }

    /**
     */
    async getBackProductionOrdersRawMaterialsUsageListHeaders(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<any> {
        const response = await this.getBackProductionOrdersRawMaterialsUsageListHeadersRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async getBackProductionOrdersWarehouseStateListHeadersRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<any>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/production-orders/warehouse-state/list/headers`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.TextApiResponse(response) as any;
    }

    /**
     */
    async getBackProductionOrdersWarehouseStateListHeaders(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<any> {
        const response = await this.getBackProductionOrdersWarehouseStateListHeadersRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async getBackProductionOrdersWarehouseToProductionListHeadersRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<any>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/production-orders/warehouse-to-production/list/headers`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.TextApiResponse(response) as any;
    }

    /**
     */
    async getBackProductionOrdersWarehouseToProductionListHeaders(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<any> {
        const response = await this.getBackProductionOrdersWarehouseToProductionListHeadersRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async getBackProductionOrdersWorktimeListHeadersRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<any>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/production-orders/worktime/list/headers`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.TextApiResponse(response) as any;
    }

    /**
     */
    async getBackProductionOrdersWorktimeListHeaders(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<any> {
        const response = await this.getBackProductionOrdersWorktimeListHeadersRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async getBackProductionSpecificationTagsListHeadersRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<any>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/production-specification/tags/list/headers`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.TextApiResponse(response) as any;
    }

    /**
     */
    async getBackProductionSpecificationTagsListHeaders(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<any> {
        const response = await this.getBackProductionSpecificationTagsListHeadersRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async getBackPushListHeadersRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<any>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/push/list/headers`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.TextApiResponse(response) as any;
    }

    /**
     */
    async getBackPushListHeaders(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<any> {
        const response = await this.getBackPushListHeadersRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async getBackQsCardListHeadersRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<any>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/qs/card/list/headers`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.TextApiResponse(response) as any;
    }

    /**
     */
    async getBackQsCardListHeaders(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<any> {
        const response = await this.getBackQsCardListHeadersRaw(initOverrides);
        return await response.value();
    }

    /**
     * Get supply card detailed view
     */
    async getBackQsCardSupplycardidDetailsRaw(requestParameters: GetBackQsCardSupplycardidDetailsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SupplyCardDetailsView>> {
        if (requestParameters.supplyCardId === null || requestParameters.supplyCardId === undefined) {
            throw new runtime.RequiredError('supplyCardId','Required parameter requestParameters.supplyCardId was null or undefined when calling getBackQsCardSupplycardidDetails.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/qs/card/{SupplyCardId}/details`.replace(`{${"SupplyCardId"}}`, encodeURIComponent(String(requestParameters.supplyCardId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Get supply card detailed view
     */
    async getBackQsCardSupplycardidDetails(requestParameters: GetBackQsCardSupplycardidDetailsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SupplyCardDetailsView> {
        const response = await this.getBackQsCardSupplycardidDetailsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get release items
     */
    async getBackReleasesItemsReleaseidRaw(requestParameters: GetBackReleasesItemsReleaseidRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ReleaseItemsView>> {
        if (requestParameters.releaseId === null || requestParameters.releaseId === undefined) {
            throw new runtime.RequiredError('releaseId','Required parameter requestParameters.releaseId was null or undefined when calling getBackReleasesItemsReleaseid.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/releases/items/{ReleaseId}`.replace(`{${"ReleaseId"}}`, encodeURIComponent(String(requestParameters.releaseId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Get release items
     */
    async getBackReleasesItemsReleaseid(requestParameters: GetBackReleasesItemsReleaseidRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ReleaseItemsView> {
        const response = await this.getBackReleasesItemsReleaseidRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getBackReleasesListHeadersRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<any>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/releases/list/headers`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.TextApiResponse(response) as any;
    }

    /**
     */
    async getBackReleasesListHeaders(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<any> {
        const response = await this.getBackReleasesListHeadersRaw(initOverrides);
        return await response.value();
    }

    /**
     * Get release plan items
     */
    async getBackReleasesPlanItemsReleaseplanidRaw(requestParameters: GetBackReleasesPlanItemsReleaseplanidRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ReleasePlanItemsView>> {
        if (requestParameters.releasePlanId === null || requestParameters.releasePlanId === undefined) {
            throw new runtime.RequiredError('releasePlanId','Required parameter requestParameters.releasePlanId was null or undefined when calling getBackReleasesPlanItemsReleaseplanid.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/releases/plan/items/{ReleasePlanId}`.replace(`{${"ReleasePlanId"}}`, encodeURIComponent(String(requestParameters.releasePlanId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Get release plan items
     */
    async getBackReleasesPlanItemsReleaseplanid(requestParameters: GetBackReleasesPlanItemsReleaseplanidRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ReleasePlanItemsView> {
        const response = await this.getBackReleasesPlanItemsReleaseplanidRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getBackReleasesPlanListHeadersRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<any>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/releases/plan/list/headers`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.TextApiResponse(response) as any;
    }

    /**
     */
    async getBackReleasesPlanListHeaders(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<any> {
        const response = await this.getBackReleasesPlanListHeadersRaw(initOverrides);
        return await response.value();
    }

    /**
     * Get initial view for planned release
     */
    async getBackReleasesPlannedInitReleaseplanidRaw(requestParameters: GetBackReleasesPlannedInitReleaseplanidRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PlannedReleaseInitialView>> {
        if (requestParameters.releasePlanId === null || requestParameters.releasePlanId === undefined) {
            throw new runtime.RequiredError('releasePlanId','Required parameter requestParameters.releasePlanId was null or undefined when calling getBackReleasesPlannedInitReleaseplanid.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/releases/planned/init/{ReleasePlanId}`.replace(`{${"ReleasePlanId"}}`, encodeURIComponent(String(requestParameters.releasePlanId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Get initial view for planned release
     */
    async getBackReleasesPlannedInitReleaseplanid(requestParameters: GetBackReleasesPlannedInitReleaseplanidRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PlannedReleaseInitialView> {
        const response = await this.getBackReleasesPlannedInitReleaseplanidRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getBackReportsDowntimeReasonsHeadersRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<any>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/reports/downtime-reasons/headers`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.TextApiResponse(response) as any;
    }

    /**
     */
    async getBackReportsDowntimeReasonsHeaders(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<any> {
        const response = await this.getBackReportsDowntimeReasonsHeadersRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async getBackReportsLoadCardsListHeadersRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<any>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/reports/load-cards/list/headers`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.TextApiResponse(response) as any;
    }

    /**
     */
    async getBackReportsLoadCardsListHeaders(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<any> {
        const response = await this.getBackReportsLoadCardsListHeadersRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async getBackReportsWasteCausesHeadersRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<any>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/reports/waste-causes/headers`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.TextApiResponse(response) as any;
    }

    /**
     */
    async getBackReportsWasteCausesHeaders(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<any> {
        const response = await this.getBackReportsWasteCausesHeadersRaw(initOverrides);
        return await response.value();
    }

    /**
     * Get workstation amount reports for batch
     */
    async getBackReportsWorkstationReportsAmountBatchBatchidRaw(requestParameters: GetBackReportsWorkstationReportsAmountBatchBatchidRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<WorkstationAmountReportView>> {
        if (requestParameters.batchId === null || requestParameters.batchId === undefined) {
            throw new runtime.RequiredError('batchId','Required parameter requestParameters.batchId was null or undefined when calling getBackReportsWorkstationReportsAmountBatchBatchid.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/reports/workstation-reports/amount/batch/{BatchId}`.replace(`{${"BatchId"}}`, encodeURIComponent(String(requestParameters.batchId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Get workstation amount reports for batch
     */
    async getBackReportsWorkstationReportsAmountBatchBatchid(requestParameters: GetBackReportsWorkstationReportsAmountBatchBatchidRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<WorkstationAmountReportView> {
        const response = await this.getBackReportsWorkstationReportsAmountBatchBatchidRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get workstation amount reports for production lot
     */
    async getBackReportsWorkstationReportsAmountProductionlotidRaw(requestParameters: GetBackReportsWorkstationReportsAmountProductionlotidRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<WorkstationAmountReportView>> {
        if (requestParameters.productionLotId === null || requestParameters.productionLotId === undefined) {
            throw new runtime.RequiredError('productionLotId','Required parameter requestParameters.productionLotId was null or undefined when calling getBackReportsWorkstationReportsAmountProductionlotid.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/reports/workstation-reports/amount/{ProductionLotId}`.replace(`{${"ProductionLotId"}}`, encodeURIComponent(String(requestParameters.productionLotId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Get workstation amount reports for production lot
     */
    async getBackReportsWorkstationReportsAmountProductionlotid(requestParameters: GetBackReportsWorkstationReportsAmountProductionlotidRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<WorkstationAmountReportView> {
        const response = await this.getBackReportsWorkstationReportsAmountProductionlotidRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get sensor reading for amount report for given lot
     */
    async getBackReportsWorkstationReportsAmountSensorProductionlotidHeadRaw(requestParameters: GetBackReportsWorkstationReportsAmountSensorProductionlotidHeadRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<WorkstationSensorAmountView>> {
        if (requestParameters.productionLotId === null || requestParameters.productionLotId === undefined) {
            throw new runtime.RequiredError('productionLotId','Required parameter requestParameters.productionLotId was null or undefined when calling getBackReportsWorkstationReportsAmountSensorProductionlotidHead.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/reports/workstation-reports/amount/sensor/{ProductionLotId}/head`.replace(`{${"ProductionLotId"}}`, encodeURIComponent(String(requestParameters.productionLotId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Get sensor reading for amount report for given lot
     */
    async getBackReportsWorkstationReportsAmountSensorProductionlotidHead(requestParameters: GetBackReportsWorkstationReportsAmountSensorProductionlotidHeadRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<WorkstationSensorAmountView> {
        const response = await this.getBackReportsWorkstationReportsAmountSensorProductionlotidHeadRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get bom for given production lot
     */
    async getBackReportsWorkstationReportsBomProductionLotProductionlotidRaw(requestParameters: GetBackReportsWorkstationReportsBomProductionLotProductionlotidRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<BomReportEntryView>>> {
        if (requestParameters.productionLotId === null || requestParameters.productionLotId === undefined) {
            throw new runtime.RequiredError('productionLotId','Required parameter requestParameters.productionLotId was null or undefined when calling getBackReportsWorkstationReportsBomProductionLotProductionlotid.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/reports/workstation-reports/bom/production-lot/{ProductionLotId}`.replace(`{${"ProductionLotId"}}`, encodeURIComponent(String(requestParameters.productionLotId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Get bom for given production lot
     */
    async getBackReportsWorkstationReportsBomProductionLotProductionlotid(requestParameters: GetBackReportsWorkstationReportsBomProductionLotProductionlotidRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<BomReportEntryView>> {
        const response = await this.getBackReportsWorkstationReportsBomProductionLotProductionlotidRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get comment for batch\'s report
     */
    async getBackReportsWorkstationReportsCommentBatchGetBatchidRaw(requestParameters: GetBackReportsWorkstationReportsCommentBatchGetBatchidRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CommentView>> {
        if (requestParameters.batchId === null || requestParameters.batchId === undefined) {
            throw new runtime.RequiredError('batchId','Required parameter requestParameters.batchId was null or undefined when calling getBackReportsWorkstationReportsCommentBatchGetBatchid.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/reports/workstation-reports/comment/batch/get/{BatchId}`.replace(`{${"BatchId"}}`, encodeURIComponent(String(requestParameters.batchId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Get comment for batch\'s report
     */
    async getBackReportsWorkstationReportsCommentBatchGetBatchid(requestParameters: GetBackReportsWorkstationReportsCommentBatchGetBatchidRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CommentView> {
        const response = await this.getBackReportsWorkstationReportsCommentBatchGetBatchidRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get comment for production lot\'s report
     */
    async getBackReportsWorkstationReportsCommentGetProductionlotidRaw(requestParameters: GetBackReportsWorkstationReportsCommentGetProductionlotidRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CommentView>> {
        if (requestParameters.productionLotId === null || requestParameters.productionLotId === undefined) {
            throw new runtime.RequiredError('productionLotId','Required parameter requestParameters.productionLotId was null or undefined when calling getBackReportsWorkstationReportsCommentGetProductionlotid.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/reports/workstation-reports/comment/get/{ProductionLotId}`.replace(`{${"ProductionLotId"}}`, encodeURIComponent(String(requestParameters.productionLotId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Get comment for production lot\'s report
     */
    async getBackReportsWorkstationReportsCommentGetProductionlotid(requestParameters: GetBackReportsWorkstationReportsCommentGetProductionlotidRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CommentView> {
        const response = await this.getBackReportsWorkstationReportsCommentGetProductionlotidRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get downtime reports by batch id
     */
    async getBackReportsWorkstationReportsDowntimeBatchBatchidRaw(requestParameters: GetBackReportsWorkstationReportsDowntimeBatchBatchidRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<DowntimeBatchGroupReportView>>> {
        if (requestParameters.batchId === null || requestParameters.batchId === undefined) {
            throw new runtime.RequiredError('batchId','Required parameter requestParameters.batchId was null or undefined when calling getBackReportsWorkstationReportsDowntimeBatchBatchid.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/reports/workstation-reports/downtime/batch/{BatchId}`.replace(`{${"BatchId"}}`, encodeURIComponent(String(requestParameters.batchId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Get downtime reports by batch id
     */
    async getBackReportsWorkstationReportsDowntimeBatchBatchid(requestParameters: GetBackReportsWorkstationReportsDowntimeBatchBatchidRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<DowntimeBatchGroupReportView>> {
        const response = await this.getBackReportsWorkstationReportsDowntimeBatchBatchidRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get active downtime report by batch id
     */
    async getBackReportsWorkstationReportsDowntimeBatchBatchidActiveRaw(requestParameters: GetBackReportsWorkstationReportsDowntimeBatchBatchidActiveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DowntimeBatchGroupReportView>> {
        if (requestParameters.batchId === null || requestParameters.batchId === undefined) {
            throw new runtime.RequiredError('batchId','Required parameter requestParameters.batchId was null or undefined when calling getBackReportsWorkstationReportsDowntimeBatchBatchidActive.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/reports/workstation-reports/downtime/batch/{BatchId}/active`.replace(`{${"BatchId"}}`, encodeURIComponent(String(requestParameters.batchId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Get active downtime report by batch id
     */
    async getBackReportsWorkstationReportsDowntimeBatchBatchidActive(requestParameters: GetBackReportsWorkstationReportsDowntimeBatchBatchidActiveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DowntimeBatchGroupReportView> {
        const response = await this.getBackReportsWorkstationReportsDowntimeBatchBatchidActiveRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get downtime reports by a production lot id
     */
    async getBackReportsWorkstationReportsDowntimeLotProductionlotidRaw(requestParameters: GetBackReportsWorkstationReportsDowntimeLotProductionlotidRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<DowntimeReportView>>> {
        if (requestParameters.productionLotId === null || requestParameters.productionLotId === undefined) {
            throw new runtime.RequiredError('productionLotId','Required parameter requestParameters.productionLotId was null or undefined when calling getBackReportsWorkstationReportsDowntimeLotProductionlotid.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/reports/workstation-reports/downtime/lot/{ProductionLotId}`.replace(`{${"ProductionLotId"}}`, encodeURIComponent(String(requestParameters.productionLotId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Get downtime reports by a production lot id
     */
    async getBackReportsWorkstationReportsDowntimeLotProductionlotid(requestParameters: GetBackReportsWorkstationReportsDowntimeLotProductionlotidRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<DowntimeReportView>> {
        const response = await this.getBackReportsWorkstationReportsDowntimeLotProductionlotidRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get load report for production lot
     */
    async getBackReportsWorkstationReportsLoadProductionLotProductionlotidRaw(requestParameters: GetBackReportsWorkstationReportsLoadProductionLotProductionlotidRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<LoadReportView>> {
        if (requestParameters.productionLotId === null || requestParameters.productionLotId === undefined) {
            throw new runtime.RequiredError('productionLotId','Required parameter requestParameters.productionLotId was null or undefined when calling getBackReportsWorkstationReportsLoadProductionLotProductionlotid.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/reports/workstation-reports/load/production-lot/{ProductionLotId}`.replace(`{${"ProductionLotId"}}`, encodeURIComponent(String(requestParameters.productionLotId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Get load report for production lot
     */
    async getBackReportsWorkstationReportsLoadProductionLotProductionlotid(requestParameters: GetBackReportsWorkstationReportsLoadProductionLotProductionlotidRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<LoadReportView> {
        const response = await this.getBackReportsWorkstationReportsLoadProductionLotProductionlotidRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get possible products for lot
     */
    async getBackReportsWorkstationReportsPossibleProductsProductionlotidRaw(requestParameters: GetBackReportsWorkstationReportsPossibleProductsProductionlotidRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<PossibleProductView>>> {
        if (requestParameters.productionLotId === null || requestParameters.productionLotId === undefined) {
            throw new runtime.RequiredError('productionLotId','Required parameter requestParameters.productionLotId was null or undefined when calling getBackReportsWorkstationReportsPossibleProductsProductionlotid.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/reports/workstation-reports/possible-products/{ProductionLotId}`.replace(`{${"ProductionLotId"}}`, encodeURIComponent(String(requestParameters.productionLotId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Get possible products for lot
     */
    async getBackReportsWorkstationReportsPossibleProductsProductionlotid(requestParameters: GetBackReportsWorkstationReportsPossibleProductsProductionlotidRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<PossibleProductView>> {
        const response = await this.getBackReportsWorkstationReportsPossibleProductsProductionlotidRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get times spent in machine states
     */
    async getBackReportsWorkstationReportsTimesProductionlotidHeadRaw(requestParameters: GetBackReportsWorkstationReportsTimesProductionlotidHeadRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<MachineStateTimesView>> {
        if (requestParameters.productionLotId === null || requestParameters.productionLotId === undefined) {
            throw new runtime.RequiredError('productionLotId','Required parameter requestParameters.productionLotId was null or undefined when calling getBackReportsWorkstationReportsTimesProductionlotidHead.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/reports/workstation-reports/times/{ProductionLotId}/head`.replace(`{${"ProductionLotId"}}`, encodeURIComponent(String(requestParameters.productionLotId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Get times spent in machine states
     */
    async getBackReportsWorkstationReportsTimesProductionlotidHead(requestParameters: GetBackReportsWorkstationReportsTimesProductionlotidHeadRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<MachineStateTimesView> {
        const response = await this.getBackReportsWorkstationReportsTimesProductionlotidHeadRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get all workstations that user is allowed to view
     */
    async getBackReportsWorkstationsAllRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<Workstation>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/reports/workstations/all`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Get all workstations that user is allowed to view
     */
    async getBackReportsWorkstationsAll(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<Workstation>> {
        const response = await this.getBackReportsWorkstationsAllRaw(initOverrides);
        return await response.value();
    }

    /**
     * Get workstation view for batch
     */
    async getBackReportsWorkstationsByBatchBatchidRaw(requestParameters: GetBackReportsWorkstationsByBatchBatchidRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<WorkstationBatchView>> {
        if (requestParameters.batchId === null || requestParameters.batchId === undefined) {
            throw new runtime.RequiredError('batchId','Required parameter requestParameters.batchId was null or undefined when calling getBackReportsWorkstationsByBatchBatchid.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/reports/workstations/by-batch/{BatchId}`.replace(`{${"BatchId"}}`, encodeURIComponent(String(requestParameters.batchId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Get workstation view for batch
     */
    async getBackReportsWorkstationsByBatchBatchid(requestParameters: GetBackReportsWorkstationsByBatchBatchidRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<WorkstationBatchView> {
        const response = await this.getBackReportsWorkstationsByBatchBatchidRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get workstation dashboard view for production lot
     */
    async getBackReportsWorkstationsByLotProductionlotidRaw(requestParameters: GetBackReportsWorkstationsByLotProductionlotidRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<WorkstationDashboardView>> {
        if (requestParameters.productionLotId === null || requestParameters.productionLotId === undefined) {
            throw new runtime.RequiredError('productionLotId','Required parameter requestParameters.productionLotId was null or undefined when calling getBackReportsWorkstationsByLotProductionlotid.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/reports/workstations/by-lot/{ProductionLotId}`.replace(`{${"ProductionLotId"}}`, encodeURIComponent(String(requestParameters.productionLotId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Get workstation dashboard view for production lot
     */
    async getBackReportsWorkstationsByLotProductionlotid(requestParameters: GetBackReportsWorkstationsByLotProductionlotidRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<WorkstationDashboardView> {
        const response = await this.getBackReportsWorkstationsByLotProductionlotidRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get workstation object view for machine
     */
    async getBackReportsWorkstationsByMachineMachineidRaw(requestParameters: GetBackReportsWorkstationsByMachineMachineidRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<WorkstationObjectView>>> {
        if (requestParameters.machineId === null || requestParameters.machineId === undefined) {
            throw new runtime.RequiredError('machineId','Required parameter requestParameters.machineId was null or undefined when calling getBackReportsWorkstationsByMachineMachineid.');
        }

        const queryParameters: any = {};

        if (requestParameters.onlyMyTasks !== undefined) {
            queryParameters['onlyMyTasks'] = requestParameters.onlyMyTasks;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/reports/workstations/by-machine/{MachineId}`.replace(`{${"MachineId"}}`, encodeURIComponent(String(requestParameters.machineId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Get workstation object view for machine
     */
    async getBackReportsWorkstationsByMachineMachineid(requestParameters: GetBackReportsWorkstationsByMachineMachineidRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<WorkstationObjectView>> {
        const response = await this.getBackReportsWorkstationsByMachineMachineidRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get todos (lots or batches) for current user
     */
    async getBackReportsWorkstationsTodosRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<WorkstationTodoView>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/reports/workstations/todos`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Get todos (lots or batches) for current user
     */
    async getBackReportsWorkstationsTodos(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<WorkstationTodoView>> {
        const response = await this.getBackReportsWorkstationsTodosRaw(initOverrides);
        return await response.value();
    }

    /**
     * Get workstations that have work assigned to them
     */
    async getBackReportsWorkstationsWithAssignedWorkRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<Workstation>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/reports/workstations/with-assigned-work`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Get workstations that have work assigned to them
     */
    async getBackReportsWorkstationsWithAssignedWork(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<Workstation>> {
        const response = await this.getBackReportsWorkstationsWithAssignedWorkRaw(initOverrides);
        return await response.value();
    }

    /**
     * Get sales entry document metadata by id
     */
    async getBackSalesDocumentP1Raw(requestParameters: GetBackSalesDocumentP1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SalesEntryDocumentMetadataView>> {
        if (requestParameters.p1 === null || requestParameters.p1 === undefined) {
            throw new runtime.RequiredError('p1','Required parameter requestParameters.p1 was null or undefined when calling getBackSalesDocumentP1.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/sales/document/{p1}`.replace(`{${"p1"}}`, encodeURIComponent(String(requestParameters.p1))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Get sales entry document metadata by id
     */
    async getBackSalesDocumentP1(requestParameters: GetBackSalesDocumentP1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SalesEntryDocumentMetadataView> {
        const response = await this.getBackSalesDocumentP1Raw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get sales entry document content by id
     */
    async getBackSalesDocumentP1ContentRaw(requestParameters: GetBackSalesDocumentP1ContentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Blob>> {
        if (requestParameters.p1 === null || requestParameters.p1 === undefined) {
            throw new runtime.RequiredError('p1','Required parameter requestParameters.p1 was null or undefined when calling getBackSalesDocumentP1Content.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/sales/document/{p1}/content`.replace(`{${"p1"}}`, encodeURIComponent(String(requestParameters.p1))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.BlobApiResponse(response);
    }

    /**
     * Get sales entry document content by id
     */
    async getBackSalesDocumentP1Content(requestParameters: GetBackSalesDocumentP1ContentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Blob> {
        const response = await this.getBackSalesDocumentP1ContentRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get summary of expenses for sales entry
     */
    async getBackSalesDocumentSummaryExpensesSalesentryidRaw(requestParameters: GetBackSalesDocumentSummaryExpensesSalesentryidRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<number>> {
        if (requestParameters.salesEntryId === null || requestParameters.salesEntryId === undefined) {
            throw new runtime.RequiredError('salesEntryId','Required parameter requestParameters.salesEntryId was null or undefined when calling getBackSalesDocumentSummaryExpensesSalesentryid.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/sales/document/summary/expenses/{SalesEntryId}`.replace(`{${"SalesEntryId"}}`, encodeURIComponent(String(requestParameters.salesEntryId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.TextApiResponse(response) as any;
    }

    /**
     * Get summary of expenses for sales entry
     */
    async getBackSalesDocumentSummaryExpensesSalesentryid(requestParameters: GetBackSalesDocumentSummaryExpensesSalesentryidRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<number> {
        const response = await this.getBackSalesDocumentSummaryExpensesSalesentryidRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getBackSalesDocumentsListHeadersRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<any>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/sales/documents/list/headers`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.TextApiResponse(response) as any;
    }

    /**
     */
    async getBackSalesDocumentsListHeaders(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<any> {
        const response = await this.getBackSalesDocumentsListHeadersRaw(initOverrides);
        return await response.value();
    }

    /**
     * Get eligible responsible users
     */
    async getBackSalesEligibleResponsibleUsersRaw(requestParameters: GetBackSalesEligibleResponsibleUsersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<UserView>>> {
        const queryParameters: any = {};

        if (requestParameters.userIds) {
            queryParameters['userIds'] = requestParameters.userIds;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/sales/eligible-responsible-users`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Get eligible responsible users
     */
    async getBackSalesEligibleResponsibleUsers(requestParameters: GetBackSalesEligibleResponsibleUsersRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<UserView>> {
        const response = await this.getBackSalesEligibleResponsibleUsersRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getBackSalesPaymentMethodListHeadersRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<any>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/sales/payment-method/list/headers`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.TextApiResponse(response) as any;
    }

    /**
     */
    async getBackSalesPaymentMethodListHeaders(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<any> {
        const response = await this.getBackSalesPaymentMethodListHeadersRaw(initOverrides);
        return await response.value();
    }

    /**
     * Get sales entry items view
     */
    async getBackSalesSalesentryidItemsRaw(requestParameters: GetBackSalesSalesentryidItemsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SalesEntryItemsView>> {
        if (requestParameters.salesEntryId === null || requestParameters.salesEntryId === undefined) {
            throw new runtime.RequiredError('salesEntryId','Required parameter requestParameters.salesEntryId was null or undefined when calling getBackSalesSalesentryidItems.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/sales/{SalesEntryId}/items`.replace(`{${"SalesEntryId"}}`, encodeURIComponent(String(requestParameters.salesEntryId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Get sales entry items view
     */
    async getBackSalesSalesentryidItems(requestParameters: GetBackSalesSalesentryidItemsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SalesEntryItemsView> {
        const response = await this.getBackSalesSalesentryidItemsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getBackSalesTagsListHeadersRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<any>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/sales/tags/list/headers`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.TextApiResponse(response) as any;
    }

    /**
     */
    async getBackSalesTagsListHeaders(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<any> {
        const response = await this.getBackSalesTagsListHeadersRaw(initOverrides);
        return await response.value();
    }

    /**
     * Search SalesEntryTags
     */
    async getBackSalesTagsSearchRaw(requestParameters: GetBackSalesTagsSearchRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<string>>> {
        if (requestParameters.text === null || requestParameters.text === undefined) {
            throw new runtime.RequiredError('text','Required parameter requestParameters.text was null or undefined when calling getBackSalesTagsSearch.');
        }

        if (requestParameters.maxResults === null || requestParameters.maxResults === undefined) {
            throw new runtime.RequiredError('maxResults','Required parameter requestParameters.maxResults was null or undefined when calling getBackSalesTagsSearch.');
        }

        const queryParameters: any = {};

        if (requestParameters.text !== undefined) {
            queryParameters['text'] = requestParameters.text;
        }

        if (requestParameters.maxResults !== undefined) {
            queryParameters['maxResults'] = requestParameters.maxResults;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/sales/tags/search`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Search SalesEntryTags
     */
    async getBackSalesTagsSearch(requestParameters: GetBackSalesTagsSearchRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<string>> {
        const response = await this.getBackSalesTagsSearchRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getBackShippingDriversListHeadersRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<any>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/shipping/drivers/list/headers`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.TextApiResponse(response) as any;
    }

    /**
     */
    async getBackShippingDriversListHeaders(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<any> {
        const response = await this.getBackShippingDriversListHeadersRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async getBackSpecificationsByMachineFeaturesListHeadersRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<any>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/specifications/by-machine-features-list/headers`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.TextApiResponse(response) as any;
    }

    /**
     */
    async getBackSpecificationsByMachineFeaturesListHeaders(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<any> {
        const response = await this.getBackSpecificationsByMachineFeaturesListHeadersRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async getBackSpecificationsByProducedItemTagsListHeadersRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<any>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/specifications/by-produced-item-tags-list/headers`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.TextApiResponse(response) as any;
    }

    /**
     */
    async getBackSpecificationsByProducedItemTagsListHeaders(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<any> {
        const response = await this.getBackSpecificationsByProducedItemTagsListHeadersRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async getBackSpecificationsByProducedVariantListHeadersRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<any>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/specifications/by-produced-variant-list/headers`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.TextApiResponse(response) as any;
    }

    /**
     */
    async getBackSpecificationsByProducedVariantListHeaders(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<any> {
        const response = await this.getBackSpecificationsByProducedVariantListHeadersRaw(initOverrides);
        return await response.value();
    }

    /**
     * Search for card parameter labels
     */
    async getBackSpecificationsCardsParametersLabelsRaw(requestParameters: GetBackSpecificationsCardsParametersLabelsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SearchResponseString>> {
        if (requestParameters.text === null || requestParameters.text === undefined) {
            throw new runtime.RequiredError('text','Required parameter requestParameters.text was null or undefined when calling getBackSpecificationsCardsParametersLabels.');
        }

        if (requestParameters.maxResults === null || requestParameters.maxResults === undefined) {
            throw new runtime.RequiredError('maxResults','Required parameter requestParameters.maxResults was null or undefined when calling getBackSpecificationsCardsParametersLabels.');
        }

        const queryParameters: any = {};

        if (requestParameters.text !== undefined) {
            queryParameters['text'] = requestParameters.text;
        }

        if (requestParameters.maxResults !== undefined) {
            queryParameters['maxResults'] = requestParameters.maxResults;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/specifications/cards/parameters/labels`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Search for card parameter labels
     */
    async getBackSpecificationsCardsParametersLabels(requestParameters: GetBackSpecificationsCardsParametersLabelsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SearchResponseString> {
        const response = await this.getBackSpecificationsCardsParametersLabelsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Search confirmation texts
     */
    async getBackSpecificationsConfirmationTextRaw(requestParameters: GetBackSpecificationsConfirmationTextRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SearchResponseString>> {
        if (requestParameters.text === null || requestParameters.text === undefined) {
            throw new runtime.RequiredError('text','Required parameter requestParameters.text was null or undefined when calling getBackSpecificationsConfirmationText.');
        }

        if (requestParameters.maxResults === null || requestParameters.maxResults === undefined) {
            throw new runtime.RequiredError('maxResults','Required parameter requestParameters.maxResults was null or undefined when calling getBackSpecificationsConfirmationText.');
        }

        const queryParameters: any = {};

        if (requestParameters.text !== undefined) {
            queryParameters['text'] = requestParameters.text;
        }

        if (requestParameters.maxResults !== undefined) {
            queryParameters['maxResults'] = requestParameters.maxResults;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/specifications/confirmation-text`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Search confirmation texts
     */
    async getBackSpecificationsConfirmationText(requestParameters: GetBackSpecificationsConfirmationTextRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SearchResponseString> {
        const response = await this.getBackSpecificationsConfirmationTextRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get short specification templates views for given item type id
     */
    async getBackSpecificationsOfTypeP1Raw(requestParameters: GetBackSpecificationsOfTypeP1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<SpecificationTemplateShortView>>> {
        if (requestParameters.p1 === null || requestParameters.p1 === undefined) {
            throw new runtime.RequiredError('p1','Required parameter requestParameters.p1 was null or undefined when calling getBackSpecificationsOfTypeP1.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/specifications/of-type/{p1}`.replace(`{${"p1"}}`, encodeURIComponent(String(requestParameters.p1))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Get short specification templates views for given item type id
     */
    async getBackSpecificationsOfTypeP1(requestParameters: GetBackSpecificationsOfTypeP1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<SpecificationTemplateShortView>> {
        const response = await this.getBackSpecificationsOfTypeP1Raw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get variant specification templates for given variant id
     */
    async getBackSpecificationsOfVariantP1Raw(requestParameters: GetBackSpecificationsOfVariantP1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<SpecificationTemplateForVariantView>>> {
        if (requestParameters.p1 === null || requestParameters.p1 === undefined) {
            throw new runtime.RequiredError('p1','Required parameter requestParameters.p1 was null or undefined when calling getBackSpecificationsOfVariantP1.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/specifications/of-variant/{p1}`.replace(`{${"p1"}}`, encodeURIComponent(String(requestParameters.p1))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Get variant specification templates for given variant id
     */
    async getBackSpecificationsOfVariantP1(requestParameters: GetBackSpecificationsOfVariantP1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<SpecificationTemplateForVariantView>> {
        const response = await this.getBackSpecificationsOfVariantP1Raw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get all allowed recipes for user
     */
    async getBackSpecificationsRecipeAllowedRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<RecipeTypeView>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/specifications/recipe/allowed`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Get all allowed recipes for user
     */
    async getBackSpecificationsRecipeAllowed(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<RecipeTypeView>> {
        const response = await this.getBackSpecificationsRecipeAllowedRaw(initOverrides);
        return await response.value();
    }

    /**
     * Get history for given recipe
     */
    async getBackSpecificationsRecipeHistoryP1Raw(requestParameters: GetBackSpecificationsRecipeHistoryP1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<EntityVersionTW>>> {
        if (requestParameters.p1 === null || requestParameters.p1 === undefined) {
            throw new runtime.RequiredError('p1','Required parameter requestParameters.p1 was null or undefined when calling getBackSpecificationsRecipeHistoryP1.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/specifications/recipe/history/{p1}`.replace(`{${"p1"}}`, encodeURIComponent(String(requestParameters.p1))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Get history for given recipe
     */
    async getBackSpecificationsRecipeHistoryP1(requestParameters: GetBackSpecificationsRecipeHistoryP1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<EntityVersionTW>> {
        const response = await this.getBackSpecificationsRecipeHistoryP1Raw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Search dosage rollers
     */
    async getBackSpecificationsRecipePrintingDosageRollersRaw(requestParameters: GetBackSpecificationsRecipePrintingDosageRollersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<ItemTypeVariant>>> {
        if (requestParameters.text === null || requestParameters.text === undefined) {
            throw new runtime.RequiredError('text','Required parameter requestParameters.text was null or undefined when calling getBackSpecificationsRecipePrintingDosageRollers.');
        }

        if (requestParameters.maxResults === null || requestParameters.maxResults === undefined) {
            throw new runtime.RequiredError('maxResults','Required parameter requestParameters.maxResults was null or undefined when calling getBackSpecificationsRecipePrintingDosageRollers.');
        }

        const queryParameters: any = {};

        if (requestParameters.text !== undefined) {
            queryParameters['text'] = requestParameters.text;
        }

        if (requestParameters.maxResults !== undefined) {
            queryParameters['maxResults'] = requestParameters.maxResults;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/specifications/recipe/printing/dosage-rollers`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Search dosage rollers
     */
    async getBackSpecificationsRecipePrintingDosageRollers(requestParameters: GetBackSpecificationsRecipePrintingDosageRollersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<ItemTypeVariant>> {
        const response = await this.getBackSpecificationsRecipePrintingDosageRollersRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Search halftone shapes
     */
    async getBackSpecificationsRecipePrintingHalftoneShapesRaw(requestParameters: GetBackSpecificationsRecipePrintingHalftoneShapesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<string>>> {
        if (requestParameters.text === null || requestParameters.text === undefined) {
            throw new runtime.RequiredError('text','Required parameter requestParameters.text was null or undefined when calling getBackSpecificationsRecipePrintingHalftoneShapes.');
        }

        if (requestParameters.maxResults === null || requestParameters.maxResults === undefined) {
            throw new runtime.RequiredError('maxResults','Required parameter requestParameters.maxResults was null or undefined when calling getBackSpecificationsRecipePrintingHalftoneShapes.');
        }

        const queryParameters: any = {};

        if (requestParameters.text !== undefined) {
            queryParameters['text'] = requestParameters.text;
        }

        if (requestParameters.maxResults !== undefined) {
            queryParameters['maxResults'] = requestParameters.maxResults;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/specifications/recipe/printing/halftone-shapes`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Search halftone shapes
     */
    async getBackSpecificationsRecipePrintingHalftoneShapes(requestParameters: GetBackSpecificationsRecipePrintingHalftoneShapesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<string>> {
        const response = await this.getBackSpecificationsRecipePrintingHalftoneShapesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Search lacquering materials
     */
    async getBackSpecificationsRecipePrintingLacqueringRaw(requestParameters: GetBackSpecificationsRecipePrintingLacqueringRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<ItemTypePropertySet>>> {
        if (requestParameters.text === null || requestParameters.text === undefined) {
            throw new runtime.RequiredError('text','Required parameter requestParameters.text was null or undefined when calling getBackSpecificationsRecipePrintingLacquering.');
        }

        if (requestParameters.maxResults === null || requestParameters.maxResults === undefined) {
            throw new runtime.RequiredError('maxResults','Required parameter requestParameters.maxResults was null or undefined when calling getBackSpecificationsRecipePrintingLacquering.');
        }

        const queryParameters: any = {};

        if (requestParameters.text !== undefined) {
            queryParameters['text'] = requestParameters.text;
        }

        if (requestParameters.maxResults !== undefined) {
            queryParameters['maxResults'] = requestParameters.maxResults;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/specifications/recipe/printing/lacquering`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Search lacquering materials
     */
    async getBackSpecificationsRecipePrintingLacquering(requestParameters: GetBackSpecificationsRecipePrintingLacqueringRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<ItemTypePropertySet>> {
        const response = await this.getBackSpecificationsRecipePrintingLacqueringRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Search lamination materials
     */
    async getBackSpecificationsRecipePrintingLaminationRaw(requestParameters: GetBackSpecificationsRecipePrintingLaminationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<ItemTypePropertySet>>> {
        if (requestParameters.text === null || requestParameters.text === undefined) {
            throw new runtime.RequiredError('text','Required parameter requestParameters.text was null or undefined when calling getBackSpecificationsRecipePrintingLamination.');
        }

        if (requestParameters.maxResults === null || requestParameters.maxResults === undefined) {
            throw new runtime.RequiredError('maxResults','Required parameter requestParameters.maxResults was null or undefined when calling getBackSpecificationsRecipePrintingLamination.');
        }

        const queryParameters: any = {};

        if (requestParameters.text !== undefined) {
            queryParameters['text'] = requestParameters.text;
        }

        if (requestParameters.maxResults !== undefined) {
            queryParameters['maxResults'] = requestParameters.maxResults;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/specifications/recipe/printing/lamination`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Search lamination materials
     */
    async getBackSpecificationsRecipePrintingLamination(requestParameters: GetBackSpecificationsRecipePrintingLaminationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<ItemTypePropertySet>> {
        const response = await this.getBackSpecificationsRecipePrintingLaminationRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Search paints
     */
    async getBackSpecificationsRecipePrintingPaintRaw(requestParameters: GetBackSpecificationsRecipePrintingPaintRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<ItemTypePropertySet>>> {
        if (requestParameters.text === null || requestParameters.text === undefined) {
            throw new runtime.RequiredError('text','Required parameter requestParameters.text was null or undefined when calling getBackSpecificationsRecipePrintingPaint.');
        }

        if (requestParameters.maxResults === null || requestParameters.maxResults === undefined) {
            throw new runtime.RequiredError('maxResults','Required parameter requestParameters.maxResults was null or undefined when calling getBackSpecificationsRecipePrintingPaint.');
        }

        const queryParameters: any = {};

        if (requestParameters.text !== undefined) {
            queryParameters['text'] = requestParameters.text;
        }

        if (requestParameters.maxResults !== undefined) {
            queryParameters['maxResults'] = requestParameters.maxResults;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/specifications/recipe/printing/paint`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Search paints
     */
    async getBackSpecificationsRecipePrintingPaint(requestParameters: GetBackSpecificationsRecipePrintingPaintRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<ItemTypePropertySet>> {
        const response = await this.getBackSpecificationsRecipePrintingPaintRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Search papers
     */
    async getBackSpecificationsRecipePrintingPaperRaw(requestParameters: GetBackSpecificationsRecipePrintingPaperRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<ItemTypePropertySet>>> {
        if (requestParameters.text === null || requestParameters.text === undefined) {
            throw new runtime.RequiredError('text','Required parameter requestParameters.text was null or undefined when calling getBackSpecificationsRecipePrintingPaper.');
        }

        if (requestParameters.maxResults === null || requestParameters.maxResults === undefined) {
            throw new runtime.RequiredError('maxResults','Required parameter requestParameters.maxResults was null or undefined when calling getBackSpecificationsRecipePrintingPaper.');
        }

        const queryParameters: any = {};

        if (requestParameters.text !== undefined) {
            queryParameters['text'] = requestParameters.text;
        }

        if (requestParameters.maxResults !== undefined) {
            queryParameters['maxResults'] = requestParameters.maxResults;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/specifications/recipe/printing/paper`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Search papers
     */
    async getBackSpecificationsRecipePrintingPaper(requestParameters: GetBackSpecificationsRecipePrintingPaperRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<ItemTypePropertySet>> {
        const response = await this.getBackSpecificationsRecipePrintingPaperRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get paper with width property name
     */
    async getBackSpecificationsRecipePrintingPaperWidthPropertyNameRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<string>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/specifications/recipe/printing/paper-width/property/name`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.TextApiResponse(response) as any;
    }

    /**
     * Get paper with width property name
     */
    async getBackSpecificationsRecipePrintingPaperWidthPropertyName(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<string> {
        const response = await this.getBackSpecificationsRecipePrintingPaperWidthPropertyNameRaw(initOverrides);
        return await response.value();
    }

    /**
     * Search plate materials
     */
    async getBackSpecificationsRecipePrintingPlateMaterialsRaw(requestParameters: GetBackSpecificationsRecipePrintingPlateMaterialsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<ItemTypePropertySet>>> {
        if (requestParameters.text === null || requestParameters.text === undefined) {
            throw new runtime.RequiredError('text','Required parameter requestParameters.text was null or undefined when calling getBackSpecificationsRecipePrintingPlateMaterials.');
        }

        if (requestParameters.maxResults === null || requestParameters.maxResults === undefined) {
            throw new runtime.RequiredError('maxResults','Required parameter requestParameters.maxResults was null or undefined when calling getBackSpecificationsRecipePrintingPlateMaterials.');
        }

        const queryParameters: any = {};

        if (requestParameters.text !== undefined) {
            queryParameters['text'] = requestParameters.text;
        }

        if (requestParameters.maxResults !== undefined) {
            queryParameters['maxResults'] = requestParameters.maxResults;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/specifications/recipe/printing/plate-materials`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Search plate materials
     */
    async getBackSpecificationsRecipePrintingPlateMaterials(requestParameters: GetBackSpecificationsRecipePrintingPlateMaterialsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<ItemTypePropertySet>> {
        const response = await this.getBackSpecificationsRecipePrintingPlateMaterialsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Search relief plates
     */
    async getBackSpecificationsRecipePrintingReliefPlatesRaw(requestParameters: GetBackSpecificationsRecipePrintingReliefPlatesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<ItemTypeVariant>>> {
        if (requestParameters.text === null || requestParameters.text === undefined) {
            throw new runtime.RequiredError('text','Required parameter requestParameters.text was null or undefined when calling getBackSpecificationsRecipePrintingReliefPlates.');
        }

        if (requestParameters.maxResults === null || requestParameters.maxResults === undefined) {
            throw new runtime.RequiredError('maxResults','Required parameter requestParameters.maxResults was null or undefined when calling getBackSpecificationsRecipePrintingReliefPlates.');
        }

        const queryParameters: any = {};

        if (requestParameters.text !== undefined) {
            queryParameters['text'] = requestParameters.text;
        }

        if (requestParameters.maxResults !== undefined) {
            queryParameters['maxResults'] = requestParameters.maxResults;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/specifications/recipe/printing/relief-plates`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Search relief plates
     */
    async getBackSpecificationsRecipePrintingReliefPlates(requestParameters: GetBackSpecificationsRecipePrintingReliefPlatesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<ItemTypeVariant>> {
        const response = await this.getBackSpecificationsRecipePrintingReliefPlatesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Search ruling
     */
    async getBackSpecificationsRecipePrintingRulingRaw(requestParameters: GetBackSpecificationsRecipePrintingRulingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<string>>> {
        if (requestParameters.text === null || requestParameters.text === undefined) {
            throw new runtime.RequiredError('text','Required parameter requestParameters.text was null or undefined when calling getBackSpecificationsRecipePrintingRuling.');
        }

        if (requestParameters.maxResults === null || requestParameters.maxResults === undefined) {
            throw new runtime.RequiredError('maxResults','Required parameter requestParameters.maxResults was null or undefined when calling getBackSpecificationsRecipePrintingRuling.');
        }

        const queryParameters: any = {};

        if (requestParameters.text !== undefined) {
            queryParameters['text'] = requestParameters.text;
        }

        if (requestParameters.maxResults !== undefined) {
            queryParameters['maxResults'] = requestParameters.maxResults;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/specifications/recipe/printing/ruling`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Search ruling
     */
    async getBackSpecificationsRecipePrintingRuling(requestParameters: GetBackSpecificationsRecipePrintingRulingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<string>> {
        const response = await this.getBackSpecificationsRecipePrintingRulingRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Search stamping materials
     */
    async getBackSpecificationsRecipePrintingStampingRaw(requestParameters: GetBackSpecificationsRecipePrintingStampingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<ItemTypePropertySet>>> {
        if (requestParameters.text === null || requestParameters.text === undefined) {
            throw new runtime.RequiredError('text','Required parameter requestParameters.text was null or undefined when calling getBackSpecificationsRecipePrintingStamping.');
        }

        if (requestParameters.maxResults === null || requestParameters.maxResults === undefined) {
            throw new runtime.RequiredError('maxResults','Required parameter requestParameters.maxResults was null or undefined when calling getBackSpecificationsRecipePrintingStamping.');
        }

        const queryParameters: any = {};

        if (requestParameters.text !== undefined) {
            queryParameters['text'] = requestParameters.text;
        }

        if (requestParameters.maxResults !== undefined) {
            queryParameters['maxResults'] = requestParameters.maxResults;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/specifications/recipe/printing/stamping`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Search stamping materials
     */
    async getBackSpecificationsRecipePrintingStamping(requestParameters: GetBackSpecificationsRecipePrintingStampingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<ItemTypePropertySet>> {
        const response = await this.getBackSpecificationsRecipePrintingStampingRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Search summary parts
     */
    async getBackSpecificationsRecipeSummaryPartsRaw(requestParameters: GetBackSpecificationsRecipeSummaryPartsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<string>>> {
        if (requestParameters.text === null || requestParameters.text === undefined) {
            throw new runtime.RequiredError('text','Required parameter requestParameters.text was null or undefined when calling getBackSpecificationsRecipeSummaryParts.');
        }

        if (requestParameters.maxResults === null || requestParameters.maxResults === undefined) {
            throw new runtime.RequiredError('maxResults','Required parameter requestParameters.maxResults was null or undefined when calling getBackSpecificationsRecipeSummaryParts.');
        }

        const queryParameters: any = {};

        if (requestParameters.text !== undefined) {
            queryParameters['text'] = requestParameters.text;
        }

        if (requestParameters.maxResults !== undefined) {
            queryParameters['maxResults'] = requestParameters.maxResults;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/specifications/recipe/summary-parts`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Search summary parts
     */
    async getBackSpecificationsRecipeSummaryParts(requestParameters: GetBackSpecificationsRecipeSummaryPartsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<string>> {
        const response = await this.getBackSpecificationsRecipeSummaryPartsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Returns all recipe user defined parameters with their possible values
     */
    async getBackSpecificationsRecipeUserDefinedParametersWithPossibleValuesRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<RecipeUserDefinedParameterWithValuesView>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/specifications/recipe/user-defined-parameters/with-possible-values`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Returns all recipe user defined parameters with their possible values
     */
    async getBackSpecificationsRecipeUserDefinedParametersWithPossibleValues(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<RecipeUserDefinedParameterWithValuesView>> {
        const response = await this.getBackSpecificationsRecipeUserDefinedParametersWithPossibleValuesRaw(initOverrides);
        return await response.value();
    }

    /**
     * Get simple specification template by item type id
     */
    async getBackSpecificationsSimpleItemtypeidRaw(requestParameters: GetBackSpecificationsSimpleItemtypeidRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SpecificationTemplateSimpleView>> {
        if (requestParameters.itemTypeId === null || requestParameters.itemTypeId === undefined) {
            throw new runtime.RequiredError('itemTypeId','Required parameter requestParameters.itemTypeId was null or undefined when calling getBackSpecificationsSimpleItemtypeid.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/specifications/simple/{ItemTypeId}`.replace(`{${"ItemTypeId"}}`, encodeURIComponent(String(requestParameters.itemTypeId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Get simple specification template by item type id
     */
    async getBackSpecificationsSimpleItemtypeid(requestParameters: GetBackSpecificationsSimpleItemtypeidRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SpecificationTemplateSimpleView> {
        const response = await this.getBackSpecificationsSimpleItemtypeidRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Search through all active specification templates
     */
    async getBackSpecificationsSpecificationsActiveRaw(requestParameters: GetBackSpecificationsSpecificationsActiveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SearchResponseIdWithName>> {
        if (requestParameters.text === null || requestParameters.text === undefined) {
            throw new runtime.RequiredError('text','Required parameter requestParameters.text was null or undefined when calling getBackSpecificationsSpecificationsActive.');
        }

        if (requestParameters.maxResults === null || requestParameters.maxResults === undefined) {
            throw new runtime.RequiredError('maxResults','Required parameter requestParameters.maxResults was null or undefined when calling getBackSpecificationsSpecificationsActive.');
        }

        const queryParameters: any = {};

        if (requestParameters.text !== undefined) {
            queryParameters['text'] = requestParameters.text;
        }

        if (requestParameters.maxResults !== undefined) {
            queryParameters['maxResults'] = requestParameters.maxResults;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/specifications/specifications-active`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Search through all active specification templates
     */
    async getBackSpecificationsSpecificationsActive(requestParameters: GetBackSpecificationsSpecificationsActiveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SearchResponseIdWithName> {
        const response = await this.getBackSpecificationsSpecificationsActiveRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Search through all specification templates
     */
    async getBackSpecificationsSpecificationsAllRaw(requestParameters: GetBackSpecificationsSpecificationsAllRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SearchResponseIdWithName>> {
        if (requestParameters.text === null || requestParameters.text === undefined) {
            throw new runtime.RequiredError('text','Required parameter requestParameters.text was null or undefined when calling getBackSpecificationsSpecificationsAll.');
        }

        if (requestParameters.maxResults === null || requestParameters.maxResults === undefined) {
            throw new runtime.RequiredError('maxResults','Required parameter requestParameters.maxResults was null or undefined when calling getBackSpecificationsSpecificationsAll.');
        }

        const queryParameters: any = {};

        if (requestParameters.text !== undefined) {
            queryParameters['text'] = requestParameters.text;
        }

        if (requestParameters.maxResults !== undefined) {
            queryParameters['maxResults'] = requestParameters.maxResults;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/specifications/specifications-all`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Search through all specification templates
     */
    async getBackSpecificationsSpecificationsAll(requestParameters: GetBackSpecificationsSpecificationsAllRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SearchResponseIdWithName> {
        const response = await this.getBackSpecificationsSpecificationsAllRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Search standard parameters
     */
    async getBackSpecificationsStandardParametersRaw(requestParameters: GetBackSpecificationsStandardParametersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SearchResponseString>> {
        if (requestParameters.text === null || requestParameters.text === undefined) {
            throw new runtime.RequiredError('text','Required parameter requestParameters.text was null or undefined when calling getBackSpecificationsStandardParameters.');
        }

        if (requestParameters.maxResults === null || requestParameters.maxResults === undefined) {
            throw new runtime.RequiredError('maxResults','Required parameter requestParameters.maxResults was null or undefined when calling getBackSpecificationsStandardParameters.');
        }

        const queryParameters: any = {};

        if (requestParameters.text !== undefined) {
            queryParameters['text'] = requestParameters.text;
        }

        if (requestParameters.maxResults !== undefined) {
            queryParameters['maxResults'] = requestParameters.maxResults;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/specifications/standard-parameters`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Search standard parameters
     */
    async getBackSpecificationsStandardParameters(requestParameters: GetBackSpecificationsStandardParametersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SearchResponseString> {
        const response = await this.getBackSpecificationsStandardParametersRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getBackSpecificationsStandardParametersHeadersRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<any>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/specifications/standard-parameters/headers`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.TextApiResponse(response) as any;
    }

    /**
     */
    async getBackSpecificationsStandardParametersHeaders(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<any> {
        const response = await this.getBackSpecificationsStandardParametersHeadersRaw(initOverrides);
        return await response.value();
    }

    /**
     * Search measurements standards
     */
    async getBackSpecificationsStandardsRaw(requestParameters: GetBackSpecificationsStandardsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SearchResponseString>> {
        if (requestParameters.text === null || requestParameters.text === undefined) {
            throw new runtime.RequiredError('text','Required parameter requestParameters.text was null or undefined when calling getBackSpecificationsStandards.');
        }

        if (requestParameters.maxResults === null || requestParameters.maxResults === undefined) {
            throw new runtime.RequiredError('maxResults','Required parameter requestParameters.maxResults was null or undefined when calling getBackSpecificationsStandards.');
        }

        const queryParameters: any = {};

        if (requestParameters.text !== undefined) {
            queryParameters['text'] = requestParameters.text;
        }

        if (requestParameters.maxResults !== undefined) {
            queryParameters['maxResults'] = requestParameters.maxResults;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/specifications/standards`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Search measurements standards
     */
    async getBackSpecificationsStandards(requestParameters: GetBackSpecificationsStandardsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SearchResponseString> {
        const response = await this.getBackSpecificationsStandardsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getBackSpecificationsStandardsHeadersRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<any>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/specifications/standards/headers`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.TextApiResponse(response) as any;
    }

    /**
     */
    async getBackSpecificationsStandardsHeaders(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<any> {
        const response = await this.getBackSpecificationsStandardsHeadersRaw(initOverrides);
        return await response.value();
    }

    /**
     * Get specification template from id
     */
    async getBackSpecificationsTemplateP1Raw(requestParameters: GetBackSpecificationsTemplateP1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SpecificationTemplate>> {
        if (requestParameters.p1 === null || requestParameters.p1 === undefined) {
            throw new runtime.RequiredError('p1','Required parameter requestParameters.p1 was null or undefined when calling getBackSpecificationsTemplateP1.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/specifications/template/{p1}`.replace(`{${"p1"}}`, encodeURIComponent(String(requestParameters.p1))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Get specification template from id
     */
    async getBackSpecificationsTemplateP1(requestParameters: GetBackSpecificationsTemplateP1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SpecificationTemplate> {
        const response = await this.getBackSpecificationsTemplateP1Raw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 
     */
    async getBackSpecificationsUnitsRaw(requestParameters: GetBackSpecificationsUnitsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<string>>> {
        if (requestParameters.text === null || requestParameters.text === undefined) {
            throw new runtime.RequiredError('text','Required parameter requestParameters.text was null or undefined when calling getBackSpecificationsUnits.');
        }

        const queryParameters: any = {};

        if (requestParameters.text !== undefined) {
            queryParameters['text'] = requestParameters.text;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/specifications/units`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * 
     */
    async getBackSpecificationsUnits(requestParameters: GetBackSpecificationsUnitsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<string>> {
        const response = await this.getBackSpecificationsUnitsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getBackSpecificationsV2ByProducedVariantListHeadersRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<any>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/specifications/v2/by-produced-variant-list/headers`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.TextApiResponse(response) as any;
    }

    /**
     */
    async getBackSpecificationsV2ByProducedVariantListHeaders(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<any> {
        const response = await this.getBackSpecificationsV2ByProducedVariantListHeadersRaw(initOverrides);
        return await response.value();
    }

    /**
     * Get demand by id
     */
    async getBackStocksDemandStockinteractionidRaw(requestParameters: GetBackStocksDemandStockinteractionidRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<StockInteractionView>> {
        if (requestParameters.stockInteractionId === null || requestParameters.stockInteractionId === undefined) {
            throw new runtime.RequiredError('stockInteractionId','Required parameter requestParameters.stockInteractionId was null or undefined when calling getBackStocksDemandStockinteractionid.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/stocks/demand/{stockInteractionId}`.replace(`{${"stockInteractionId"}}`, encodeURIComponent(String(requestParameters.stockInteractionId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Get demand by id
     */
    async getBackStocksDemandStockinteractionid(requestParameters: GetBackStocksDemandStockinteractionidRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<StockInteractionView> {
        const response = await this.getBackStocksDemandStockinteractionidRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get fulfillments for demand by demand id
     */
    async getBackStocksDemandStockinteractionidFulfillmentsRaw(requestParameters: GetBackStocksDemandStockinteractionidFulfillmentsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<StockInteractionView>>> {
        if (requestParameters.stockInteractionId === null || requestParameters.stockInteractionId === undefined) {
            throw new runtime.RequiredError('stockInteractionId','Required parameter requestParameters.stockInteractionId was null or undefined when calling getBackStocksDemandStockinteractionidFulfillments.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/stocks/demand/{stockInteractionId}/fulfillments`.replace(`{${"stockInteractionId"}}`, encodeURIComponent(String(requestParameters.stockInteractionId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Get fulfillments for demand by demand id
     */
    async getBackStocksDemandStockinteractionidFulfillments(requestParameters: GetBackStocksDemandStockinteractionidFulfillmentsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<StockInteractionView>> {
        const response = await this.getBackStocksDemandStockinteractionidFulfillmentsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getBackStocksDemandsListHeadersRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<any>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/stocks/demands-list/headers`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.TextApiResponse(response) as any;
    }

    /**
     */
    async getBackStocksDemandsListHeaders(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<any> {
        const response = await this.getBackStocksDemandsListHeadersRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async getBackStocksListHeadersRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<any>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/stocks/list/headers`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.TextApiResponse(response) as any;
    }

    /**
     */
    async getBackStocksListHeaders(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<any> {
        const response = await this.getBackStocksListHeadersRaw(initOverrides);
        return await response.value();
    }

    /**
     * Get stock amounts for variant not in given place in specified date range
     */
    async getBackStocksStockAmountsItemtypevariantidNotInPlaceidTimeframeRaw(requestParameters: GetBackStocksStockAmountsItemtypevariantidNotInPlaceidTimeframeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<StockAmountView>>> {
        if (requestParameters.itemTypeVariantId === null || requestParameters.itemTypeVariantId === undefined) {
            throw new runtime.RequiredError('itemTypeVariantId','Required parameter requestParameters.itemTypeVariantId was null or undefined when calling getBackStocksStockAmountsItemtypevariantidNotInPlaceidTimeframe.');
        }

        if (requestParameters.placeId === null || requestParameters.placeId === undefined) {
            throw new runtime.RequiredError('placeId','Required parameter requestParameters.placeId was null or undefined when calling getBackStocksStockAmountsItemtypevariantidNotInPlaceidTimeframe.');
        }

        if (requestParameters.from === null || requestParameters.from === undefined) {
            throw new runtime.RequiredError('from','Required parameter requestParameters.from was null or undefined when calling getBackStocksStockAmountsItemtypevariantidNotInPlaceidTimeframe.');
        }

        if (requestParameters.to === null || requestParameters.to === undefined) {
            throw new runtime.RequiredError('to','Required parameter requestParameters.to was null or undefined when calling getBackStocksStockAmountsItemtypevariantidNotInPlaceidTimeframe.');
        }

        const queryParameters: any = {};

        if (requestParameters.from !== undefined) {
            queryParameters['from'] = requestParameters.from;
        }

        if (requestParameters.to !== undefined) {
            queryParameters['to'] = requestParameters.to;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/stocks/stock-amounts/{itemTypeVariantId}/not-in/{placeId}/timeframe`.replace(`{${"itemTypeVariantId"}}`, encodeURIComponent(String(requestParameters.itemTypeVariantId))).replace(`{${"placeId"}}`, encodeURIComponent(String(requestParameters.placeId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Get stock amounts for variant not in given place in specified date range
     */
    async getBackStocksStockAmountsItemtypevariantidNotInPlaceidTimeframe(requestParameters: GetBackStocksStockAmountsItemtypevariantidNotInPlaceidTimeframeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<StockAmountView>> {
        const response = await this.getBackStocksStockAmountsItemtypevariantidNotInPlaceidTimeframeRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get stock amounts for variant in given place in specified date range
     */
    async getBackStocksStockAmountsItemtypevariantidPlaceidTimeframeRaw(requestParameters: GetBackStocksStockAmountsItemtypevariantidPlaceidTimeframeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<StockAmountView>>> {
        if (requestParameters.itemTypeVariantId === null || requestParameters.itemTypeVariantId === undefined) {
            throw new runtime.RequiredError('itemTypeVariantId','Required parameter requestParameters.itemTypeVariantId was null or undefined when calling getBackStocksStockAmountsItemtypevariantidPlaceidTimeframe.');
        }

        if (requestParameters.placeId === null || requestParameters.placeId === undefined) {
            throw new runtime.RequiredError('placeId','Required parameter requestParameters.placeId was null or undefined when calling getBackStocksStockAmountsItemtypevariantidPlaceidTimeframe.');
        }

        if (requestParameters.from === null || requestParameters.from === undefined) {
            throw new runtime.RequiredError('from','Required parameter requestParameters.from was null or undefined when calling getBackStocksStockAmountsItemtypevariantidPlaceidTimeframe.');
        }

        if (requestParameters.to === null || requestParameters.to === undefined) {
            throw new runtime.RequiredError('to','Required parameter requestParameters.to was null or undefined when calling getBackStocksStockAmountsItemtypevariantidPlaceidTimeframe.');
        }

        const queryParameters: any = {};

        if (requestParameters.from !== undefined) {
            queryParameters['from'] = requestParameters.from;
        }

        if (requestParameters.to !== undefined) {
            queryParameters['to'] = requestParameters.to;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/stocks/stock-amounts/{itemTypeVariantId}/{placeId}/timeframe`.replace(`{${"itemTypeVariantId"}}`, encodeURIComponent(String(requestParameters.itemTypeVariantId))).replace(`{${"placeId"}}`, encodeURIComponent(String(requestParameters.placeId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Get stock amounts for variant in given place in specified date range
     */
    async getBackStocksStockAmountsItemtypevariantidPlaceidTimeframe(requestParameters: GetBackStocksStockAmountsItemtypevariantidPlaceidTimeframeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<StockAmountView>> {
        const response = await this.getBackStocksStockAmountsItemtypevariantidPlaceidTimeframeRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get stock amounts for variant in specified date range
     */
    async getBackStocksStockAmountsP1TimeframeRaw(requestParameters: GetBackStocksStockAmountsP1TimeframeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<StockAmountView>>> {
        if (requestParameters.p1 === null || requestParameters.p1 === undefined) {
            throw new runtime.RequiredError('p1','Required parameter requestParameters.p1 was null or undefined when calling getBackStocksStockAmountsP1Timeframe.');
        }

        if (requestParameters.from === null || requestParameters.from === undefined) {
            throw new runtime.RequiredError('from','Required parameter requestParameters.from was null or undefined when calling getBackStocksStockAmountsP1Timeframe.');
        }

        if (requestParameters.to === null || requestParameters.to === undefined) {
            throw new runtime.RequiredError('to','Required parameter requestParameters.to was null or undefined when calling getBackStocksStockAmountsP1Timeframe.');
        }

        const queryParameters: any = {};

        if (requestParameters.from !== undefined) {
            queryParameters['from'] = requestParameters.from;
        }

        if (requestParameters.to !== undefined) {
            queryParameters['to'] = requestParameters.to;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/stocks/stock-amounts/{p1}/timeframe`.replace(`{${"p1"}}`, encodeURIComponent(String(requestParameters.p1))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Get stock amounts for variant in specified date range
     */
    async getBackStocksStockAmountsP1Timeframe(requestParameters: GetBackStocksStockAmountsP1TimeframeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<StockAmountView>> {
        const response = await this.getBackStocksStockAmountsP1TimeframeRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getBackStocksSupplementListHeadersRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<any>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/stocks/supplement/list/headers`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.TextApiResponse(response) as any;
    }

    /**
     */
    async getBackStocksSupplementListHeaders(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<any> {
        const response = await this.getBackStocksSupplementListHeadersRaw(initOverrides);
        return await response.value();
    }

    /**
     * Get variant availability by stock id
     */
    async getBackStocksVariantAvailabilityRaw(requestParameters: GetBackStocksVariantAvailabilityRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<AmountInPlace>>> {
        if (requestParameters.variantId === null || requestParameters.variantId === undefined) {
            throw new runtime.RequiredError('variantId','Required parameter requestParameters.variantId was null or undefined when calling getBackStocksVariantAvailability.');
        }

        if (requestParameters.futureDate === null || requestParameters.futureDate === undefined) {
            throw new runtime.RequiredError('futureDate','Required parameter requestParameters.futureDate was null or undefined when calling getBackStocksVariantAvailability.');
        }

        const queryParameters: any = {};

        if (requestParameters.variantId !== undefined) {
            queryParameters['variantId'] = requestParameters.variantId;
        }

        if (requestParameters.futureDate !== undefined) {
            queryParameters['futureDate'] = requestParameters.futureDate;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/stocks/variant-availability`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Get variant availability by stock id
     */
    async getBackStocksVariantAvailability(requestParameters: GetBackStocksVariantAvailabilityRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<AmountInPlace>> {
        const response = await this.getBackStocksVariantAvailabilityRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get stock availability by id
     */
    async getBackStocksVariantAvailabilityStockinteractionidRaw(requestParameters: GetBackStocksVariantAvailabilityStockinteractionidRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<VariantAvailabilityView>> {
        if (requestParameters.stockInteractionId === null || requestParameters.stockInteractionId === undefined) {
            throw new runtime.RequiredError('stockInteractionId','Required parameter requestParameters.stockInteractionId was null or undefined when calling getBackStocksVariantAvailabilityStockinteractionid.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/stocks/variant-availability/{StockInteractionId}`.replace(`{${"StockInteractionId"}}`, encodeURIComponent(String(requestParameters.stockInteractionId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Get stock availability by id
     */
    async getBackStocksVariantAvailabilityStockinteractionid(requestParameters: GetBackStocksVariantAvailabilityStockinteractionidRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<VariantAvailabilityView> {
        const response = await this.getBackStocksVariantAvailabilityStockinteractionidRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getBackStocktakingCountsheetListHeadersRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<any>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/stocktaking/countsheet/list/headers`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.TextApiResponse(response) as any;
    }

    /**
     */
    async getBackStocktakingCountsheetListHeaders(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<any> {
        const response = await this.getBackStocktakingCountsheetListHeadersRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async getBackStocktakingListHeadersRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<any>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/stocktaking/list/headers`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.TextApiResponse(response) as any;
    }

    /**
     */
    async getBackStocktakingListHeaders(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<any> {
        const response = await this.getBackStocktakingListHeadersRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async getBackSupplyListHeadersRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<any>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/supply/list/headers`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.TextApiResponse(response) as any;
    }

    /**
     */
    async getBackSupplyListHeaders(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<any> {
        const response = await this.getBackSupplyListHeadersRaw(initOverrides);
        return await response.value();
    }

    /**
     * Get planned supply detailed view
     */
    async getBackSupplyOrderDetailsSupplyorderidRaw(requestParameters: GetBackSupplyOrderDetailsSupplyorderidRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SupplyOrderDetailsView>> {
        if (requestParameters.supplyOrderId === null || requestParameters.supplyOrderId === undefined) {
            throw new runtime.RequiredError('supplyOrderId','Required parameter requestParameters.supplyOrderId was null or undefined when calling getBackSupplyOrderDetailsSupplyorderid.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/supply/order/details/{SupplyOrderId}`.replace(`{${"SupplyOrderId"}}`, encodeURIComponent(String(requestParameters.supplyOrderId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Get planned supply detailed view
     */
    async getBackSupplyOrderDetailsSupplyorderid(requestParameters: GetBackSupplyOrderDetailsSupplyorderidRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SupplyOrderDetailsView> {
        const response = await this.getBackSupplyOrderDetailsSupplyorderidRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getBackSupplyOrdersCreatorListHeadersRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<any>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/supply-orders/creator/list/headers`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.TextApiResponse(response) as any;
    }

    /**
     */
    async getBackSupplyOrdersCreatorListHeaders(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<any> {
        const response = await this.getBackSupplyOrdersCreatorListHeadersRaw(initOverrides);
        return await response.value();
    }

    /**
     * Get initial planned supply form
     */
    async getBackSupplyPlannedSupplyorderidRaw(requestParameters: GetBackSupplyPlannedSupplyorderidRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PlannedSupplyInitialView>> {
        if (requestParameters.supplyOrderId === null || requestParameters.supplyOrderId === undefined) {
            throw new runtime.RequiredError('supplyOrderId','Required parameter requestParameters.supplyOrderId was null or undefined when calling getBackSupplyPlannedSupplyorderid.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/supply/planned/{SupplyOrderId}`.replace(`{${"SupplyOrderId"}}`, encodeURIComponent(String(requestParameters.supplyOrderId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Get initial planned supply form
     */
    async getBackSupplyPlannedSupplyorderid(requestParameters: GetBackSupplyPlannedSupplyorderidRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PlannedSupplyInitialView> {
        const response = await this.getBackSupplyPlannedSupplyorderidRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getBackSupplyWarehouseTagListHeadersRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<any>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/supply/warehouse-tag/list/headers`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.TextApiResponse(response) as any;
    }

    /**
     */
    async getBackSupplyWarehouseTagListHeaders(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<any> {
        const response = await this.getBackSupplyWarehouseTagListHeadersRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async getBackTicketsListHeadersRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<any>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/tickets/list/headers`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.TextApiResponse(response) as any;
    }

    /**
     */
    async getBackTicketsListHeaders(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<any> {
        const response = await this.getBackTicketsListHeadersRaw(initOverrides);
        return await response.value();
    }

    /**
     * Fetch details for production unit\'s traceability
     */
    async getBackTraceabilityProductionUnitDetailsProductionunitidRaw(requestParameters: GetBackTraceabilityProductionUnitDetailsProductionunitidRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TraceabilityProductionUnitDetails>> {
        if (requestParameters.productionUnitId === null || requestParameters.productionUnitId === undefined) {
            throw new runtime.RequiredError('productionUnitId','Required parameter requestParameters.productionUnitId was null or undefined when calling getBackTraceabilityProductionUnitDetailsProductionunitid.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/traceability/production-unit-details/{ProductionUnitId}`.replace(`{${"ProductionUnitId"}}`, encodeURIComponent(String(requestParameters.productionUnitId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Fetch details for production unit\'s traceability
     */
    async getBackTraceabilityProductionUnitDetailsProductionunitid(requestParameters: GetBackTraceabilityProductionUnitDetailsProductionunitidRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TraceabilityProductionUnitDetails> {
        const response = await this.getBackTraceabilityProductionUnitDetailsProductionunitidRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getBackUnitsBlobsListHeadersRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<any>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/units/blobs/list/headers`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.TextApiResponse(response) as any;
    }

    /**
     */
    async getBackUnitsBlobsListHeaders(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<any> {
        const response = await this.getBackUnitsBlobsListHeadersRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async getBackUnitsEquipmentListHeadersRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<any>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/units/equipment/list/headers`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.TextApiResponse(response) as any;
    }

    /**
     */
    async getBackUnitsEquipmentListHeaders(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<any> {
        const response = await this.getBackUnitsEquipmentListHeadersRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async getBackUnitsItemsListHeadersRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<any>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/units/items/list/headers`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.TextApiResponse(response) as any;
    }

    /**
     */
    async getBackUnitsItemsListHeaders(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<any> {
        const response = await this.getBackUnitsItemsListHeadersRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async getBackUnitsListHeadersRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<any>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/units/list/headers`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.TextApiResponse(response) as any;
    }

    /**
     */
    async getBackUnitsListHeaders(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<any> {
        const response = await this.getBackUnitsListHeadersRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async getBackVehiclesListHeadersRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<any>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/vehicles/list/headers`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.TextApiResponse(response) as any;
    }

    /**
     */
    async getBackVehiclesListHeaders(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<any> {
        const response = await this.getBackVehiclesListHeadersRaw(initOverrides);
        return await response.value();
    }

    /**
     * Get worker absence event by id
     */
    async getBackWorkersAbsenceEventsP1Raw(requestParameters: GetBackWorkersAbsenceEventsP1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<WorkerEventSaveView>> {
        if (requestParameters.p1 === null || requestParameters.p1 === undefined) {
            throw new runtime.RequiredError('p1','Required parameter requestParameters.p1 was null or undefined when calling getBackWorkersAbsenceEventsP1.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/workers/absence-events/{p1}`.replace(`{${"p1"}}`, encodeURIComponent(String(requestParameters.p1))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Get worker absence event by id
     */
    async getBackWorkersAbsenceEventsP1(requestParameters: GetBackWorkersAbsenceEventsP1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<WorkerEventSaveView> {
        const response = await this.getBackWorkersAbsenceEventsP1Raw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getBackWorkersCompetenceCategoriesListHeadersRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<any>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/workers/competence/categories/list/headers`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.TextApiResponse(response) as any;
    }

    /**
     */
    async getBackWorkersCompetenceCategoriesListHeaders(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<any> {
        const response = await this.getBackWorkersCompetenceCategoriesListHeadersRaw(initOverrides);
        return await response.value();
    }

    /**
     * Retrieves competence related with the specified name
     */
    async getBackWorkersCompetencesRaw(requestParameters: GetBackWorkersCompetencesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Competence>> {
        if (requestParameters.name === null || requestParameters.name === undefined) {
            throw new runtime.RequiredError('name','Required parameter requestParameters.name was null or undefined when calling getBackWorkersCompetences.');
        }

        const queryParameters: any = {};

        if (requestParameters.name !== undefined) {
            queryParameters['name'] = requestParameters.name;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/workers/competences`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Retrieves competence related with the specified name
     */
    async getBackWorkersCompetences(requestParameters: GetBackWorkersCompetencesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Competence> {
        const response = await this.getBackWorkersCompetencesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Search competence authorities
     */
    async getBackWorkersCompetencesAuthoritySearchRaw(requestParameters: GetBackWorkersCompetencesAuthoritySearchRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SearchResponseCompetenceAuthority>> {
        if (requestParameters.text === null || requestParameters.text === undefined) {
            throw new runtime.RequiredError('text','Required parameter requestParameters.text was null or undefined when calling getBackWorkersCompetencesAuthoritySearch.');
        }

        if (requestParameters.maxResults === null || requestParameters.maxResults === undefined) {
            throw new runtime.RequiredError('maxResults','Required parameter requestParameters.maxResults was null or undefined when calling getBackWorkersCompetencesAuthoritySearch.');
        }

        const queryParameters: any = {};

        if (requestParameters.text !== undefined) {
            queryParameters['text'] = requestParameters.text;
        }

        if (requestParameters.maxResults !== undefined) {
            queryParameters['maxResults'] = requestParameters.maxResults;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/workers/competences/authority/search`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Search competence authorities
     */
    async getBackWorkersCompetencesAuthoritySearch(requestParameters: GetBackWorkersCompetencesAuthoritySearchRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SearchResponseCompetenceAuthority> {
        const response = await this.getBackWorkersCompetencesAuthoritySearchRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getBackWorkersCompetencesListHeadersRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<any>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/workers/competences/list/headers`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.TextApiResponse(response) as any;
    }

    /**
     */
    async getBackWorkersCompetencesListHeaders(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<any> {
        const response = await this.getBackWorkersCompetencesListHeadersRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async getBackWorkersCompetencesMatrixListHeadersRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<any>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/workers/competences/matrix/list/headers`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.TextApiResponse(response) as any;
    }

    /**
     */
    async getBackWorkersCompetencesMatrixListHeaders(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<any> {
        const response = await this.getBackWorkersCompetencesMatrixListHeadersRaw(initOverrides);
        return await response.value();
    }

    /**
     * Retrieves competence by the specified id
     */
    async getBackWorkersCompetencesP1Raw(requestParameters: GetBackWorkersCompetencesP1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Competence>> {
        if (requestParameters.p1 === null || requestParameters.p1 === undefined) {
            throw new runtime.RequiredError('p1','Required parameter requestParameters.p1 was null or undefined when calling getBackWorkersCompetencesP1.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/workers/competences/{p1}`.replace(`{${"p1"}}`, encodeURIComponent(String(requestParameters.p1))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Retrieves competence by the specified id
     */
    async getBackWorkersCompetencesP1(requestParameters: GetBackWorkersCompetencesP1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Competence> {
        const response = await this.getBackWorkersCompetencesP1Raw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get worker document metadata by id
     */
    async getBackWorkersDocumentP1Raw(requestParameters: GetBackWorkersDocumentP1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<WorkerDocumentMetadataView>> {
        if (requestParameters.p1 === null || requestParameters.p1 === undefined) {
            throw new runtime.RequiredError('p1','Required parameter requestParameters.p1 was null or undefined when calling getBackWorkersDocumentP1.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/workers/document/{p1}`.replace(`{${"p1"}}`, encodeURIComponent(String(requestParameters.p1))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Get worker document metadata by id
     */
    async getBackWorkersDocumentP1(requestParameters: GetBackWorkersDocumentP1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<WorkerDocumentMetadataView> {
        const response = await this.getBackWorkersDocumentP1Raw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get worker document content by id
     */
    async getBackWorkersDocumentP1ContentRaw(requestParameters: GetBackWorkersDocumentP1ContentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Blob>> {
        if (requestParameters.p1 === null || requestParameters.p1 === undefined) {
            throw new runtime.RequiredError('p1','Required parameter requestParameters.p1 was null or undefined when calling getBackWorkersDocumentP1Content.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/workers/document/{p1}/content`.replace(`{${"p1"}}`, encodeURIComponent(String(requestParameters.p1))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.BlobApiResponse(response);
    }

    /**
     * Get worker document content by id
     */
    async getBackWorkersDocumentP1Content(requestParameters: GetBackWorkersDocumentP1ContentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Blob> {
        const response = await this.getBackWorkersDocumentP1ContentRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getBackWorkersDocumentsListHeadersRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<any>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/workers/documents/list/headers`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.TextApiResponse(response) as any;
    }

    /**
     */
    async getBackWorkersDocumentsListHeaders(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<any> {
        const response = await this.getBackWorkersDocumentsListHeadersRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async getBackWorkersListHeadersRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<any>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/workers/list/headers`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.TextApiResponse(response) as any;
    }

    /**
     */
    async getBackWorkersListHeaders(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<any> {
        const response = await this.getBackWorkersListHeadersRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async getBackWorkersWorkerCompetencesListHeadersRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<any>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/workers/worker-competences/list/headers`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.TextApiResponse(response) as any;
    }

    /**
     */
    async getBackWorkersWorkerCompetencesListHeaders(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<any> {
        const response = await this.getBackWorkersWorkerCompetencesListHeadersRaw(initOverrides);
        return await response.value();
    }

    /**
     * Retrieves worker by the specified id
     */
    async getBackWorkersWorkerP1Raw(requestParameters: GetBackWorkersWorkerP1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<WorkerView>> {
        if (requestParameters.p1 === null || requestParameters.p1 === undefined) {
            throw new runtime.RequiredError('p1','Required parameter requestParameters.p1 was null or undefined when calling getBackWorkersWorkerP1.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/workers/worker/{p1}`.replace(`{${"p1"}}`, encodeURIComponent(String(requestParameters.p1))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Retrieves worker by the specified id
     */
    async getBackWorkersWorkerP1(requestParameters: GetBackWorkersWorkerP1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<WorkerView> {
        const response = await this.getBackWorkersWorkerP1Raw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get total variant availability
     */
    async getExpectedTotalAvailabilityRaw(requestParameters: GetExpectedTotalAvailabilityRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TotalAvailabilityView>> {
        if (requestParameters.totalAvailabilityQuery === null || requestParameters.totalAvailabilityQuery === undefined) {
            throw new runtime.RequiredError('totalAvailabilityQuery','Required parameter requestParameters.totalAvailabilityQuery was null or undefined when calling getExpectedTotalAvailability.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/stocks/total-variant-availability`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.totalAvailabilityQuery,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Get total variant availability
     */
    async getExpectedTotalAvailability(requestParameters: GetExpectedTotalAvailabilityRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TotalAvailabilityView> {
        const response = await this.getExpectedTotalAvailabilityRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Runs external system synchronization and after start that full inbound synchronization
     */
    async getExternalSynchronizationRunSagaRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/dev/synchronize-erp/with-external`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Runs external system synchronization and after start that full inbound synchronization
     */
    async getExternalSynchronizationRunSaga(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.getExternalSynchronizationRunSagaRaw(initOverrides);
    }

    /**
     * Init countsheet list for stocktaking creation
     */
    async getInitStocktakingCountsheetViewRaw(requestParameters: GetInitStocktakingCountsheetViewRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<CountsheetInitView>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/stocktaking/countsheet/init`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.requestBody,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Init countsheet list for stocktaking creation
     */
    async getInitStocktakingCountsheetView(requestParameters: GetInitStocktakingCountsheetViewRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<CountsheetInitView>> {
        const response = await this.getInitStocktakingCountsheetViewRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get material movement items
     */
    async getMaterialMovementItemsRaw(requestParameters: GetMaterialMovementItemsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<MaterialMovementItemsView>> {
        if (requestParameters.materialMovementId === null || requestParameters.materialMovementId === undefined) {
            throw new runtime.RequiredError('materialMovementId','Required parameter requestParameters.materialMovementId was null or undefined when calling getMaterialMovementItems.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/material-movements/items/{MaterialMovementId}`.replace(`{${"MaterialMovementId"}}`, encodeURIComponent(String(requestParameters.materialMovementId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Get material movement items
     */
    async getMaterialMovementItems(requestParameters: GetMaterialMovementItemsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<MaterialMovementItemsView> {
        const response = await this.getMaterialMovementItemsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get place labels for place and variant
     */
    async getPlaceLabelsRaw(requestParameters: GetPlaceLabelsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<string>>> {
        if (requestParameters.placeId === null || requestParameters.placeId === undefined) {
            throw new runtime.RequiredError('placeId','Required parameter requestParameters.placeId was null or undefined when calling getPlaceLabels.');
        }

        if (requestParameters.variantId === null || requestParameters.variantId === undefined) {
            throw new runtime.RequiredError('variantId','Required parameter requestParameters.variantId was null or undefined when calling getPlaceLabels.');
        }

        const queryParameters: any = {};

        if (requestParameters.placeId !== undefined) {
            queryParameters['placeId'] = requestParameters.placeId;
        }

        if (requestParameters.variantId !== undefined) {
            queryParameters['variantId'] = requestParameters.variantId;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/units/place-labels`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Get place labels for place and variant
     */
    async getPlaceLabels(requestParameters: GetPlaceLabelsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<string>> {
        const response = await this.getPlaceLabelsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get confirmation for modal
     */
    async getSupplyOrderConfirmationViewRaw(requestParameters: GetSupplyOrderConfirmationViewRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SupplyOrderConfirmationView>> {
        if (requestParameters.supplyOrderItemsSavingView === null || requestParameters.supplyOrderItemsSavingView === undefined) {
            throw new runtime.RequiredError('supplyOrderItemsSavingView','Required parameter requestParameters.supplyOrderItemsSavingView was null or undefined when calling getSupplyOrderConfirmationView.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/supply-order/confirmation`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.supplyOrderItemsSavingView,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Get confirmation for modal
     */
    async getSupplyOrderConfirmationView(requestParameters: GetSupplyOrderConfirmationViewRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SupplyOrderConfirmationView> {
        const response = await this.getSupplyOrderConfirmationViewRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get supply order items for selected supply order id
     */
    async getSupplyOrderItemsRaw(requestParameters: GetSupplyOrderItemsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SupplyOrderInitView>> {
        if (requestParameters.supplyOrderId === null || requestParameters.supplyOrderId === undefined) {
            throw new runtime.RequiredError('supplyOrderId','Required parameter requestParameters.supplyOrderId was null or undefined when calling getSupplyOrderItems.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/supply-order/get-items/{SupplyOrderId}`.replace(`{${"SupplyOrderId"}}`, encodeURIComponent(String(requestParameters.supplyOrderId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Get supply order items for selected supply order id
     */
    async getSupplyOrderItems(requestParameters: GetSupplyOrderItemsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SupplyOrderInitView> {
        const response = await this.getSupplyOrderItemsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get warehouse state with planned deliveries for a specified number of days
     */
    async getSupplyWarehouseStateRaw(requestParameters: GetSupplyWarehouseStateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<SupplyWarehouseStateWithPlannedDeliveriesViewRow>>> {
        if (requestParameters.planningWindowDays === null || requestParameters.planningWindowDays === undefined) {
            throw new runtime.RequiredError('planningWindowDays','Required parameter requestParameters.planningWindowDays was null or undefined when calling getSupplyWarehouseState.');
        }

        const queryParameters: any = {};

        if (requestParameters.planningWindowDays !== undefined) {
            queryParameters['planningWindowDays'] = requestParameters.planningWindowDays;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/supply/warehouse-state`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Get warehouse state with planned deliveries for a specified number of days
     */
    async getSupplyWarehouseState(requestParameters: GetSupplyWarehouseStateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<SupplyWarehouseStateWithPlannedDeliveriesViewRow>> {
        const response = await this.getSupplyWarehouseStateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieve list view config for logged user
     */
    async getUmConfigurationRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<object>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/um/configuration`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Retrieve list view config for logged user
     */
    async getUmConfiguration(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<object> {
        const response = await this.getUmConfigurationRaw(initOverrides);
        return await response.value();
    }

    /**
     * Retrieve logged user\'s config for given key
     */
    async getUmConfigurationKeyRaw(requestParameters: GetUmConfigurationKeyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<any>> {
        if (requestParameters.path === null || requestParameters.path === undefined) {
            throw new runtime.RequiredError('path','Required parameter requestParameters.path was null or undefined when calling getUmConfigurationKey.');
        }

        const queryParameters: any = {};

        if (requestParameters.path !== undefined) {
            queryParameters['path'] = requestParameters.path;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/um/configuration/key`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.TextApiResponse(response) as any;
    }

    /**
     * Retrieve logged user\'s config for given key
     */
    async getUmConfigurationKey(requestParameters: GetUmConfigurationKeyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<any> {
        const response = await this.getUmConfigurationKeyRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get all available languages
     */
    async getUmLanguagesRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<Lang>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/um/languages`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Get all available languages
     */
    async getUmLanguages(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<Lang>> {
        const response = await this.getUmLanguagesRaw(initOverrides);
        return await response.value();
    }

    /**
     * Get all locations
     */
    async getUmLocationsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<string>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/um/locations`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Get all locations
     */
    async getUmLocations(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<string>> {
        const response = await this.getUmLocationsRaw(initOverrides);
        return await response.value();
    }

    /**
     * Get logged user\'s context
     */
    async getUmLoggedRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UserContextView>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/um/logged`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Get logged user\'s context
     */
    async getUmLogged(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UserContextView> {
        const response = await this.getUmLoggedRaw(initOverrides);
        return await response.value();
    }

    /**
     * Log out user
     */
    async getUmLogoutRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/um/logout`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Log out user
     */
    async getUmLogout(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.getUmLogoutRaw(initOverrides);
    }

    /**
     * Find all available permissions for organization
     */
    async getUmPermissionsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<string>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/um/permissions`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Find all available permissions for organization
     */
    async getUmPermissions(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<string>> {
        const response = await this.getUmPermissionsRaw(initOverrides);
        return await response.value();
    }

    /**
     * Show roles that contains specified permissions
     */
    async getUmPermissionsIdRolesRaw(requestParameters: GetUmPermissionsIdRolesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<RoleView>>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling getUmPermissionsIdRoles.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/um/permissions/{id}/roles`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Show roles that contains specified permissions
     */
    async getUmPermissionsIdRoles(requestParameters: GetUmPermissionsIdRolesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<RoleView>> {
        const response = await this.getUmPermissionsIdRolesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Returns all organization roles
     */
    async getUmRolesRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<RoleView>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/um/roles`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Returns all organization roles
     */
    async getUmRoles(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<RoleView>> {
        const response = await this.getUmRolesRaw(initOverrides);
        return await response.value();
    }

    /**
     * Get all role permissions
     */
    async getUmRolesIdPermissionsRaw(requestParameters: GetUmRolesIdPermissionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<string>>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling getUmRolesIdPermissions.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/um/roles/{id}/permissions`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Get all role permissions
     */
    async getUmRolesIdPermissions(requestParameters: GetUmRolesIdPermissionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<string>> {
        const response = await this.getUmRolesIdPermissionsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Find users by role ID
     */
    async getUmRolesIdUsersRaw(requestParameters: GetUmRolesIdUsersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<User>>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling getUmRolesIdUsers.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/um/roles/{id}/users`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Find users by role ID
     */
    async getUmRolesIdUsers(requestParameters: GetUmRolesIdUsersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<User>> {
        const response = await this.getUmRolesIdUsersRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getUmRolesListHeadersRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<any>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/um/roles/list/headers`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.TextApiResponse(response) as any;
    }

    /**
     */
    async getUmRolesListHeaders(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<any> {
        const response = await this.getUmRolesListHeadersRaw(initOverrides);
        return await response.value();
    }

    /**
     * Returns single role
     */
    async getUmRolesP1Raw(requestParameters: GetUmRolesP1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RoleView>> {
        if (requestParameters.p1 === null || requestParameters.p1 === undefined) {
            throw new runtime.RequiredError('p1','Required parameter requestParameters.p1 was null or undefined when calling getUmRolesP1.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/um/roles/{p1}`.replace(`{${"p1"}}`, encodeURIComponent(String(requestParameters.p1))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Returns single role
     */
    async getUmRolesP1(requestParameters: GetUmRolesP1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RoleView> {
        const response = await this.getUmRolesP1Raw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Returns multiple roles
     */
    async getUmRolesSelectRaw(requestParameters: GetUmRolesSelectRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<RoleView>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/um/roles/select`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.requestBody,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Returns multiple roles
     */
    async getUmRolesSelect(requestParameters: GetUmRolesSelectRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<RoleView>> {
        const response = await this.getUmRolesSelectRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Show organization permissions
     */
    async getUmSuOrganizationPermissionsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<string>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/um/su/organization/permissions`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Show organization permissions
     */
    async getUmSuOrganizationPermissions(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<string>> {
        const response = await this.getUmSuOrganizationPermissionsRaw(initOverrides);
        return await response.value();
    }

    /**
     * List all users
     */
    async getUmUsersAllRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<User>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/um/users/all`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * List all users
     */
    async getUmUsersAll(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<User>> {
        const response = await this.getUmUsersAllRaw(initOverrides);
        return await response.value();
    }

    /**
     * List all visible users
     */
    async getUmUsersAllVisibleRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<User>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/um/users/all-visible`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * List all visible users
     */
    async getUmUsersAllVisible(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<User>> {
        const response = await this.getUmUsersAllVisibleRaw(initOverrides);
        return await response.value();
    }

    /**
     * List users for specified ids
     */
    async getUmUsersByIdsRaw(requestParameters: GetUmUsersByIdsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<UserShortView>>> {
        const queryParameters: any = {};

        if (requestParameters.ids) {
            queryParameters['ids'] = requestParameters.ids;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/um/users/by-ids`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * List users for specified ids
     */
    async getUmUsersByIds(requestParameters: GetUmUsersByIdsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<UserShortView>> {
        const response = await this.getUmUsersByIdsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Show user\'s roles
     */
    async getUmUsersIdRolesRaw(requestParameters: GetUmUsersIdRolesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<RoleView>>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling getUmUsersIdRoles.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/um/users/{id}/roles`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Show user\'s roles
     */
    async getUmUsersIdRoles(requestParameters: GetUmUsersIdRolesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<RoleView>> {
        const response = await this.getUmUsersIdRolesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getUmUsersListHeadersRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<any>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/um/users/list/headers`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.TextApiResponse(response) as any;
    }

    /**
     */
    async getUmUsersListHeaders(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<any> {
        const response = await this.getUmUsersListHeadersRaw(initOverrides);
        return await response.value();
    }

    /**
     * Get user by ID
     */
    async getUmUsersUseridRaw(requestParameters: GetUmUsersUseridRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<User>> {
        if (requestParameters.userId === null || requestParameters.userId === undefined) {
            throw new runtime.RequiredError('userId','Required parameter requestParameters.userId was null or undefined when calling getUmUsersUserid.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/um/users/{UserId}`.replace(`{${"UserId"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Get user by ID
     */
    async getUmUsersUserid(requestParameters: GetUmUsersUseridRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<User> {
        const response = await this.getUmUsersUseridRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get user\'s view by ID
     */
    async getUmUsersUseridViewRaw(requestParameters: GetUmUsersUseridViewRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UserView1>> {
        if (requestParameters.userId === null || requestParameters.userId === undefined) {
            throw new runtime.RequiredError('userId','Required parameter requestParameters.userId was null or undefined when calling getUmUsersUseridView.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/um/users/{UserId}/view`.replace(`{${"UserId"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Get user\'s view by ID
     */
    async getUmUsersUseridView(requestParameters: GetUmUsersUseridViewRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UserView1> {
        const response = await this.getUmUsersUseridViewRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Import api production order
     */
    async importProductionOrderRaw(requestParameters: ImportProductionOrderRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ImportResult>> {
        if (requestParameters.apiProductionOrderImportView === null || requestParameters.apiProductionOrderImportView === undefined) {
            throw new runtime.RequiredError('apiProductionOrderImportView','Required parameter requestParameters.apiProductionOrderImportView was null or undefined when calling importProductionOrder.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/api/import/production-order`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.apiProductionOrderImportView,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Import api production order
     */
    async importProductionOrder(requestParameters: ImportProductionOrderRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ImportResult> {
        const response = await this.importProductionOrderRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Finish task
     */
    async lotFinishTaskRaw(requestParameters: LotFinishTaskRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.productionLotId === null || requestParameters.productionLotId === undefined) {
            throw new runtime.RequiredError('productionLotId','Required parameter requestParameters.productionLotId was null or undefined when calling lotFinishTask.');
        }

        if (requestParameters.finishTaskView === null || requestParameters.finishTaskView === undefined) {
            throw new runtime.RequiredError('finishTaskView','Required parameter requestParameters.finishTaskView was null or undefined when calling lotFinishTask.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/production/modal/task/lot/{ProductionLotId}/finish`.replace(`{${"ProductionLotId"}}`, encodeURIComponent(String(requestParameters.productionLotId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.finishTaskView,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Finish task
     */
    async lotFinishTask(requestParameters: LotFinishTaskRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.lotFinishTaskRaw(requestParameters, initOverrides);
    }

    /**
     * Mark supply order as ordered (confirmed on supplier side)
     */
    async markSupplyOrderInProgressRaw(requestParameters: MarkSupplyOrderInProgressRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IdWithNumberSupplyOrderId>> {
        if (requestParameters.supplyOrderId === null || requestParameters.supplyOrderId === undefined) {
            throw new runtime.RequiredError('supplyOrderId','Required parameter requestParameters.supplyOrderId was null or undefined when calling markSupplyOrderInProgress.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/supply-order/confirm-ordered/{SupplyOrderId}`.replace(`{${"SupplyOrderId"}}`, encodeURIComponent(String(requestParameters.supplyOrderId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Mark supply order as ordered (confirmed on supplier side)
     */
    async markSupplyOrderInProgress(requestParameters: MarkSupplyOrderInProgressRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IdWithNumberSupplyOrderId> {
        const response = await this.markSupplyOrderInProgressRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Confirm draft order
     */
    async ordersEndpointsConfirmRaw(requestParameters: OrdersEndpointsConfirmRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<number>> {
        if (requestParameters.salesEntryId === null || requestParameters.salesEntryId === undefined) {
            throw new runtime.RequiredError('salesEntryId','Required parameter requestParameters.salesEntryId was null or undefined when calling ordersEndpointsConfirm.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/orders/order/{SalesEntryId}/confirm`.replace(`{${"SalesEntryId"}}`, encodeURIComponent(String(requestParameters.salesEntryId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.TextApiResponse(response) as any;
    }

    /**
     * Confirm draft order
     */
    async ordersEndpointsConfirm(requestParameters: OrdersEndpointsConfirmRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<number> {
        const response = await this.ordersEndpointsConfirmRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Deactivate item type tag
     */
    async patchBackItemsTagsDeactivateP1Raw(requestParameters: PatchBackItemsTagsDeactivateP1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<number>> {
        if (requestParameters.p1 === null || requestParameters.p1 === undefined) {
            throw new runtime.RequiredError('p1','Required parameter requestParameters.p1 was null or undefined when calling patchBackItemsTagsDeactivateP1.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/items/tags/deactivate/{p1}`.replace(`{${"p1"}}`, encodeURIComponent(String(requestParameters.p1))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.TextApiResponse(response) as any;
    }

    /**
     * Deactivate item type tag
     */
    async patchBackItemsTagsDeactivateP1(requestParameters: PatchBackItemsTagsDeactivateP1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<number> {
        const response = await this.patchBackItemsTagsDeactivateP1Raw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Automatically add lots to production plan
     */
    async postBackApiAutoplanRaw(requestParameters: PostBackApiAutoplanRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AjaxActionResponse>> {
        if (requestParameters.kanbanFilterDefinition === null || requestParameters.kanbanFilterDefinition === undefined) {
            throw new runtime.RequiredError('kanbanFilterDefinition','Required parameter requestParameters.kanbanFilterDefinition was null or undefined when calling postBackApiAutoplan.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/api/autoplan`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.kanbanFilterDefinition,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Automatically add lots to production plan
     */
    async postBackApiAutoplan(requestParameters: PostBackApiAutoplanRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AjaxActionResponse> {
        const response = await this.postBackApiAutoplanRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Synchronize production lot with Graphne
     */
    async postBackApiSynchronizeLotLotidRaw(requestParameters: PostBackApiSynchronizeLotLotidRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.lotId === null || requestParameters.lotId === undefined) {
            throw new runtime.RequiredError('lotId','Required parameter requestParameters.lotId was null or undefined when calling postBackApiSynchronizeLotLotid.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/api/synchronize-lot/{lotId}`.replace(`{${"lotId"}}`, encodeURIComponent(String(requestParameters.lotId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Synchronize production lot with Graphne
     */
    async postBackApiSynchronizeLotLotid(requestParameters: PostBackApiSynchronizeLotLotidRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.postBackApiSynchronizeLotLotidRaw(requestParameters, initOverrides);
    }

    /**
     * Resolve domain actions for one or more barcodes
     */
    async postBackBarcodesResolveRaw(requestParameters: PostBackBarcodesResolveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<BarcodeAction>>> {
        if (requestParameters.barcodesView === null || requestParameters.barcodesView === undefined) {
            throw new runtime.RequiredError('barcodesView','Required parameter requestParameters.barcodesView was null or undefined when calling postBackBarcodesResolve.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/barcodes/resolve`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.barcodesView,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Resolve domain actions for one or more barcodes
     */
    async postBackBarcodesResolve(requestParameters: PostBackBarcodesResolveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<BarcodeAction>> {
        const response = await this.postBackBarcodesResolveRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 
     */
    async postBackBarcodesResolveLegacyRaw(requestParameters: PostBackBarcodesResolveLegacyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<BarcodeResultData>> {
        if (requestParameters.barcodeScanContext === null || requestParameters.barcodeScanContext === undefined) {
            throw new runtime.RequiredError('barcodeScanContext','Required parameter requestParameters.barcodeScanContext was null or undefined when calling postBackBarcodesResolveLegacy.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/barcodes/resolve/legacy`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.barcodeScanContext,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * 
     */
    async postBackBarcodesResolveLegacy(requestParameters: PostBackBarcodesResolveLegacyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<BarcodeResultData> {
        const response = await this.postBackBarcodesResolveLegacyRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get cog count fit
     */
    async postBackCalculationsCogCountFitRaw(requestParameters: PostBackCalculationsCogCountFitRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<FitAlongRibbon>>> {
        if (requestParameters.body === null || requestParameters.body === undefined) {
            throw new runtime.RequiredError('body','Required parameter requestParameters.body was null or undefined when calling postBackCalculationsCogCountFit.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/calculations/cog-count/fit`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.body as any,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Get cog count fit
     */
    async postBackCalculationsCogCountFit(requestParameters: PostBackCalculationsCogCountFitRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<FitAlongRibbon>> {
        const response = await this.postBackCalculationsCogCountFitRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get cost estimate
     */
    async postBackCalculationsCostEstimateRaw(requestParameters: PostBackCalculationsCostEstimateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CostEstimateResult>> {
        if (requestParameters.priceCalculationInputView === null || requestParameters.priceCalculationInputView === undefined) {
            throw new runtime.RequiredError('priceCalculationInputView','Required parameter requestParameters.priceCalculationInputView was null or undefined when calling postBackCalculationsCostEstimate.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/calculations/cost-estimate`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.priceCalculationInputView,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Get cost estimate
     */
    async postBackCalculationsCostEstimate(requestParameters: PostBackCalculationsCostEstimateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CostEstimateResult> {
        const response = await this.postBackCalculationsCostEstimateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get paper width fit
     */
    async postBackCalculationsPaperWidthFitRaw(requestParameters: PostBackCalculationsPaperWidthFitRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<FitAcrossRibbon>>> {
        if (requestParameters.body === null || requestParameters.body === undefined) {
            throw new runtime.RequiredError('body','Required parameter requestParameters.body was null or undefined when calling postBackCalculationsPaperWidthFit.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/calculations/paper-width/fit`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.body as any,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Get paper width fit
     */
    async postBackCalculationsPaperWidthFit(requestParameters: PostBackCalculationsPaperWidthFitRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<FitAcrossRibbon>> {
        const response = await this.postBackCalculationsPaperWidthFitRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 
     */
    async postBackCalculationsPunchingDiesSearchRaw(requestParameters: PostBackCalculationsPunchingDiesSearchRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<ItemTypeVariant>>> {
        if (requestParameters.text === null || requestParameters.text === undefined) {
            throw new runtime.RequiredError('text','Required parameter requestParameters.text was null or undefined when calling postBackCalculationsPunchingDiesSearch.');
        }

        if (requestParameters.maxResults === null || requestParameters.maxResults === undefined) {
            throw new runtime.RequiredError('maxResults','Required parameter requestParameters.maxResults was null or undefined when calling postBackCalculationsPunchingDiesSearch.');
        }

        if (requestParameters.labelDimensionsView === null || requestParameters.labelDimensionsView === undefined) {
            throw new runtime.RequiredError('labelDimensionsView','Required parameter requestParameters.labelDimensionsView was null or undefined when calling postBackCalculationsPunchingDiesSearch.');
        }

        const queryParameters: any = {};

        if (requestParameters.text !== undefined) {
            queryParameters['text'] = requestParameters.text;
        }

        if (requestParameters.maxResults !== undefined) {
            queryParameters['maxResults'] = requestParameters.maxResults;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/calculations/punching-dies/search`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.labelDimensionsView,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * 
     */
    async postBackCalculationsPunchingDiesSearch(requestParameters: PostBackCalculationsPunchingDiesSearchRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<ItemTypeVariant>> {
        const response = await this.postBackCalculationsPunchingDiesSearchRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Save assignees for an event
     */
    async postBackCalendarAssigneesRaw(requestParameters: PostBackCalendarAssigneesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AjaxActionResponse>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling postBackCalendarAssignees.');
        }

        if (requestParameters.calendarAssigneesSaveView === null || requestParameters.calendarAssigneesSaveView === undefined) {
            throw new runtime.RequiredError('calendarAssigneesSaveView','Required parameter requestParameters.calendarAssigneesSaveView was null or undefined when calling postBackCalendarAssignees.');
        }

        const queryParameters: any = {};

        if (requestParameters.id !== undefined) {
            queryParameters['id'] = requestParameters.id;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/calendar/assignees`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.calendarAssigneesSaveView,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Save assignees for an event
     */
    async postBackCalendarAssignees(requestParameters: PostBackCalendarAssigneesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AjaxActionResponse> {
        const response = await this.postBackCalendarAssigneesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get assignees for an event
     */
    async postBackCalendarAssigneesCalendareventidRaw(requestParameters: PostBackCalendarAssigneesCalendareventidRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<CalendarEventAssigneeView>>> {
        if (requestParameters.calendarEventId === null || requestParameters.calendarEventId === undefined) {
            throw new runtime.RequiredError('calendarEventId','Required parameter requestParameters.calendarEventId was null or undefined when calling postBackCalendarAssigneesCalendareventid.');
        }

        if (requestParameters.calendarAssigneeRequestView === null || requestParameters.calendarAssigneeRequestView === undefined) {
            throw new runtime.RequiredError('calendarAssigneeRequestView','Required parameter requestParameters.calendarAssigneeRequestView was null or undefined when calling postBackCalendarAssigneesCalendareventid.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/calendar/assignees/{calendarEventId}`.replace(`{${"calendarEventId"}}`, encodeURIComponent(String(requestParameters.calendarEventId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.calendarAssigneeRequestView,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Get assignees for an event
     */
    async postBackCalendarAssigneesCalendareventid(requestParameters: PostBackCalendarAssigneesCalendareventidRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<CalendarEventAssigneeView>> {
        const response = await this.postBackCalendarAssigneesCalendareventidRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Save assignees for an event
     */
    async postBackCalendarMonthAssigneesRaw(requestParameters: PostBackCalendarMonthAssigneesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CalendarAssigneesMultipleView>> {
        if (requestParameters.calendarAssigneeMultipleRequestView === null || requestParameters.calendarAssigneeMultipleRequestView === undefined) {
            throw new runtime.RequiredError('calendarAssigneeMultipleRequestView','Required parameter requestParameters.calendarAssigneeMultipleRequestView was null or undefined when calling postBackCalendarMonthAssignees.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/calendar/month/assignees`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.calendarAssigneeMultipleRequestView,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Save assignees for an event
     */
    async postBackCalendarMonthAssignees(requestParameters: PostBackCalendarMonthAssigneesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CalendarAssigneesMultipleView> {
        const response = await this.postBackCalendarMonthAssigneesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Contacts list
     */
    async postBackContractorsContactsListFilterRaw(requestParameters: PostBackContractorsContactsListFilterOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CompoundResultContactsListController>> {
        if (requestParameters.postBackContractorsContactsListFilterRequest === null || requestParameters.postBackContractorsContactsListFilterRequest === undefined) {
            throw new runtime.RequiredError('postBackContractorsContactsListFilterRequest','Required parameter requestParameters.postBackContractorsContactsListFilterRequest was null or undefined when calling postBackContractorsContactsListFilter.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/contractors/contacts/list/filter`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.postBackContractorsContactsListFilterRequest,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Contacts list
     */
    async postBackContractorsContactsListFilter(requestParameters: PostBackContractorsContactsListFilterOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CompoundResultContactsListController> {
        const response = await this.postBackContractorsContactsListFilterRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Save comment for given ContractorId
     */
    async postBackContractorsContractoridCommentSaveRaw(requestParameters: PostBackContractorsContractoridCommentSaveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AjaxActionResponse>> {
        if (requestParameters.contractorId === null || requestParameters.contractorId === undefined) {
            throw new runtime.RequiredError('contractorId','Required parameter requestParameters.contractorId was null or undefined when calling postBackContractorsContractoridCommentSave.');
        }

        if (requestParameters.contractorCommentUpdateView === null || requestParameters.contractorCommentUpdateView === undefined) {
            throw new runtime.RequiredError('contractorCommentUpdateView','Required parameter requestParameters.contractorCommentUpdateView was null or undefined when calling postBackContractorsContractoridCommentSave.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/contractors/{contractorId}/comment/save`.replace(`{${"contractorId"}}`, encodeURIComponent(String(requestParameters.contractorId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.contractorCommentUpdateView,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Save comment for given ContractorId
     */
    async postBackContractorsContractoridCommentSave(requestParameters: PostBackContractorsContractoridCommentSaveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AjaxActionResponse> {
        const response = await this.postBackContractorsContractoridCommentSaveRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Save marketing keeper for given ContractorId
     */
    async postBackContractorsContractoridMarketingKeeperSaveRaw(requestParameters: PostBackContractorsContractoridMarketingKeeperSaveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AjaxActionResponse>> {
        if (requestParameters.contractorId === null || requestParameters.contractorId === undefined) {
            throw new runtime.RequiredError('contractorId','Required parameter requestParameters.contractorId was null or undefined when calling postBackContractorsContractoridMarketingKeeperSave.');
        }

        if (requestParameters.marketingKeeperUpdateView === null || requestParameters.marketingKeeperUpdateView === undefined) {
            throw new runtime.RequiredError('marketingKeeperUpdateView','Required parameter requestParameters.marketingKeeperUpdateView was null or undefined when calling postBackContractorsContractoridMarketingKeeperSave.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/contractors/{contractorId}/marketing-keeper/save`.replace(`{${"contractorId"}}`, encodeURIComponent(String(requestParameters.contractorId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.marketingKeeperUpdateView,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Save marketing keeper for given ContractorId
     */
    async postBackContractorsContractoridMarketingKeeperSave(requestParameters: PostBackContractorsContractoridMarketingKeeperSaveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AjaxActionResponse> {
        const response = await this.postBackContractorsContractoridMarketingKeeperSaveRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get contractor data from external service
     */
    async postBackContractorsFetchDetailsRaw(requestParameters: PostBackContractorsFetchDetailsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ExternalContractorDetailsView>> {
        if (requestParameters.taxId === null || requestParameters.taxId === undefined) {
            throw new runtime.RequiredError('taxId','Required parameter requestParameters.taxId was null or undefined when calling postBackContractorsFetchDetails.');
        }

        const queryParameters: any = {};

        if (requestParameters.taxId !== undefined) {
            queryParameters['taxId'] = requestParameters.taxId;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/contractors/fetch-details`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Get contractor data from external service
     */
    async postBackContractorsFetchDetails(requestParameters: PostBackContractorsFetchDetailsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ExternalContractorDetailsView> {
        const response = await this.postBackContractorsFetchDetailsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Contractors list
     */
    async postBackContractorsListFilterRaw(requestParameters: PostBackContractorsListFilterOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CompoundResultContractorsListController>> {
        if (requestParameters.postBackContractorsListFilterRequest === null || requestParameters.postBackContractorsListFilterRequest === undefined) {
            throw new runtime.RequiredError('postBackContractorsListFilterRequest','Required parameter requestParameters.postBackContractorsListFilterRequest was null or undefined when calling postBackContractorsListFilter.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/contractors/list/filter`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.postBackContractorsListFilterRequest,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Contractors list
     */
    async postBackContractorsListFilter(requestParameters: PostBackContractorsListFilterOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CompoundResultContractorsListController> {
        const response = await this.postBackContractorsListFilterRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Marketing keepers list
     */
    async postBackContractorsMarketingKeepersListFilterRaw(requestParameters: PostBackContractorsMarketingKeepersListFilterOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CompoundResultMarketingKeepersListController>> {
        if (requestParameters.postBackContractorsMarketingKeepersListFilterRequest === null || requestParameters.postBackContractorsMarketingKeepersListFilterRequest === undefined) {
            throw new runtime.RequiredError('postBackContractorsMarketingKeepersListFilterRequest','Required parameter requestParameters.postBackContractorsMarketingKeepersListFilterRequest was null or undefined when calling postBackContractorsMarketingKeepersListFilter.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/contractors/marketing-keepers/list/filter`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.postBackContractorsMarketingKeepersListFilterRequest,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Marketing keepers list
     */
    async postBackContractorsMarketingKeepersListFilter(requestParameters: PostBackContractorsMarketingKeepersListFilterOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CompoundResultMarketingKeepersListController> {
        const response = await this.postBackContractorsMarketingKeepersListFilterRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Save Contact for given ContractorId
     */
    async postBackContractorsP1ContactsSaveRaw(requestParameters: PostBackContractorsP1ContactsSaveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<number>> {
        if (requestParameters.p1 === null || requestParameters.p1 === undefined) {
            throw new runtime.RequiredError('p1','Required parameter requestParameters.p1 was null or undefined when calling postBackContractorsP1ContactsSave.');
        }

        if (requestParameters.contact === null || requestParameters.contact === undefined) {
            throw new runtime.RequiredError('contact','Required parameter requestParameters.contact was null or undefined when calling postBackContractorsP1ContactsSave.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/contractors/{p1}/contacts/save`.replace(`{${"p1"}}`, encodeURIComponent(String(requestParameters.p1))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.contact,
        }, initOverrides);

        return new runtime.TextApiResponse(response) as any;
    }

    /**
     * Save Contact for given ContractorId
     */
    async postBackContractorsP1ContactsSave(requestParameters: PostBackContractorsP1ContactsSaveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<number> {
        const response = await this.postBackContractorsP1ContactsSaveRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get multiple ContractorViews by ContractorIds
     */
    async postBackContractorsSearchMultipleRaw(requestParameters: PostBackContractorsSearchMultipleRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<ContractorView>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/contractors/search/multiple`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.requestBody,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Get multiple ContractorViews by ContractorIds
     */
    async postBackContractorsSearchMultiple(requestParameters: PostBackContractorsSearchMultipleRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<ContractorView>> {
        const response = await this.postBackContractorsSearchMultipleRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Document status list
     */
    async postBackDocumentsDocumentStatusListFilterRaw(requestParameters: PostBackDocumentsDocumentStatusListFilterOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CompoundResultDocumentStatusListController>> {
        if (requestParameters.postBackDocumentsDocumentStatusListFilterRequest === null || requestParameters.postBackDocumentsDocumentStatusListFilterRequest === undefined) {
            throw new runtime.RequiredError('postBackDocumentsDocumentStatusListFilterRequest','Required parameter requestParameters.postBackDocumentsDocumentStatusListFilterRequest was null or undefined when calling postBackDocumentsDocumentStatusListFilter.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/documents/document-status/list/filter`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.postBackDocumentsDocumentStatusListFilterRequest,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Document status list
     */
    async postBackDocumentsDocumentStatusListFilter(requestParameters: PostBackDocumentsDocumentStatusListFilterOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CompoundResultDocumentStatusListController> {
        const response = await this.postBackDocumentsDocumentStatusListFilterRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Print labels
     */
    async postBackDocumentsPrinterPrintLabelsRaw(requestParameters: PostBackDocumentsPrinterPrintLabelsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.printingRequest === null || requestParameters.printingRequest === undefined) {
            throw new runtime.RequiredError('printingRequest','Required parameter requestParameters.printingRequest was null or undefined when calling postBackDocumentsPrinterPrintLabels.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/documents/printer/print-labels`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.printingRequest,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Print labels
     */
    async postBackDocumentsPrinterPrintLabels(requestParameters: PostBackDocumentsPrinterPrintLabelsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.postBackDocumentsPrinterPrintLabelsRaw(requestParameters, initOverrides);
    }

    /**
     * Erp synchronization status list
     */
    async postBackErpSynchronizationStatusesFilterRaw(requestParameters: PostBackErpSynchronizationStatusesFilterOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CompoundResultSynchronizationStatusListController>> {
        if (requestParameters.postBackErpSynchronizationStatusesFilterRequest === null || requestParameters.postBackErpSynchronizationStatusesFilterRequest === undefined) {
            throw new runtime.RequiredError('postBackErpSynchronizationStatusesFilterRequest','Required parameter requestParameters.postBackErpSynchronizationStatusesFilterRequest was null or undefined when calling postBackErpSynchronizationStatusesFilter.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/erp/synchronization/statuses/filter`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.postBackErpSynchronizationStatusesFilterRequest,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Erp synchronization status list
     */
    async postBackErpSynchronizationStatusesFilter(requestParameters: PostBackErpSynchronizationStatusesFilterOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CompoundResultSynchronizationStatusListController> {
        const response = await this.postBackErpSynchronizationStatusesFilterRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Save item type basic info
     */
    async postBackItemsItemSaveBasicInfoRaw(requestParameters: PostBackItemsItemSaveBasicInfoRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<number>> {
        if (requestParameters.itemTypeBasicInfoSaveView === null || requestParameters.itemTypeBasicInfoSaveView === undefined) {
            throw new runtime.RequiredError('itemTypeBasicInfoSaveView','Required parameter requestParameters.itemTypeBasicInfoSaveView was null or undefined when calling postBackItemsItemSaveBasicInfo.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/items/item-save/basic-info`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.itemTypeBasicInfoSaveView,
        }, initOverrides);

        return new runtime.TextApiResponse(response) as any;
    }

    /**
     * Save item type basic info
     */
    async postBackItemsItemSaveBasicInfo(requestParameters: PostBackItemsItemSaveBasicInfoRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<number> {
        const response = await this.postBackItemsItemSaveBasicInfoRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Save item type basic info
     */
    async postBackItemsItemSavePricingItemtypeidRaw(requestParameters: PostBackItemsItemSavePricingItemtypeidRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<number>> {
        if (requestParameters.itemTypeId === null || requestParameters.itemTypeId === undefined) {
            throw new runtime.RequiredError('itemTypeId','Required parameter requestParameters.itemTypeId was null or undefined when calling postBackItemsItemSavePricingItemtypeid.');
        }

        if (requestParameters.itemTypePricingSaveView === null || requestParameters.itemTypePricingSaveView === undefined) {
            throw new runtime.RequiredError('itemTypePricingSaveView','Required parameter requestParameters.itemTypePricingSaveView was null or undefined when calling postBackItemsItemSavePricingItemtypeid.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/items/item-save/pricing/{ItemTypeId}`.replace(`{${"ItemTypeId"}}`, encodeURIComponent(String(requestParameters.itemTypeId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.itemTypePricingSaveView,
        }, initOverrides);

        return new runtime.TextApiResponse(response) as any;
    }

    /**
     * Save item type basic info
     */
    async postBackItemsItemSavePricingItemtypeid(requestParameters: PostBackItemsItemSavePricingItemtypeidRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<number> {
        const response = await this.postBackItemsItemSavePricingItemtypeidRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Item type tag list
     */
    async postBackItemsItemTypeTagsListFilterRaw(requestParameters: PostBackItemsItemTypeTagsListFilterOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CompoundResultItemTypeTagListController>> {
        if (requestParameters.postBackItemsItemTypeTagsListFilterRequest === null || requestParameters.postBackItemsItemTypeTagsListFilterRequest === undefined) {
            throw new runtime.RequiredError('postBackItemsItemTypeTagsListFilterRequest','Required parameter requestParameters.postBackItemsItemTypeTagsListFilterRequest was null or undefined when calling postBackItemsItemTypeTagsListFilter.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/items/item-type-tags/list/filter`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.postBackItemsItemTypeTagsListFilterRequest,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Item type tag list
     */
    async postBackItemsItemTypeTagsListFilter(requestParameters: PostBackItemsItemTypeTagsListFilterOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CompoundResultItemTypeTagListController> {
        const response = await this.postBackItemsItemTypeTagsListFilterRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get ItemTypeViews of given ItemTypeIds
     */
    async postBackItemsMultipleRaw(requestParameters: PostBackItemsMultipleRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<ItemTypeView>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/items/multiple`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.requestBody,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Get ItemTypeViews of given ItemTypeIds
     */
    async postBackItemsMultiple(requestParameters: PostBackItemsMultipleRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<ItemTypeView>> {
        const response = await this.postBackItemsMultipleRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Price lists list
     */
    async postBackItemsPriceListsFilterRaw(requestParameters: PostBackItemsPriceListsFilterOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CompoundResultPriceListsListController>> {
        if (requestParameters.postBackItemsPriceListsFilterRequest === null || requestParameters.postBackItemsPriceListsFilterRequest === undefined) {
            throw new runtime.RequiredError('postBackItemsPriceListsFilterRequest','Required parameter requestParameters.postBackItemsPriceListsFilterRequest was null or undefined when calling postBackItemsPriceListsFilter.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/items/price-lists/filter`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.postBackItemsPriceListsFilterRequest,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Price lists list
     */
    async postBackItemsPriceListsFilter(requestParameters: PostBackItemsPriceListsFilterOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CompoundResultPriceListsListController> {
        const response = await this.postBackItemsPriceListsFilterRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Item type property sets list
     */
    async postBackItemsPropertySetsListFilterRaw(requestParameters: PostBackItemsPropertySetsListFilterOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CompoundResultItemTypePropertySetListController>> {
        if (requestParameters.postBackItemsPropertySetsListFilterRequest === null || requestParameters.postBackItemsPropertySetsListFilterRequest === undefined) {
            throw new runtime.RequiredError('postBackItemsPropertySetsListFilterRequest','Required parameter requestParameters.postBackItemsPropertySetsListFilterRequest was null or undefined when calling postBackItemsPropertySetsListFilter.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/items/property-sets/list/filter`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.postBackItemsPropertySetsListFilterRequest,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Item type property sets list
     */
    async postBackItemsPropertySetsListFilter(requestParameters: PostBackItemsPropertySetsListFilterOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CompoundResultItemTypePropertySetListController> {
        const response = await this.postBackItemsPropertySetsListFilterRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Item type property types list
     */
    async postBackItemsPropertyTypesFilterRaw(requestParameters: PostBackItemsPropertyTypesFilterOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CompoundResultItemTypePropertyTypesListController>> {
        if (requestParameters.postBackItemsPropertyTypesFilterRequest === null || requestParameters.postBackItemsPropertyTypesFilterRequest === undefined) {
            throw new runtime.RequiredError('postBackItemsPropertyTypesFilterRequest','Required parameter requestParameters.postBackItemsPropertyTypesFilterRequest was null or undefined when calling postBackItemsPropertyTypesFilter.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/items/property/types/filter`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.postBackItemsPropertyTypesFilterRequest,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Item type property types list
     */
    async postBackItemsPropertyTypesFilter(requestParameters: PostBackItemsPropertyTypesFilterOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CompoundResultItemTypePropertyTypesListController> {
        const response = await this.postBackItemsPropertyTypesFilterRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Save item type property type
     */
    async postBackItemsPropertyTypesSaveRaw(requestParameters: PostBackItemsPropertyTypesSaveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<number>> {
        if (requestParameters.itemTypePropertyType === null || requestParameters.itemTypePropertyType === undefined) {
            throw new runtime.RequiredError('itemTypePropertyType','Required parameter requestParameters.itemTypePropertyType was null or undefined when calling postBackItemsPropertyTypesSave.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/items/property/types/save`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.itemTypePropertyType,
        }, initOverrides);

        return new runtime.TextApiResponse(response) as any;
    }

    /**
     * Save item type property type
     */
    async postBackItemsPropertyTypesSave(requestParameters: PostBackItemsPropertyTypesSaveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<number> {
        const response = await this.postBackItemsPropertyTypesSaveRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Saves item
     */
    async postBackItemsSaveRaw(requestParameters: PostBackItemsSaveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ItemTypeView>> {
        if (requestParameters.itemTypeSavingView === null || requestParameters.itemTypeSavingView === undefined) {
            throw new runtime.RequiredError('itemTypeSavingView','Required parameter requestParameters.itemTypeSavingView was null or undefined when calling postBackItemsSave.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/items/save`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.itemTypeSavingView,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Saves item
     */
    async postBackItemsSave(requestParameters: PostBackItemsSaveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ItemTypeView> {
        const response = await this.postBackItemsSaveRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 
     */
    async postBackItemsSavePropertiesItemtypeidRaw(requestParameters: PostBackItemsSavePropertiesItemtypeidRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<number>> {
        if (requestParameters.itemTypeId === null || requestParameters.itemTypeId === undefined) {
            throw new runtime.RequiredError('itemTypeId','Required parameter requestParameters.itemTypeId was null or undefined when calling postBackItemsSavePropertiesItemtypeid.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/items/save-properties/{ItemTypeId}`.replace(`{${"ItemTypeId"}}`, encodeURIComponent(String(requestParameters.itemTypeId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.itemTypePropertySaveView,
        }, initOverrides);

        return new runtime.TextApiResponse(response) as any;
    }

    /**
     * 
     */
    async postBackItemsSavePropertiesItemtypeid(requestParameters: PostBackItemsSavePropertiesItemtypeidRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<number> {
        const response = await this.postBackItemsSavePropertiesItemtypeidRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Searches items based on criteria in the payload
     */
    async postBackItemsSearchItemTypesRaw(requestParameters: PostBackItemsSearchItemTypesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<ItemTypeView>>> {
        if (requestParameters.itemTypeSearchCriteriaView === null || requestParameters.itemTypeSearchCriteriaView === undefined) {
            throw new runtime.RequiredError('itemTypeSearchCriteriaView','Required parameter requestParameters.itemTypeSearchCriteriaView was null or undefined when calling postBackItemsSearchItemTypes.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/items/search/item-types`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.itemTypeSearchCriteriaView,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Searches items based on criteria in the payload
     */
    async postBackItemsSearchItemTypes(requestParameters: PostBackItemsSearchItemTypesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<ItemTypeView>> {
        const response = await this.postBackItemsSearchItemTypesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get item with service kind by Id
     */
    async postBackItemsServicesRaw(requestParameters: PostBackItemsServicesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<number>> {
        if (requestParameters.itemTypeServiceSavingView === null || requestParameters.itemTypeServiceSavingView === undefined) {
            throw new runtime.RequiredError('itemTypeServiceSavingView','Required parameter requestParameters.itemTypeServiceSavingView was null or undefined when calling postBackItemsServices.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/items/services`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.itemTypeServiceSavingView,
        }, initOverrides);

        return new runtime.TextApiResponse(response) as any;
    }

    /**
     * Get item with service kind by Id
     */
    async postBackItemsServices(requestParameters: PostBackItemsServicesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<number> {
        const response = await this.postBackItemsServicesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Save item type tag
     */
    async postBackItemsTagsSaveRaw(requestParameters: PostBackItemsTagsSaveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<number>> {
        if (requestParameters.itemTypeTag === null || requestParameters.itemTypeTag === undefined) {
            throw new runtime.RequiredError('itemTypeTag','Required parameter requestParameters.itemTypeTag was null or undefined when calling postBackItemsTagsSave.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/items/tags/save`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.itemTypeTag,
        }, initOverrides);

        return new runtime.TextApiResponse(response) as any;
    }

    /**
     * Save item type tag
     */
    async postBackItemsTagsSave(requestParameters: PostBackItemsTagsSaveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<number> {
        const response = await this.postBackItemsTagsSaveRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 
     */
    async postBackItemsVariantsRaw(requestParameters: PostBackItemsVariantsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<number>> {
        if (requestParameters.contextualItemTypeVariant === null || requestParameters.contextualItemTypeVariant === undefined) {
            throw new runtime.RequiredError('contextualItemTypeVariant','Required parameter requestParameters.contextualItemTypeVariant was null or undefined when calling postBackItemsVariants.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/items/variants`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.contextualItemTypeVariant,
        }, initOverrides);

        return new runtime.TextApiResponse(response) as any;
    }

    /**
     * 
     */
    async postBackItemsVariants(requestParameters: PostBackItemsVariantsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<number> {
        const response = await this.postBackItemsVariantsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * ItemType variant list
     */
    async postBackItemsVariantsFilterRaw(requestParameters: PostBackItemsVariantsFilterOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CompoundResultItemTypeVariantListController>> {
        if (requestParameters.postBackItemsVariantsFilterRequest === null || requestParameters.postBackItemsVariantsFilterRequest === undefined) {
            throw new runtime.RequiredError('postBackItemsVariantsFilterRequest','Required parameter requestParameters.postBackItemsVariantsFilterRequest was null or undefined when calling postBackItemsVariantsFilter.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/items/variants/filter`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.postBackItemsVariantsFilterRequest,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * ItemType variant list
     */
    async postBackItemsVariantsFilter(requestParameters: PostBackItemsVariantsFilterOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CompoundResultItemTypeVariantListController> {
        const response = await this.postBackItemsVariantsFilterRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Search multiple item type variants by ids
     */
    async postBackItemsVariantsMultipleRaw(requestParameters: PostBackItemsVariantsMultipleRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<ItemTypeVariant>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/items/variants/multiple`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.requestBody,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Search multiple item type variants by ids
     */
    async postBackItemsVariantsMultiple(requestParameters: PostBackItemsVariantsMultipleRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<ItemTypeVariant>> {
        const response = await this.postBackItemsVariantsMultipleRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * ItemType variant list
     */
    async postBackItemsVariantsPropertySetFilterRaw(requestParameters: PostBackItemsVariantsPropertySetFilterOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CompoundResultItemTypeVariantWithPropertySetListController>> {
        if (requestParameters.postBackItemsVariantsPropertySetFilterRequest === null || requestParameters.postBackItemsVariantsPropertySetFilterRequest === undefined) {
            throw new runtime.RequiredError('postBackItemsVariantsPropertySetFilterRequest','Required parameter requestParameters.postBackItemsVariantsPropertySetFilterRequest was null or undefined when calling postBackItemsVariantsPropertySetFilter.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/items/variants/property-set/filter`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.postBackItemsVariantsPropertySetFilterRequest,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * ItemType variant list
     */
    async postBackItemsVariantsPropertySetFilter(requestParameters: PostBackItemsVariantsPropertySetFilterOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CompoundResultItemTypeVariantWithPropertySetListController> {
        const response = await this.postBackItemsVariantsPropertySetFilterRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Machine areas list
     */
    async postBackMachineAreasListFilterRaw(requestParameters: PostBackMachineAreasListFilterOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CompoundResultMachineAreasListController>> {
        if (requestParameters.postBackMachineAreasListFilterRequest === null || requestParameters.postBackMachineAreasListFilterRequest === undefined) {
            throw new runtime.RequiredError('postBackMachineAreasListFilterRequest','Required parameter requestParameters.postBackMachineAreasListFilterRequest was null or undefined when calling postBackMachineAreasListFilter.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/machine-areas/list/filter`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.postBackMachineAreasListFilterRequest,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Machine areas list
     */
    async postBackMachineAreasListFilter(requestParameters: PostBackMachineAreasListFilterOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CompoundResultMachineAreasListController> {
        const response = await this.postBackMachineAreasListFilterRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Save Contact for given ContractorId
     */
    async postBackMachinesCalendarEventP1Raw(requestParameters: PostBackMachinesCalendarEventP1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<number>> {
        if (requestParameters.p1 === null || requestParameters.p1 === undefined) {
            throw new runtime.RequiredError('p1','Required parameter requestParameters.p1 was null or undefined when calling postBackMachinesCalendarEventP1.');
        }

        if (requestParameters.calendarEventView === null || requestParameters.calendarEventView === undefined) {
            throw new runtime.RequiredError('calendarEventView','Required parameter requestParameters.calendarEventView was null or undefined when calling postBackMachinesCalendarEventP1.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/machines/calendar/event/{p1}`.replace(`{${"p1"}}`, encodeURIComponent(String(requestParameters.p1))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.calendarEventView,
        }, initOverrides);

        return new runtime.TextApiResponse(response) as any;
    }

    /**
     * Save Contact for given ContractorId
     */
    async postBackMachinesCalendarEventP1(requestParameters: PostBackMachinesCalendarEventP1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<number> {
        const response = await this.postBackMachinesCalendarEventP1Raw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Machines list
     */
    async postBackMachinesListFilterRaw(requestParameters: PostBackMachinesListFilterOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CompoundResultMachinesListController>> {
        if (requestParameters.postBackMachinesListFilterRequest === null || requestParameters.postBackMachinesListFilterRequest === undefined) {
            throw new runtime.RequiredError('postBackMachinesListFilterRequest','Required parameter requestParameters.postBackMachinesListFilterRequest was null or undefined when calling postBackMachinesListFilter.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/machines/list/filter`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.postBackMachinesListFilterRequest,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Machines list
     */
    async postBackMachinesListFilter(requestParameters: PostBackMachinesListFilterOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CompoundResultMachinesListController> {
        const response = await this.postBackMachinesListFilterRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Save machine
     */
    async postBackMachinesMachineRaw(requestParameters: PostBackMachinesMachineRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<number>> {
        if (requestParameters.machineSaveView === null || requestParameters.machineSaveView === undefined) {
            throw new runtime.RequiredError('machineSaveView','Required parameter requestParameters.machineSaveView was null or undefined when calling postBackMachinesMachine.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/machines/machine`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.machineSaveView,
        }, initOverrides);

        return new runtime.TextApiResponse(response) as any;
    }

    /**
     * Save machine
     */
    async postBackMachinesMachine(requestParameters: PostBackMachinesMachineRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<number> {
        const response = await this.postBackMachinesMachineRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Set machine permissions
     */
    async postBackMachinesMachinePermissionsRaw(requestParameters: PostBackMachinesMachinePermissionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<number>> {
        if (requestParameters.machinePermissionsView === null || requestParameters.machinePermissionsView === undefined) {
            throw new runtime.RequiredError('machinePermissionsView','Required parameter requestParameters.machinePermissionsView was null or undefined when calling postBackMachinesMachinePermissions.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/machines/machine/permissions`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.machinePermissionsView,
        }, initOverrides);

        return new runtime.TextApiResponse(response) as any;
    }

    /**
     * Set machine permissions
     */
    async postBackMachinesMachinePermissions(requestParameters: PostBackMachinesMachinePermissionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<number> {
        const response = await this.postBackMachinesMachinePermissionsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Save allowed machines for role
     */
    async postBackMachinesMachinesRoleRoleidRaw(requestParameters: PostBackMachinesMachinesRoleRoleidRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AjaxActionResponse>> {
        if (requestParameters.roleId === null || requestParameters.roleId === undefined) {
            throw new runtime.RequiredError('roleId','Required parameter requestParameters.roleId was null or undefined when calling postBackMachinesMachinesRoleRoleid.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/machines/machines/role/{RoleId}`.replace(`{${"RoleId"}}`, encodeURIComponent(String(requestParameters.roleId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.requestBody,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Save allowed machines for role
     */
    async postBackMachinesMachinesRoleRoleid(requestParameters: PostBackMachinesMachinesRoleRoleidRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AjaxActionResponse> {
        const response = await this.postBackMachinesMachinesRoleRoleidRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Marketing rules list
     */
    async postBackMarketingrulesListFilterRaw(requestParameters: PostBackMarketingrulesListFilterOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CompoundResultMarketingRulesListController>> {
        if (requestParameters.postBackMarketingrulesListFilterRequest === null || requestParameters.postBackMarketingrulesListFilterRequest === undefined) {
            throw new runtime.RequiredError('postBackMarketingrulesListFilterRequest','Required parameter requestParameters.postBackMarketingrulesListFilterRequest was null or undefined when calling postBackMarketingrulesListFilter.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/marketingrules/list/filter`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.postBackMarketingrulesListFilterRequest,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Marketing rules list
     */
    async postBackMarketingrulesListFilter(requestParameters: PostBackMarketingrulesListFilterOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CompoundResultMarketingRulesListController> {
        const response = await this.postBackMarketingrulesListFilterRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Material movements list
     */
    async postBackMaterialMovementsListFilterRaw(requestParameters: PostBackMaterialMovementsListFilterOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CompoundResultMaterialMovementListController>> {
        if (requestParameters.postBackMaterialMovementsListFilterRequest === null || requestParameters.postBackMaterialMovementsListFilterRequest === undefined) {
            throw new runtime.RequiredError('postBackMaterialMovementsListFilterRequest','Required parameter requestParameters.postBackMaterialMovementsListFilterRequest was null or undefined when calling postBackMaterialMovementsListFilter.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/material-movements/list/filter`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.postBackMaterialMovementsListFilterRequest,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Material movements list
     */
    async postBackMaterialMovementsListFilter(requestParameters: PostBackMaterialMovementsListFilterOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CompoundResultMaterialMovementListController> {
        const response = await this.postBackMaterialMovementsListFilterRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieves measurement reports for a specific filter
     */
    async postBackMeasurementReportsByProductionLotWithFilterRaw(requestParameters: PostBackMeasurementReportsByProductionLotWithFilterRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<MeasurementReport>>> {
        if (requestParameters.measurementReportFilter === null || requestParameters.measurementReportFilter === undefined) {
            throw new runtime.RequiredError('measurementReportFilter','Required parameter requestParameters.measurementReportFilter was null or undefined when calling postBackMeasurementReportsByProductionLotWithFilter.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/measurement-reports/by-production-lot-with-filter`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.measurementReportFilter,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Retrieves measurement reports for a specific filter
     */
    async postBackMeasurementReportsByProductionLotWithFilter(requestParameters: PostBackMeasurementReportsByProductionLotWithFilterRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<MeasurementReport>> {
        const response = await this.postBackMeasurementReportsByProductionLotWithFilterRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Measurement devices list
     */
    async postBackMeasurementsMeasurementDevicesFilterRaw(requestParameters: PostBackMeasurementsMeasurementDevicesFilterOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CompoundResultMeasurementDevicesListController>> {
        if (requestParameters.postBackMeasurementsMeasurementDevicesFilterRequest === null || requestParameters.postBackMeasurementsMeasurementDevicesFilterRequest === undefined) {
            throw new runtime.RequiredError('postBackMeasurementsMeasurementDevicesFilterRequest','Required parameter requestParameters.postBackMeasurementsMeasurementDevicesFilterRequest was null or undefined when calling postBackMeasurementsMeasurementDevicesFilter.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/measurements/measurement-devices/filter`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.postBackMeasurementsMeasurementDevicesFilterRequest,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Measurement devices list
     */
    async postBackMeasurementsMeasurementDevicesFilter(requestParameters: PostBackMeasurementsMeasurementDevicesFilterOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CompoundResultMeasurementDevicesListController> {
        const response = await this.postBackMeasurementsMeasurementDevicesFilterRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Clone offer item
     */
    async postBackOffersItemCloneRaw(requestParameters: PostBackOffersItemCloneRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SalesEntryItemView>> {
        if (requestParameters.salesEntryItemView === null || requestParameters.salesEntryItemView === undefined) {
            throw new runtime.RequiredError('salesEntryItemView','Required parameter requestParameters.salesEntryItemView was null or undefined when calling postBackOffersItemClone.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/offers/item/clone`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.salesEntryItemView,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Clone offer item
     */
    async postBackOffersItemClone(requestParameters: PostBackOffersItemCloneRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SalesEntryItemView> {
        const response = await this.postBackOffersItemCloneRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Offers list
     */
    async postBackOffersListFilterRaw(requestParameters: PostBackOffersListFilterOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CompoundResultOffersListController>> {
        if (requestParameters.postBackOffersListFilterRequest === null || requestParameters.postBackOffersListFilterRequest === undefined) {
            throw new runtime.RequiredError('postBackOffersListFilterRequest','Required parameter requestParameters.postBackOffersListFilterRequest was null or undefined when calling postBackOffersListFilter.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/offers/list/filter`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.postBackOffersListFilterRequest,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Offers list
     */
    async postBackOffersListFilter(requestParameters: PostBackOffersListFilterOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CompoundResultOffersListController> {
        const response = await this.postBackOffersListFilterRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Save offer items
     */
    async postBackOffersSalesentryidItemsSaveRaw(requestParameters: PostBackOffersSalesentryidItemsSaveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<number>> {
        if (requestParameters.salesEntryId === null || requestParameters.salesEntryId === undefined) {
            throw new runtime.RequiredError('salesEntryId','Required parameter requestParameters.salesEntryId was null or undefined when calling postBackOffersSalesentryidItemsSave.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/offers/{SalesEntryId}/items/save`.replace(`{${"SalesEntryId"}}`, encodeURIComponent(String(requestParameters.salesEntryId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.salesEntryItemSavingView,
        }, initOverrides);

        return new runtime.TextApiResponse(response) as any;
    }

    /**
     * Save offer items
     */
    async postBackOffersSalesentryidItemsSave(requestParameters: PostBackOffersSalesentryidItemsSaveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<number> {
        const response = await this.postBackOffersSalesentryidItemsSaveRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Save Offer
     */
    async postBackOffersSaveRaw(requestParameters: PostBackOffersSaveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<number>> {
        if (requestParameters.offerSaveView === null || requestParameters.offerSaveView === undefined) {
            throw new runtime.RequiredError('offerSaveView','Required parameter requestParameters.offerSaveView was null or undefined when calling postBackOffersSave.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/offers/save`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.offerSaveView,
        }, initOverrides);

        return new runtime.TextApiResponse(response) as any;
    }

    /**
     * Save Offer
     */
    async postBackOffersSave(requestParameters: PostBackOffersSaveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<number> {
        const response = await this.postBackOffersSaveRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Save Offer returning offer\'s view
     */
    async postBackOffersSaveWithViewRaw(requestParameters: PostBackOffersSaveWithViewRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OfferView>> {
        if (requestParameters.offerSaveView === null || requestParameters.offerSaveView === undefined) {
            throw new runtime.RequiredError('offerSaveView','Required parameter requestParameters.offerSaveView was null or undefined when calling postBackOffersSaveWithView.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/offers/save-with-view`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.offerSaveView,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Save Offer returning offer\'s view
     */
    async postBackOffersSaveWithView(requestParameters: PostBackOffersSaveWithViewRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OfferView> {
        const response = await this.postBackOffersSaveWithViewRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update and accept Offer
     */
    async postBackOffersUpdateAndAcceptRaw(requestParameters: PostBackOffersUpdateAndAcceptRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<number>> {
        if (requestParameters.offerSaveView === null || requestParameters.offerSaveView === undefined) {
            throw new runtime.RequiredError('offerSaveView','Required parameter requestParameters.offerSaveView was null or undefined when calling postBackOffersUpdateAndAccept.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/offers/update-and-accept`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.offerSaveView,
        }, initOverrides);

        return new runtime.TextApiResponse(response) as any;
    }

    /**
     * Update and accept Offer
     */
    async postBackOffersUpdateAndAccept(requestParameters: PostBackOffersUpdateAndAcceptRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<number> {
        const response = await this.postBackOffersUpdateAndAcceptRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Adds new order assignment event
     */
    async postBackOrdersAssignmentEventsSaveRaw(requestParameters: PostBackOrdersAssignmentEventsSaveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<number>>> {
        if (requestParameters.orderAssignmentEventSaveView === null || requestParameters.orderAssignmentEventSaveView === undefined) {
            throw new runtime.RequiredError('orderAssignmentEventSaveView','Required parameter requestParameters.orderAssignmentEventSaveView was null or undefined when calling postBackOrdersAssignmentEventsSave.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/orders/assignment-events/save`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.orderAssignmentEventSaveView,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Adds new order assignment event
     */
    async postBackOrdersAssignmentEventsSave(requestParameters: PostBackOrdersAssignmentEventsSaveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<number>> {
        const response = await this.postBackOrdersAssignmentEventsSaveRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Create draft order
     */
    async postBackOrdersDraftRaw(requestParameters: PostBackOrdersDraftRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<number>> {
        if (requestParameters.orderDraft === null || requestParameters.orderDraft === undefined) {
            throw new runtime.RequiredError('orderDraft','Required parameter requestParameters.orderDraft was null or undefined when calling postBackOrdersDraft.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/orders/draft`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.orderDraft,
        }, initOverrides);

        return new runtime.TextApiResponse(response) as any;
    }

    /**
     * Create draft order
     */
    async postBackOrdersDraft(requestParameters: PostBackOrdersDraftRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<number> {
        const response = await this.postBackOrdersDraftRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Create draft of returning order
     */
    async postBackOrdersDraftAddReturningOrderRaw(requestParameters: PostBackOrdersDraftAddReturningOrderRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OrderView>> {
        if (requestParameters.orderDraft === null || requestParameters.orderDraft === undefined) {
            throw new runtime.RequiredError('orderDraft','Required parameter requestParameters.orderDraft was null or undefined when calling postBackOrdersDraftAddReturningOrder.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/orders/draft/add-returning-order`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.orderDraft,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Create draft of returning order
     */
    async postBackOrdersDraftAddReturningOrder(requestParameters: PostBackOrdersDraftAddReturningOrderRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OrderView> {
        const response = await this.postBackOrdersDraftAddReturningOrderRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Equipment demands list
     */
    async postBackOrdersEquipmentDemandsListFilterRaw(requestParameters: PostBackOrdersEquipmentDemandsListFilterOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CompoundResultEquipmentDemandListController>> {
        if (requestParameters.postBackOrdersEquipmentDemandsListFilterRequest === null || requestParameters.postBackOrdersEquipmentDemandsListFilterRequest === undefined) {
            throw new runtime.RequiredError('postBackOrdersEquipmentDemandsListFilterRequest','Required parameter requestParameters.postBackOrdersEquipmentDemandsListFilterRequest was null or undefined when calling postBackOrdersEquipmentDemandsListFilter.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/orders/equipment-demands/list/filter`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.postBackOrdersEquipmentDemandsListFilterRequest,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Equipment demands list
     */
    async postBackOrdersEquipmentDemandsListFilter(requestParameters: PostBackOrdersEquipmentDemandsListFilterOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CompoundResultEquipmentDemandListController> {
        const response = await this.postBackOrdersEquipmentDemandsListFilterRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Upserts equipment demand with optionally specified id
     */
    async postBackOrdersEquipmentDemandsSaveRaw(requestParameters: PostBackOrdersEquipmentDemandsSaveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<number>> {
        if (requestParameters.equipmentDemandSavingView === null || requestParameters.equipmentDemandSavingView === undefined) {
            throw new runtime.RequiredError('equipmentDemandSavingView','Required parameter requestParameters.equipmentDemandSavingView was null or undefined when calling postBackOrdersEquipmentDemandsSave.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/orders/equipment-demands/save`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.equipmentDemandSavingView,
        }, initOverrides);

        return new runtime.TextApiResponse(response) as any;
    }

    /**
     * Upserts equipment demand with optionally specified id
     */
    async postBackOrdersEquipmentDemandsSave(requestParameters: PostBackOrdersEquipmentDemandsSaveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<number> {
        const response = await this.postBackOrdersEquipmentDemandsSaveRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Create order
     */
    async postBackOrdersExternalRaw(requestParameters: PostBackOrdersExternalRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<number>> {
        if (requestParameters.externalOrder === null || requestParameters.externalOrder === undefined) {
            throw new runtime.RequiredError('externalOrder','Required parameter requestParameters.externalOrder was null or undefined when calling postBackOrdersExternal.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/orders/external`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.externalOrder,
        }, initOverrides);

        return new runtime.TextApiResponse(response) as any;
    }

    /**
     * Create order
     */
    async postBackOrdersExternal(requestParameters: PostBackOrdersExternalRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<number> {
        const response = await this.postBackOrdersExternalRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Create draft order from existing offer
     */
    async postBackOrdersFromOfferRaw(requestParameters: PostBackOrdersFromOfferRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OrderFromOffer>> {
        if (requestParameters.offerId === null || requestParameters.offerId === undefined) {
            throw new runtime.RequiredError('offerId','Required parameter requestParameters.offerId was null or undefined when calling postBackOrdersFromOffer.');
        }

        const queryParameters: any = {};

        if (requestParameters.offerId !== undefined) {
            queryParameters['offerId'] = requestParameters.offerId;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/orders/from-offer`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Create draft order from existing offer
     */
    async postBackOrdersFromOffer(requestParameters: PostBackOrdersFromOfferRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OrderFromOffer> {
        const response = await this.postBackOrdersFromOfferRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Create and save order from existing offer
     */
    async postBackOrdersFromOfferCreateRaw(requestParameters: PostBackOrdersFromOfferCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<number>> {
        if (requestParameters.offerId === null || requestParameters.offerId === undefined) {
            throw new runtime.RequiredError('offerId','Required parameter requestParameters.offerId was null or undefined when calling postBackOrdersFromOfferCreate.');
        }

        const queryParameters: any = {};

        if (requestParameters.offerId !== undefined) {
            queryParameters['offerId'] = requestParameters.offerId;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/orders/from-offer/create`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.TextApiResponse(response) as any;
    }

    /**
     * Create and save order from existing offer
     */
    async postBackOrdersFromOfferCreate(requestParameters: PostBackOrdersFromOfferCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<number> {
        const response = await this.postBackOrdersFromOfferCreateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Create order from existing draft order
     */
    async postBackOrdersFromOfferSaveRaw(requestParameters: PostBackOrdersFromOfferSaveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AjaxActionResponse>> {
        if (requestParameters.orderFromOffer === null || requestParameters.orderFromOffer === undefined) {
            throw new runtime.RequiredError('orderFromOffer','Required parameter requestParameters.orderFromOffer was null or undefined when calling postBackOrdersFromOfferSave.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/orders/from-offer/save`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.orderFromOffer,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Create order from existing draft order
     */
    async postBackOrdersFromOfferSave(requestParameters: PostBackOrdersFromOfferSaveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AjaxActionResponse> {
        const response = await this.postBackOrdersFromOfferSaveRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async postBackOrdersIdAssignmentsRaw(requestParameters: PostBackOrdersIdAssignmentsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling postBackOrdersIdAssignments.');
        }

        if (requestParameters.orderAssignmentsSaveView === null || requestParameters.orderAssignmentsSaveView === undefined) {
            throw new runtime.RequiredError('orderAssignmentsSaveView','Required parameter requestParameters.orderAssignmentsSaveView was null or undefined when calling postBackOrdersIdAssignments.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/orders/{id}/assignments`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.orderAssignmentsSaveView,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async postBackOrdersIdAssignments(requestParameters: PostBackOrdersIdAssignmentsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.postBackOrdersIdAssignmentsRaw(requestParameters, initOverrides);
    }

    /**
     * Clone item
     */
    async postBackOrdersItemCloneRaw(requestParameters: PostBackOrdersItemCloneRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SalesEntryItemView>> {
        if (requestParameters.salesEntryItemView === null || requestParameters.salesEntryItemView === undefined) {
            throw new runtime.RequiredError('salesEntryItemView','Required parameter requestParameters.salesEntryItemView was null or undefined when calling postBackOrdersItemClone.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/orders/item/clone`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.salesEntryItemView,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Clone item
     */
    async postBackOrdersItemClone(requestParameters: PostBackOrdersItemCloneRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SalesEntryItemView> {
        const response = await this.postBackOrdersItemCloneRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Mark the order item as shipped
     */
    async postBackOrdersItemIdConfirmShippedRaw(requestParameters: PostBackOrdersItemIdConfirmShippedRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AjaxActionResponse>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling postBackOrdersItemIdConfirmShipped.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/orders/item/{id}/confirm-shipped`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Mark the order item as shipped
     */
    async postBackOrdersItemIdConfirmShipped(requestParameters: PostBackOrdersItemIdConfirmShippedRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AjaxActionResponse> {
        const response = await this.postBackOrdersItemIdConfirmShippedRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Orders list
     */
    async postBackOrdersListFilterRaw(requestParameters: PostBackOrdersListFilterOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CompoundResultOrdersListController>> {
        if (requestParameters.postBackOrdersListFilterRequest === null || requestParameters.postBackOrdersListFilterRequest === undefined) {
            throw new runtime.RequiredError('postBackOrdersListFilterRequest','Required parameter requestParameters.postBackOrdersListFilterRequest was null or undefined when calling postBackOrdersListFilter.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/orders/list/filter`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.postBackOrdersListFilterRequest,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Orders list
     */
    async postBackOrdersListFilter(requestParameters: PostBackOrdersListFilterOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CompoundResultOrdersListController> {
        const response = await this.postBackOrdersListFilterRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Cancel order by id
     */
    async postBackOrdersOrderIdCancelRaw(requestParameters: PostBackOrdersOrderIdCancelRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AjaxActionResponse>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling postBackOrdersOrderIdCancel.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/orders/order/{id}/cancel`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Cancel order by id
     */
    async postBackOrdersOrderIdCancel(requestParameters: PostBackOrdersOrderIdCancelRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AjaxActionResponse> {
        const response = await this.postBackOrdersOrderIdCancelRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Set estimated budget for order
     */
    async postBackOrdersOrderIdSetBudgetRaw(requestParameters: PostBackOrdersOrderIdSetBudgetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling postBackOrdersOrderIdSetBudget.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/orders/order/{id}/set-budget`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.body as any,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Set estimated budget for order
     */
    async postBackOrdersOrderIdSetBudget(requestParameters: PostBackOrdersOrderIdSetBudgetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.postBackOrdersOrderIdSetBudgetRaw(requestParameters, initOverrides);
    }

    /**
     * Save order items
     */
    async postBackOrdersOrderSalesentryidItemsSaveRaw(requestParameters: PostBackOrdersOrderSalesentryidItemsSaveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<number>> {
        if (requestParameters.salesEntryId === null || requestParameters.salesEntryId === undefined) {
            throw new runtime.RequiredError('salesEntryId','Required parameter requestParameters.salesEntryId was null or undefined when calling postBackOrdersOrderSalesentryidItemsSave.');
        }

        const queryParameters: any = {};

        if (requestParameters.draft !== undefined) {
            queryParameters['draft'] = requestParameters.draft;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/orders/order/{SalesEntryId}/items/save`.replace(`{${"SalesEntryId"}}`, encodeURIComponent(String(requestParameters.salesEntryId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.salesEntryItemSavingView,
        }, initOverrides);

        return new runtime.TextApiResponse(response) as any;
    }

    /**
     * Save order items
     */
    async postBackOrdersOrderSalesentryidItemsSave(requestParameters: PostBackOrdersOrderSalesentryidItemsSaveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<number> {
        const response = await this.postBackOrdersOrderSalesentryidItemsSaveRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Other demands list
     */
    async postBackOrdersOtherDemandsListFilterRaw(requestParameters: PostBackOrdersOtherDemandsListFilterOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CompoundResultOtherDemandListController>> {
        if (requestParameters.postBackOrdersOtherDemandsListFilterRequest === null || requestParameters.postBackOrdersOtherDemandsListFilterRequest === undefined) {
            throw new runtime.RequiredError('postBackOrdersOtherDemandsListFilterRequest','Required parameter requestParameters.postBackOrdersOtherDemandsListFilterRequest was null or undefined when calling postBackOrdersOtherDemandsListFilter.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/orders/other-demands/list/filter`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.postBackOrdersOtherDemandsListFilterRequest,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Other demands list
     */
    async postBackOrdersOtherDemandsListFilter(requestParameters: PostBackOrdersOtherDemandsListFilterOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CompoundResultOtherDemandListController> {
        const response = await this.postBackOrdersOtherDemandsListFilterRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Upserts other demands with optionally specified id
     */
    async postBackOrdersOtherDemandsSaveRaw(requestParameters: PostBackOrdersOtherDemandsSaveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<number>> {
        if (requestParameters.otherDemandSavingView === null || requestParameters.otherDemandSavingView === undefined) {
            throw new runtime.RequiredError('otherDemandSavingView','Required parameter requestParameters.otherDemandSavingView was null or undefined when calling postBackOrdersOtherDemandsSave.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/orders/other-demands/save`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.otherDemandSavingView,
        }, initOverrides);

        return new runtime.TextApiResponse(response) as any;
    }

    /**
     * Upserts other demands with optionally specified id
     */
    async postBackOrdersOtherDemandsSave(requestParameters: PostBackOrdersOtherDemandsSaveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<number> {
        const response = await this.postBackOrdersOtherDemandsSaveRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Create order returning order\'s view
     */
    async postBackOrdersSaveRaw(requestParameters: PostBackOrdersSaveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OrderView>> {
        if (requestParameters.orderSavingView === null || requestParameters.orderSavingView === undefined) {
            throw new runtime.RequiredError('orderSavingView','Required parameter requestParameters.orderSavingView was null or undefined when calling postBackOrdersSave.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/orders/save`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.orderSavingView,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Create order returning order\'s view
     */
    async postBackOrdersSave(requestParameters: PostBackOrdersSaveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OrderView> {
        const response = await this.postBackOrdersSaveRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get similar orders
     */
    async postBackOrdersSimilarRaw(requestParameters: PostBackOrdersSimilarRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<SimilarOrderInfoView>>> {
        if (requestParameters.externalOrder === null || requestParameters.externalOrder === undefined) {
            throw new runtime.RequiredError('externalOrder','Required parameter requestParameters.externalOrder was null or undefined when calling postBackOrdersSimilar.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/orders/similar`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.externalOrder,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Get similar orders
     */
    async postBackOrdersSimilar(requestParameters: PostBackOrdersSimilarRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<SimilarOrderInfoView>> {
        const response = await this.postBackOrdersSimilarRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Create sales entries using created order
     */
    async postBackOrdersSplitRaw(requestParameters: PostBackOrdersSplitRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<number>> {
        if (requestParameters.externalOrder === null || requestParameters.externalOrder === undefined) {
            throw new runtime.RequiredError('externalOrder','Required parameter requestParameters.externalOrder was null or undefined when calling postBackOrdersSplit.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/orders/split`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.externalOrder,
        }, initOverrides);

        return new runtime.TextApiResponse(response) as any;
    }

    /**
     * Create sales entries using created order
     */
    async postBackOrdersSplit(requestParameters: PostBackOrdersSplitRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<number> {
        const response = await this.postBackOrdersSplitRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get time records for workers by order id
     */
    async postBackOrdersTimeRecordsRaw(requestParameters: PostBackOrdersTimeRecordsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TimeRecordEventView>> {
        if (requestParameters.timeRecordEventGetView === null || requestParameters.timeRecordEventGetView === undefined) {
            throw new runtime.RequiredError('timeRecordEventGetView','Required parameter requestParameters.timeRecordEventGetView was null or undefined when calling postBackOrdersTimeRecords.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/orders/time-records`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.timeRecordEventGetView,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Get time records for workers by order id
     */
    async postBackOrdersTimeRecords(requestParameters: PostBackOrdersTimeRecordsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TimeRecordEventView> {
        const response = await this.postBackOrdersTimeRecordsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Create order returning order\'s view
     */
    async postBackOrdersV2SaveRaw(requestParameters: PostBackOrdersV2SaveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OrderView>> {
        if (requestParameters.orderSavingViewV2 === null || requestParameters.orderSavingViewV2 === undefined) {
            throw new runtime.RequiredError('orderSavingViewV2','Required parameter requestParameters.orderSavingViewV2 was null or undefined when calling postBackOrdersV2Save.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/orders/v2/save`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.orderSavingViewV2,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Create order returning order\'s view
     */
    async postBackOrdersV2Save(requestParameters: PostBackOrdersV2SaveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OrderView> {
        const response = await this.postBackOrdersV2SaveRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Save external contractor data
     */
    async postBackPresentationsContractorExternalSaveRaw(requestParameters: PostBackPresentationsContractorExternalSaveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.externalContractorSavingView === null || requestParameters.externalContractorSavingView === undefined) {
            throw new runtime.RequiredError('externalContractorSavingView','Required parameter requestParameters.externalContractorSavingView was null or undefined when calling postBackPresentationsContractorExternalSave.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/presentations/contractor/external/save`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.externalContractorSavingView,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Save external contractor data
     */
    async postBackPresentationsContractorExternalSave(requestParameters: PostBackPresentationsContractorExternalSaveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.postBackPresentationsContractorExternalSaveRaw(requestParameters, initOverrides);
    }

    /**
     * Completes order without any additional data
     */
    async postBackPresentationsFastStatusTransitionOrderCompleteSalesentryidRaw(requestParameters: PostBackPresentationsFastStatusTransitionOrderCompleteSalesentryidRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.salesEntryId === null || requestParameters.salesEntryId === undefined) {
            throw new runtime.RequiredError('salesEntryId','Required parameter requestParameters.salesEntryId was null or undefined when calling postBackPresentationsFastStatusTransitionOrderCompleteSalesentryid.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/presentations/fast-status-transition/order/complete/{SalesEntryId}`.replace(`{${"SalesEntryId"}}`, encodeURIComponent(String(requestParameters.salesEntryId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Completes order without any additional data
     */
    async postBackPresentationsFastStatusTransitionOrderCompleteSalesentryid(requestParameters: PostBackPresentationsFastStatusTransitionOrderCompleteSalesentryidRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.postBackPresentationsFastStatusTransitionOrderCompleteSalesentryidRaw(requestParameters, initOverrides);
    }

    /**
     * Start order by changing it\'s status to InProgress
     */
    async postBackPresentationsFastStatusTransitionOrderStartSalesentryidRaw(requestParameters: PostBackPresentationsFastStatusTransitionOrderStartSalesentryidRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.salesEntryId === null || requestParameters.salesEntryId === undefined) {
            throw new runtime.RequiredError('salesEntryId','Required parameter requestParameters.salesEntryId was null or undefined when calling postBackPresentationsFastStatusTransitionOrderStartSalesentryid.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/presentations/fast-status-transition/order/start/{SalesEntryId}`.replace(`{${"SalesEntryId"}}`, encodeURIComponent(String(requestParameters.salesEntryId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Start order by changing it\'s status to InProgress
     */
    async postBackPresentationsFastStatusTransitionOrderStartSalesentryid(requestParameters: PostBackPresentationsFastStatusTransitionOrderStartSalesentryidRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.postBackPresentationsFastStatusTransitionOrderStartSalesentryidRaw(requestParameters, initOverrides);
    }

    /**
     * Order item costs group list
     */
    async postBackPresentationsOrderItemsItemsGroupListFilterRaw(requestParameters: PostBackPresentationsOrderItemsItemsGroupListFilterOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CompoundResultOrderItemCostsGroupListController>> {
        if (requestParameters.postBackPresentationsOrderItemsItemsGroupListFilterRequest === null || requestParameters.postBackPresentationsOrderItemsItemsGroupListFilterRequest === undefined) {
            throw new runtime.RequiredError('postBackPresentationsOrderItemsItemsGroupListFilterRequest','Required parameter requestParameters.postBackPresentationsOrderItemsItemsGroupListFilterRequest was null or undefined when calling postBackPresentationsOrderItemsItemsGroupListFilter.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/presentations/order-items/items-group/list/filter`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.postBackPresentationsOrderItemsItemsGroupListFilterRequest,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Order item costs group list
     */
    async postBackPresentationsOrderItemsItemsGroupListFilter(requestParameters: PostBackPresentationsOrderItemsItemsGroupListFilterOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CompoundResultOrderItemCostsGroupListController> {
        const response = await this.postBackPresentationsOrderItemsItemsGroupListFilterRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Production lot periods group list
     */
    async postBackPresentationsProductionLotPeriodsGroupListFilterRaw(requestParameters: PostBackPresentationsProductionLotPeriodsGroupListFilterOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CompoundResultProductionLotPeriodsGroupListController>> {
        if (requestParameters.postBackPresentationsProductionLotPeriodsGroupListFilterRequest === null || requestParameters.postBackPresentationsProductionLotPeriodsGroupListFilterRequest === undefined) {
            throw new runtime.RequiredError('postBackPresentationsProductionLotPeriodsGroupListFilterRequest','Required parameter requestParameters.postBackPresentationsProductionLotPeriodsGroupListFilterRequest was null or undefined when calling postBackPresentationsProductionLotPeriodsGroupListFilter.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/presentations/production-lot/periods-group/list/filter`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.postBackPresentationsProductionLotPeriodsGroupListFilterRequest,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Production lot periods group list
     */
    async postBackPresentationsProductionLotPeriodsGroupListFilter(requestParameters: PostBackPresentationsProductionLotPeriodsGroupListFilterOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CompoundResultProductionLotPeriodsGroupListController> {
        const response = await this.postBackPresentationsProductionLotPeriodsGroupListFilterRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Product catalog item list
     */
    async postBackProductcatalogListFilterRaw(requestParameters: PostBackProductcatalogListFilterOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CompoundResultProductCatalogListController>> {
        if (requestParameters.postBackProductcatalogListFilterRequest === null || requestParameters.postBackProductcatalogListFilterRequest === undefined) {
            throw new runtime.RequiredError('postBackProductcatalogListFilterRequest','Required parameter requestParameters.postBackProductcatalogListFilterRequest was null or undefined when calling postBackProductcatalogListFilter.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/productcatalog/list/filter`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.postBackProductcatalogListFilterRequest,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Product catalog item list
     */
    async postBackProductcatalogListFilter(requestParameters: PostBackProductcatalogListFilterOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CompoundResultProductCatalogListController> {
        const response = await this.postBackProductcatalogListFilterRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Accept production lot
     */
    async postBackProductionBoardActionsProductionLotProductionlotidAcceptRaw(requestParameters: PostBackProductionBoardActionsProductionLotProductionlotidAcceptRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<MessagesAction>>> {
        if (requestParameters.productionLotId === null || requestParameters.productionLotId === undefined) {
            throw new runtime.RequiredError('productionLotId','Required parameter requestParameters.productionLotId was null or undefined when calling postBackProductionBoardActionsProductionLotProductionlotidAccept.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/production-board/actions/production-lot/{ProductionLotId}/accept`.replace(`{${"ProductionLotId"}}`, encodeURIComponent(String(requestParameters.productionLotId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Accept production lot
     */
    async postBackProductionBoardActionsProductionLotProductionlotidAccept(requestParameters: PostBackProductionBoardActionsProductionLotProductionlotidAcceptRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<MessagesAction>> {
        const response = await this.postBackProductionBoardActionsProductionLotProductionlotidAcceptRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Unaccept production lot
     */
    async postBackProductionBoardActionsProductionLotProductionlotidUnacceptRaw(requestParameters: PostBackProductionBoardActionsProductionLotProductionlotidUnacceptRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<MessagesAction>>> {
        if (requestParameters.productionLotId === null || requestParameters.productionLotId === undefined) {
            throw new runtime.RequiredError('productionLotId','Required parameter requestParameters.productionLotId was null or undefined when calling postBackProductionBoardActionsProductionLotProductionlotidUnaccept.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/production-board/actions/production-lot/{ProductionLotId}/unaccept`.replace(`{${"ProductionLotId"}}`, encodeURIComponent(String(requestParameters.productionLotId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Unaccept production lot
     */
    async postBackProductionBoardActionsProductionLotProductionlotidUnaccept(requestParameters: PostBackProductionBoardActionsProductionLotProductionlotidUnacceptRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<MessagesAction>> {
        const response = await this.postBackProductionBoardActionsProductionLotProductionlotidUnacceptRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Automatically assign workers and save. Requires non-empty machineAreaIds, from/to, and workerGroupIds; only workers from those brigades (within the areas and date range) are considered.
     */
    async postBackProductionLotAutoAssignWorkersRaw(requestParameters: PostBackProductionLotAutoAssignWorkersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AutoAssignWorkersResultView>> {
        if (requestParameters.autoAssignWorkersRequest === null || requestParameters.autoAssignWorkersRequest === undefined) {
            throw new runtime.RequiredError('autoAssignWorkersRequest','Required parameter requestParameters.autoAssignWorkersRequest was null or undefined when calling postBackProductionLotAutoAssignWorkers.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/production/lot/auto-assign-workers`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.autoAssignWorkersRequest,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Automatically assign workers and save. Requires non-empty machineAreaIds, from/to, and workerGroupIds; only workers from those brigades (within the areas and date range) are considered.
     */
    async postBackProductionLotAutoAssignWorkers(requestParameters: PostBackProductionLotAutoAssignWorkersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AutoAssignWorkersResultView> {
        const response = await this.postBackProductionLotAutoAssignWorkersRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Automatically assign workers and save. Requires non-empty machineAreaIds and from/to. Considers all competence- and availability-qualified workers in the given machine areas (no brigade filter).
     */
    async postBackProductionLotAutoAssignWorkersOnAreasRaw(requestParameters: PostBackProductionLotAutoAssignWorkersOnAreasRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AutoAssignWorkersResultView>> {
        if (requestParameters.autoAssignWorkersOnAreasRequest === null || requestParameters.autoAssignWorkersOnAreasRequest === undefined) {
            throw new runtime.RequiredError('autoAssignWorkersOnAreasRequest','Required parameter requestParameters.autoAssignWorkersOnAreasRequest was null or undefined when calling postBackProductionLotAutoAssignWorkersOnAreas.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/production/lot/auto-assign-workers-on-areas`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.autoAssignWorkersOnAreasRequest,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Automatically assign workers and save. Requires non-empty machineAreaIds and from/to. Considers all competence- and availability-qualified workers in the given machine areas (no brigade filter).
     */
    async postBackProductionLotAutoAssignWorkersOnAreas(requestParameters: PostBackProductionLotAutoAssignWorkersOnAreasRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AutoAssignWorkersResultView> {
        const response = await this.postBackProductionLotAutoAssignWorkersOnAreasRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Cancel production lots
     */
    async postBackProductionLotCancelRaw(requestParameters: PostBackProductionLotCancelRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AjaxActionResponse>> {
        if (requestParameters.cancelProductionLots === null || requestParameters.cancelProductionLots === undefined) {
            throw new runtime.RequiredError('cancelProductionLots','Required parameter requestParameters.cancelProductionLots was null or undefined when calling postBackProductionLotCancel.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/production-lot/cancel`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.cancelProductionLots,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Cancel production lots
     */
    async postBackProductionLotCancel(requestParameters: PostBackProductionLotCancelRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AjaxActionResponse> {
        const response = await this.postBackProductionLotCancelRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Cancel production lots in column
     */
    async postBackProductionLotCancelColumnRaw(requestParameters: PostBackProductionLotCancelColumnRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AjaxActionResponse>> {
        if (requestParameters.cancelProductionLotsInColumn === null || requestParameters.cancelProductionLotsInColumn === undefined) {
            throw new runtime.RequiredError('cancelProductionLotsInColumn','Required parameter requestParameters.cancelProductionLotsInColumn was null or undefined when calling postBackProductionLotCancelColumn.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/production-lot/cancel/column`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.cancelProductionLotsInColumn,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Cancel production lots in column
     */
    async postBackProductionLotCancelColumn(requestParameters: PostBackProductionLotCancelColumnRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AjaxActionResponse> {
        const response = await this.postBackProductionLotCancelColumnRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Cancel production lot - legacy endpoint
     */
    async postBackProductionLotProductionlotidCancelLegacyRaw(requestParameters: PostBackProductionLotProductionlotidCancelLegacyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<MessagesAction>>> {
        if (requestParameters.productionLotId === null || requestParameters.productionLotId === undefined) {
            throw new runtime.RequiredError('productionLotId','Required parameter requestParameters.productionLotId was null or undefined when calling postBackProductionLotProductionlotidCancelLegacy.');
        }

        const queryParameters: any = {};

        if (requestParameters.machineIdOpt !== undefined) {
            queryParameters['machineIdOpt'] = requestParameters.machineIdOpt;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/production-lot/{ProductionLotId}/cancel/legacy`.replace(`{${"ProductionLotId"}}`, encodeURIComponent(String(requestParameters.productionLotId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Cancel production lot - legacy endpoint
     */
    async postBackProductionLotProductionlotidCancelLegacy(requestParameters: PostBackProductionLotProductionlotidCancelLegacyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<MessagesAction>> {
        const response = await this.postBackProductionLotProductionlotidCancelLegacyRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Calculate time for provided amount
     */
    async postBackProductionOrderCalculateTimeItemtypevariantidRaw(requestParameters: PostBackProductionOrderCalculateTimeItemtypevariantidRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<number>> {
        if (requestParameters.itemTypeVariantId === null || requestParameters.itemTypeVariantId === undefined) {
            throw new runtime.RequiredError('itemTypeVariantId','Required parameter requestParameters.itemTypeVariantId was null or undefined when calling postBackProductionOrderCalculateTimeItemtypevariantid.');
        }

        if (requestParameters.body === null || requestParameters.body === undefined) {
            throw new runtime.RequiredError('body','Required parameter requestParameters.body was null or undefined when calling postBackProductionOrderCalculateTimeItemtypevariantid.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/production-order/calculate-time/{ItemTypeVariantId}`.replace(`{${"ItemTypeVariantId"}}`, encodeURIComponent(String(requestParameters.itemTypeVariantId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.body as any,
        }, initOverrides);

        return new runtime.TextApiResponse(response) as any;
    }

    /**
     * Calculate time for provided amount
     */
    async postBackProductionOrderCalculateTimeItemtypevariantid(requestParameters: PostBackProductionOrderCalculateTimeItemtypevariantidRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<number> {
        const response = await this.postBackProductionOrderCalculateTimeItemtypevariantidRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Create production order based on queried simulation via its query payload
     */
    async postBackProductionOrderCreateQuickRaw(requestParameters: PostBackProductionOrderCreateQuickRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<number>>> {
        if (requestParameters.draft === null || requestParameters.draft === undefined) {
            throw new runtime.RequiredError('draft','Required parameter requestParameters.draft was null or undefined when calling postBackProductionOrderCreateQuick.');
        }

        if (requestParameters.simulationQueryPayload === null || requestParameters.simulationQueryPayload === undefined) {
            throw new runtime.RequiredError('simulationQueryPayload','Required parameter requestParameters.simulationQueryPayload was null or undefined when calling postBackProductionOrderCreateQuick.');
        }

        const queryParameters: any = {};

        if (requestParameters.draft !== undefined) {
            queryParameters['draft'] = requestParameters.draft;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/production/create-production-order/quick`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.simulationQueryPayload,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Create production order based on queried simulation via its query payload
     */
    async postBackProductionOrderCreateQuick(requestParameters: PostBackProductionOrderCreateQuickRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<number>> {
        const response = await this.postBackProductionOrderCreateQuickRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Save production order
     */
    async postBackProductionOrderOrderCreateRaw(requestParameters: PostBackProductionOrderOrderCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<number>>> {
        if (requestParameters.draft === null || requestParameters.draft === undefined) {
            throw new runtime.RequiredError('draft','Required parameter requestParameters.draft was null or undefined when calling postBackProductionOrderOrderCreate.');
        }

        if (requestParameters.productionOrderSavingView === null || requestParameters.productionOrderSavingView === undefined) {
            throw new runtime.RequiredError('productionOrderSavingView','Required parameter requestParameters.productionOrderSavingView was null or undefined when calling postBackProductionOrderOrderCreate.');
        }

        const queryParameters: any = {};

        if (requestParameters.draft !== undefined) {
            queryParameters['draft'] = requestParameters.draft;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/production/order/save`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.productionOrderSavingView,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Save production order
     */
    async postBackProductionOrderOrderCreate(requestParameters: PostBackProductionOrderOrderCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<number>> {
        const response = await this.postBackProductionOrderOrderCreateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Cancel production order and its lots
     */
    async postBackProductionOrderOrderProductionorderidCancelRaw(requestParameters: PostBackProductionOrderOrderProductionorderidCancelRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.productionOrderId === null || requestParameters.productionOrderId === undefined) {
            throw new runtime.RequiredError('productionOrderId','Required parameter requestParameters.productionOrderId was null or undefined when calling postBackProductionOrderOrderProductionorderidCancel.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/production-order/order/{ProductionOrderId}/cancel`.replace(`{${"ProductionOrderId"}}`, encodeURIComponent(String(requestParameters.productionOrderId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Cancel production order and its lots
     */
    async postBackProductionOrderOrderProductionorderidCancel(requestParameters: PostBackProductionOrderOrderProductionorderidCancelRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.postBackProductionOrderOrderProductionorderidCancelRaw(requestParameters, initOverrides);
    }

    /**
     * Edit production order\'s tags and priority
     */
    async postBackProductionOrderOrderProductionorderidEditRaw(requestParameters: PostBackProductionOrderOrderProductionorderidEditRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.productionOrderId === null || requestParameters.productionOrderId === undefined) {
            throw new runtime.RequiredError('productionOrderId','Required parameter requestParameters.productionOrderId was null or undefined when calling postBackProductionOrderOrderProductionorderidEdit.');
        }

        if (requestParameters.productionOrderEditView === null || requestParameters.productionOrderEditView === undefined) {
            throw new runtime.RequiredError('productionOrderEditView','Required parameter requestParameters.productionOrderEditView was null or undefined when calling postBackProductionOrderOrderProductionorderidEdit.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/production-order/order/{ProductionOrderId}/edit`.replace(`{${"ProductionOrderId"}}`, encodeURIComponent(String(requestParameters.productionOrderId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.productionOrderEditView,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Edit production order\'s tags and priority
     */
    async postBackProductionOrderOrderProductionorderidEdit(requestParameters: PostBackProductionOrderOrderProductionorderidEditRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.postBackProductionOrderOrderProductionorderidEditRaw(requestParameters, initOverrides);
    }

    /**
     * Get full simulation of lots that would be created for provided demands
     */
    async postBackProductionOrderSimulationGetRaw(requestParameters: PostBackProductionOrderSimulationGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SimulationView>> {
        if (requestParameters.simulationQueryPayload === null || requestParameters.simulationQueryPayload === undefined) {
            throw new runtime.RequiredError('simulationQueryPayload','Required parameter requestParameters.simulationQueryPayload was null or undefined when calling postBackProductionOrderSimulationGet.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/production-order/simulation/get`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.simulationQueryPayload,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Get full simulation of lots that would be created for provided demands
     */
    async postBackProductionOrderSimulationGet(requestParameters: PostBackProductionOrderSimulationGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SimulationView> {
        const response = await this.postBackProductionOrderSimulationGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get saved simulation
     */
    async postBackProductionOrderSimulationGetProductionorderidRaw(requestParameters: PostBackProductionOrderSimulationGetProductionorderidRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SimulationView>> {
        if (requestParameters.productionOrderId === null || requestParameters.productionOrderId === undefined) {
            throw new runtime.RequiredError('productionOrderId','Required parameter requestParameters.productionOrderId was null or undefined when calling postBackProductionOrderSimulationGetProductionorderid.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/production-order/simulation/get/{ProductionOrderId}`.replace(`{${"ProductionOrderId"}}`, encodeURIComponent(String(requestParameters.productionOrderId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Get saved simulation
     */
    async postBackProductionOrderSimulationGetProductionorderid(requestParameters: PostBackProductionOrderSimulationGetProductionorderidRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SimulationView> {
        const response = await this.postBackProductionOrderSimulationGetProductionorderidRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get simulation of lots that would be created for provided demands
     */
    async postBackProductionOrderSimulationQueryRaw(requestParameters: PostBackProductionOrderSimulationQueryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SimulationQueryView>> {
        if (requestParameters.simulationQueryPayload === null || requestParameters.simulationQueryPayload === undefined) {
            throw new runtime.RequiredError('simulationQueryPayload','Required parameter requestParameters.simulationQueryPayload was null or undefined when calling postBackProductionOrderSimulationQuery.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/production-order/simulation/query`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.simulationQueryPayload,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Get simulation of lots that would be created for provided demands
     */
    async postBackProductionOrderSimulationQuery(requestParameters: PostBackProductionOrderSimulationQueryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SimulationQueryView> {
        const response = await this.postBackProductionOrderSimulationQueryRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Production orders creator list
     */
    async postBackProductionOrdersCreatorListFilterRaw(requestParameters: PostBackProductionOrdersCreatorListFilterOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CompoundResultProductionOrderCreatorListController>> {
        if (requestParameters.postBackProductionOrdersCreatorListFilterRequest === null || requestParameters.postBackProductionOrdersCreatorListFilterRequest === undefined) {
            throw new runtime.RequiredError('postBackProductionOrdersCreatorListFilterRequest','Required parameter requestParameters.postBackProductionOrdersCreatorListFilterRequest was null or undefined when calling postBackProductionOrdersCreatorListFilter.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/production-orders/creator/list/filter`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.postBackProductionOrdersCreatorListFilterRequest,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Production orders creator list
     */
    async postBackProductionOrdersCreatorListFilter(requestParameters: PostBackProductionOrdersCreatorListFilterOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CompoundResultProductionOrderCreatorListController> {
        const response = await this.postBackProductionOrdersCreatorListFilterRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Production orders list
     */
    async postBackProductionOrdersLegacyListFilterRaw(requestParameters: PostBackProductionOrdersLegacyListFilterOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CompoundResultLegacyProductionOrdersListController>> {
        if (requestParameters.postBackProductionOrdersLegacyListFilterRequest === null || requestParameters.postBackProductionOrdersLegacyListFilterRequest === undefined) {
            throw new runtime.RequiredError('postBackProductionOrdersLegacyListFilterRequest','Required parameter requestParameters.postBackProductionOrdersLegacyListFilterRequest was null or undefined when calling postBackProductionOrdersLegacyListFilter.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/production-orders/legacy/list/filter`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.postBackProductionOrdersLegacyListFilterRequest,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Production orders list
     */
    async postBackProductionOrdersLegacyListFilter(requestParameters: PostBackProductionOrdersLegacyListFilterOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CompoundResultLegacyProductionOrdersListController> {
        const response = await this.postBackProductionOrdersLegacyListFilterRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Production lot legacy list
     */
    async postBackProductionOrdersLegacyLotsFilterRaw(requestParameters: PostBackProductionOrdersLegacyLotsFilterOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CompoundResultLegacyProductionLotListController>> {
        if (requestParameters.postBackProductionOrdersLegacyLotsFilterRequest === null || requestParameters.postBackProductionOrdersLegacyLotsFilterRequest === undefined) {
            throw new runtime.RequiredError('postBackProductionOrdersLegacyLotsFilterRequest','Required parameter requestParameters.postBackProductionOrdersLegacyLotsFilterRequest was null or undefined when calling postBackProductionOrdersLegacyLotsFilter.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/production-orders/legacy/lots/filter`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.postBackProductionOrdersLegacyLotsFilterRequest,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Production lot legacy list
     */
    async postBackProductionOrdersLegacyLotsFilter(requestParameters: PostBackProductionOrdersLegacyLotsFilterOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CompoundResultLegacyProductionLotListController> {
        const response = await this.postBackProductionOrdersLegacyLotsFilterRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Production orders list
     */
    async postBackProductionOrdersListFilterRaw(requestParameters: PostBackProductionOrdersListFilterOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CompoundResultProductionOrdersListController>> {
        if (requestParameters.postBackProductionOrdersListFilterRequest === null || requestParameters.postBackProductionOrdersListFilterRequest === undefined) {
            throw new runtime.RequiredError('postBackProductionOrdersListFilterRequest','Required parameter requestParameters.postBackProductionOrdersListFilterRequest was null or undefined when calling postBackProductionOrdersListFilter.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/production-orders/list/filter`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.postBackProductionOrdersListFilterRequest,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Production orders list
     */
    async postBackProductionOrdersListFilter(requestParameters: PostBackProductionOrdersListFilterOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CompoundResultProductionOrdersListController> {
        const response = await this.postBackProductionOrdersListFilterRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Production lot details raw materials usage list
     */
    async postBackProductionOrdersLotRawMaterialsUsageListFilterRaw(requestParameters: PostBackProductionOrdersLotRawMaterialsUsageListFilterOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CompoundResultProductionLotRawMaterialsUsageListController>> {
        if (requestParameters.postBackProductionOrdersLotRawMaterialsUsageListFilterRequest === null || requestParameters.postBackProductionOrdersLotRawMaterialsUsageListFilterRequest === undefined) {
            throw new runtime.RequiredError('postBackProductionOrdersLotRawMaterialsUsageListFilterRequest','Required parameter requestParameters.postBackProductionOrdersLotRawMaterialsUsageListFilterRequest was null or undefined when calling postBackProductionOrdersLotRawMaterialsUsageListFilter.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/production-orders/lot/raw-materials-usage/list/filter`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.postBackProductionOrdersLotRawMaterialsUsageListFilterRequest,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Production lot details raw materials usage list
     */
    async postBackProductionOrdersLotRawMaterialsUsageListFilter(requestParameters: PostBackProductionOrdersLotRawMaterialsUsageListFilterOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CompoundResultProductionLotRawMaterialsUsageListController> {
        const response = await this.postBackProductionOrdersLotRawMaterialsUsageListFilterRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Production lot list
     */
    async postBackProductionOrdersLotsListFilterRaw(requestParameters: PostBackProductionOrdersLotsListFilterOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CompoundResultProductionLotListController>> {
        if (requestParameters.postBackProductionOrdersLotsListFilterRequest === null || requestParameters.postBackProductionOrdersLotsListFilterRequest === undefined) {
            throw new runtime.RequiredError('postBackProductionOrdersLotsListFilterRequest','Required parameter requestParameters.postBackProductionOrdersLotsListFilterRequest was null or undefined when calling postBackProductionOrdersLotsListFilter.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/production-orders/lots/list/filter`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.postBackProductionOrdersLotsListFilterRequest,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Production lot list
     */
    async postBackProductionOrdersLotsListFilter(requestParameters: PostBackProductionOrdersLotsListFilterOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CompoundResultProductionLotListController> {
        const response = await this.postBackProductionOrdersLotsListFilterRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Order demands to production list
     */
    async postBackProductionOrdersOrderDemandsListFilterRaw(requestParameters: PostBackProductionOrdersOrderDemandsListFilterOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CompoundResultOrderDemandsToProductionListController>> {
        if (requestParameters.postBackProductionOrdersOrderDemandsListFilterRequest === null || requestParameters.postBackProductionOrdersOrderDemandsListFilterRequest === undefined) {
            throw new runtime.RequiredError('postBackProductionOrdersOrderDemandsListFilterRequest','Required parameter requestParameters.postBackProductionOrdersOrderDemandsListFilterRequest was null or undefined when calling postBackProductionOrdersOrderDemandsListFilter.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/production-orders/order-demands/list/filter`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.postBackProductionOrdersOrderDemandsListFilterRequest,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Order demands to production list
     */
    async postBackProductionOrdersOrderDemandsListFilter(requestParameters: PostBackProductionOrdersOrderDemandsListFilterOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CompoundResultOrderDemandsToProductionListController> {
        const response = await this.postBackProductionOrdersOrderDemandsListFilterRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Production lots for production order details
     */
    async postBackProductionOrdersProductionOrderLotsListFilterRaw(requestParameters: PostBackProductionOrdersProductionOrderLotsListFilterOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CompoundResultProductionOrderLotListController>> {
        if (requestParameters.postBackProductionOrdersProductionOrderLotsListFilterRequest === null || requestParameters.postBackProductionOrdersProductionOrderLotsListFilterRequest === undefined) {
            throw new runtime.RequiredError('postBackProductionOrdersProductionOrderLotsListFilterRequest','Required parameter requestParameters.postBackProductionOrdersProductionOrderLotsListFilterRequest was null or undefined when calling postBackProductionOrdersProductionOrderLotsListFilter.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/production-orders/production-order-lots/list/filter`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.postBackProductionOrdersProductionOrderLotsListFilterRequest,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Production lots for production order details
     */
    async postBackProductionOrdersProductionOrderLotsListFilter(requestParameters: PostBackProductionOrdersProductionOrderLotsListFilterOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CompoundResultProductionOrderLotListController> {
        const response = await this.postBackProductionOrdersProductionOrderLotsListFilterRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Production order details raw materials usage list
     */
    async postBackProductionOrdersRawMaterialsUsageListFilterRaw(requestParameters: PostBackProductionOrdersRawMaterialsUsageListFilterOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CompoundResultProductionOrderRawMaterialsUsageListController>> {
        if (requestParameters.postBackProductionOrdersRawMaterialsUsageListFilterRequest === null || requestParameters.postBackProductionOrdersRawMaterialsUsageListFilterRequest === undefined) {
            throw new runtime.RequiredError('postBackProductionOrdersRawMaterialsUsageListFilterRequest','Required parameter requestParameters.postBackProductionOrdersRawMaterialsUsageListFilterRequest was null or undefined when calling postBackProductionOrdersRawMaterialsUsageListFilter.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/production-orders/raw-materials-usage/list/filter`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.postBackProductionOrdersRawMaterialsUsageListFilterRequest,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Production order details raw materials usage list
     */
    async postBackProductionOrdersRawMaterialsUsageListFilter(requestParameters: PostBackProductionOrdersRawMaterialsUsageListFilterOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CompoundResultProductionOrderRawMaterialsUsageListController> {
        const response = await this.postBackProductionOrdersRawMaterialsUsageListFilterRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Warehouse states
     */
    async postBackProductionOrdersWarehouseStateListFilterRaw(requestParameters: PostBackProductionOrdersWarehouseStateListFilterOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CompoundResultWarehouseStateListController>> {
        if (requestParameters.postBackProductionOrdersWarehouseStateListFilterRequest === null || requestParameters.postBackProductionOrdersWarehouseStateListFilterRequest === undefined) {
            throw new runtime.RequiredError('postBackProductionOrdersWarehouseStateListFilterRequest','Required parameter requestParameters.postBackProductionOrdersWarehouseStateListFilterRequest was null or undefined when calling postBackProductionOrdersWarehouseStateListFilter.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/production-orders/warehouse-state/list/filter`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.postBackProductionOrdersWarehouseStateListFilterRequest,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Warehouse states
     */
    async postBackProductionOrdersWarehouseStateListFilter(requestParameters: PostBackProductionOrdersWarehouseStateListFilterOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CompoundResultWarehouseStateListController> {
        const response = await this.postBackProductionOrdersWarehouseStateListFilterRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Warehouse state to production list controller
     */
    async postBackProductionOrdersWarehouseToProductionListFilterRaw(requestParameters: PostBackProductionOrdersWarehouseToProductionListFilterOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CompoundResultWarehouseStateToProductionListController>> {
        if (requestParameters.postBackProductionOrdersWarehouseToProductionListFilterRequest === null || requestParameters.postBackProductionOrdersWarehouseToProductionListFilterRequest === undefined) {
            throw new runtime.RequiredError('postBackProductionOrdersWarehouseToProductionListFilterRequest','Required parameter requestParameters.postBackProductionOrdersWarehouseToProductionListFilterRequest was null or undefined when calling postBackProductionOrdersWarehouseToProductionListFilter.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/production-orders/warehouse-to-production/list/filter`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.postBackProductionOrdersWarehouseToProductionListFilterRequest,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Warehouse state to production list controller
     */
    async postBackProductionOrdersWarehouseToProductionListFilter(requestParameters: PostBackProductionOrdersWarehouseToProductionListFilterOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CompoundResultWarehouseStateToProductionListController> {
        const response = await this.postBackProductionOrdersWarehouseToProductionListFilterRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Production order details worktime list
     */
    async postBackProductionOrdersWorktimeListFilterRaw(requestParameters: PostBackProductionOrdersWorktimeListFilterOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CompoundResultProductionOrderWorktimeListController>> {
        if (requestParameters.postBackProductionOrdersWorktimeListFilterRequest === null || requestParameters.postBackProductionOrdersWorktimeListFilterRequest === undefined) {
            throw new runtime.RequiredError('postBackProductionOrdersWorktimeListFilterRequest','Required parameter requestParameters.postBackProductionOrdersWorktimeListFilterRequest was null or undefined when calling postBackProductionOrdersWorktimeListFilter.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/production-orders/worktime/list/filter`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.postBackProductionOrdersWorktimeListFilterRequest,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Production order details worktime list
     */
    async postBackProductionOrdersWorktimeListFilter(requestParameters: PostBackProductionOrdersWorktimeListFilterOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CompoundResultProductionOrderWorktimeListController> {
        const response = await this.postBackProductionOrdersWorktimeListFilterRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Production lot tag list
     */
    async postBackProductionSpecificationTagsListFilterRaw(requestParameters: PostBackProductionSpecificationTagsListFilterOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CompoundResultProductionLotTagListController>> {
        if (requestParameters.postBackProductionSpecificationTagsListFilterRequest === null || requestParameters.postBackProductionSpecificationTagsListFilterRequest === undefined) {
            throw new runtime.RequiredError('postBackProductionSpecificationTagsListFilterRequest','Required parameter requestParameters.postBackProductionSpecificationTagsListFilterRequest was null or undefined when calling postBackProductionSpecificationTagsListFilter.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/production-specification/tags/list/filter`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.postBackProductionSpecificationTagsListFilterRequest,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Production lot tag list
     */
    async postBackProductionSpecificationTagsListFilter(requestParameters: PostBackProductionSpecificationTagsListFilterOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CompoundResultProductionLotTagListController> {
        const response = await this.postBackProductionSpecificationTagsListFilterRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Cancel synchronization
     */
    async postBackPushCancelDocumenttypeTargetidRaw(requestParameters: PostBackPushCancelDocumenttypeTargetidRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.documentType === null || requestParameters.documentType === undefined) {
            throw new runtime.RequiredError('documentType','Required parameter requestParameters.documentType was null or undefined when calling postBackPushCancelDocumenttypeTargetid.');
        }

        if (requestParameters.targetId === null || requestParameters.targetId === undefined) {
            throw new runtime.RequiredError('targetId','Required parameter requestParameters.targetId was null or undefined when calling postBackPushCancelDocumenttypeTargetid.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/push/cancel/{DocumentType}/{TargetId}`.replace(`{${"DocumentType"}}`, encodeURIComponent(String(requestParameters.documentType))).replace(`{${"TargetId"}}`, encodeURIComponent(String(requestParameters.targetId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Cancel synchronization
     */
    async postBackPushCancelDocumenttypeTargetid(requestParameters: PostBackPushCancelDocumenttypeTargetidRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.postBackPushCancelDocumenttypeTargetidRaw(requestParameters, initOverrides);
    }

    /**
     * Force synchronization
     */
    async postBackPushForceDocumenttypeTargetidRaw(requestParameters: PostBackPushForceDocumenttypeTargetidRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.documentType === null || requestParameters.documentType === undefined) {
            throw new runtime.RequiredError('documentType','Required parameter requestParameters.documentType was null or undefined when calling postBackPushForceDocumenttypeTargetid.');
        }

        if (requestParameters.targetId === null || requestParameters.targetId === undefined) {
            throw new runtime.RequiredError('targetId','Required parameter requestParameters.targetId was null or undefined when calling postBackPushForceDocumenttypeTargetid.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/push/force/{DocumentType}/{TargetId}`.replace(`{${"DocumentType"}}`, encodeURIComponent(String(requestParameters.documentType))).replace(`{${"TargetId"}}`, encodeURIComponent(String(requestParameters.targetId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Force synchronization
     */
    async postBackPushForceDocumenttypeTargetid(requestParameters: PostBackPushForceDocumenttypeTargetidRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.postBackPushForceDocumenttypeTargetidRaw(requestParameters, initOverrides);
    }

    /**
     * Push status list
     */
    async postBackPushListFilterRaw(requestParameters: PostBackPushListFilterOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CompoundResultPushStatusListController>> {
        if (requestParameters.postBackPushListFilterRequest === null || requestParameters.postBackPushListFilterRequest === undefined) {
            throw new runtime.RequiredError('postBackPushListFilterRequest','Required parameter requestParameters.postBackPushListFilterRequest was null or undefined when calling postBackPushListFilter.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/push/list/filter`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.postBackPushListFilterRequest,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Push status list
     */
    async postBackPushListFilter(requestParameters: PostBackPushListFilterOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CompoundResultPushStatusListController> {
        const response = await this.postBackPushListFilterRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Supply cards list
     */
    async postBackQsCardListFilterRaw(requestParameters: PostBackQsCardListFilterOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CompoundResultSupplyCardListController>> {
        if (requestParameters.postBackQsCardListFilterRequest === null || requestParameters.postBackQsCardListFilterRequest === undefined) {
            throw new runtime.RequiredError('postBackQsCardListFilterRequest','Required parameter requestParameters.postBackQsCardListFilterRequest was null or undefined when calling postBackQsCardListFilter.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/qs/card/list/filter`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.postBackQsCardListFilterRequest,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Supply cards list
     */
    async postBackQsCardListFilter(requestParameters: PostBackQsCardListFilterOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CompoundResultSupplyCardListController> {
        const response = await this.postBackQsCardListFilterRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Create planned supply card
     */
    async postBackQsPlannedSupplyCardCreateRaw(requestParameters: PostBackQsPlannedSupplyCardCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<number>> {
        if (requestParameters.plannedSupplyCardCreateView === null || requestParameters.plannedSupplyCardCreateView === undefined) {
            throw new runtime.RequiredError('plannedSupplyCardCreateView','Required parameter requestParameters.plannedSupplyCardCreateView was null or undefined when calling postBackQsPlannedSupplyCardCreate.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/qs/planned/supply-card/create`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.plannedSupplyCardCreateView,
        }, initOverrides);

        return new runtime.TextApiResponse(response) as any;
    }

    /**
     * Create planned supply card
     */
    async postBackQsPlannedSupplyCardCreate(requestParameters: PostBackQsPlannedSupplyCardCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<number> {
        const response = await this.postBackQsPlannedSupplyCardCreateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Create spontaneous supply card
     */
    async postBackQsSpontaneousSupplyCardCreateRaw(requestParameters: PostBackQsSpontaneousSupplyCardCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<number>> {
        if (requestParameters.spontaneousSupplyCardCreateView === null || requestParameters.spontaneousSupplyCardCreateView === undefined) {
            throw new runtime.RequiredError('spontaneousSupplyCardCreateView','Required parameter requestParameters.spontaneousSupplyCardCreateView was null or undefined when calling postBackQsSpontaneousSupplyCardCreate.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/qs/spontaneous/supply-card/create`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.spontaneousSupplyCardCreateView,
        }, initOverrides);

        return new runtime.TextApiResponse(response) as any;
    }

    /**
     * Create spontaneous supply card
     */
    async postBackQsSpontaneousSupplyCardCreate(requestParameters: PostBackQsSpontaneousSupplyCardCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<number> {
        const response = await this.postBackQsSpontaneousSupplyCardCreateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Releases list
     */
    async postBackReleasesListFilterRaw(requestParameters: PostBackReleasesListFilterOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CompoundResultReleaseListController>> {
        if (requestParameters.postBackReleasesListFilterRequest === null || requestParameters.postBackReleasesListFilterRequest === undefined) {
            throw new runtime.RequiredError('postBackReleasesListFilterRequest','Required parameter requestParameters.postBackReleasesListFilterRequest was null or undefined when calling postBackReleasesListFilter.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/releases/list/filter`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.postBackReleasesListFilterRequest,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Releases list
     */
    async postBackReleasesListFilter(requestParameters: PostBackReleasesListFilterOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CompoundResultReleaseListController> {
        const response = await this.postBackReleasesListFilterRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Release plans list
     */
    async postBackReleasesPlanListFilterRaw(requestParameters: PostBackReleasesPlanListFilterOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CompoundResultReleasePlanListController>> {
        if (requestParameters.postBackReleasesPlanListFilterRequest === null || requestParameters.postBackReleasesPlanListFilterRequest === undefined) {
            throw new runtime.RequiredError('postBackReleasesPlanListFilterRequest','Required parameter requestParameters.postBackReleasesPlanListFilterRequest was null or undefined when calling postBackReleasesPlanListFilter.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/releases/plan/list/filter`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.postBackReleasesPlanListFilterRequest,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Release plans list
     */
    async postBackReleasesPlanListFilter(requestParameters: PostBackReleasesPlanListFilterOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CompoundResultReleasePlanListController> {
        const response = await this.postBackReleasesPlanListFilterRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Downtime reasons list
     */
    async postBackReportsDowntimeReasonsFilterRaw(requestParameters: PostBackReportsDowntimeReasonsFilterOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CompoundResultDowntimeReasonsListController>> {
        if (requestParameters.postBackReportsDowntimeReasonsFilterRequest === null || requestParameters.postBackReportsDowntimeReasonsFilterRequest === undefined) {
            throw new runtime.RequiredError('postBackReportsDowntimeReasonsFilterRequest','Required parameter requestParameters.postBackReportsDowntimeReasonsFilterRequest was null or undefined when calling postBackReportsDowntimeReasonsFilter.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/reports/downtime-reasons/filter`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.postBackReportsDowntimeReasonsFilterRequest,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Downtime reasons list
     */
    async postBackReportsDowntimeReasonsFilter(requestParameters: PostBackReportsDowntimeReasonsFilterOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CompoundResultDowntimeReasonsListController> {
        const response = await this.postBackReportsDowntimeReasonsFilterRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get absentees list
     */
    async postBackReportsGroupLeaderDashboardAbsenteesRaw(requestParameters: PostBackReportsGroupLeaderDashboardAbsenteesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AbsenteesResponse>> {
        if (requestParameters.groupLeaderDashboardFilters === null || requestParameters.groupLeaderDashboardFilters === undefined) {
            throw new runtime.RequiredError('groupLeaderDashboardFilters','Required parameter requestParameters.groupLeaderDashboardFilters was null or undefined when calling postBackReportsGroupLeaderDashboardAbsentees.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/reports/group-leader-dashboard/absentees`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.groupLeaderDashboardFilters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Get absentees list
     */
    async postBackReportsGroupLeaderDashboardAbsentees(requestParameters: PostBackReportsGroupLeaderDashboardAbsenteesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AbsenteesResponse> {
        const response = await this.postBackReportsGroupLeaderDashboardAbsenteesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get availability details with per-workstation breakdown
     */
    async postBackReportsGroupLeaderDashboardAvailabilityRaw(requestParameters: PostBackReportsGroupLeaderDashboardAvailabilityRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AvailabilityDetailsResponse>> {
        if (requestParameters.groupLeaderDashboardFilters === null || requestParameters.groupLeaderDashboardFilters === undefined) {
            throw new runtime.RequiredError('groupLeaderDashboardFilters','Required parameter requestParameters.groupLeaderDashboardFilters was null or undefined when calling postBackReportsGroupLeaderDashboardAvailability.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/reports/group-leader-dashboard/availability`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.groupLeaderDashboardFilters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Get availability details with per-workstation breakdown
     */
    async postBackReportsGroupLeaderDashboardAvailability(requestParameters: PostBackReportsGroupLeaderDashboardAvailabilityRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AvailabilityDetailsResponse> {
        const response = await this.postBackReportsGroupLeaderDashboardAvailabilityRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get downtimes over time
     */
    async postBackReportsGroupLeaderDashboardDowntimesOverTimeRaw(requestParameters: PostBackReportsGroupLeaderDashboardDowntimesOverTimeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DowntimesOverTimeResponse>> {
        if (requestParameters.downtimesOverTimeRequest === null || requestParameters.downtimesOverTimeRequest === undefined) {
            throw new runtime.RequiredError('downtimesOverTimeRequest','Required parameter requestParameters.downtimesOverTimeRequest was null or undefined when calling postBackReportsGroupLeaderDashboardDowntimesOverTime.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/reports/group-leader-dashboard/downtimes-over-time`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.downtimesOverTimeRequest,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Get downtimes over time
     */
    async postBackReportsGroupLeaderDashboardDowntimesOverTime(requestParameters: PostBackReportsGroupLeaderDashboardDowntimesOverTimeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DowntimesOverTimeResponse> {
        const response = await this.postBackReportsGroupLeaderDashboardDowntimesOverTimeRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get latest events
     */
    async postBackReportsGroupLeaderDashboardLatestEventsRaw(requestParameters: PostBackReportsGroupLeaderDashboardLatestEventsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GroupLeaderEventsResponse>> {
        if (requestParameters.groupLeaderDashboardFilters === null || requestParameters.groupLeaderDashboardFilters === undefined) {
            throw new runtime.RequiredError('groupLeaderDashboardFilters','Required parameter requestParameters.groupLeaderDashboardFilters was null or undefined when calling postBackReportsGroupLeaderDashboardLatestEvents.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/reports/group-leader-dashboard/latest-events`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.groupLeaderDashboardFilters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Get latest events
     */
    async postBackReportsGroupLeaderDashboardLatestEvents(requestParameters: PostBackReportsGroupLeaderDashboardLatestEventsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GroupLeaderEventsResponse> {
        const response = await this.postBackReportsGroupLeaderDashboardLatestEventsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get NOK status over time (mock)
     */
    async postBackReportsGroupLeaderDashboardNoksOverTimeRaw(requestParameters: PostBackReportsGroupLeaderDashboardNoksOverTimeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<NoksOverTimeResponse>> {
        if (requestParameters.noksOverTimeRequest === null || requestParameters.noksOverTimeRequest === undefined) {
            throw new runtime.RequiredError('noksOverTimeRequest','Required parameter requestParameters.noksOverTimeRequest was null or undefined when calling postBackReportsGroupLeaderDashboardNoksOverTime.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/reports/group-leader-dashboard/noks-over-time`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.noksOverTimeRequest,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Get NOK status over time (mock)
     */
    async postBackReportsGroupLeaderDashboardNoksOverTime(requestParameters: PostBackReportsGroupLeaderDashboardNoksOverTimeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<NoksOverTimeResponse> {
        const response = await this.postBackReportsGroupLeaderDashboardNoksOverTimeRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get OEE (Overall Equipment Effectiveness) data
     */
    async postBackReportsGroupLeaderDashboardOeeRaw(requestParameters: PostBackReportsGroupLeaderDashboardOeeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OeeResponse>> {
        if (requestParameters.groupLeaderDashboardFilters === null || requestParameters.groupLeaderDashboardFilters === undefined) {
            throw new runtime.RequiredError('groupLeaderDashboardFilters','Required parameter requestParameters.groupLeaderDashboardFilters was null or undefined when calling postBackReportsGroupLeaderDashboardOee.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/reports/group-leader-dashboard/oee`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.groupLeaderDashboardFilters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Get OEE (Overall Equipment Effectiveness) data
     */
    async postBackReportsGroupLeaderDashboardOee(requestParameters: PostBackReportsGroupLeaderDashboardOeeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OeeResponse> {
        const response = await this.postBackReportsGroupLeaderDashboardOeeRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get performance details with per-workstation breakdown
     */
    async postBackReportsGroupLeaderDashboardPerformanceRaw(requestParameters: PostBackReportsGroupLeaderDashboardPerformanceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PerformanceDetailsResponse>> {
        if (requestParameters.groupLeaderDashboardFilters === null || requestParameters.groupLeaderDashboardFilters === undefined) {
            throw new runtime.RequiredError('groupLeaderDashboardFilters','Required parameter requestParameters.groupLeaderDashboardFilters was null or undefined when calling postBackReportsGroupLeaderDashboardPerformance.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/reports/group-leader-dashboard/performance`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.groupLeaderDashboardFilters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Get performance details with per-workstation breakdown
     */
    async postBackReportsGroupLeaderDashboardPerformance(requestParameters: PostBackReportsGroupLeaderDashboardPerformanceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PerformanceDetailsResponse> {
        const response = await this.postBackReportsGroupLeaderDashboardPerformanceRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get quality details with per-workstation breakdown
     */
    async postBackReportsGroupLeaderDashboardQualityRaw(requestParameters: PostBackReportsGroupLeaderDashboardQualityRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<QualityDetailsResponse>> {
        if (requestParameters.groupLeaderDashboardFilters === null || requestParameters.groupLeaderDashboardFilters === undefined) {
            throw new runtime.RequiredError('groupLeaderDashboardFilters','Required parameter requestParameters.groupLeaderDashboardFilters was null or undefined when calling postBackReportsGroupLeaderDashboardQuality.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/reports/group-leader-dashboard/quality`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.groupLeaderDashboardFilters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Get quality details with per-workstation breakdown
     */
    async postBackReportsGroupLeaderDashboardQuality(requestParameters: PostBackReportsGroupLeaderDashboardQualityRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<QualityDetailsResponse> {
        const response = await this.postBackReportsGroupLeaderDashboardQualityRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get top 5 downtime causes, products, and employees
     */
    async postBackReportsGroupLeaderDashboardTopDowntimesRaw(requestParameters: PostBackReportsGroupLeaderDashboardTopDowntimesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TopDowntimesResponse>> {
        if (requestParameters.groupLeaderDashboardFilters === null || requestParameters.groupLeaderDashboardFilters === undefined) {
            throw new runtime.RequiredError('groupLeaderDashboardFilters','Required parameter requestParameters.groupLeaderDashboardFilters was null or undefined when calling postBackReportsGroupLeaderDashboardTopDowntimes.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/reports/group-leader-dashboard/top-downtimes`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.groupLeaderDashboardFilters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Get top 5 downtime causes, products, and employees
     */
    async postBackReportsGroupLeaderDashboardTopDowntimes(requestParameters: PostBackReportsGroupLeaderDashboardTopDowntimesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TopDowntimesResponse> {
        const response = await this.postBackReportsGroupLeaderDashboardTopDowntimesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get top 5 NOK causes, products, and employees (mock)
     */
    async postBackReportsGroupLeaderDashboardTopNoksRaw(requestParameters: PostBackReportsGroupLeaderDashboardTopNoksRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TopNoksResponse>> {
        if (requestParameters.groupLeaderDashboardFilters === null || requestParameters.groupLeaderDashboardFilters === undefined) {
            throw new runtime.RequiredError('groupLeaderDashboardFilters','Required parameter requestParameters.groupLeaderDashboardFilters was null or undefined when calling postBackReportsGroupLeaderDashboardTopNoks.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/reports/group-leader-dashboard/top-noks`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.groupLeaderDashboardFilters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Get top 5 NOK causes, products, and employees (mock)
     */
    async postBackReportsGroupLeaderDashboardTopNoks(requestParameters: PostBackReportsGroupLeaderDashboardTopNoksRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TopNoksResponse> {
        const response = await this.postBackReportsGroupLeaderDashboardTopNoksRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get downtimes over time
     */
    async postBackReportsGroupLeaderDashboardV2DowntimesOverTimeRaw(requestParameters: PostBackReportsGroupLeaderDashboardV2DowntimesOverTimeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DowntimesOverTimeResponseV2>> {
        if (requestParameters.downtimesOverTimeRequestV2 === null || requestParameters.downtimesOverTimeRequestV2 === undefined) {
            throw new runtime.RequiredError('downtimesOverTimeRequestV2','Required parameter requestParameters.downtimesOverTimeRequestV2 was null or undefined when calling postBackReportsGroupLeaderDashboardV2DowntimesOverTime.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/reports/group-leader-dashboard/v2/downtimes-over-time`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.downtimesOverTimeRequestV2,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Get downtimes over time
     */
    async postBackReportsGroupLeaderDashboardV2DowntimesOverTime(requestParameters: PostBackReportsGroupLeaderDashboardV2DowntimesOverTimeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DowntimesOverTimeResponseV2> {
        const response = await this.postBackReportsGroupLeaderDashboardV2DowntimesOverTimeRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get NOK status over time
     */
    async postBackReportsGroupLeaderDashboardV2NoksOverTimeRaw(requestParameters: PostBackReportsGroupLeaderDashboardV2NoksOverTimeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<NoksOverTimeResponseV2>> {
        if (requestParameters.noksOverTimeRequestV2 === null || requestParameters.noksOverTimeRequestV2 === undefined) {
            throw new runtime.RequiredError('noksOverTimeRequestV2','Required parameter requestParameters.noksOverTimeRequestV2 was null or undefined when calling postBackReportsGroupLeaderDashboardV2NoksOverTime.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/reports/group-leader-dashboard/v2/noks-over-time`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.noksOverTimeRequestV2,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Get NOK status over time
     */
    async postBackReportsGroupLeaderDashboardV2NoksOverTime(requestParameters: PostBackReportsGroupLeaderDashboardV2NoksOverTimeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<NoksOverTimeResponseV2> {
        const response = await this.postBackReportsGroupLeaderDashboardV2NoksOverTimeRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get top 5 downtime causes, products, and employees
     */
    async postBackReportsGroupLeaderDashboardV2TopDowntimesRaw(requestParameters: PostBackReportsGroupLeaderDashboardV2TopDowntimesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TopDowntimesResponseV2>> {
        if (requestParameters.groupLeaderDashboardFilters === null || requestParameters.groupLeaderDashboardFilters === undefined) {
            throw new runtime.RequiredError('groupLeaderDashboardFilters','Required parameter requestParameters.groupLeaderDashboardFilters was null or undefined when calling postBackReportsGroupLeaderDashboardV2TopDowntimes.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/reports/group-leader-dashboard/v2/top-downtimes`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.groupLeaderDashboardFilters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Get top 5 downtime causes, products, and employees
     */
    async postBackReportsGroupLeaderDashboardV2TopDowntimes(requestParameters: PostBackReportsGroupLeaderDashboardV2TopDowntimesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TopDowntimesResponseV2> {
        const response = await this.postBackReportsGroupLeaderDashboardV2TopDowntimesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get top 5 NOK causes, products, and employees
     */
    async postBackReportsGroupLeaderDashboardV2TopNoksRaw(requestParameters: PostBackReportsGroupLeaderDashboardV2TopNoksRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TopNoksResponseV2>> {
        if (requestParameters.groupLeaderDashboardFilters === null || requestParameters.groupLeaderDashboardFilters === undefined) {
            throw new runtime.RequiredError('groupLeaderDashboardFilters','Required parameter requestParameters.groupLeaderDashboardFilters was null or undefined when calling postBackReportsGroupLeaderDashboardV2TopNoks.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/reports/group-leader-dashboard/v2/top-noks`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.groupLeaderDashboardFilters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Get top 5 NOK causes, products, and employees
     */
    async postBackReportsGroupLeaderDashboardV2TopNoks(requestParameters: PostBackReportsGroupLeaderDashboardV2TopNoksRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TopNoksResponseV2> {
        const response = await this.postBackReportsGroupLeaderDashboardV2TopNoksRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Load cards list
     */
    async postBackReportsLoadCardsListFilterRaw(requestParameters: PostBackReportsLoadCardsListFilterOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CompoundResultLoadCardListController>> {
        if (requestParameters.postBackReportsLoadCardsListFilterRequest === null || requestParameters.postBackReportsLoadCardsListFilterRequest === undefined) {
            throw new runtime.RequiredError('postBackReportsLoadCardsListFilterRequest','Required parameter requestParameters.postBackReportsLoadCardsListFilterRequest was null or undefined when calling postBackReportsLoadCardsListFilter.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/reports/load-cards/list/filter`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.postBackReportsLoadCardsListFilterRequest,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Load cards list
     */
    async postBackReportsLoadCardsListFilter(requestParameters: PostBackReportsLoadCardsListFilterOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CompoundResultLoadCardListController> {
        const response = await this.postBackReportsLoadCardsListFilterRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Waste causes list
     */
    async postBackReportsWasteCausesFilterRaw(requestParameters: PostBackReportsWasteCausesFilterRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CompoundResultWasteCausesListController>> {
        if (requestParameters.postBackMeasurementsMeasurementDevicesFilterRequest === null || requestParameters.postBackMeasurementsMeasurementDevicesFilterRequest === undefined) {
            throw new runtime.RequiredError('postBackMeasurementsMeasurementDevicesFilterRequest','Required parameter requestParameters.postBackMeasurementsMeasurementDevicesFilterRequest was null or undefined when calling postBackReportsWasteCausesFilter.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/reports/waste-causes/filter`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.postBackMeasurementsMeasurementDevicesFilterRequest,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Waste causes list
     */
    async postBackReportsWasteCausesFilter(requestParameters: PostBackReportsWasteCausesFilterRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CompoundResultWasteCausesListController> {
        const response = await this.postBackReportsWasteCausesFilterRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Save workstation amount reports for production lot
     */
    async postBackReportsWorkstationReportsAmountProductionlotidRaw(requestParameters: PostBackReportsWorkstationReportsAmountProductionlotidRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<number>> {
        if (requestParameters.productionLotId === null || requestParameters.productionLotId === undefined) {
            throw new runtime.RequiredError('productionLotId','Required parameter requestParameters.productionLotId was null or undefined when calling postBackReportsWorkstationReportsAmountProductionlotid.');
        }

        if (requestParameters.workstationAmountReportSaveView === null || requestParameters.workstationAmountReportSaveView === undefined) {
            throw new runtime.RequiredError('workstationAmountReportSaveView','Required parameter requestParameters.workstationAmountReportSaveView was null or undefined when calling postBackReportsWorkstationReportsAmountProductionlotid.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/reports/workstation-reports/amount/{ProductionLotId}`.replace(`{${"ProductionLotId"}}`, encodeURIComponent(String(requestParameters.productionLotId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.workstationAmountReportSaveView,
        }, initOverrides);

        return new runtime.TextApiResponse(response) as any;
    }

    /**
     * Save workstation amount reports for production lot
     */
    async postBackReportsWorkstationReportsAmountProductionlotid(requestParameters: PostBackReportsWorkstationReportsAmountProductionlotidRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<number> {
        const response = await this.postBackReportsWorkstationReportsAmountProductionlotidRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Save comment for batch\'s report
     */
    async postBackReportsWorkstationReportsCommentSaveForBatchBatchidRaw(requestParameters: PostBackReportsWorkstationReportsCommentSaveForBatchBatchidRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.batchId === null || requestParameters.batchId === undefined) {
            throw new runtime.RequiredError('batchId','Required parameter requestParameters.batchId was null or undefined when calling postBackReportsWorkstationReportsCommentSaveForBatchBatchid.');
        }

        if (requestParameters.commentView === null || requestParameters.commentView === undefined) {
            throw new runtime.RequiredError('commentView','Required parameter requestParameters.commentView was null or undefined when calling postBackReportsWorkstationReportsCommentSaveForBatchBatchid.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/reports/workstation-reports/comment/save-for-batch/{BatchId}`.replace(`{${"BatchId"}}`, encodeURIComponent(String(requestParameters.batchId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.commentView,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Save comment for batch\'s report
     */
    async postBackReportsWorkstationReportsCommentSaveForBatchBatchid(requestParameters: PostBackReportsWorkstationReportsCommentSaveForBatchBatchidRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.postBackReportsWorkstationReportsCommentSaveForBatchBatchidRaw(requestParameters, initOverrides);
    }

    /**
     * Save comment for production lot\'s report
     */
    async postBackReportsWorkstationReportsCommentSaveProductionlotidRaw(requestParameters: PostBackReportsWorkstationReportsCommentSaveProductionlotidRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.productionLotId === null || requestParameters.productionLotId === undefined) {
            throw new runtime.RequiredError('productionLotId','Required parameter requestParameters.productionLotId was null or undefined when calling postBackReportsWorkstationReportsCommentSaveProductionlotid.');
        }

        if (requestParameters.commentView === null || requestParameters.commentView === undefined) {
            throw new runtime.RequiredError('commentView','Required parameter requestParameters.commentView was null or undefined when calling postBackReportsWorkstationReportsCommentSaveProductionlotid.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/reports/workstation-reports/comment/save/{ProductionLotId}`.replace(`{${"ProductionLotId"}}`, encodeURIComponent(String(requestParameters.productionLotId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.commentView,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Save comment for production lot\'s report
     */
    async postBackReportsWorkstationReportsCommentSaveProductionlotid(requestParameters: PostBackReportsWorkstationReportsCommentSaveProductionlotidRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.postBackReportsWorkstationReportsCommentSaveProductionlotidRaw(requestParameters, initOverrides);
    }

    /**
     * Update downtime report coming from sensor for a batch
     */
    async postBackReportsWorkstationReportsDowntimeBatchUpdateFromSensorRaw(requestParameters: PostBackReportsWorkstationReportsDowntimeBatchUpdateFromSensorRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<number>>> {
        if (requestParameters.sensorDowntimeGroupUpdateView === null || requestParameters.sensorDowntimeGroupUpdateView === undefined) {
            throw new runtime.RequiredError('sensorDowntimeGroupUpdateView','Required parameter requestParameters.sensorDowntimeGroupUpdateView was null or undefined when calling postBackReportsWorkstationReportsDowntimeBatchUpdateFromSensor.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/reports/workstation-reports/downtime/batch/update-from-sensor`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.sensorDowntimeGroupUpdateView,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Update downtime report coming from sensor for a batch
     */
    async postBackReportsWorkstationReportsDowntimeBatchUpdateFromSensor(requestParameters: PostBackReportsWorkstationReportsDowntimeBatchUpdateFromSensorRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<number>> {
        const response = await this.postBackReportsWorkstationReportsDowntimeBatchUpdateFromSensorRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Save downtime report with start and end dates for a production lot
     */
    async postBackReportsWorkstationReportsDowntimeSaveProductionlotidStartEndRaw(requestParameters: PostBackReportsWorkstationReportsDowntimeSaveProductionlotidStartEndRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<number>> {
        if (requestParameters.productionLotId === null || requestParameters.productionLotId === undefined) {
            throw new runtime.RequiredError('productionLotId','Required parameter requestParameters.productionLotId was null or undefined when calling postBackReportsWorkstationReportsDowntimeSaveProductionlotidStartEnd.');
        }

        if (requestParameters.downtimeReportStartEndSaveView === null || requestParameters.downtimeReportStartEndSaveView === undefined) {
            throw new runtime.RequiredError('downtimeReportStartEndSaveView','Required parameter requestParameters.downtimeReportStartEndSaveView was null or undefined when calling postBackReportsWorkstationReportsDowntimeSaveProductionlotidStartEnd.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/reports/workstation-reports/downtime/save/{ProductionLotId}/start-end`.replace(`{${"ProductionLotId"}}`, encodeURIComponent(String(requestParameters.productionLotId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.downtimeReportStartEndSaveView,
        }, initOverrides);

        return new runtime.TextApiResponse(response) as any;
    }

    /**
     * Save downtime report with start and end dates for a production lot
     */
    async postBackReportsWorkstationReportsDowntimeSaveProductionlotidStartEnd(requestParameters: PostBackReportsWorkstationReportsDowntimeSaveProductionlotidStartEndRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<number> {
        const response = await this.postBackReportsWorkstationReportsDowntimeSaveProductionlotidStartEndRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update downtime report coming from sensor for a production lot
     */
    async postBackReportsWorkstationReportsDowntimeUpdateFromSensorRaw(requestParameters: PostBackReportsWorkstationReportsDowntimeUpdateFromSensorRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.sensorDowntimeUpdateView === null || requestParameters.sensorDowntimeUpdateView === undefined) {
            throw new runtime.RequiredError('sensorDowntimeUpdateView','Required parameter requestParameters.sensorDowntimeUpdateView was null or undefined when calling postBackReportsWorkstationReportsDowntimeUpdateFromSensor.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/reports/workstation-reports/downtime/update-from-sensor`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.sensorDowntimeUpdateView,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Update downtime report coming from sensor for a production lot
     */
    async postBackReportsWorkstationReportsDowntimeUpdateFromSensor(requestParameters: PostBackReportsWorkstationReportsDowntimeUpdateFromSensorRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.postBackReportsWorkstationReportsDowntimeUpdateFromSensorRaw(requestParameters, initOverrides);
    }

    /**
     * Update load report
     */
    async postBackReportsWorkstationReportsLoadUpdateRaw(requestParameters: PostBackReportsWorkstationReportsLoadUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<LoadReportView>> {
        if (requestParameters.loadReportSaveView === null || requestParameters.loadReportSaveView === undefined) {
            throw new runtime.RequiredError('loadReportSaveView','Required parameter requestParameters.loadReportSaveView was null or undefined when calling postBackReportsWorkstationReportsLoadUpdate.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/reports/workstation-reports/load/update`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.loadReportSaveView,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Update load report
     */
    async postBackReportsWorkstationReportsLoadUpdate(requestParameters: PostBackReportsWorkstationReportsLoadUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<LoadReportView> {
        const response = await this.postBackReportsWorkstationReportsLoadUpdateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Abort production for batch
     */
    async postBackReportsWorkstationsByBatchBatchidAbortRaw(requestParameters: PostBackReportsWorkstationsByBatchBatchidAbortRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<AjaxAction>>> {
        if (requestParameters.batchId === null || requestParameters.batchId === undefined) {
            throw new runtime.RequiredError('batchId','Required parameter requestParameters.batchId was null or undefined when calling postBackReportsWorkstationsByBatchBatchidAbort.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/reports/workstations/by-batch/{BatchId}/abort`.replace(`{${"BatchId"}}`, encodeURIComponent(String(requestParameters.batchId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Abort production for batch
     */
    async postBackReportsWorkstationsByBatchBatchidAbort(requestParameters: PostBackReportsWorkstationsByBatchBatchidAbortRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<AjaxAction>> {
        const response = await this.postBackReportsWorkstationsByBatchBatchidAbortRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Start production for batch
     */
    async postBackReportsWorkstationsByBatchBatchidStartRaw(requestParameters: PostBackReportsWorkstationsByBatchBatchidStartRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.batchId === null || requestParameters.batchId === undefined) {
            throw new runtime.RequiredError('batchId','Required parameter requestParameters.batchId was null or undefined when calling postBackReportsWorkstationsByBatchBatchidStart.');
        }

        const queryParameters: any = {};

        if (requestParameters.startDateTime !== undefined) {
            queryParameters['startDateTime'] = requestParameters.startDateTime;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/reports/workstations/by-batch/{BatchId}/start`.replace(`{${"BatchId"}}`, encodeURIComponent(String(requestParameters.batchId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Start production for batch
     */
    async postBackReportsWorkstationsByBatchBatchidStart(requestParameters: PostBackReportsWorkstationsByBatchBatchidStartRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.postBackReportsWorkstationsByBatchBatchidStartRaw(requestParameters, initOverrides);
    }

    /**
     * Finish production for batch
     */
    async postBackReportsWorkstationsByLotBatchidFinishRaw(requestParameters: PostBackReportsWorkstationsByLotBatchidFinishRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.batchId === null || requestParameters.batchId === undefined) {
            throw new runtime.RequiredError('batchId','Required parameter requestParameters.batchId was null or undefined when calling postBackReportsWorkstationsByLotBatchidFinish.');
        }

        const queryParameters: any = {};

        if (requestParameters.startDateTime !== undefined) {
            queryParameters['startDateTime'] = requestParameters.startDateTime;
        }

        if (requestParameters.endDateTime !== undefined) {
            queryParameters['endDateTime'] = requestParameters.endDateTime;
        }

        if (requestParameters.createNewLotForUnfinished !== undefined) {
            queryParameters['createNewLotForUnfinished'] = requestParameters.createNewLotForUnfinished;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/reports/workstations/by-batch/{BatchId}/finish`.replace(`{${"BatchId"}}`, encodeURIComponent(String(requestParameters.batchId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Finish production for batch
     */
    async postBackReportsWorkstationsByLotBatchidFinish(requestParameters: PostBackReportsWorkstationsByLotBatchidFinishRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.postBackReportsWorkstationsByLotBatchidFinishRaw(requestParameters, initOverrides);
    }

    /**
     * Abort production for production lot
     */
    async postBackReportsWorkstationsByLotProductionlotidAbortRaw(requestParameters: PostBackReportsWorkstationsByLotProductionlotidAbortRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<AjaxAction>>> {
        if (requestParameters.productionLotId === null || requestParameters.productionLotId === undefined) {
            throw new runtime.RequiredError('productionLotId','Required parameter requestParameters.productionLotId was null or undefined when calling postBackReportsWorkstationsByLotProductionlotidAbort.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/reports/workstations/by-lot/{ProductionLotId}/abort`.replace(`{${"ProductionLotId"}}`, encodeURIComponent(String(requestParameters.productionLotId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Abort production for production lot
     */
    async postBackReportsWorkstationsByLotProductionlotidAbort(requestParameters: PostBackReportsWorkstationsByLotProductionlotidAbortRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<AjaxAction>> {
        const response = await this.postBackReportsWorkstationsByLotProductionlotidAbortRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Finish production for production lot
     */
    async postBackReportsWorkstationsByLotProductionlotidFinishRaw(requestParameters: PostBackReportsWorkstationsByLotProductionlotidFinishRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.productionLotId === null || requestParameters.productionLotId === undefined) {
            throw new runtime.RequiredError('productionLotId','Required parameter requestParameters.productionLotId was null or undefined when calling postBackReportsWorkstationsByLotProductionlotidFinish.');
        }

        const queryParameters: any = {};

        if (requestParameters.startDateTime !== undefined) {
            queryParameters['startDateTime'] = requestParameters.startDateTime;
        }

        if (requestParameters.endDateTime !== undefined) {
            queryParameters['endDateTime'] = requestParameters.endDateTime;
        }

        if (requestParameters.createNewLotForUnfinished !== undefined) {
            queryParameters['createNewLotForUnfinished'] = requestParameters.createNewLotForUnfinished;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/reports/workstations/by-lot/{ProductionLotId}/finish`.replace(`{${"ProductionLotId"}}`, encodeURIComponent(String(requestParameters.productionLotId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Finish production for production lot
     */
    async postBackReportsWorkstationsByLotProductionlotidFinish(requestParameters: PostBackReportsWorkstationsByLotProductionlotidFinishRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.postBackReportsWorkstationsByLotProductionlotidFinishRaw(requestParameters, initOverrides);
    }

    /**
     * Start production for production lot
     */
    async postBackReportsWorkstationsByLotProductionlotidStartRaw(requestParameters: PostBackReportsWorkstationsByLotProductionlotidStartRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.productionLotId === null || requestParameters.productionLotId === undefined) {
            throw new runtime.RequiredError('productionLotId','Required parameter requestParameters.productionLotId was null or undefined when calling postBackReportsWorkstationsByLotProductionlotidStart.');
        }

        const queryParameters: any = {};

        if (requestParameters.startDateTime !== undefined) {
            queryParameters['startDateTime'] = requestParameters.startDateTime;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/reports/workstations/by-lot/{ProductionLotId}/start`.replace(`{${"ProductionLotId"}}`, encodeURIComponent(String(requestParameters.productionLotId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Start production for production lot
     */
    async postBackReportsWorkstationsByLotProductionlotidStart(requestParameters: PostBackReportsWorkstationsByLotProductionlotidStartRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.postBackReportsWorkstationsByLotProductionlotidStartRaw(requestParameters, initOverrides);
    }

    /**
     * Set machine state with obligatory comment
     */
    async postBackReportsWorkstationsMachineMachineidSetBreakdownRaw(requestParameters: PostBackReportsWorkstationsMachineMachineidSetBreakdownRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<MachineState>> {
        if (requestParameters.machineId === null || requestParameters.machineId === undefined) {
            throw new runtime.RequiredError('machineId','Required parameter requestParameters.machineId was null or undefined when calling postBackReportsWorkstationsMachineMachineidSetBreakdown.');
        }

        if (requestParameters.body === null || requestParameters.body === undefined) {
            throw new runtime.RequiredError('body','Required parameter requestParameters.body was null or undefined when calling postBackReportsWorkstationsMachineMachineidSetBreakdown.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/reports/workstations/machine/{MachineId}/set-breakdown`.replace(`{${"MachineId"}}`, encodeURIComponent(String(requestParameters.machineId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.body as any,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Set machine state with obligatory comment
     */
    async postBackReportsWorkstationsMachineMachineidSetBreakdown(requestParameters: PostBackReportsWorkstationsMachineMachineidSetBreakdownRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<MachineState> {
        const response = await this.postBackReportsWorkstationsMachineMachineidSetBreakdownRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Set machine state with obligatory reason and optional comment
     */
    async postBackReportsWorkstationsMachineMachineidSetIdleRaw(requestParameters: PostBackReportsWorkstationsMachineMachineidSetIdleRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<MachineState>> {
        if (requestParameters.machineId === null || requestParameters.machineId === undefined) {
            throw new runtime.RequiredError('machineId','Required parameter requestParameters.machineId was null or undefined when calling postBackReportsWorkstationsMachineMachineidSetIdle.');
        }

        if (requestParameters.machineStateChangeData === null || requestParameters.machineStateChangeData === undefined) {
            throw new runtime.RequiredError('machineStateChangeData','Required parameter requestParameters.machineStateChangeData was null or undefined when calling postBackReportsWorkstationsMachineMachineidSetIdle.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/reports/workstations/machine/{MachineId}/set-idle`.replace(`{${"MachineId"}}`, encodeURIComponent(String(requestParameters.machineId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.machineStateChangeData,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Set machine state with obligatory reason and optional comment
     */
    async postBackReportsWorkstationsMachineMachineidSetIdle(requestParameters: PostBackReportsWorkstationsMachineMachineidSetIdleRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<MachineState> {
        const response = await this.postBackReportsWorkstationsMachineMachineidSetIdleRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Add sales entry document
     */
    async postBackSalesDocumentAddRaw(requestParameters: PostBackSalesDocumentAddRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<number>> {
        if (requestParameters.name === null || requestParameters.name === undefined) {
            throw new runtime.RequiredError('name','Required parameter requestParameters.name was null or undefined when calling postBackSalesDocumentAdd.');
        }

        if (requestParameters.fileName === null || requestParameters.fileName === undefined) {
            throw new runtime.RequiredError('fileName','Required parameter requestParameters.fileName was null or undefined when calling postBackSalesDocumentAdd.');
        }

        if (requestParameters.content === null || requestParameters.content === undefined) {
            throw new runtime.RequiredError('content','Required parameter requestParameters.content was null or undefined when calling postBackSalesDocumentAdd.');
        }

        if (requestParameters.salesEntryId === null || requestParameters.salesEntryId === undefined) {
            throw new runtime.RequiredError('salesEntryId','Required parameter requestParameters.salesEntryId was null or undefined when calling postBackSalesDocumentAdd.');
        }

        if (requestParameters.documentType === null || requestParameters.documentType === undefined) {
            throw new runtime.RequiredError('documentType','Required parameter requestParameters.documentType was null or undefined when calling postBackSalesDocumentAdd.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const consumes: runtime.Consume[] = [
            { contentType: 'multipart/form-data' },
        ];
        // @ts-ignore: canConsumeForm may be unused
        const canConsumeForm = runtime.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): any };
        let useForm = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new URLSearchParams();
        }

        if (requestParameters.name !== undefined) {
            formParams.append('name', requestParameters.name as any);
        }

        if (requestParameters.fileName !== undefined) {
            formParams.append('fileName', requestParameters.fileName as any);
        }

        if (requestParameters.content !== undefined) {
            formParams.append('content', requestParameters.content as any);
        }

        if (requestParameters.salesEntryId !== undefined) {
            formParams.append('salesEntryId', requestParameters.salesEntryId as any);
        }

        if (requestParameters.documentType !== undefined) {

            formParams.append('documentType', new Blob([JSON.stringify(requestParameters.documentType)], { type: "application/json", }));
        }

        if (requestParameters.amount !== undefined) {
            formParams.append('amount', requestParameters.amount as any);
        }

        const response = await this.request({
            path: `/back/sales/document/add`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: formParams,
        }, initOverrides);

        return new runtime.TextApiResponse(response) as any;
    }

    /**
     * Add sales entry document
     */
    async postBackSalesDocumentAdd(requestParameters: PostBackSalesDocumentAddRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<number> {
        const response = await this.postBackSalesDocumentAddRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update sales entry document\'s metadata
     */
    async postBackSalesDocumentUpdateRaw(requestParameters: PostBackSalesDocumentUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<number>> {
        if (requestParameters.salesEntryDocumentUpdateView === null || requestParameters.salesEntryDocumentUpdateView === undefined) {
            throw new runtime.RequiredError('salesEntryDocumentUpdateView','Required parameter requestParameters.salesEntryDocumentUpdateView was null or undefined when calling postBackSalesDocumentUpdate.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/sales/document/update`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.salesEntryDocumentUpdateView,
        }, initOverrides);

        return new runtime.TextApiResponse(response) as any;
    }

    /**
     * Update sales entry document\'s metadata
     */
    async postBackSalesDocumentUpdate(requestParameters: PostBackSalesDocumentUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<number> {
        const response = await this.postBackSalesDocumentUpdateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Sales entry document list
     */
    async postBackSalesDocumentsListFilterRaw(requestParameters: PostBackSalesDocumentsListFilterOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CompoundResultSalesEntryDocumentListViewController>> {
        if (requestParameters.postBackSalesDocumentsListFilterRequest === null || requestParameters.postBackSalesDocumentsListFilterRequest === undefined) {
            throw new runtime.RequiredError('postBackSalesDocumentsListFilterRequest','Required parameter requestParameters.postBackSalesDocumentsListFilterRequest was null or undefined when calling postBackSalesDocumentsListFilter.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/sales/documents/list/filter`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.postBackSalesDocumentsListFilterRequest,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Sales entry document list
     */
    async postBackSalesDocumentsListFilter(requestParameters: PostBackSalesDocumentsListFilterOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CompoundResultSalesEntryDocumentListViewController> {
        const response = await this.postBackSalesDocumentsListFilterRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Methods of payment list
     */
    async postBackSalesPaymentMethodListFilterRaw(requestParameters: PostBackSalesPaymentMethodListFilterRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CompoundResultMethodsOfPaymentListController>> {
        if (requestParameters.postBackMeasurementsMeasurementDevicesFilterRequest === null || requestParameters.postBackMeasurementsMeasurementDevicesFilterRequest === undefined) {
            throw new runtime.RequiredError('postBackMeasurementsMeasurementDevicesFilterRequest','Required parameter requestParameters.postBackMeasurementsMeasurementDevicesFilterRequest was null or undefined when calling postBackSalesPaymentMethodListFilter.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/sales/payment-method/list/filter`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.postBackMeasurementsMeasurementDevicesFilterRequest,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Methods of payment list
     */
    async postBackSalesPaymentMethodListFilter(requestParameters: PostBackSalesPaymentMethodListFilterRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CompoundResultMethodsOfPaymentListController> {
        const response = await this.postBackSalesPaymentMethodListFilterRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Save new payment method
     */
    async postBackSalesPaymentMethodSaveRaw(requestParameters: PostBackSalesPaymentMethodSaveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<MethodOfPaymentView>> {
        if (requestParameters.methodOfPaymentView === null || requestParameters.methodOfPaymentView === undefined) {
            throw new runtime.RequiredError('methodOfPaymentView','Required parameter requestParameters.methodOfPaymentView was null or undefined when calling postBackSalesPaymentMethodSave.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/sales/payment-method/save`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.methodOfPaymentView,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Save new payment method
     */
    async postBackSalesPaymentMethodSave(requestParameters: PostBackSalesPaymentMethodSaveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<MethodOfPaymentView> {
        const response = await this.postBackSalesPaymentMethodSaveRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Sales entry tags list
     */
    async postBackSalesTagsListFilterRaw(requestParameters: PostBackSalesTagsListFilterOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CompoundResultSalesEntryTagListController>> {
        if (requestParameters.postBackSalesTagsListFilterRequest === null || requestParameters.postBackSalesTagsListFilterRequest === undefined) {
            throw new runtime.RequiredError('postBackSalesTagsListFilterRequest','Required parameter requestParameters.postBackSalesTagsListFilterRequest was null or undefined when calling postBackSalesTagsListFilter.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/sales/tags/list/filter`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.postBackSalesTagsListFilterRequest,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Sales entry tags list
     */
    async postBackSalesTagsListFilter(requestParameters: PostBackSalesTagsListFilterOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CompoundResultSalesEntryTagListController> {
        const response = await this.postBackSalesTagsListFilterRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Save SalesEntryTag
     */
    async postBackSalesTagsSaveRaw(requestParameters: PostBackSalesTagsSaveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<number>> {
        if (requestParameters.salesEntryTag === null || requestParameters.salesEntryTag === undefined) {
            throw new runtime.RequiredError('salesEntryTag','Required parameter requestParameters.salesEntryTag was null or undefined when calling postBackSalesTagsSave.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/sales/tags/save`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.salesEntryTag,
        }, initOverrides);

        return new runtime.TextApiResponse(response) as any;
    }

    /**
     * Save SalesEntryTag
     */
    async postBackSalesTagsSave(requestParameters: PostBackSalesTagsSaveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<number> {
        const response = await this.postBackSalesTagsSaveRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Drivers list
     */
    async postBackShippingDriversListFilterRaw(requestParameters: PostBackShippingDriversListFilterOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CompoundResultDriverListController>> {
        if (requestParameters.postBackShippingDriversListFilterRequest === null || requestParameters.postBackShippingDriversListFilterRequest === undefined) {
            throw new runtime.RequiredError('postBackShippingDriversListFilterRequest','Required parameter requestParameters.postBackShippingDriversListFilterRequest was null or undefined when calling postBackShippingDriversListFilter.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/shipping/drivers/list/filter`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.postBackShippingDriversListFilterRequest,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Drivers list
     */
    async postBackShippingDriversListFilter(requestParameters: PostBackShippingDriversListFilterOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CompoundResultDriverListController> {
        const response = await this.postBackShippingDriversListFilterRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Convert given product specification to recipe
     */
    async postBackSpecificationProductConvertItemtypevariantidRecipetypeRaw(requestParameters: PostBackSpecificationProductConvertItemtypevariantidRecipetypeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GenericRecipe>> {
        if (requestParameters.itemTypeVariantId === null || requestParameters.itemTypeVariantId === undefined) {
            throw new runtime.RequiredError('itemTypeVariantId','Required parameter requestParameters.itemTypeVariantId was null or undefined when calling postBackSpecificationProductConvertItemtypevariantidRecipetype.');
        }

        if (requestParameters.recipeType === null || requestParameters.recipeType === undefined) {
            throw new runtime.RequiredError('recipeType','Required parameter requestParameters.recipeType was null or undefined when calling postBackSpecificationProductConvertItemtypevariantidRecipetype.');
        }

        if (requestParameters.productSpecificationGraph === null || requestParameters.productSpecificationGraph === undefined) {
            throw new runtime.RequiredError('productSpecificationGraph','Required parameter requestParameters.productSpecificationGraph was null or undefined when calling postBackSpecificationProductConvertItemtypevariantidRecipetype.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/specification/product/convert/{ItemTypeVariantId}/{RecipeType}`.replace(`{${"ItemTypeVariantId"}}`, encodeURIComponent(String(requestParameters.itemTypeVariantId))).replace(`{${"RecipeType"}}`, encodeURIComponent(String(requestParameters.recipeType))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.productSpecificationGraph,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Convert given product specification to recipe
     */
    async postBackSpecificationProductConvertItemtypevariantidRecipetype(requestParameters: PostBackSpecificationProductConvertItemtypevariantidRecipetypeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GenericRecipe> {
        const response = await this.postBackSpecificationProductConvertItemtypevariantidRecipetypeRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Specifications by machine features list
     */
    async postBackSpecificationsByMachineFeaturesListFilterRaw(requestParameters: PostBackSpecificationsByMachineFeaturesListFilterOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CompoundResultSpecificationsByMachineFeaturesListController>> {
        if (requestParameters.postBackSpecificationsByMachineFeaturesListFilterRequest === null || requestParameters.postBackSpecificationsByMachineFeaturesListFilterRequest === undefined) {
            throw new runtime.RequiredError('postBackSpecificationsByMachineFeaturesListFilterRequest','Required parameter requestParameters.postBackSpecificationsByMachineFeaturesListFilterRequest was null or undefined when calling postBackSpecificationsByMachineFeaturesListFilter.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/specifications/by-machine-features-list/filter`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.postBackSpecificationsByMachineFeaturesListFilterRequest,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Specifications by machine features list
     */
    async postBackSpecificationsByMachineFeaturesListFilter(requestParameters: PostBackSpecificationsByMachineFeaturesListFilterOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CompoundResultSpecificationsByMachineFeaturesListController> {
        const response = await this.postBackSpecificationsByMachineFeaturesListFilterRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Specifications by produced item tags list
     */
    async postBackSpecificationsByProducedItemTagsListFilterRaw(requestParameters: PostBackSpecificationsByProducedItemTagsListFilterOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CompoundResultSpecificationsByProducedItemTagsListController>> {
        if (requestParameters.postBackSpecificationsByProducedItemTagsListFilterRequest === null || requestParameters.postBackSpecificationsByProducedItemTagsListFilterRequest === undefined) {
            throw new runtime.RequiredError('postBackSpecificationsByProducedItemTagsListFilterRequest','Required parameter requestParameters.postBackSpecificationsByProducedItemTagsListFilterRequest was null or undefined when calling postBackSpecificationsByProducedItemTagsListFilter.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/specifications/by-produced-item-tags-list/filter`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.postBackSpecificationsByProducedItemTagsListFilterRequest,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Specifications by produced item tags list
     */
    async postBackSpecificationsByProducedItemTagsListFilter(requestParameters: PostBackSpecificationsByProducedItemTagsListFilterOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CompoundResultSpecificationsByProducedItemTagsListController> {
        const response = await this.postBackSpecificationsByProducedItemTagsListFilterRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Specifications by produced item tags list
     */
    async postBackSpecificationsByProducedVariantListFilterRaw(requestParameters: PostBackSpecificationsByProducedVariantListFilterOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CompoundResultSpecificationsByProducedVariantListController>> {
        if (requestParameters.postBackSpecificationsByProducedVariantListFilterRequest === null || requestParameters.postBackSpecificationsByProducedVariantListFilterRequest === undefined) {
            throw new runtime.RequiredError('postBackSpecificationsByProducedVariantListFilterRequest','Required parameter requestParameters.postBackSpecificationsByProducedVariantListFilterRequest was null or undefined when calling postBackSpecificationsByProducedVariantListFilter.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/specifications/by-produced-variant-list/filter`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.postBackSpecificationsByProducedVariantListFilterRequest,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Specifications by produced item tags list
     */
    async postBackSpecificationsByProducedVariantListFilter(requestParameters: PostBackSpecificationsByProducedVariantListFilterOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CompoundResultSpecificationsByProducedVariantListController> {
        const response = await this.postBackSpecificationsByProducedVariantListFilterRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Save template for item type id
     */
    async postBackSpecificationsItemTypeItemtypeidSaveRaw(requestParameters: PostBackSpecificationsItemTypeItemtypeidSaveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<number>> {
        if (requestParameters.itemTypeId === null || requestParameters.itemTypeId === undefined) {
            throw new runtime.RequiredError('itemTypeId','Required parameter requestParameters.itemTypeId was null or undefined when calling postBackSpecificationsItemTypeItemtypeidSave.');
        }

        if (requestParameters.specificationTemplateWithItemTypeSavingView === null || requestParameters.specificationTemplateWithItemTypeSavingView === undefined) {
            throw new runtime.RequiredError('specificationTemplateWithItemTypeSavingView','Required parameter requestParameters.specificationTemplateWithItemTypeSavingView was null or undefined when calling postBackSpecificationsItemTypeItemtypeidSave.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/specifications/item-type/{ItemTypeId}/save`.replace(`{${"ItemTypeId"}}`, encodeURIComponent(String(requestParameters.itemTypeId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.specificationTemplateWithItemTypeSavingView,
        }, initOverrides);

        return new runtime.TextApiResponse(response) as any;
    }

    /**
     * Save template for item type id
     */
    async postBackSpecificationsItemTypeItemtypeidSave(requestParameters: PostBackSpecificationsItemTypeItemtypeidSaveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<number> {
        const response = await this.postBackSpecificationsItemTypeItemtypeidSaveRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Convert recipe to recipe view
     */
    async postBackSpecificationsRecipeConvertToViewRaw(requestParameters: PostBackSpecificationsRecipeConvertToViewRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GenericRecipeView>> {
        if (requestParameters.genericRecipe === null || requestParameters.genericRecipe === undefined) {
            throw new runtime.RequiredError('genericRecipe','Required parameter requestParameters.genericRecipe was null or undefined when calling postBackSpecificationsRecipeConvertToView.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/specifications/recipe/convert/to-view`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.genericRecipe,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Convert recipe to recipe view
     */
    async postBackSpecificationsRecipeConvertToView(requestParameters: PostBackSpecificationsRecipeConvertToViewRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GenericRecipeView> {
        const response = await this.postBackSpecificationsRecipeConvertToViewRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Convert printing recipe to view
     */
    async postBackSpecificationsRecipePrintingRaw(requestParameters: PostBackSpecificationsRecipePrintingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GenericRecipeView>> {
        if (requestParameters.genericRecipe === null || requestParameters.genericRecipe === undefined) {
            throw new runtime.RequiredError('genericRecipe','Required parameter requestParameters.genericRecipe was null or undefined when calling postBackSpecificationsRecipePrinting.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/specifications/recipe/printing`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.genericRecipe,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Convert printing recipe to view
     */
    async postBackSpecificationsRecipePrinting(requestParameters: PostBackSpecificationsRecipePrintingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GenericRecipeView> {
        const response = await this.postBackSpecificationsRecipePrintingRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Create plate item
     */
    async postBackSpecificationsRecipePrintingCreatePlateItemRaw(requestParameters: PostBackSpecificationsRecipePrintingCreatePlateItemRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ItemTypeVariant>> {
        if (requestParameters.plateItemTypeSaveView === null || requestParameters.plateItemTypeSaveView === undefined) {
            throw new runtime.RequiredError('plateItemTypeSaveView','Required parameter requestParameters.plateItemTypeSaveView was null or undefined when calling postBackSpecificationsRecipePrintingCreatePlateItem.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/specifications/recipe/printing/create-plate-item`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.plateItemTypeSaveView,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Create plate item
     */
    async postBackSpecificationsRecipePrintingCreatePlateItem(requestParameters: PostBackSpecificationsRecipePrintingCreatePlateItemRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ItemTypeVariant> {
        const response = await this.postBackSpecificationsRecipePrintingCreatePlateItemRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Convert given recipe to product specification
     */
    async postBackSpecificationsRecipeRecipeToProductionSpecRaw(requestParameters: PostBackSpecificationsRecipeRecipeToProductionSpecRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ProductSpecificationGraph>> {
        if (requestParameters.genericRecipe === null || requestParameters.genericRecipe === undefined) {
            throw new runtime.RequiredError('genericRecipe','Required parameter requestParameters.genericRecipe was null or undefined when calling postBackSpecificationsRecipeRecipeToProductionSpec.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/specifications/recipe/recipe/to-production-spec`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.genericRecipe,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Convert given recipe to product specification
     */
    async postBackSpecificationsRecipeRecipeToProductionSpec(requestParameters: PostBackSpecificationsRecipeRecipeToProductionSpecRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ProductSpecificationGraph> {
        const response = await this.postBackSpecificationsRecipeRecipeToProductionSpecRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Convert relief plate recipe to view
     */
    async postBackSpecificationsRecipeReliefPlateRaw(requestParameters: PostBackSpecificationsRecipeReliefPlateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GenericRecipeView>> {
        if (requestParameters.genericRecipe === null || requestParameters.genericRecipe === undefined) {
            throw new runtime.RequiredError('genericRecipe','Required parameter requestParameters.genericRecipe was null or undefined when calling postBackSpecificationsRecipeReliefPlate.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/specifications/recipe/relief-plate`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.genericRecipe,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Convert relief plate recipe to view
     */
    async postBackSpecificationsRecipeReliefPlate(requestParameters: PostBackSpecificationsRecipeReliefPlateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GenericRecipeView> {
        const response = await this.postBackSpecificationsRecipeReliefPlateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Save specification template
     */
    async postBackSpecificationsSaveRaw(requestParameters: PostBackSpecificationsSaveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<number>> {
        if (requestParameters.specificationTemplate === null || requestParameters.specificationTemplate === undefined) {
            throw new runtime.RequiredError('specificationTemplate','Required parameter requestParameters.specificationTemplate was null or undefined when calling postBackSpecificationsSave.');
        }

        const queryParameters: any = {};

        if (requestParameters.asCopy !== undefined) {
            queryParameters['asCopy'] = requestParameters.asCopy;
        }

        if (requestParameters.asDefault !== undefined) {
            queryParameters['asDefault'] = requestParameters.asDefault;
        }

        if (requestParameters.deleteConflicting !== undefined) {
            queryParameters['deleteConflicting'] = requestParameters.deleteConflicting;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/specifications/save`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.specificationTemplate,
        }, initOverrides);

        return new runtime.TextApiResponse(response) as any;
    }

    /**
     * Save specification template
     */
    async postBackSpecificationsSave(requestParameters: PostBackSpecificationsSaveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<number> {
        const response = await this.postBackSpecificationsSaveRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Create simple template for item type id
     */
    async postBackSpecificationsSimpleItemTypeItemtypeidCreateRaw(requestParameters: PostBackSpecificationsSimpleItemTypeItemtypeidCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<number>> {
        if (requestParameters.itemTypeId === null || requestParameters.itemTypeId === undefined) {
            throw new runtime.RequiredError('itemTypeId','Required parameter requestParameters.itemTypeId was null or undefined when calling postBackSpecificationsSimpleItemTypeItemtypeidCreate.');
        }

        if (requestParameters.specificationTemplateSimpleCreateView === null || requestParameters.specificationTemplateSimpleCreateView === undefined) {
            throw new runtime.RequiredError('specificationTemplateSimpleCreateView','Required parameter requestParameters.specificationTemplateSimpleCreateView was null or undefined when calling postBackSpecificationsSimpleItemTypeItemtypeidCreate.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/specifications/simple/item-type/{ItemTypeId}/create`.replace(`{${"ItemTypeId"}}`, encodeURIComponent(String(requestParameters.itemTypeId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.specificationTemplateSimpleCreateView,
        }, initOverrides);

        return new runtime.TextApiResponse(response) as any;
    }

    /**
     * Create simple template for item type id
     */
    async postBackSpecificationsSimpleItemTypeItemtypeidCreate(requestParameters: PostBackSpecificationsSimpleItemTypeItemtypeidCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<number> {
        const response = await this.postBackSpecificationsSimpleItemTypeItemtypeidCreateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update simple template with specified id
     */
    async postBackSpecificationsSimpleUpdateRaw(requestParameters: PostBackSpecificationsSimpleUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<number>> {
        if (requestParameters.specificationTemplateSimpleUpdateView === null || requestParameters.specificationTemplateSimpleUpdateView === undefined) {
            throw new runtime.RequiredError('specificationTemplateSimpleUpdateView','Required parameter requestParameters.specificationTemplateSimpleUpdateView was null or undefined when calling postBackSpecificationsSimpleUpdate.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/specifications/simple/update`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.specificationTemplateSimpleUpdateView,
        }, initOverrides);

        return new runtime.TextApiResponse(response) as any;
    }

    /**
     * Update simple template with specified id
     */
    async postBackSpecificationsSimpleUpdate(requestParameters: PostBackSpecificationsSimpleUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<number> {
        const response = await this.postBackSpecificationsSimpleUpdateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Standard parameters list
     */
    async postBackSpecificationsStandardParametersFilterRaw(requestParameters: PostBackSpecificationsStandardParametersFilterOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CompoundResultStandardParametersListController>> {
        if (requestParameters.postBackSpecificationsStandardParametersFilterRequest === null || requestParameters.postBackSpecificationsStandardParametersFilterRequest === undefined) {
            throw new runtime.RequiredError('postBackSpecificationsStandardParametersFilterRequest','Required parameter requestParameters.postBackSpecificationsStandardParametersFilterRequest was null or undefined when calling postBackSpecificationsStandardParametersFilter.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/specifications/standard-parameters/filter`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.postBackSpecificationsStandardParametersFilterRequest,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Standard parameters list
     */
    async postBackSpecificationsStandardParametersFilter(requestParameters: PostBackSpecificationsStandardParametersFilterOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CompoundResultStandardParametersListController> {
        const response = await this.postBackSpecificationsStandardParametersFilterRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Measurement standards list
     */
    async postBackSpecificationsStandardsFilterRaw(requestParameters: PostBackSpecificationsStandardsFilterRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CompoundResultMeasurementStandardsListController>> {
        if (requestParameters.postBackMeasurementsMeasurementDevicesFilterRequest === null || requestParameters.postBackMeasurementsMeasurementDevicesFilterRequest === undefined) {
            throw new runtime.RequiredError('postBackMeasurementsMeasurementDevicesFilterRequest','Required parameter requestParameters.postBackMeasurementsMeasurementDevicesFilterRequest was null or undefined when calling postBackSpecificationsStandardsFilter.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/specifications/standards/filter`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.postBackMeasurementsMeasurementDevicesFilterRequest,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Measurement standards list
     */
    async postBackSpecificationsStandardsFilter(requestParameters: PostBackSpecificationsStandardsFilterRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CompoundResultMeasurementStandardsListController> {
        const response = await this.postBackSpecificationsStandardsFilterRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Marks template with id as active
     */
    async postBackSpecificationsTemplateReactivateP1Raw(requestParameters: PostBackSpecificationsTemplateReactivateP1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.p1 === null || requestParameters.p1 === undefined) {
            throw new runtime.RequiredError('p1','Required parameter requestParameters.p1 was null or undefined when calling postBackSpecificationsTemplateReactivateP1.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/specifications/template/reactivate/{p1}`.replace(`{${"p1"}}`, encodeURIComponent(String(requestParameters.p1))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Marks template with id as active
     */
    async postBackSpecificationsTemplateReactivateP1(requestParameters: PostBackSpecificationsTemplateReactivateP1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.postBackSpecificationsTemplateReactivateP1Raw(requestParameters, initOverrides);
    }

    /**
     * Specifications by produced item type variant
     */
    async postBackSpecificationsV2ByProducedVariantListFilterRaw(requestParameters: PostBackSpecificationsV2ByProducedVariantListFilterOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CompoundResultSpecificationsByProducedVariantListControllerV2>> {
        if (requestParameters.postBackSpecificationsV2ByProducedVariantListFilterRequest === null || requestParameters.postBackSpecificationsV2ByProducedVariantListFilterRequest === undefined) {
            throw new runtime.RequiredError('postBackSpecificationsV2ByProducedVariantListFilterRequest','Required parameter requestParameters.postBackSpecificationsV2ByProducedVariantListFilterRequest was null or undefined when calling postBackSpecificationsV2ByProducedVariantListFilter.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/specifications/v2/by-produced-variant-list/filter`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.postBackSpecificationsV2ByProducedVariantListFilterRequest,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Specifications by produced item type variant
     */
    async postBackSpecificationsV2ByProducedVariantListFilter(requestParameters: PostBackSpecificationsV2ByProducedVariantListFilterOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CompoundResultSpecificationsByProducedVariantListControllerV2> {
        const response = await this.postBackSpecificationsV2ByProducedVariantListFilterRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Validate given client specification
     */
    async postBackSpecificationsValidateRaw(requestParameters: PostBackSpecificationsValidateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.clientSpecification === null || requestParameters.clientSpecification === undefined) {
            throw new runtime.RequiredError('clientSpecification','Required parameter requestParameters.clientSpecification was null or undefined when calling postBackSpecificationsValidate.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/specifications/validate`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.clientSpecification,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Validate given client specification
     */
    async postBackSpecificationsValidate(requestParameters: PostBackSpecificationsValidateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.postBackSpecificationsValidateRaw(requestParameters, initOverrides);
    }

    /**
     * Save item type with its initial template
     */
    async postBackSpecificationsWithItemSaveRaw(requestParameters: PostBackSpecificationsWithItemSaveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ItemTypeView>> {
        if (requestParameters.itemTypeWithTemplateSavingView === null || requestParameters.itemTypeWithTemplateSavingView === undefined) {
            throw new runtime.RequiredError('itemTypeWithTemplateSavingView','Required parameter requestParameters.itemTypeWithTemplateSavingView was null or undefined when calling postBackSpecificationsWithItemSave.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/specifications/with-item/save`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.itemTypeWithTemplateSavingView,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Save item type with its initial template
     */
    async postBackSpecificationsWithItemSave(requestParameters: PostBackSpecificationsWithItemSaveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ItemTypeView> {
        const response = await this.postBackSpecificationsWithItemSaveRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Change destination for demand
     */
    async postBackStocksDemandStockinteractionidChangeDestinationWithoutvalidationRaw(requestParameters: PostBackStocksDemandStockinteractionidChangeDestinationWithoutvalidationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AjaxActionResponse>> {
        if (requestParameters.stockInteractionId === null || requestParameters.stockInteractionId === undefined) {
            throw new runtime.RequiredError('stockInteractionId','Required parameter requestParameters.stockInteractionId was null or undefined when calling postBackStocksDemandStockinteractionidChangeDestinationWithoutvalidation.');
        }

        if (requestParameters.withoutValidation === null || requestParameters.withoutValidation === undefined) {
            throw new runtime.RequiredError('withoutValidation','Required parameter requestParameters.withoutValidation was null or undefined when calling postBackStocksDemandStockinteractionidChangeDestinationWithoutvalidation.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/stocks/demand/{stockInteractionId}/change-destination/{withoutValidation}`.replace(`{${"stockInteractionId"}}`, encodeURIComponent(String(requestParameters.stockInteractionId))).replace(`{${"withoutValidation"}}`, encodeURIComponent(String(requestParameters.withoutValidation))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.demandDestination,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Change destination for demand
     */
    async postBackStocksDemandStockinteractionidChangeDestinationWithoutvalidation(requestParameters: PostBackStocksDemandStockinteractionidChangeDestinationWithoutvalidationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AjaxActionResponse> {
        const response = await this.postBackStocksDemandStockinteractionidChangeDestinationWithoutvalidationRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Demands list
     */
    async postBackStocksDemandsListFilterRaw(requestParameters: PostBackStocksDemandsListFilterOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CompoundResultDemandListController>> {
        if (requestParameters.postBackStocksDemandsListFilterRequest === null || requestParameters.postBackStocksDemandsListFilterRequest === undefined) {
            throw new runtime.RequiredError('postBackStocksDemandsListFilterRequest','Required parameter requestParameters.postBackStocksDemandsListFilterRequest was null or undefined when calling postBackStocksDemandsListFilter.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/stocks/demands-list/filter`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.postBackStocksDemandsListFilterRequest,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Demands list
     */
    async postBackStocksDemandsListFilter(requestParameters: PostBackStocksDemandsListFilterOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CompoundResultDemandListController> {
        const response = await this.postBackStocksDemandsListFilterRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Demands manager list
     */
    async postBackStocksListFilterRaw(requestParameters: PostBackStocksListFilterOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CompoundResultDemandsManagerListController>> {
        if (requestParameters.postBackStocksListFilterRequest === null || requestParameters.postBackStocksListFilterRequest === undefined) {
            throw new runtime.RequiredError('postBackStocksListFilterRequest','Required parameter requestParameters.postBackStocksListFilterRequest was null or undefined when calling postBackStocksListFilter.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/stocks/list/filter`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.postBackStocksListFilterRequest,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Demands manager list
     */
    async postBackStocksListFilter(requestParameters: PostBackStocksListFilterOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CompoundResultDemandsManagerListController> {
        const response = await this.postBackStocksListFilterRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get variant availability by stock id
     */
    async postBackStocksPlaceVariantAvailabilityStockinteractionidRaw(requestParameters: PostBackStocksPlaceVariantAvailabilityStockinteractionidRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AmountWithUnit>> {
        if (requestParameters.stockInteractionId === null || requestParameters.stockInteractionId === undefined) {
            throw new runtime.RequiredError('stockInteractionId','Required parameter requestParameters.stockInteractionId was null or undefined when calling postBackStocksPlaceVariantAvailabilityStockinteractionid.');
        }

        if (requestParameters.availabilityInputView === null || requestParameters.availabilityInputView === undefined) {
            throw new runtime.RequiredError('availabilityInputView','Required parameter requestParameters.availabilityInputView was null or undefined when calling postBackStocksPlaceVariantAvailabilityStockinteractionid.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/stocks/place/variant-availability/{StockInteractionId}`.replace(`{${"StockInteractionId"}}`, encodeURIComponent(String(requestParameters.stockInteractionId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.availabilityInputView,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Get variant availability by stock id
     */
    async postBackStocksPlaceVariantAvailabilityStockinteractionid(requestParameters: PostBackStocksPlaceVariantAvailabilityStockinteractionidRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AmountWithUnit> {
        const response = await this.postBackStocksPlaceVariantAvailabilityStockinteractionidRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Add production order items from filter results
     */
    async postBackStocksProductionOrdersAddP1Raw(requestParameters: PostBackStocksProductionOrdersAddP1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<string>> {
        if (requestParameters.p1 === null || requestParameters.p1 === undefined) {
            throw new runtime.RequiredError('p1','Required parameter requestParameters.p1 was null or undefined when calling postBackStocksProductionOrdersAddP1.');
        }

        if (requestParameters.postBackStocksDemandsListFilterRequest === null || requestParameters.postBackStocksDemandsListFilterRequest === undefined) {
            throw new runtime.RequiredError('postBackStocksDemandsListFilterRequest','Required parameter requestParameters.postBackStocksDemandsListFilterRequest was null or undefined when calling postBackStocksProductionOrdersAddP1.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/stocks/production-orders/add/{p1}`.replace(`{${"p1"}}`, encodeURIComponent(String(requestParameters.p1))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.postBackStocksDemandsListFilterRequest,
        }, initOverrides);

        return new runtime.TextApiResponse(response) as any;
    }

    /**
     * Add production order items from filter results
     */
    async postBackStocksProductionOrdersAddP1(requestParameters: PostBackStocksProductionOrdersAddP1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<string> {
        const response = await this.postBackStocksProductionOrdersAddP1Raw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Create production order from filter results
     */
    async postBackStocksProductionOrdersCreateRaw(requestParameters: PostBackStocksProductionOrdersCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<MessagesAction>>> {
        if (requestParameters.postBackStocksDemandsListFilterRequest === null || requestParameters.postBackStocksDemandsListFilterRequest === undefined) {
            throw new runtime.RequiredError('postBackStocksDemandsListFilterRequest','Required parameter requestParameters.postBackStocksDemandsListFilterRequest was null or undefined when calling postBackStocksProductionOrdersCreate.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/stocks/production-orders/create`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.postBackStocksDemandsListFilterRequest,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Create production order from filter results
     */
    async postBackStocksProductionOrdersCreate(requestParameters: PostBackStocksProductionOrdersCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<MessagesAction>> {
        const response = await this.postBackStocksProductionOrdersCreateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Stocks to supplement list
     */
    async postBackStocksSupplementListFilterRaw(requestParameters: PostBackStocksSupplementListFilterOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CompoundResultStocksToSupplementListViewController>> {
        if (requestParameters.postBackStocksSupplementListFilterRequest === null || requestParameters.postBackStocksSupplementListFilterRequest === undefined) {
            throw new runtime.RequiredError('postBackStocksSupplementListFilterRequest','Required parameter requestParameters.postBackStocksSupplementListFilterRequest was null or undefined when calling postBackStocksSupplementListFilter.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/stocks/supplement/list/filter`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.postBackStocksSupplementListFilterRequest,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Stocks to supplement list
     */
    async postBackStocksSupplementListFilter(requestParameters: PostBackStocksSupplementListFilterOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CompoundResultStocksToSupplementListViewController> {
        const response = await this.postBackStocksSupplementListFilterRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Countsheet entries + proposed (based on warehouse state) countsheet entries list
     */
    async postBackStocktakingCountsheetListFilterRaw(requestParameters: PostBackStocktakingCountsheetListFilterOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CompoundResultCountsheetEntriesListController>> {
        if (requestParameters.postBackStocktakingCountsheetListFilterRequest === null || requestParameters.postBackStocktakingCountsheetListFilterRequest === undefined) {
            throw new runtime.RequiredError('postBackStocktakingCountsheetListFilterRequest','Required parameter requestParameters.postBackStocktakingCountsheetListFilterRequest was null or undefined when calling postBackStocktakingCountsheetListFilter.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/stocktaking/countsheet/list/filter`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.postBackStocktakingCountsheetListFilterRequest,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Countsheet entries + proposed (based on warehouse state) countsheet entries list
     */
    async postBackStocktakingCountsheetListFilter(requestParameters: PostBackStocktakingCountsheetListFilterOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CompoundResultCountsheetEntriesListController> {
        const response = await this.postBackStocktakingCountsheetListFilterRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Stocktaking list
     */
    async postBackStocktakingListFilterRaw(requestParameters: PostBackStocktakingListFilterOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CompoundResultStocktakingListController>> {
        if (requestParameters.postBackStocktakingListFilterRequest === null || requestParameters.postBackStocktakingListFilterRequest === undefined) {
            throw new runtime.RequiredError('postBackStocktakingListFilterRequest','Required parameter requestParameters.postBackStocktakingListFilterRequest was null or undefined when calling postBackStocktakingListFilter.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/stocktaking/list/filter`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.postBackStocktakingListFilterRequest,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Stocktaking list
     */
    async postBackStocktakingListFilter(requestParameters: PostBackStocktakingListFilterOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CompoundResultStocktakingListController> {
        const response = await this.postBackStocktakingListFilterRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Supply order list
     */
    async postBackSupplyListFilterRaw(requestParameters: PostBackSupplyListFilterOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CompoundResultSupplyOrderListController>> {
        if (requestParameters.postBackSupplyListFilterRequest === null || requestParameters.postBackSupplyListFilterRequest === undefined) {
            throw new runtime.RequiredError('postBackSupplyListFilterRequest','Required parameter requestParameters.postBackSupplyListFilterRequest was null or undefined when calling postBackSupplyListFilter.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/supply/list/filter`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.postBackSupplyListFilterRequest,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Supply order list
     */
    async postBackSupplyListFilter(requestParameters: PostBackSupplyListFilterOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CompoundResultSupplyOrderListController> {
        const response = await this.postBackSupplyListFilterRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Supply orders creator list
     */
    async postBackSupplyOrdersCreatorListFilterRaw(requestParameters: PostBackSupplyOrdersCreatorListFilterOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CompoundResultSupplyOrderCreatorListController>> {
        if (requestParameters.postBackSupplyOrdersCreatorListFilterRequest === null || requestParameters.postBackSupplyOrdersCreatorListFilterRequest === undefined) {
            throw new runtime.RequiredError('postBackSupplyOrdersCreatorListFilterRequest','Required parameter requestParameters.postBackSupplyOrdersCreatorListFilterRequest was null or undefined when calling postBackSupplyOrdersCreatorListFilter.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/supply-orders/creator/list/filter`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.postBackSupplyOrdersCreatorListFilterRequest,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Supply orders creator list
     */
    async postBackSupplyOrdersCreatorListFilter(requestParameters: PostBackSupplyOrdersCreatorListFilterOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CompoundResultSupplyOrderCreatorListController> {
        const response = await this.postBackSupplyOrdersCreatorListFilterRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Cancel initial planning supply for supply order
     */
    async postBackSupplyPlannedSupplyorderidCancelRaw(requestParameters: PostBackSupplyPlannedSupplyorderidCancelRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.supplyOrderId === null || requestParameters.supplyOrderId === undefined) {
            throw new runtime.RequiredError('supplyOrderId','Required parameter requestParameters.supplyOrderId was null or undefined when calling postBackSupplyPlannedSupplyorderidCancel.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/supply/planned/{SupplyOrderId}/cancel`.replace(`{${"SupplyOrderId"}}`, encodeURIComponent(String(requestParameters.supplyOrderId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Cancel initial planning supply for supply order
     */
    async postBackSupplyPlannedSupplyorderidCancel(requestParameters: PostBackSupplyPlannedSupplyorderidCancelRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.postBackSupplyPlannedSupplyorderidCancelRaw(requestParameters, initOverrides);
    }

    /**
     * Warehouse tag list
     */
    async postBackSupplyWarehouseTagListFilterRaw(requestParameters: PostBackSupplyWarehouseTagListFilterOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CompoundResultWarehouseTagListController>> {
        if (requestParameters.postBackSupplyWarehouseTagListFilterRequest === null || requestParameters.postBackSupplyWarehouseTagListFilterRequest === undefined) {
            throw new runtime.RequiredError('postBackSupplyWarehouseTagListFilterRequest','Required parameter requestParameters.postBackSupplyWarehouseTagListFilterRequest was null or undefined when calling postBackSupplyWarehouseTagListFilter.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/supply/warehouse-tag/list/filter`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.postBackSupplyWarehouseTagListFilterRequest,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Warehouse tag list
     */
    async postBackSupplyWarehouseTagListFilter(requestParameters: PostBackSupplyWarehouseTagListFilterOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CompoundResultWarehouseTagListController> {
        const response = await this.postBackSupplyWarehouseTagListFilterRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Tickets list
     */
    async postBackTicketsListFilterRaw(requestParameters: PostBackTicketsListFilterOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CompoundResultTicketsListController>> {
        if (requestParameters.postBackTicketsListFilterRequest === null || requestParameters.postBackTicketsListFilterRequest === undefined) {
            throw new runtime.RequiredError('postBackTicketsListFilterRequest','Required parameter requestParameters.postBackTicketsListFilterRequest was null or undefined when calling postBackTicketsListFilter.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/tickets/list/filter`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.postBackTicketsListFilterRequest,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Tickets list
     */
    async postBackTicketsListFilter(requestParameters: PostBackTicketsListFilterOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CompoundResultTicketsListController> {
        const response = await this.postBackTicketsListFilterRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Fetch left expansion for production lot
     */
    async postBackTraceabilityGraphExpandProductionLotProductionlotidLeftRaw(requestParameters: PostBackTraceabilityGraphExpandProductionLotProductionlotidLeftRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TraceabilityGraphPart>> {
        if (requestParameters.productionLotId === null || requestParameters.productionLotId === undefined) {
            throw new runtime.RequiredError('productionLotId','Required parameter requestParameters.productionLotId was null or undefined when calling postBackTraceabilityGraphExpandProductionLotProductionlotidLeft.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/traceability/graph/expand/production-lot/{ProductionLotId}/left`.replace(`{${"ProductionLotId"}}`, encodeURIComponent(String(requestParameters.productionLotId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Fetch left expansion for production lot
     */
    async postBackTraceabilityGraphExpandProductionLotProductionlotidLeft(requestParameters: PostBackTraceabilityGraphExpandProductionLotProductionlotidLeftRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TraceabilityGraphPart> {
        const response = await this.postBackTraceabilityGraphExpandProductionLotProductionlotidLeftRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Fetch right expansion for production lot
     */
    async postBackTraceabilityGraphExpandProductionLotProductionlotidRightRaw(requestParameters: PostBackTraceabilityGraphExpandProductionLotProductionlotidRightRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TraceabilityGraphPart>> {
        if (requestParameters.productionLotId === null || requestParameters.productionLotId === undefined) {
            throw new runtime.RequiredError('productionLotId','Required parameter requestParameters.productionLotId was null or undefined when calling postBackTraceabilityGraphExpandProductionLotProductionlotidRight.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/traceability/graph/expand/production-lot/{ProductionLotId}/right`.replace(`{${"ProductionLotId"}}`, encodeURIComponent(String(requestParameters.productionLotId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Fetch right expansion for production lot
     */
    async postBackTraceabilityGraphExpandProductionLotProductionlotidRight(requestParameters: PostBackTraceabilityGraphExpandProductionLotProductionlotidRightRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TraceabilityGraphPart> {
        const response = await this.postBackTraceabilityGraphExpandProductionLotProductionlotidRightRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Fetch initial graph for production unit
     */
    async postBackTraceabilityGraphInitialProductionUnitProductionunitidRaw(requestParameters: PostBackTraceabilityGraphInitialProductionUnitProductionunitidRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TraceabilityGraphPart>> {
        if (requestParameters.productionUnitId === null || requestParameters.productionUnitId === undefined) {
            throw new runtime.RequiredError('productionUnitId','Required parameter requestParameters.productionUnitId was null or undefined when calling postBackTraceabilityGraphInitialProductionUnitProductionunitid.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/traceability/graph/initial/production-unit/{ProductionUnitId}`.replace(`{${"ProductionUnitId"}}`, encodeURIComponent(String(requestParameters.productionUnitId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Fetch initial graph for production unit
     */
    async postBackTraceabilityGraphInitialProductionUnitProductionunitid(requestParameters: PostBackTraceabilityGraphInitialProductionUnitProductionunitidRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TraceabilityGraphPart> {
        const response = await this.postBackTraceabilityGraphInitialProductionUnitProductionunitidRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Blob items list
     */
    async postBackUnitsBlobsListFilterRaw(requestParameters: PostBackUnitsBlobsListFilterOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CompoundResultBlobItemsListController>> {
        if (requestParameters.postBackUnitsBlobsListFilterRequest === null || requestParameters.postBackUnitsBlobsListFilterRequest === undefined) {
            throw new runtime.RequiredError('postBackUnitsBlobsListFilterRequest','Required parameter requestParameters.postBackUnitsBlobsListFilterRequest was null or undefined when calling postBackUnitsBlobsListFilter.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/units/blobs/list/filter`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.postBackUnitsBlobsListFilterRequest,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Blob items list
     */
    async postBackUnitsBlobsListFilter(requestParameters: PostBackUnitsBlobsListFilterOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CompoundResultBlobItemsListController> {
        const response = await this.postBackUnitsBlobsListFilterRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Equipment list
     */
    async postBackUnitsEquipmentListFilterRaw(requestParameters: PostBackUnitsEquipmentListFilterOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CompoundResultEquipmentListController>> {
        if (requestParameters.postBackUnitsEquipmentListFilterRequest === null || requestParameters.postBackUnitsEquipmentListFilterRequest === undefined) {
            throw new runtime.RequiredError('postBackUnitsEquipmentListFilterRequest','Required parameter requestParameters.postBackUnitsEquipmentListFilterRequest was null or undefined when calling postBackUnitsEquipmentListFilter.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/units/equipment/list/filter`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.postBackUnitsEquipmentListFilterRequest,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Equipment list
     */
    async postBackUnitsEquipmentListFilter(requestParameters: PostBackUnitsEquipmentListFilterOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CompoundResultEquipmentListController> {
        const response = await this.postBackUnitsEquipmentListFilterRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Item types list with total stock value
     */
    async postBackUnitsItemsListFilterRaw(requestParameters: PostBackUnitsItemsListFilterOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CompoundResultItemTypeTotalStockListController>> {
        if (requestParameters.postBackUnitsItemsListFilterRequest === null || requestParameters.postBackUnitsItemsListFilterRequest === undefined) {
            throw new runtime.RequiredError('postBackUnitsItemsListFilterRequest','Required parameter requestParameters.postBackUnitsItemsListFilterRequest was null or undefined when calling postBackUnitsItemsListFilter.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/units/items/list/filter`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.postBackUnitsItemsListFilterRequest,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Item types list with total stock value
     */
    async postBackUnitsItemsListFilter(requestParameters: PostBackUnitsItemsListFilterOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CompoundResultItemTypeTotalStockListController> {
        const response = await this.postBackUnitsItemsListFilterRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Report borrow or return
     */
    async postBackUnitsLendingLedgerReportRaw(requestParameters: PostBackUnitsLendingLedgerReportRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<number>> {
        if (requestParameters.lendingLedgerEntrySaveView === null || requestParameters.lendingLedgerEntrySaveView === undefined) {
            throw new runtime.RequiredError('lendingLedgerEntrySaveView','Required parameter requestParameters.lendingLedgerEntrySaveView was null or undefined when calling postBackUnitsLendingLedgerReport.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/units/lending-ledger/report`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.lendingLedgerEntrySaveView,
        }, initOverrides);

        return new runtime.TextApiResponse(response) as any;
    }

    /**
     * Report borrow or return
     */
    async postBackUnitsLendingLedgerReport(requestParameters: PostBackUnitsLendingLedgerReportRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<number> {
        const response = await this.postBackUnitsLendingLedgerReportRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Production unit list
     */
    async postBackUnitsListFilterRaw(requestParameters: PostBackUnitsListFilterOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CompoundResultWithSummaryProductionUnitListViewRow>> {
        if (requestParameters.postBackUnitsListFilterRequest === null || requestParameters.postBackUnitsListFilterRequest === undefined) {
            throw new runtime.RequiredError('postBackUnitsListFilterRequest','Required parameter requestParameters.postBackUnitsListFilterRequest was null or undefined when calling postBackUnitsListFilter.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/units/list/filter`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.postBackUnitsListFilterRequest,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Production unit list
     */
    async postBackUnitsListFilter(requestParameters: PostBackUnitsListFilterOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CompoundResultWithSummaryProductionUnitListViewRow> {
        const response = await this.postBackUnitsListFilterRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Vehicles list
     */
    async postBackVehiclesListFilterRaw(requestParameters: PostBackVehiclesListFilterOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CompoundResultActiveVehicleListController>> {
        if (requestParameters.postBackVehiclesListFilterRequest === null || requestParameters.postBackVehiclesListFilterRequest === undefined) {
            throw new runtime.RequiredError('postBackVehiclesListFilterRequest','Required parameter requestParameters.postBackVehiclesListFilterRequest was null or undefined when calling postBackVehiclesListFilter.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/vehicles/list/filter`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.postBackVehiclesListFilterRequest,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Vehicles list
     */
    async postBackVehiclesListFilter(requestParameters: PostBackVehiclesListFilterOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CompoundResultActiveVehicleListController> {
        const response = await this.postBackVehiclesListFilterRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Adds new worker absence event
     */
    async postBackWorkersAbsenceEventsSaveRaw(requestParameters: PostBackWorkersAbsenceEventsSaveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<number>> {
        if (requestParameters.workerEventSaveView === null || requestParameters.workerEventSaveView === undefined) {
            throw new runtime.RequiredError('workerEventSaveView','Required parameter requestParameters.workerEventSaveView was null or undefined when calling postBackWorkersAbsenceEventsSave.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/workers/absence-events/save`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.workerEventSaveView,
        }, initOverrides);

        return new runtime.TextApiResponse(response) as any;
    }

    /**
     * Adds new worker absence event
     */
    async postBackWorkersAbsenceEventsSave(requestParameters: PostBackWorkersAbsenceEventsSaveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<number> {
        const response = await this.postBackWorkersAbsenceEventsSaveRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Competence categories list
     */
    async postBackWorkersCompetenceCategoriesListFilterRaw(requestParameters: PostBackWorkersCompetenceCategoriesListFilterOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CompoundResultCompetenceCategoryListViewController>> {
        if (requestParameters.postBackWorkersCompetenceCategoriesListFilterRequest === null || requestParameters.postBackWorkersCompetenceCategoriesListFilterRequest === undefined) {
            throw new runtime.RequiredError('postBackWorkersCompetenceCategoriesListFilterRequest','Required parameter requestParameters.postBackWorkersCompetenceCategoriesListFilterRequest was null or undefined when calling postBackWorkersCompetenceCategoriesListFilter.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/workers/competence/categories/list/filter`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.postBackWorkersCompetenceCategoriesListFilterRequest,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Competence categories list
     */
    async postBackWorkersCompetenceCategoriesListFilter(requestParameters: PostBackWorkersCompetenceCategoriesListFilterOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CompoundResultCompetenceCategoryListViewController> {
        const response = await this.postBackWorkersCompetenceCategoriesListFilterRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Competences list
     */
    async postBackWorkersCompetencesListFilterRaw(requestParameters: PostBackWorkersCompetencesListFilterOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CompoundResultCompetenceListViewController>> {
        if (requestParameters.postBackWorkersCompetencesListFilterRequest === null || requestParameters.postBackWorkersCompetencesListFilterRequest === undefined) {
            throw new runtime.RequiredError('postBackWorkersCompetencesListFilterRequest','Required parameter requestParameters.postBackWorkersCompetencesListFilterRequest was null or undefined when calling postBackWorkersCompetencesListFilter.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/workers/competences/list/filter`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.postBackWorkersCompetencesListFilterRequest,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Competences list
     */
    async postBackWorkersCompetencesListFilter(requestParameters: PostBackWorkersCompetencesListFilterOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CompoundResultCompetenceListViewController> {
        const response = await this.postBackWorkersCompetencesListFilterRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Competence matrix list
     */
    async postBackWorkersCompetencesMatrixListFilterRaw(requestParameters: PostBackWorkersCompetencesMatrixListFilterOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CompoundResultCompetenceMatrixListController>> {
        if (requestParameters.postBackWorkersCompetencesMatrixListFilterRequest === null || requestParameters.postBackWorkersCompetencesMatrixListFilterRequest === undefined) {
            throw new runtime.RequiredError('postBackWorkersCompetencesMatrixListFilterRequest','Required parameter requestParameters.postBackWorkersCompetencesMatrixListFilterRequest was null or undefined when calling postBackWorkersCompetencesMatrixListFilter.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/workers/competences/matrix/list/filter`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.postBackWorkersCompetencesMatrixListFilterRequest,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Competence matrix list
     */
    async postBackWorkersCompetencesMatrixListFilter(requestParameters: PostBackWorkersCompetencesMatrixListFilterOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CompoundResultCompetenceMatrixListController> {
        const response = await this.postBackWorkersCompetencesMatrixListFilterRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Upserts competence with optionally specified id
     */
    async postBackWorkersCompetencesSaveRaw(requestParameters: PostBackWorkersCompetencesSaveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<number>> {
        if (requestParameters.competence === null || requestParameters.competence === undefined) {
            throw new runtime.RequiredError('competence','Required parameter requestParameters.competence was null or undefined when calling postBackWorkersCompetencesSave.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/workers/competences/save`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.competence,
        }, initOverrides);

        return new runtime.TextApiResponse(response) as any;
    }

    /**
     * Upserts competence with optionally specified id
     */
    async postBackWorkersCompetencesSave(requestParameters: PostBackWorkersCompetencesSaveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<number> {
        const response = await this.postBackWorkersCompetencesSaveRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Add worker document
     */
    async postBackWorkersDocumentAddRaw(requestParameters: PostBackWorkersDocumentAddRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<number>> {
        if (requestParameters.name === null || requestParameters.name === undefined) {
            throw new runtime.RequiredError('name','Required parameter requestParameters.name was null or undefined when calling postBackWorkersDocumentAdd.');
        }

        if (requestParameters.fileName === null || requestParameters.fileName === undefined) {
            throw new runtime.RequiredError('fileName','Required parameter requestParameters.fileName was null or undefined when calling postBackWorkersDocumentAdd.');
        }

        if (requestParameters.content === null || requestParameters.content === undefined) {
            throw new runtime.RequiredError('content','Required parameter requestParameters.content was null or undefined when calling postBackWorkersDocumentAdd.');
        }

        if (requestParameters.workerId === null || requestParameters.workerId === undefined) {
            throw new runtime.RequiredError('workerId','Required parameter requestParameters.workerId was null or undefined when calling postBackWorkersDocumentAdd.');
        }

        if (requestParameters.documentType === null || requestParameters.documentType === undefined) {
            throw new runtime.RequiredError('documentType','Required parameter requestParameters.documentType was null or undefined when calling postBackWorkersDocumentAdd.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const consumes: runtime.Consume[] = [
            { contentType: 'multipart/form-data' },
        ];
        // @ts-ignore: canConsumeForm may be unused
        const canConsumeForm = runtime.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): any };
        let useForm = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new URLSearchParams();
        }

        if (requestParameters.name !== undefined) {
            formParams.append('name', requestParameters.name as any);
        }

        if (requestParameters.fileName !== undefined) {
            formParams.append('fileName', requestParameters.fileName as any);
        }

        if (requestParameters.content !== undefined) {
            formParams.append('content', requestParameters.content as any);
        }

        if (requestParameters.workerId !== undefined) {
            formParams.append('workerId', requestParameters.workerId as any);
        }

        if (requestParameters.documentType !== undefined) {

            formParams.append('documentType', new Blob([JSON.stringify(requestParameters.documentType)], { type: "application/json", }));
        }

        if (requestParameters.dueDate !== undefined) {
            formParams.append('dueDate', requestParameters.dueDate as any);
        }

        if (requestParameters.workerCompetenceId !== undefined) {
            formParams.append('workerCompetenceId', requestParameters.workerCompetenceId as any);
        }

        const response = await this.request({
            path: `/back/workers/document/add`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: formParams,
        }, initOverrides);

        return new runtime.TextApiResponse(response) as any;
    }

    /**
     * Add worker document
     */
    async postBackWorkersDocumentAdd(requestParameters: PostBackWorkersDocumentAddRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<number> {
        const response = await this.postBackWorkersDocumentAddRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update worker document\'s metadata
     */
    async postBackWorkersDocumentUpdateRaw(requestParameters: PostBackWorkersDocumentUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<number>> {
        if (requestParameters.workerDocumentUpdateView === null || requestParameters.workerDocumentUpdateView === undefined) {
            throw new runtime.RequiredError('workerDocumentUpdateView','Required parameter requestParameters.workerDocumentUpdateView was null or undefined when calling postBackWorkersDocumentUpdate.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/workers/document/update`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.workerDocumentUpdateView,
        }, initOverrides);

        return new runtime.TextApiResponse(response) as any;
    }

    /**
     * Update worker document\'s metadata
     */
    async postBackWorkersDocumentUpdate(requestParameters: PostBackWorkersDocumentUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<number> {
        const response = await this.postBackWorkersDocumentUpdateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Worker document list
     */
    async postBackWorkersDocumentsListFilterRaw(requestParameters: PostBackWorkersDocumentsListFilterOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CompoundResultWorkerDocumentListViewController>> {
        if (requestParameters.postBackWorkersDocumentsListFilterRequest === null || requestParameters.postBackWorkersDocumentsListFilterRequest === undefined) {
            throw new runtime.RequiredError('postBackWorkersDocumentsListFilterRequest','Required parameter requestParameters.postBackWorkersDocumentsListFilterRequest was null or undefined when calling postBackWorkersDocumentsListFilter.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/workers/documents/list/filter`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.postBackWorkersDocumentsListFilterRequest,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Worker document list
     */
    async postBackWorkersDocumentsListFilter(requestParameters: PostBackWorkersDocumentsListFilterOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CompoundResultWorkerDocumentListViewController> {
        const response = await this.postBackWorkersDocumentsListFilterRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get calendar events for worker in month
     */
    async postBackWorkersEventsCalendarWorkeridRaw(requestParameters: PostBackWorkersEventsCalendarWorkeridRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<WorkerEventCalendarView>>> {
        if (requestParameters.workerId === null || requestParameters.workerId === undefined) {
            throw new runtime.RequiredError('workerId','Required parameter requestParameters.workerId was null or undefined when calling postBackWorkersEventsCalendarWorkerid.');
        }

        if (requestParameters.workerEventFilterView === null || requestParameters.workerEventFilterView === undefined) {
            throw new runtime.RequiredError('workerEventFilterView','Required parameter requestParameters.workerEventFilterView was null or undefined when calling postBackWorkersEventsCalendarWorkerid.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/workers/events/calendar/{WorkerId}`.replace(`{${"WorkerId"}}`, encodeURIComponent(String(requestParameters.workerId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.workerEventFilterView,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Get calendar events for worker in month
     */
    async postBackWorkersEventsCalendarWorkerid(requestParameters: PostBackWorkersEventsCalendarWorkeridRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<WorkerEventCalendarView>> {
        const response = await this.postBackWorkersEventsCalendarWorkeridRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Workers list
     */
    async postBackWorkersListFilterRaw(requestParameters: PostBackWorkersListFilterOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CompoundResultWorkerListViewController>> {
        if (requestParameters.postBackWorkersListFilterRequest === null || requestParameters.postBackWorkersListFilterRequest === undefined) {
            throw new runtime.RequiredError('postBackWorkersListFilterRequest','Required parameter requestParameters.postBackWorkersListFilterRequest was null or undefined when calling postBackWorkersListFilter.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/workers/list/filter`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.postBackWorkersListFilterRequest,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Workers list
     */
    async postBackWorkersListFilter(requestParameters: PostBackWorkersListFilterOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CompoundResultWorkerListViewController> {
        const response = await this.postBackWorkersListFilterRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Adds new worker with optionally connected user
     */
    async postBackWorkersWorkerAddRaw(requestParameters: PostBackWorkersWorkerAddRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<number>> {
        if (requestParameters.workerAddView === null || requestParameters.workerAddView === undefined) {
            throw new runtime.RequiredError('workerAddView','Required parameter requestParameters.workerAddView was null or undefined when calling postBackWorkersWorkerAdd.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/workers/worker/add`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.workerAddView,
        }, initOverrides);

        return new runtime.TextApiResponse(response) as any;
    }

    /**
     * Adds new worker with optionally connected user
     */
    async postBackWorkersWorkerAdd(requestParameters: PostBackWorkersWorkerAddRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<number> {
        const response = await this.postBackWorkersWorkerAddRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Competences list
     */
    async postBackWorkersWorkerCompetencesListFilterRaw(requestParameters: PostBackWorkersWorkerCompetencesListFilterOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CompoundResultWorkerCompetenceListViewController>> {
        if (requestParameters.postBackWorkersWorkerCompetencesListFilterRequest === null || requestParameters.postBackWorkersWorkerCompetencesListFilterRequest === undefined) {
            throw new runtime.RequiredError('postBackWorkersWorkerCompetencesListFilterRequest','Required parameter requestParameters.postBackWorkersWorkerCompetencesListFilterRequest was null or undefined when calling postBackWorkersWorkerCompetencesListFilter.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/workers/worker-competences/list/filter`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.postBackWorkersWorkerCompetencesListFilterRequest,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Competences list
     */
    async postBackWorkersWorkerCompetencesListFilter(requestParameters: PostBackWorkersWorkerCompetencesListFilterOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CompoundResultWorkerCompetenceListViewController> {
        const response = await this.postBackWorkersWorkerCompetencesListFilterRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Add worker competence
     */
    async postBackWorkersWorkerCompetencesSaveRaw(requestParameters: PostBackWorkersWorkerCompetencesSaveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<number>> {
        if (requestParameters.workerCompetenceSaveView === null || requestParameters.workerCompetenceSaveView === undefined) {
            throw new runtime.RequiredError('workerCompetenceSaveView','Required parameter requestParameters.workerCompetenceSaveView was null or undefined when calling postBackWorkersWorkerCompetencesSave.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/workers/worker-competences/save`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.workerCompetenceSaveView,
        }, initOverrides);

        return new runtime.TextApiResponse(response) as any;
    }

    /**
     * Add worker competence
     */
    async postBackWorkersWorkerCompetencesSave(requestParameters: PostBackWorkersWorkerCompetencesSaveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<number> {
        const response = await this.postBackWorkersWorkerCompetencesSaveRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Reactivates worker, optionally with reactivating linked user
     */
    async postBackWorkersWorkerP1ReactivateRaw(requestParameters: PostBackWorkersWorkerP1ReactivateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.p1 === null || requestParameters.p1 === undefined) {
            throw new runtime.RequiredError('p1','Required parameter requestParameters.p1 was null or undefined when calling postBackWorkersWorkerP1Reactivate.');
        }

        const queryParameters: any = {};

        if (requestParameters.reactivateUser !== undefined) {
            queryParameters['reactivateUser'] = requestParameters.reactivateUser;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/workers/worker/{p1}/reactivate`.replace(`{${"p1"}}`, encodeURIComponent(String(requestParameters.p1))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Reactivates worker, optionally with reactivating linked user
     */
    async postBackWorkersWorkerP1Reactivate(requestParameters: PostBackWorkersWorkerP1ReactivateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.postBackWorkersWorkerP1ReactivateRaw(requestParameters, initOverrides);
    }

    /**
     * Updates worker
     */
    async postBackWorkersWorkerUpdateRaw(requestParameters: PostBackWorkersWorkerUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<number>> {
        if (requestParameters.workerUpdateView === null || requestParameters.workerUpdateView === undefined) {
            throw new runtime.RequiredError('workerUpdateView','Required parameter requestParameters.workerUpdateView was null or undefined when calling postBackWorkersWorkerUpdate.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/workers/worker/update`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.workerUpdateView,
        }, initOverrides);

        return new runtime.TextApiResponse(response) as any;
    }

    /**
     * Updates worker
     */
    async postBackWorkersWorkerUpdate(requestParameters: PostBackWorkersWorkerUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<number> {
        const response = await this.postBackWorkersWorkerUpdateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Save logged user\'s config for given key
     */
    async postUmConfigurationKeySaveRaw(requestParameters: PostUmConfigurationKeySaveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.path === null || requestParameters.path === undefined) {
            throw new runtime.RequiredError('path','Required parameter requestParameters.path was null or undefined when calling postUmConfigurationKeySave.');
        }

        if (requestParameters.body === null || requestParameters.body === undefined) {
            throw new runtime.RequiredError('body','Required parameter requestParameters.body was null or undefined when calling postUmConfigurationKeySave.');
        }

        const queryParameters: any = {};

        if (requestParameters.path !== undefined) {
            queryParameters['path'] = requestParameters.path;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/um/configuration/key/save`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.body as any,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Save logged user\'s config for given key
     */
    async postUmConfigurationKeySave(requestParameters: PostUmConfigurationKeySaveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.postUmConfigurationKeySaveRaw(requestParameters, initOverrides);
    }

    /**
     * Save list view configuration for the logged user
     */
    async postUmConfigurationSaveRaw(requestParameters: PostUmConfigurationSaveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.body === null || requestParameters.body === undefined) {
            throw new runtime.RequiredError('body','Required parameter requestParameters.body was null or undefined when calling postUmConfigurationSave.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/um/configuration/save`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.body as any,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Save list view configuration for the logged user
     */
    async postUmConfigurationSave(requestParameters: PostUmConfigurationSaveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.postUmConfigurationSaveRaw(requestParameters, initOverrides);
    }

    /**
     * Authenticate user with redirect
     */
    async postUmLoginRaw(requestParameters: PostUmLoginRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.login === null || requestParameters.login === undefined) {
            throw new runtime.RequiredError('login','Required parameter requestParameters.login was null or undefined when calling postUmLogin.');
        }

        if (requestParameters.password === null || requestParameters.password === undefined) {
            throw new runtime.RequiredError('password','Required parameter requestParameters.password was null or undefined when calling postUmLogin.');
        }

        if (requestParameters.redirect === null || requestParameters.redirect === undefined) {
            throw new runtime.RequiredError('redirect','Required parameter requestParameters.redirect was null or undefined when calling postUmLogin.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters.acceptLanguage !== undefined && requestParameters.acceptLanguage !== null) {
            headerParameters['Accept-Language'] = String(requestParameters.acceptLanguage);
        }

        const consumes: runtime.Consume[] = [
            { contentType: 'application/x-www-form-urlencoded' },
        ];
        // @ts-ignore: canConsumeForm may be unused
        const canConsumeForm = runtime.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): any };
        let useForm = false;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new URLSearchParams();
        }

        if (requestParameters.login !== undefined) {
            formParams.append('login', requestParameters.login as any);
        }

        if (requestParameters.password !== undefined) {
            formParams.append('password', requestParameters.password as any);
        }

        if (requestParameters.redirect !== undefined) {
            formParams.append('redirect', requestParameters.redirect as any);
        }

        const response = await this.request({
            path: `/um/login`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: formParams,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Authenticate user with redirect
     */
    async postUmLogin(requestParameters: PostUmLoginRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.postUmLoginRaw(requestParameters, initOverrides);
    }

    /**
     * Authenticate user without redirects
     */
    async postUmLoginNoRedirectRaw(requestParameters: PostUmLoginNoRedirectRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.login === null || requestParameters.login === undefined) {
            throw new runtime.RequiredError('login','Required parameter requestParameters.login was null or undefined when calling postUmLoginNoRedirect.');
        }

        if (requestParameters.password === null || requestParameters.password === undefined) {
            throw new runtime.RequiredError('password','Required parameter requestParameters.password was null or undefined when calling postUmLoginNoRedirect.');
        }

        if (requestParameters.redirect === null || requestParameters.redirect === undefined) {
            throw new runtime.RequiredError('redirect','Required parameter requestParameters.redirect was null or undefined when calling postUmLoginNoRedirect.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters.acceptLanguage !== undefined && requestParameters.acceptLanguage !== null) {
            headerParameters['Accept-Language'] = String(requestParameters.acceptLanguage);
        }

        const consumes: runtime.Consume[] = [
            { contentType: 'application/x-www-form-urlencoded' },
        ];
        // @ts-ignore: canConsumeForm may be unused
        const canConsumeForm = runtime.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): any };
        let useForm = false;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new URLSearchParams();
        }

        if (requestParameters.login !== undefined) {
            formParams.append('login', requestParameters.login as any);
        }

        if (requestParameters.password !== undefined) {
            formParams.append('password', requestParameters.password as any);
        }

        if (requestParameters.redirect !== undefined) {
            formParams.append('redirect', requestParameters.redirect as any);
        }

        const response = await this.request({
            path: `/um/login/no-redirect`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: formParams,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Authenticate user without redirects
     */
    async postUmLoginNoRedirect(requestParameters: PostUmLoginNoRedirectRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.postUmLoginNoRedirectRaw(requestParameters, initOverrides);
    }

    /**
     * Authenticate user with RFID (Radio Frequency Identification)
     */
    async postUmRfidLoginRaw(requestParameters: PostUmRfidLoginRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.rfid === null || requestParameters.rfid === undefined) {
            throw new runtime.RequiredError('rfid','Required parameter requestParameters.rfid was null or undefined when calling postUmRfidLogin.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters.acceptLanguage !== undefined && requestParameters.acceptLanguage !== null) {
            headerParameters['Accept-Language'] = String(requestParameters.acceptLanguage);
        }

        const response = await this.request({
            path: `/um/rfid-login`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.rfid,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Authenticate user with RFID (Radio Frequency Identification)
     */
    async postUmRfidLogin(requestParameters: PostUmRfidLoginRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.postUmRfidLoginRaw(requestParameters, initOverrides);
    }

    /**
     * Authenticate user with RFID (Radio Frequency Identification), returns HTML with headers
     */
    async postUmRfidLoginLegacyRaw(requestParameters: PostUmRfidLoginLegacyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.rfid === null || requestParameters.rfid === undefined) {
            throw new runtime.RequiredError('rfid','Required parameter requestParameters.rfid was null or undefined when calling postUmRfidLoginLegacy.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters.acceptLanguage !== undefined && requestParameters.acceptLanguage !== null) {
            headerParameters['Accept-Language'] = String(requestParameters.acceptLanguage);
        }

        const response = await this.request({
            path: `/um/rfid-login/legacy`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.rfid,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Authenticate user with RFID (Radio Frequency Identification), returns HTML with headers
     */
    async postUmRfidLoginLegacy(requestParameters: PostUmRfidLoginLegacyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.postUmRfidLoginLegacyRaw(requestParameters, initOverrides);
    }

    /**
     * Save role
     */
    async postUmRolesRaw(requestParameters: PostUmRolesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<number>> {
        if (requestParameters.roleView === null || requestParameters.roleView === undefined) {
            throw new runtime.RequiredError('roleView','Required parameter requestParameters.roleView was null or undefined when calling postUmRoles.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/um/roles`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.roleView,
        }, initOverrides);

        return new runtime.TextApiResponse(response) as any;
    }

    /**
     * Save role
     */
    async postUmRoles(requestParameters: PostUmRolesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<number> {
        const response = await this.postUmRolesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Add permissions to role
     */
    async postUmRolesIdPermissionsAddRaw(requestParameters: PostUmRolesIdPermissionsAddRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<string>>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling postUmRolesIdPermissionsAdd.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/um/roles/{id}/permissions/add`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.requestBody,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Add permissions to role
     */
    async postUmRolesIdPermissionsAdd(requestParameters: PostUmRolesIdPermissionsAddRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<string>> {
        const response = await this.postUmRolesIdPermissionsAddRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Remove permissions from role
     */
    async postUmRolesIdPermissionsDeleteRaw(requestParameters: PostUmRolesIdPermissionsDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<string>>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling postUmRolesIdPermissionsDelete.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/um/roles/{id}/permissions/delete`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.requestBody,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Remove permissions from role
     */
    async postUmRolesIdPermissionsDelete(requestParameters: PostUmRolesIdPermissionsDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<string>> {
        const response = await this.postUmRolesIdPermissionsDeleteRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Roles list
     */
    async postUmRolesListFilterRaw(requestParameters: PostUmRolesListFilterOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CompoundResultRolesListViewController>> {
        if (requestParameters.postUmRolesListFilterRequest === null || requestParameters.postUmRolesListFilterRequest === undefined) {
            throw new runtime.RequiredError('postUmRolesListFilterRequest','Required parameter requestParameters.postUmRolesListFilterRequest was null or undefined when calling postUmRolesListFilter.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/um/roles/list/filter`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.postUmRolesListFilterRequest,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Roles list
     */
    async postUmRolesListFilter(requestParameters: PostUmRolesListFilterOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CompoundResultRolesListViewController> {
        const response = await this.postUmRolesListFilterRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Block user by his ID
     */
    async postUmSuUsersIdBlockRaw(requestParameters: PostUmSuUsersIdBlockRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling postUmSuUsersIdBlock.');
        }

        if (requestParameters.blocked === null || requestParameters.blocked === undefined) {
            throw new runtime.RequiredError('blocked','Required parameter requestParameters.blocked was null or undefined when calling postUmSuUsersIdBlock.');
        }

        const queryParameters: any = {};

        if (requestParameters.blocked !== undefined) {
            queryParameters['blocked'] = requestParameters.blocked;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/um/su/users/{id}/block`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Block user by his ID
     */
    async postUmSuUsersIdBlock(requestParameters: PostUmSuUsersIdBlockRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.postUmSuUsersIdBlockRaw(requestParameters, initOverrides);
    }

    /**
     * Create new user
     */
    async postUmUsersRaw(requestParameters: PostUmUsersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<number>> {
        if (requestParameters.userCreationView === null || requestParameters.userCreationView === undefined) {
            throw new runtime.RequiredError('userCreationView','Required parameter requestParameters.userCreationView was null or undefined when calling postUmUsers.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/um/users`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.userCreationView,
        }, initOverrides);

        return new runtime.TextApiResponse(response) as any;
    }

    /**
     * Create new user
     */
    async postUmUsers(requestParameters: PostUmUsersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<number> {
        const response = await this.postUmUsersRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Users list
     */
    async postUmUsersListFilterRaw(requestParameters: PostUmUsersListFilterOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CompoundResultUsersListController>> {
        if (requestParameters.postUmUsersListFilterRequest === null || requestParameters.postUmUsersListFilterRequest === undefined) {
            throw new runtime.RequiredError('postUmUsersListFilterRequest','Required parameter requestParameters.postUmUsersListFilterRequest was null or undefined when calling postUmUsersListFilter.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/um/users/list/filter`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.postUmUsersListFilterRequest,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Users list
     */
    async postUmUsersListFilter(requestParameters: PostUmUsersListFilterOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CompoundResultUsersListController> {
        const response = await this.postUmUsersListFilterRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Generate a random secure password with given length
     */
    async postUmUsersPasswordGenerateRaw(requestParameters: PostUmUsersPasswordGenerateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GeneratedPassword>> {
        if (requestParameters.generatingPasswordLength === null || requestParameters.generatingPasswordLength === undefined) {
            throw new runtime.RequiredError('generatingPasswordLength','Required parameter requestParameters.generatingPasswordLength was null or undefined when calling postUmUsersPasswordGenerate.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/um/users/password/generate`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.generatingPasswordLength,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Generate a random secure password with given length
     */
    async postUmUsersPasswordGenerate(requestParameters: PostUmUsersPasswordGenerateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GeneratedPassword> {
        const response = await this.postUmUsersPasswordGenerateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Merge production lots in context of production order
     */
    async productionOrderLotMergeRaw(requestParameters: ProductionOrderLotMergeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ProductionOrderLotsMergeOutputView>> {
        if (requestParameters.productionOrderLotsMergeQueryView === null || requestParameters.productionOrderLotsMergeQueryView === undefined) {
            throw new runtime.RequiredError('productionOrderLotsMergeQueryView','Required parameter requestParameters.productionOrderLotsMergeQueryView was null or undefined when calling productionOrderLotMerge.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/production-order/lots/merge`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.productionOrderLotsMergeQueryView,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Merge production lots in context of production order
     */
    async productionOrderLotMerge(requestParameters: ProductionOrderLotMergeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ProductionOrderLotsMergeOutputView> {
        const response = await this.productionOrderLotMergeRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Split production lots in context of production order
     */
    async productionOrderLotSplitRaw(requestParameters: ProductionOrderLotSplitRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ProductionOrderLotsSplitOutputView>> {
        if (requestParameters.productionOrderLotsSplitQueryView === null || requestParameters.productionOrderLotsSplitQueryView === undefined) {
            throw new runtime.RequiredError('productionOrderLotsSplitQueryView','Required parameter requestParameters.productionOrderLotsSplitQueryView was null or undefined when calling productionOrderLotSplit.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/production-order/lots/split`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.productionOrderLotsSplitQueryView,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Split production lots in context of production order
     */
    async productionOrderLotSplit(requestParameters: ProductionOrderLotSplitRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ProductionOrderLotsSplitOutputView> {
        const response = await this.productionOrderLotSplitRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Exports BPSC production data for given production orders
     */
    async publishBpscExportRaw(requestParameters: PublishBpscExportRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.bpscExportRequest === null || requestParameters.bpscExportRequest === undefined) {
            throw new runtime.RequiredError('bpscExportRequest','Required parameter requestParameters.bpscExportRequest was null or undefined when calling publishBpscExport.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/nanochem/bpsc-export`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.bpscExportRequest,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Exports BPSC production data for given production orders
     */
    async publishBpscExport(requestParameters: PublishBpscExportRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.publishBpscExportRaw(requestParameters, initOverrides);
    }

    /**
     * Set machine state
     */
    async putBackMachinesMachineMachineidSetStateStateRaw(requestParameters: PutBackMachinesMachineMachineidSetStateStateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<MachineState>> {
        if (requestParameters.machineId === null || requestParameters.machineId === undefined) {
            throw new runtime.RequiredError('machineId','Required parameter requestParameters.machineId was null or undefined when calling putBackMachinesMachineMachineidSetStateState.');
        }

        if (requestParameters.state === null || requestParameters.state === undefined) {
            throw new runtime.RequiredError('state','Required parameter requestParameters.state was null or undefined when calling putBackMachinesMachineMachineidSetStateState.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/machines/machine/{MachineId}/set-state/{state}`.replace(`{${"MachineId"}}`, encodeURIComponent(String(requestParameters.machineId))).replace(`{${"state"}}`, encodeURIComponent(String(requestParameters.state))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Set machine state
     */
    async putBackMachinesMachineMachineidSetStateState(requestParameters: PutBackMachinesMachineMachineidSetStateStateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<MachineState> {
        const response = await this.putBackMachinesMachineMachineidSetStateStateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Set language
     */
    async putUmLanguagesLangRaw(requestParameters: PutUmLanguagesLangRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.lang === null || requestParameters.lang === undefined) {
            throw new runtime.RequiredError('lang','Required parameter requestParameters.lang was null or undefined when calling putUmLanguagesLang.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/um/languages/{lang}`.replace(`{${"lang"}}`, encodeURIComponent(String(requestParameters.lang))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Set language
     */
    async putUmLanguagesLang(requestParameters: PutUmLanguagesLangRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.putUmLanguagesLangRaw(requestParameters, initOverrides);
    }

    /**
     * Update user profile
     */
    async putUmProfileRaw(requestParameters: PutUmProfileRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<number>> {
        if (requestParameters.profile === null || requestParameters.profile === undefined) {
            throw new runtime.RequiredError('profile','Required parameter requestParameters.profile was null or undefined when calling putUmProfile.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/um/profile`,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.profile,
        }, initOverrides);

        return new runtime.TextApiResponse(response) as any;
    }

    /**
     * Update user profile
     */
    async putUmProfile(requestParameters: PutUmProfileRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<number> {
        const response = await this.putUmProfileRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update user contact data
     */
    async putUmProfileContactDataUseridRaw(requestParameters: PutUmProfileContactDataUseridRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<number>> {
        if (requestParameters.userId === null || requestParameters.userId === undefined) {
            throw new runtime.RequiredError('userId','Required parameter requestParameters.userId was null or undefined when calling putUmProfileContactDataUserid.');
        }

        if (requestParameters.contactDataUpdateView === null || requestParameters.contactDataUpdateView === undefined) {
            throw new runtime.RequiredError('contactDataUpdateView','Required parameter requestParameters.contactDataUpdateView was null or undefined when calling putUmProfileContactDataUserid.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/um/profile/contact-data/{UserId}`.replace(`{${"UserId"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.contactDataUpdateView,
        }, initOverrides);

        return new runtime.TextApiResponse(response) as any;
    }

    /**
     * Update user contact data
     */
    async putUmProfileContactDataUserid(requestParameters: PutUmProfileContactDataUseridRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<number> {
        const response = await this.putUmProfileContactDataUseridRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update user profile by himself
     */
    async putUmProfileSelfRaw(requestParameters: PutUmProfileSelfRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<number>> {
        if (requestParameters.selfProfileUpdateView === null || requestParameters.selfProfileUpdateView === undefined) {
            throw new runtime.RequiredError('selfProfileUpdateView','Required parameter requestParameters.selfProfileUpdateView was null or undefined when calling putUmProfileSelf.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/um/profile/self`,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.selfProfileUpdateView,
        }, initOverrides);

        return new runtime.TextApiResponse(response) as any;
    }

    /**
     * Update user profile by himself
     */
    async putUmProfileSelf(requestParameters: PutUmProfileSelfRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<number> {
        const response = await this.putUmProfileSelfRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update user\'s password
     */
    async putUmProfileUseridUpdatePasswordRaw(requestParameters: PutUmProfileUseridUpdatePasswordRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<number>> {
        if (requestParameters.userId === null || requestParameters.userId === undefined) {
            throw new runtime.RequiredError('userId','Required parameter requestParameters.userId was null or undefined when calling putUmProfileUseridUpdatePassword.');
        }

        if (requestParameters.newManuallyTypedPassword === null || requestParameters.newManuallyTypedPassword === undefined) {
            throw new runtime.RequiredError('newManuallyTypedPassword','Required parameter requestParameters.newManuallyTypedPassword was null or undefined when calling putUmProfileUseridUpdatePassword.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/um/profile/{UserId}/update-password`.replace(`{${"UserId"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.newManuallyTypedPassword,
        }, initOverrides);

        return new runtime.TextApiResponse(response) as any;
    }

    /**
     * Update user\'s password
     */
    async putUmProfileUseridUpdatePassword(requestParameters: PutUmProfileUseridUpdatePasswordRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<number> {
        const response = await this.putUmProfileUseridUpdatePasswordRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Add role to the user
     */
    async putUmRolesIdUsersUidRaw(requestParameters: PutUmRolesIdUsersUidRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling putUmRolesIdUsersUid.');
        }

        if (requestParameters.uid === null || requestParameters.uid === undefined) {
            throw new runtime.RequiredError('uid','Required parameter requestParameters.uid was null or undefined when calling putUmRolesIdUsersUid.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/um/roles/{id}/users/{uid}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))).replace(`{${"uid"}}`, encodeURIComponent(String(requestParameters.uid))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Add role to the user
     */
    async putUmRolesIdUsersUid(requestParameters: PutUmRolesIdUsersUidRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.putUmRolesIdUsersUidRaw(requestParameters, initOverrides);
    }

    /**
     * Query acceptance resolution
     */
    async querySupplyOrderAcceptanceResolutionRaw(requestParameters: QuerySupplyOrderAcceptanceResolutionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SupplyOrderAcceptanceResolution>> {
        if (requestParameters.supplyOrderItemsSavingView === null || requestParameters.supplyOrderItemsSavingView === undefined) {
            throw new runtime.RequiredError('supplyOrderItemsSavingView','Required parameter requestParameters.supplyOrderItemsSavingView was null or undefined when calling querySupplyOrderAcceptanceResolution.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/supply-order/acceptance-resolution`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.supplyOrderItemsSavingView,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Query acceptance resolution
     */
    async querySupplyOrderAcceptanceResolution(requestParameters: QuerySupplyOrderAcceptanceResolutionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SupplyOrderAcceptanceResolution> {
        const response = await this.querySupplyOrderAcceptanceResolutionRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get supply order items based on selected demands
     */
    async querySupplyOrderItemsRaw(requestParameters: QuerySupplyOrderItemsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SupplyOrderInitView>> {
        if (requestParameters.simulationQueryPayload === null || requestParameters.simulationQueryPayload === undefined) {
            throw new runtime.RequiredError('simulationQueryPayload','Required parameter requestParameters.simulationQueryPayload was null or undefined when calling querySupplyOrderItems.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/supply-order/query-items`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.simulationQueryPayload,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Get supply order items based on selected demands
     */
    async querySupplyOrderItems(requestParameters: QuerySupplyOrderItemsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SupplyOrderInitView> {
        const response = await this.querySupplyOrderItemsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Save supply order draft based on demands query
     */
    async quickSaveSupplyOrderItemsRaw(requestParameters: QuickSaveSupplyOrderItemsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<IdWithNumberSupplyOrderId>>> {
        if (requestParameters.simulationQueryPayload === null || requestParameters.simulationQueryPayload === undefined) {
            throw new runtime.RequiredError('simulationQueryPayload','Required parameter requestParameters.simulationQueryPayload was null or undefined when calling quickSaveSupplyOrderItems.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/supply-order/save-items/quick`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.simulationQueryPayload,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Save supply order draft based on demands query
     */
    async quickSaveSupplyOrderItems(requestParameters: QuickSaveSupplyOrderItemsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<IdWithNumberSupplyOrderId>> {
        const response = await this.quickSaveSupplyOrderItemsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get part of tree recalculated according to its input
     */
    async recalculateProductionOrderSimulationRaw(requestParameters: RecalculateProductionOrderSimulationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SimulationLotView>> {
        if (requestParameters.recalculateProductionOrderPayload === null || requestParameters.recalculateProductionOrderPayload === undefined) {
            throw new runtime.RequiredError('recalculateProductionOrderPayload','Required parameter requestParameters.recalculateProductionOrderPayload was null or undefined when calling recalculateProductionOrderSimulation.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/production-order/recalculate`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.recalculateProductionOrderPayload,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Get part of tree recalculated according to its input
     */
    async recalculateProductionOrderSimulation(requestParameters: RecalculateProductionOrderSimulationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SimulationLotView> {
        const response = await this.recalculateProductionOrderSimulationRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Reschedule stocktaking
     */
    async rescheduleStocktakingRaw(requestParameters: RescheduleStocktakingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IdWithNumberStocktakingId>> {
        if (requestParameters.stocktakingId === null || requestParameters.stocktakingId === undefined) {
            throw new runtime.RequiredError('stocktakingId','Required parameter requestParameters.stocktakingId was null or undefined when calling rescheduleStocktaking.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/stocktaking/reschedule/{StocktakingId}`.replace(`{${"StocktakingId"}}`, encodeURIComponent(String(requestParameters.stocktakingId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Reschedule stocktaking
     */
    async rescheduleStocktaking(requestParameters: RescheduleStocktakingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IdWithNumberStocktakingId> {
        const response = await this.rescheduleStocktakingRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Save bom for given production lot
     */
    async saveBomReportRaw(requestParameters: SaveBomReportRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<BomReportEntryView>>> {
        if (requestParameters.productionLotId === null || requestParameters.productionLotId === undefined) {
            throw new runtime.RequiredError('productionLotId','Required parameter requestParameters.productionLotId was null or undefined when calling saveBomReport.');
        }

        if (requestParameters.bomReportSaveView === null || requestParameters.bomReportSaveView === undefined) {
            throw new runtime.RequiredError('bomReportSaveView','Required parameter requestParameters.bomReportSaveView was null or undefined when calling saveBomReport.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/reports/workstation-reports/bom/production-lot/{ProductionLotId}/save`.replace(`{${"ProductionLotId"}}`, encodeURIComponent(String(requestParameters.productionLotId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.bomReportSaveView,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Save bom for given production lot
     */
    async saveBomReport(requestParameters: SaveBomReportRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<BomReportEntryView>> {
        const response = await this.saveBomReportRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Countsheet entry
     */
    async saveCountsheetEntryRaw(requestParameters: SaveCountsheetEntryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<number>> {
        if (requestParameters.countsheetEntrySaveView === null || requestParameters.countsheetEntrySaveView === undefined) {
            throw new runtime.RequiredError('countsheetEntrySaveView','Required parameter requestParameters.countsheetEntrySaveView was null or undefined when calling saveCountsheetEntry.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/stocktaking/entry`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.countsheetEntrySaveView,
        }, initOverrides);

        return new runtime.TextApiResponse(response) as any;
    }

    /**
     * Countsheet entry
     */
    async saveCountsheetEntry(requestParameters: SaveCountsheetEntryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<number> {
        const response = await this.saveCountsheetEntryRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Save downtime report with duration for a batch
     */
    async saveDurationBatchDowntimeRaw(requestParameters: SaveDurationBatchDowntimeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<number>> {
        if (requestParameters.batchId === null || requestParameters.batchId === undefined) {
            throw new runtime.RequiredError('batchId','Required parameter requestParameters.batchId was null or undefined when calling saveDurationBatchDowntime.');
        }

        if (requestParameters.downtimeReportDurationSaveView === null || requestParameters.downtimeReportDurationSaveView === undefined) {
            throw new runtime.RequiredError('downtimeReportDurationSaveView','Required parameter requestParameters.downtimeReportDurationSaveView was null or undefined when calling saveDurationBatchDowntime.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/reports/workstation-reports/downtime/batch/save/{BatchId}/duration`.replace(`{${"BatchId"}}`, encodeURIComponent(String(requestParameters.batchId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.downtimeReportDurationSaveView,
        }, initOverrides);

        return new runtime.TextApiResponse(response) as any;
    }

    /**
     * Save downtime report with duration for a batch
     */
    async saveDurationBatchDowntime(requestParameters: SaveDurationBatchDowntimeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<number> {
        const response = await this.saveDurationBatchDowntimeRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Save downtime report with duration for a batch
     */
    async saveDurationBatchDowntimeV2Raw(requestParameters: SaveDurationBatchDowntimeV2Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<number>>> {
        if (requestParameters.batchId === null || requestParameters.batchId === undefined) {
            throw new runtime.RequiredError('batchId','Required parameter requestParameters.batchId was null or undefined when calling saveDurationBatchDowntimeV2.');
        }

        if (requestParameters.batchDowntimeReportDurationSaveView === null || requestParameters.batchDowntimeReportDurationSaveView === undefined) {
            throw new runtime.RequiredError('batchDowntimeReportDurationSaveView','Required parameter requestParameters.batchDowntimeReportDurationSaveView was null or undefined when calling saveDurationBatchDowntimeV2.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/reports/workstation-reports/downtime/batch/v2/save/{BatchId}/duration`.replace(`{${"BatchId"}}`, encodeURIComponent(String(requestParameters.batchId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.batchDowntimeReportDurationSaveView,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Save downtime report with duration for a batch
     */
    async saveDurationBatchDowntimeV2(requestParameters: SaveDurationBatchDowntimeV2Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<number>> {
        const response = await this.saveDurationBatchDowntimeV2Raw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Save downtime report with duration for a production lot
     */
    async saveDurationDowntimeRaw(requestParameters: SaveDurationDowntimeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<number>> {
        if (requestParameters.productionLotId === null || requestParameters.productionLotId === undefined) {
            throw new runtime.RequiredError('productionLotId','Required parameter requestParameters.productionLotId was null or undefined when calling saveDurationDowntime.');
        }

        if (requestParameters.downtimeReportDurationSaveView === null || requestParameters.downtimeReportDurationSaveView === undefined) {
            throw new runtime.RequiredError('downtimeReportDurationSaveView','Required parameter requestParameters.downtimeReportDurationSaveView was null or undefined when calling saveDurationDowntime.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/reports/workstation-reports/downtime/save/{ProductionLotId}/duration`.replace(`{${"ProductionLotId"}}`, encodeURIComponent(String(requestParameters.productionLotId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.downtimeReportDurationSaveView,
        }, initOverrides);

        return new runtime.TextApiResponse(response) as any;
    }

    /**
     * Save downtime report with duration for a production lot
     */
    async saveDurationDowntime(requestParameters: SaveDurationDowntimeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<number> {
        const response = await this.saveDurationDowntimeRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Save downtime report with duration for a production lot
     */
    async saveDurationDowntimeV2Raw(requestParameters: SaveDurationDowntimeV2Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<number>>> {
        if (requestParameters.productionLotId === null || requestParameters.productionLotId === undefined) {
            throw new runtime.RequiredError('productionLotId','Required parameter requestParameters.productionLotId was null or undefined when calling saveDurationDowntimeV2.');
        }

        if (requestParameters.downtimeReportDurationSaveView === null || requestParameters.downtimeReportDurationSaveView === undefined) {
            throw new runtime.RequiredError('downtimeReportDurationSaveView','Required parameter requestParameters.downtimeReportDurationSaveView was null or undefined when calling saveDurationDowntimeV2.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/reports/workstation-reports/downtime/v2/save/{ProductionLotId}/duration`.replace(`{${"ProductionLotId"}}`, encodeURIComponent(String(requestParameters.productionLotId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.downtimeReportDurationSaveView,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Save downtime report with duration for a production lot
     */
    async saveDurationDowntimeV2(requestParameters: SaveDurationDowntimeV2Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<number>> {
        const response = await this.saveDurationDowntimeV2Raw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Save material movement
     */
    async saveMaterialMovementRaw(requestParameters: SaveMaterialMovementRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IdWithNumberMaterialMovementId>> {
        if (requestParameters.materialMovementSaveView === null || requestParameters.materialMovementSaveView === undefined) {
            throw new runtime.RequiredError('materialMovementSaveView','Required parameter requestParameters.materialMovementSaveView was null or undefined when calling saveMaterialMovement.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/material-movements/save`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.materialMovementSaveView,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Save material movement
     */
    async saveMaterialMovement(requestParameters: SaveMaterialMovementRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IdWithNumberMaterialMovementId> {
        const response = await this.saveMaterialMovementRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Save planned release
     */
    async savePlannedReleaseRaw(requestParameters: SavePlannedReleaseRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<number>>> {
        if (requestParameters.plannedReleaseSavingView === null || requestParameters.plannedReleaseSavingView === undefined) {
            throw new runtime.RequiredError('plannedReleaseSavingView','Required parameter requestParameters.plannedReleaseSavingView was null or undefined when calling savePlannedRelease.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/releases/planned/save`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.plannedReleaseSavingView,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Save planned release
     */
    async savePlannedRelease(requestParameters: SavePlannedReleaseRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<number>> {
        const response = await this.savePlannedReleaseRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Save spontaneous release
     */
    async saveSpontaneousReleaseRaw(requestParameters: SaveSpontaneousReleaseRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<number>> {
        if (requestParameters.spontaneousReleaseSavingView === null || requestParameters.spontaneousReleaseSavingView === undefined) {
            throw new runtime.RequiredError('spontaneousReleaseSavingView','Required parameter requestParameters.spontaneousReleaseSavingView was null or undefined when calling saveSpontaneousRelease.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/releases/spontaneous/save`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.spontaneousReleaseSavingView,
        }, initOverrides);

        return new runtime.TextApiResponse(response) as any;
    }

    /**
     * Save spontaneous release
     */
    async saveSpontaneousRelease(requestParameters: SaveSpontaneousReleaseRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<number> {
        const response = await this.saveSpontaneousReleaseRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Save downtime report with start and end dates for a batch
     */
    async saveStartEndBatchDowntimeRaw(requestParameters: SaveStartEndBatchDowntimeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<number>> {
        if (requestParameters.batchId === null || requestParameters.batchId === undefined) {
            throw new runtime.RequiredError('batchId','Required parameter requestParameters.batchId was null or undefined when calling saveStartEndBatchDowntime.');
        }

        if (requestParameters.downtimeReportStartEndSaveView === null || requestParameters.downtimeReportStartEndSaveView === undefined) {
            throw new runtime.RequiredError('downtimeReportStartEndSaveView','Required parameter requestParameters.downtimeReportStartEndSaveView was null or undefined when calling saveStartEndBatchDowntime.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/reports/workstation-reports/downtime/batch/save/{BatchId}/start-end`.replace(`{${"BatchId"}}`, encodeURIComponent(String(requestParameters.batchId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.downtimeReportStartEndSaveView,
        }, initOverrides);

        return new runtime.TextApiResponse(response) as any;
    }

    /**
     * Save downtime report with start and end dates for a batch
     */
    async saveStartEndBatchDowntime(requestParameters: SaveStartEndBatchDowntimeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<number> {
        const response = await this.saveStartEndBatchDowntimeRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Save downtime report with start and end dates for a batch
     */
    async saveStartEndBatchDowntimeV2Raw(requestParameters: SaveStartEndBatchDowntimeV2Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<number>> {
        if (requestParameters.batchId === null || requestParameters.batchId === undefined) {
            throw new runtime.RequiredError('batchId','Required parameter requestParameters.batchId was null or undefined when calling saveStartEndBatchDowntimeV2.');
        }

        if (requestParameters.batchDowntimeReportStartEndSaveView === null || requestParameters.batchDowntimeReportStartEndSaveView === undefined) {
            throw new runtime.RequiredError('batchDowntimeReportStartEndSaveView','Required parameter requestParameters.batchDowntimeReportStartEndSaveView was null or undefined when calling saveStartEndBatchDowntimeV2.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/reports/workstation-reports/downtime/batch/v2/save/{BatchId}/start-end`.replace(`{${"BatchId"}}`, encodeURIComponent(String(requestParameters.batchId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.batchDowntimeReportStartEndSaveView,
        }, initOverrides);

        return new runtime.TextApiResponse(response) as any;
    }

    /**
     * Save downtime report with start and end dates for a batch
     */
    async saveStartEndBatchDowntimeV2(requestParameters: SaveStartEndBatchDowntimeV2Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<number> {
        const response = await this.saveStartEndBatchDowntimeV2Raw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Save stocktaking
     */
    async saveStocktakingRaw(requestParameters: SaveStocktakingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IdWithNumberStocktakingId>> {
        if (requestParameters.stocktakingSaveView === null || requestParameters.stocktakingSaveView === undefined) {
            throw new runtime.RequiredError('stocktakingSaveView','Required parameter requestParameters.stocktakingSaveView was null or undefined when calling saveStocktaking.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/stocktaking/create`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.stocktakingSaveView,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Save stocktaking
     */
    async saveStocktaking(requestParameters: SaveStocktakingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IdWithNumberStocktakingId> {
        const response = await this.saveStocktakingRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Save supply order items
     */
    async saveSupplyOrderItemsRaw(requestParameters: SaveSupplyOrderItemsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<IdWithNumberSupplyOrderId>>> {
        if (requestParameters.supplyOrderItemsSavingView === null || requestParameters.supplyOrderItemsSavingView === undefined) {
            throw new runtime.RequiredError('supplyOrderItemsSavingView','Required parameter requestParameters.supplyOrderItemsSavingView was null or undefined when calling saveSupplyOrderItems.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/supply-order/save-items`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.supplyOrderItemsSavingView,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Save supply order items
     */
    async saveSupplyOrderItems(requestParameters: SaveSupplyOrderItemsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<IdWithNumberSupplyOrderId>> {
        const response = await this.saveSupplyOrderItemsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Send external documents for production orders
     */
    async sendExternalDocumentsRaw(requestParameters: SendExternalDocumentsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/documents/production-order/send-external-documents`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.requestBody,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Send external documents for production orders
     */
    async sendExternalDocuments(requestParameters: SendExternalDocumentsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.sendExternalDocumentsRaw(requestParameters, initOverrides);
    }

    /**
     * Set comment for supply order
     */
    async setSupplyOrderCommentRaw(requestParameters: SetSupplyOrderCommentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IdWithNumberSupplyOrderId>> {
        if (requestParameters.supplyOrderId === null || requestParameters.supplyOrderId === undefined) {
            throw new runtime.RequiredError('supplyOrderId','Required parameter requestParameters.supplyOrderId was null or undefined when calling setSupplyOrderComment.');
        }

        if (requestParameters.body === null || requestParameters.body === undefined) {
            throw new runtime.RequiredError('body','Required parameter requestParameters.body was null or undefined when calling setSupplyOrderComment.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/supply-order/set-comment/{SupplyOrderId}`.replace(`{${"SupplyOrderId"}}`, encodeURIComponent(String(requestParameters.supplyOrderId))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.body as any,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Set comment for supply order
     */
    async setSupplyOrderComment(requestParameters: SetSupplyOrderCommentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IdWithNumberSupplyOrderId> {
        const response = await this.setSupplyOrderCommentRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Set responsible person for supply order
     */
    async setSupplyOrderResponsiblePersonRaw(requestParameters: SetSupplyOrderResponsiblePersonRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IdWithNumberSupplyOrderId>> {
        if (requestParameters.supplyOrderId === null || requestParameters.supplyOrderId === undefined) {
            throw new runtime.RequiredError('supplyOrderId','Required parameter requestParameters.supplyOrderId was null or undefined when calling setSupplyOrderResponsiblePerson.');
        }

        if (requestParameters.userId === null || requestParameters.userId === undefined) {
            throw new runtime.RequiredError('userId','Required parameter requestParameters.userId was null or undefined when calling setSupplyOrderResponsiblePerson.');
        }

        const queryParameters: any = {};

        if (requestParameters.userId !== undefined) {
            queryParameters['userId'] = requestParameters.userId;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/supply-order/set-responsible-person/{SupplyOrderId}`.replace(`{${"SupplyOrderId"}}`, encodeURIComponent(String(requestParameters.supplyOrderId))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Set responsible person for supply order
     */
    async setSupplyOrderResponsiblePerson(requestParameters: SetSupplyOrderResponsiblePersonRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IdWithNumberSupplyOrderId> {
        const response = await this.setSupplyOrderResponsiblePersonRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Start merge of simulation
     */
    async startSimulationMergeRaw(requestParameters: StartSimulationMergeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<NexelemMergeImportState>> {
        if (requestParameters.simulationMergeView === null || requestParameters.simulationMergeView === undefined) {
            throw new runtime.RequiredError('simulationMergeView','Required parameter requestParameters.simulationMergeView was null or undefined when calling startSimulationMerge.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/api/import/simulation/start`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.simulationMergeView,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Start merge of simulation
     */
    async startSimulationMerge(requestParameters: StartSimulationMergeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<NexelemMergeImportState> {
        const response = await this.startSimulationMergeRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Start stocktaking
     */
    async startStocktakingRaw(requestParameters: StartStocktakingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IdWithNumberStocktakingId>> {
        if (requestParameters.stocktakingId === null || requestParameters.stocktakingId === undefined) {
            throw new runtime.RequiredError('stocktakingId','Required parameter requestParameters.stocktakingId was null or undefined when calling startStocktaking.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/stocktaking/start/{StocktakingId}`.replace(`{${"StocktakingId"}}`, encodeURIComponent(String(requestParameters.stocktakingId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Start stocktaking
     */
    async startStocktaking(requestParameters: StartStocktakingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IdWithNumberStocktakingId> {
        const response = await this.startStocktakingRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Start stopwatch downtime report for a batch
     */
    async startStopwatchBatchDowntimeRaw(requestParameters: StartStopwatchBatchDowntimeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<number>> {
        if (requestParameters.batchId === null || requestParameters.batchId === undefined) {
            throw new runtime.RequiredError('batchId','Required parameter requestParameters.batchId was null or undefined when calling startStopwatchBatchDowntime.');
        }

        if (requestParameters.downtimeReportStartStopwatchView === null || requestParameters.downtimeReportStartStopwatchView === undefined) {
            throw new runtime.RequiredError('downtimeReportStartStopwatchView','Required parameter requestParameters.downtimeReportStartStopwatchView was null or undefined when calling startStopwatchBatchDowntime.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/reports/workstation-reports/downtime/batch/save/{BatchId}/stopwatch/start`.replace(`{${"BatchId"}}`, encodeURIComponent(String(requestParameters.batchId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.downtimeReportStartStopwatchView,
        }, initOverrides);

        return new runtime.TextApiResponse(response) as any;
    }

    /**
     * Start stopwatch downtime report for a batch
     */
    async startStopwatchBatchDowntime(requestParameters: StartStopwatchBatchDowntimeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<number> {
        const response = await this.startStopwatchBatchDowntimeRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Save downtime report with start date for a production lot
     */
    async startStopwatchDowntimeRaw(requestParameters: StartStopwatchDowntimeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<number>> {
        if (requestParameters.productionLotId === null || requestParameters.productionLotId === undefined) {
            throw new runtime.RequiredError('productionLotId','Required parameter requestParameters.productionLotId was null or undefined when calling startStopwatchDowntime.');
        }

        if (requestParameters.downtimeReportStartStopwatchView === null || requestParameters.downtimeReportStartStopwatchView === undefined) {
            throw new runtime.RequiredError('downtimeReportStartStopwatchView','Required parameter requestParameters.downtimeReportStartStopwatchView was null or undefined when calling startStopwatchDowntime.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/reports/workstation-reports/downtime/save/{ProductionLotId}/stopwatch/start`.replace(`{${"ProductionLotId"}}`, encodeURIComponent(String(requestParameters.productionLotId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.downtimeReportStartStopwatchView,
        }, initOverrides);

        return new runtime.TextApiResponse(response) as any;
    }

    /**
     * Save downtime report with start date for a production lot
     */
    async startStopwatchDowntime(requestParameters: StartStopwatchDowntimeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<number> {
        const response = await this.startStopwatchDowntimeRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get supply order details
     */
    async supplyOrderDetailsRaw(requestParameters: SupplyOrderDetailsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SupplyOrderDetailsView2>> {
        if (requestParameters.supplyOrderId === null || requestParameters.supplyOrderId === undefined) {
            throw new runtime.RequiredError('supplyOrderId','Required parameter requestParameters.supplyOrderId was null or undefined when calling supplyOrderDetails.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/supply-order/details/{SupplyOrderId}`.replace(`{${"SupplyOrderId"}}`, encodeURIComponent(String(requestParameters.supplyOrderId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Get supply order details
     */
    async supplyOrderDetails(requestParameters: SupplyOrderDetailsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SupplyOrderDetailsView2> {
        const response = await this.supplyOrderDetailsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update responsible person for countsheet
     */
    async updateCountsheetResponsiblePersonRaw(requestParameters: UpdateCountsheetResponsiblePersonRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<number>> {
        if (requestParameters.countsheetId === null || requestParameters.countsheetId === undefined) {
            throw new runtime.RequiredError('countsheetId','Required parameter requestParameters.countsheetId was null or undefined when calling updateCountsheetResponsiblePerson.');
        }

        if (requestParameters.userId === null || requestParameters.userId === undefined) {
            throw new runtime.RequiredError('userId','Required parameter requestParameters.userId was null or undefined when calling updateCountsheetResponsiblePerson.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/stocktaking/countsheet/{CountsheetId}/update-reponsible-person/{UserId}`.replace(`{${"CountsheetId"}}`, encodeURIComponent(String(requestParameters.countsheetId))).replace(`{${"UserId"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.TextApiResponse(response) as any;
    }

    /**
     * Update responsible person for countsheet
     */
    async updateCountsheetResponsiblePerson(requestParameters: UpdateCountsheetResponsiblePersonRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<number> {
        const response = await this.updateCountsheetResponsiblePersonRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update measurement
     */
    async updateMeasurementRaw(requestParameters: UpdateMeasurementRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.measurementUpdateView === null || requestParameters.measurementUpdateView === undefined) {
            throw new runtime.RequiredError('measurementUpdateView','Required parameter requestParameters.measurementUpdateView was null or undefined when calling updateMeasurement.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/measurement-reports/measurement/update`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.measurementUpdateView,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Update measurement
     */
    async updateMeasurement(requestParameters: UpdateMeasurementRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.updateMeasurementRaw(requestParameters, initOverrides);
    }

    /**
     * Update user\'s RFID (Radio Frequency Identification)
     */
    async updateRfidRaw(requestParameters: UpdateRfidRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<number>> {
        if (requestParameters.userId === null || requestParameters.userId === undefined) {
            throw new runtime.RequiredError('userId','Required parameter requestParameters.userId was null or undefined when calling updateRfid.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/um/profile/{UserId}/update-rfid`.replace(`{${"UserId"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.rfid,
        }, initOverrides);

        return new runtime.TextApiResponse(response) as any;
    }

    /**
     * Update user\'s RFID (Radio Frequency Identification)
     */
    async updateRfid(requestParameters: UpdateRfidRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<number> {
        const response = await this.updateRfidRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update comment for stocktaking
     */
    async updateStocktakingCommentRaw(requestParameters: UpdateStocktakingCommentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IdWithNumberStocktakingId>> {
        if (requestParameters.stocktakingId === null || requestParameters.stocktakingId === undefined) {
            throw new runtime.RequiredError('stocktakingId','Required parameter requestParameters.stocktakingId was null or undefined when calling updateStocktakingComment.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/stocktaking/update-comment/{StocktakingId}`.replace(`{${"StocktakingId"}}`, encodeURIComponent(String(requestParameters.stocktakingId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.body as any,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Update comment for stocktaking
     */
    async updateStocktakingComment(requestParameters: UpdateStocktakingCommentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IdWithNumberStocktakingId> {
        const response = await this.updateStocktakingCommentRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Validate material movement
     */
    async validateMaterialMovementRaw(requestParameters: ValidateMaterialMovementRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<MaterialMovementApplyView>> {
        if (requestParameters.materialMovementValidationView === null || requestParameters.materialMovementValidationView === undefined) {
            throw new runtime.RequiredError('materialMovementValidationView','Required parameter requestParameters.materialMovementValidationView was null or undefined when calling validateMaterialMovement.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/back/material-movements/validate`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.materialMovementValidationView,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Validate material movement
     */
    async validateMaterialMovement(requestParameters: ValidateMaterialMovementRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<MaterialMovementApplyView> {
        const response = await this.validateMaterialMovementRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
